import * as i0 from '@angular/core';
import { Injectable, APP_INITIALIZER, NgModule, Optional, SkipSelf, EventEmitter, NgZone, Pipe } from '@angular/core';
import * as i2 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i3$1 from '@angular/common';
import { CommonModule, CurrencyPipe } from '@angular/common';
import * as i1 from '@congacommerce/core';
import { AObject, ATable, AField, AFilter, ACondition, AObjectService, TreeUtils, PlatformConstants, ApttusModule, ApiService, SalesforceUtils, ConfigurationService, AJoin, ASort, SoapService, SimpleDate, APageInfo, MetadataService } from '@congacommerce/core';
import { FormsModule } from '@angular/forms';
import { LaddaModule } from 'angular2-ladda';
import * as i5 from '@ngx-translate/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import * as i3 from '@angular/common/http';
import { BehaviorSubject, of, combineLatest, throwError, Observable, zip, iif } from 'rxjs';
import { switchMap, take, filter as filter$1, map as map$1, mergeMap, tap, catchError, skip, retryWhen, delay, flatMap, delayWhen } from 'rxjs/operators';
import * as _ from 'lodash';
import { get, filter, compact, map, sumBy, forEach, concat, isEmpty, isNil, some, merge, has, find, assign, pick, keys, startsWith, includes, set, cloneDeep, first, every, remove, values, keyBy, uniq, bind, uniqBy, flatten, join, defaultTo, isEqual, omit, debounce, sortBy, mapValues, memoize as memoize$1, reduce, sum, isArray, deburr, split, difference, flatMap as flatMap$1, intersection } from 'lodash';
import { __decorate, __metadata } from 'tslib';
import { Expose, Type, plainToClass } from 'class-transformer';
import * as moment from 'moment';
import * as LocaleCurrency from 'locale-currency';
import * as cc from 'currency-codes';
import * as i4 from 'ngx-toastr';
import { MemoizeAll, Delay, memoize } from 'lodash-decorators';
import * as i4$1 from '@angular/platform-browser';
import * as download from 'downloadjs';

let PriceListBase = class PriceListBase extends AObject {
    constructor() {
        super(...arguments);
        this.BasedOnAdjustmentAmount = null;
        this.BasedOnAdjustmentType = null;
        this.BasedOnPriceListId = null;
        this.Name = null;
        this.AccountId = null;
        this.CurrencyIsoCode = null;
        this.Active = false;
        this.EffectiveDate = null;
        this.ExpirationDate = null;
    }
};
__decorate([
    Expose({ name: 'Apttus_Config2__BasedOnAdjustmentAmount__c' }),
    __metadata("design:type", Number)
], PriceListBase.prototype, "BasedOnAdjustmentAmount", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BasedOnAdjustmentType__c' }),
    __metadata("design:type", String)
], PriceListBase.prototype, "BasedOnAdjustmentType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BasedOnPriceListId__c' }),
    __metadata("design:type", String)
], PriceListBase.prototype, "BasedOnPriceListId", void 0);
__decorate([
    Expose({ name: 'Name' }),
    __metadata("design:type", String)
], PriceListBase.prototype, "Name", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AccountId__c' }),
    __metadata("design:type", String)
], PriceListBase.prototype, "AccountId", void 0);
__decorate([
    Expose({ name: 'CurrencyIsoCode' }),
    __metadata("design:type", String)
], PriceListBase.prototype, "CurrencyIsoCode", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Active__c' }),
    __metadata("design:type", Boolean)
], PriceListBase.prototype, "Active", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__EffectiveDate__c' }),
    __metadata("design:type", String)
], PriceListBase.prototype, "EffectiveDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ExpirationDate__c' }),
    __metadata("design:type", String)
], PriceListBase.prototype, "ExpirationDate", void 0);
PriceListBase = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__PriceList__c',
        aqlName: 'cpq_PriceList'
    })
], PriceListBase);
let PriceList = class PriceList extends PriceListBase {
    constructor() {
        super(...arguments);
        this.BasedOnPriceList = null;
    }
};
__decorate([
    Type(() => PriceListBase),
    Expose({ name: 'Apttus_Config2__BasedOnPriceListId__r' }),
    __metadata("design:type", PriceListBase)
], PriceList.prototype, "BasedOnPriceList", void 0);
PriceList = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__PriceList__c',
        aqlName: 'cpq_PriceList'
    })
], PriceList);

let ProductAttribute = class ProductAttribute extends AObject {
    constructor() {
        super(...arguments);
        this.AttributeGroupId = null;
        this.DisplayType = null;
        this.Field = null;
        this.FieldUpdateId = null;
        this.IsHidden = null;
        this.IsPrimary = null;
        this.IsReadOnly = null;
        this.ProductAttributeValueField = null;
        this.Sequence = null;
    }
};
__decorate([
    Expose({ name: 'Apttus_Config2__AttributeGroupId__c' }),
    __metadata("design:type", String)
], ProductAttribute.prototype, "AttributeGroupId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__DisplayType__c' }),
    __metadata("design:type", String)
], ProductAttribute.prototype, "DisplayType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Field__c' }),
    __metadata("design:type", String)
], ProductAttribute.prototype, "Field", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__FieldUpdateId__c' }),
    __metadata("design:type", String)
], ProductAttribute.prototype, "FieldUpdateId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsHidden__c' }),
    __metadata("design:type", Boolean)
], ProductAttribute.prototype, "IsHidden", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsPrimary__c' }),
    __metadata("design:type", Boolean)
], ProductAttribute.prototype, "IsPrimary", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsReadOnly__c' }),
    __metadata("design:type", Boolean)
], ProductAttribute.prototype, "IsReadOnly", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductAttributeValueField__c' }),
    __metadata("design:type", String)
], ProductAttribute.prototype, "ProductAttributeValueField", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Sequence__c' }),
    __metadata("design:type", Number)
], ProductAttribute.prototype, "Sequence", void 0);
ProductAttribute = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__ProductAttribute__c',
        aqlName: 'cpq_ProductAttribute'
    })
], ProductAttribute);

let PriceDimensionBase = class PriceDimensionBase extends AObject {
    constructor() {
        super(...arguments);
        this.Attribute = new ProductAttribute();
        this.BusinessObject = null;
        this.ChildFilterName = null;
        this.ContextType = null;
        this.Description = null;
        this.Datasource = null;
        this.IncentiveId = null;
        this.RelationType = null;
        this.Type = null;
    }
};
__decorate([
    AField({
        soql: 'Apttus_Config2__AttributeId__r',
        aql: 'AttributeId'
    }),
    __metadata("design:type", ProductAttribute)
], PriceDimensionBase.prototype, "Attribute", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__BusinessObject__c',
        aql: 'BusinessObject'
    }),
    __metadata("design:type", String)
], PriceDimensionBase.prototype, "BusinessObject", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__childFilterName__c',
        aql: 'ChildFilterName'
    }),
    __metadata("design:type", String)
], PriceDimensionBase.prototype, "ChildFilterName", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__contextType__c',
        aql: 'ContextType'
    }),
    __metadata("design:type", String)
], PriceDimensionBase.prototype, "ContextType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Description__c',
        aql: 'Description'
    }),
    __metadata("design:type", String)
], PriceDimensionBase.prototype, "Description", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Datasource__c',
        aql: 'Datasource'
    }),
    __metadata("design:type", String)
], PriceDimensionBase.prototype, "Datasource", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__IncentiveId__c',
        aql: 'IncentiveId'
    }),
    __metadata("design:type", String)
], PriceDimensionBase.prototype, "IncentiveId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__RelationType__c',
        aql: 'RelationType'
    }),
    __metadata("design:type", String)
], PriceDimensionBase.prototype, "RelationType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Type__c',
        aql: 'Type'
    }),
    __metadata("design:type", String)
], PriceDimensionBase.prototype, "Type", void 0);
PriceDimensionBase = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__PriceDimension__c',
        aqlName: 'cpq_PriceDimension'
    })
], PriceDimensionBase);
let PriceDimension = class PriceDimension extends PriceDimensionBase {
    constructor() {
        super(...arguments);
        this.CumulativeDimension = new PriceDimensionBase();
    }
};
__decorate([
    AField({
        soql: 'Apttus_Config2__CumulativeDimensionId__r',
        aql: 'CumulativeDimensionId'
    }),
    __metadata("design:type", PriceDimensionBase)
], PriceDimension.prototype, "CumulativeDimension", void 0);
PriceDimension = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__PriceDimension__c',
        aqlName: 'cpq_PriceDimension'
    })
], PriceDimension);

let PriceMatrix = class PriceMatrix extends AObject {
    constructor() {
        super(...arguments);
        this.Description = null;
        this.Dimension1 = new PriceDimension();
        this.Dimension1ValueType = null;
        this.Dimension2 = new PriceDimension();
        this.Dimension2ValueType = null;
        this.Dimension3 = new PriceDimension();
        this.Dimension3ValueType = null;
        this.Dimension4 = new PriceDimension();
        this.Dimension4ValueType = null;
        this.Dimension5 = new PriceDimension();
        this.Dimension5ValueType = null;
        this.Dimension6 = new PriceDimension();
        this.Dimension6ValueType = null;
        this.EnableDateRange = null;
        this.InitialRows = null;
        this.IsCumulativeRange = null;
        this.MatrixType = null;
        this.NumberOfEntries = null;
        this.PriceListItemId = null;
        this.Sequence = null;
        this.StopProcessingMoreMatrices = null;
        this.MatrixEntries = null;
    }
};
__decorate([
    AField({
        soql: 'Apttus_Config2__Description__c',
        aql: 'Description'
    }),
    __metadata("design:type", String)
], PriceMatrix.prototype, "Description", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension1Id__r',
        aql: 'Dimension1Id'
    }),
    __metadata("design:type", PriceDimension)
], PriceMatrix.prototype, "Dimension1", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension1ValueType__c',
        aql: 'Dimension1ValueType'
    }),
    __metadata("design:type", String)
], PriceMatrix.prototype, "Dimension1ValueType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension2Id__r',
        aql: 'Dimension2Id'
    }),
    __metadata("design:type", PriceDimension)
], PriceMatrix.prototype, "Dimension2", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension2ValueType__c',
        aql: 'Dimension2ValueType'
    }),
    __metadata("design:type", String)
], PriceMatrix.prototype, "Dimension2ValueType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension3Id__r',
        aql: 'Dimension3Id'
    }),
    __metadata("design:type", PriceDimension)
], PriceMatrix.prototype, "Dimension3", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension3ValueType__c',
        aql: 'Dimension3ValueType'
    }),
    __metadata("design:type", String)
], PriceMatrix.prototype, "Dimension3ValueType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension4Id__r',
        aql: 'Dimension4Id'
    }),
    __metadata("design:type", PriceDimension)
], PriceMatrix.prototype, "Dimension4", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension4ValueType__c',
        aql: 'Dimension4ValueType'
    }),
    __metadata("design:type", String)
], PriceMatrix.prototype, "Dimension4ValueType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension5Id__r',
        aql: 'Dimension5Id'
    }),
    __metadata("design:type", PriceDimension)
], PriceMatrix.prototype, "Dimension5", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension5ValueType__c',
        aql: 'Dimension5ValueType'
    }),
    __metadata("design:type", String)
], PriceMatrix.prototype, "Dimension5ValueType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension6Id__r',
        aql: 'Dimension6Id'
    }),
    __metadata("design:type", PriceDimension)
], PriceMatrix.prototype, "Dimension6", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension6ValueType__c',
        aql: 'Dimension6ValueType'
    }),
    __metadata("design:type", String)
], PriceMatrix.prototype, "Dimension6ValueType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__EnableDateRange__c',
        aql: 'EnableDateRange'
    }),
    __metadata("design:type", Boolean)
], PriceMatrix.prototype, "EnableDateRange", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__InitialRows__c',
        aql: 'InitialRows'
    }),
    __metadata("design:type", Number)
], PriceMatrix.prototype, "InitialRows", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__IsCumulativeRange__c',
        aql: 'IsCumulativeRange'
    }),
    __metadata("design:type", Boolean)
], PriceMatrix.prototype, "IsCumulativeRange", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__MatrixType__c',
        aql: 'MatrixType'
    }),
    __metadata("design:type", String)
], PriceMatrix.prototype, "MatrixType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__NumberOfEntries__c',
        aql: 'NumberOfEntries'
    }),
    __metadata("design:type", Number)
], PriceMatrix.prototype, "NumberOfEntries", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__PriceListItemId__c',
        aql: 'PriceListItemId'
    }),
    __metadata("design:type", String)
], PriceMatrix.prototype, "PriceListItemId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Sequence__c',
        aql: 'Sequence'
    }),
    __metadata("design:type", Number)
], PriceMatrix.prototype, "Sequence", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__StopProcessingMoreMatrices__c',
        aql: 'StopProcessingMoreMatrices'
    }),
    __metadata("design:type", Boolean)
], PriceMatrix.prototype, "StopProcessingMoreMatrices", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__MatrixEntries__r',
    }),
    Type(() => PriceMatrixEntry),
    __metadata("design:type", Array)
], PriceMatrix.prototype, "MatrixEntries", void 0);
PriceMatrix = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__PriceMatrix__c',
        aqlName: 'cpq_PriceMatrix'
    })
], PriceMatrix);
let PriceMatrixEntry = class PriceMatrixEntry extends AObject {
    constructor() {
        super(...arguments);
        this.AdjustmentAmount = null;
        this.AdjustmentType = null;
        this.BandSize = null;
        this.condition = null;
        this.Dimension1Value = null;
        this.Dimension2Value = null;
        this.Dimension3Value = null;
        this.Dimension4Value = null;
        this.Dimension5Value = null;
        this.Dimension6Value = null;
        this.PeriodEndDat = null;
        this.EndFactor = null;
        this.EntryKey = null;
        this.FlatPrice = null;
        this.TierStartValue = null;
        this.PriceMatrixId = null;
        this.PriceOverride = null;
        this.Sequence = null;
        this.PeriodStartDate = null;
        this.StartFactor = null;
        this.TierEndValue = null;
        this.UsageRate = null;
    }
};
__decorate([
    AField({
        soql: 'Apttus_Config2__AdjustmentAmount__c',
        aql: 'AdjustmentAmount'
    }),
    __metadata("design:type", Number)
], PriceMatrixEntry.prototype, "AdjustmentAmount", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__AdjustmentType__c',
        aql: 'AdjustmentType'
    }),
    __metadata("design:type", String)
], PriceMatrixEntry.prototype, "AdjustmentType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__BandSize__c',
        aql: 'BandSize'
    }),
    __metadata("design:type", Number)
], PriceMatrixEntry.prototype, "BandSize", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__condition__c',
        aql: 'Condition'
    }),
    __metadata("design:type", String)
], PriceMatrixEntry.prototype, "condition", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension1Value__c',
        aql: 'Dimension1Value'
    }),
    __metadata("design:type", String)
], PriceMatrixEntry.prototype, "Dimension1Value", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension2Value__c',
        aql: 'Dimension2Value'
    }),
    __metadata("design:type", String)
], PriceMatrixEntry.prototype, "Dimension2Value", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension3Value__c',
        aql: 'Dimension3Value'
    }),
    __metadata("design:type", String)
], PriceMatrixEntry.prototype, "Dimension3Value", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension4Value__c',
        aql: 'Dimension4Value'
    }),
    __metadata("design:type", String)
], PriceMatrixEntry.prototype, "Dimension4Value", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension5Value__c',
        aql: 'Dimension5Value'
    }),
    __metadata("design:type", String)
], PriceMatrixEntry.prototype, "Dimension5Value", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension6Value__c',
        aql: 'Dimension6Value'
    }),
    __metadata("design:type", String)
], PriceMatrixEntry.prototype, "Dimension6Value", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__PeriodEndDate__c',
        aql: 'PeriodEndDate'
    }),
    __metadata("design:type", Date)
], PriceMatrixEntry.prototype, "PeriodEndDat", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__EndFactor__c',
        aql: 'EndFactor'
    }),
    __metadata("design:type", Number)
], PriceMatrixEntry.prototype, "EndFactor", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__EntryKey__c',
        aql: 'EntryKey'
    }),
    __metadata("design:type", String)
], PriceMatrixEntry.prototype, "EntryKey", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__FlatPrice__c',
        aql: 'FlatPrice'
    }),
    __metadata("design:type", Number)
], PriceMatrixEntry.prototype, "FlatPrice", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__TierStartValue__c',
        aql: 'TierStartValue'
    }),
    __metadata("design:type", Number)
], PriceMatrixEntry.prototype, "TierStartValue", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__IsIncluded__c',
        aql: 'IsIncluded'
    }),
    AField({
        soql: 'Apttus_Config2__PriceMatrixId__c',
        aql: 'PriceMatrixId'
    }),
    __metadata("design:type", String)
], PriceMatrixEntry.prototype, "PriceMatrixId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__PriceOverride__c',
        aql: 'PriceOverride'
    }),
    __metadata("design:type", Number)
], PriceMatrixEntry.prototype, "PriceOverride", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Sequence__c',
        aql: 'Sequence'
    }),
    __metadata("design:type", Number)
], PriceMatrixEntry.prototype, "Sequence", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__PeriodStartDate__c',
        aql: 'PeriodStartDate'
    }),
    __metadata("design:type", Date)
], PriceMatrixEntry.prototype, "PeriodStartDate", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__StartFactor__c',
        aql: 'StartFactor'
    }),
    __metadata("design:type", Number)
], PriceMatrixEntry.prototype, "StartFactor", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__TierEndValue__c',
        aql: 'TierEndValue'
    }),
    __metadata("design:type", Number)
], PriceMatrixEntry.prototype, "TierEndValue", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__UsageRate__c',
        aql: 'UsageRate'
    }),
    __metadata("design:type", Number)
], PriceMatrixEntry.prototype, "UsageRate", void 0);
PriceMatrixEntry = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__PriceMatrixEntry__c',
        aqlName: 'cpq_PriceMatrixEntry'
    })
], PriceMatrixEntry);

let TaxCode = class TaxCode extends AObject {
    constructor() {
        super(...arguments);
        this.Code = null;
        this.Description = null;
    }
};
__decorate([
    Expose({ name: 'Apttus_Config2__Code__c' }),
    __metadata("design:type", String)
], TaxCode.prototype, "Code", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Description__c' }),
    __metadata("design:type", String)
], TaxCode.prototype, "Description", void 0);
TaxCode = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__TaxCode__c',
        aqlName: 'cpq_TaxCode'
    })
], TaxCode);

var PriceListItem_1;
let PriceListItem = PriceListItem_1 = class PriceListItem extends AObject {
    constructor() {
        super(...arguments);
        this.ExpirationDate = null;
        this.EffectiveDate = null;
        this.ContractPrice = null;
        this.ListPrice = null;
        this.Active = null;
        this.ProductId = null;
        this.PriceListId = null;
        this.PriceList = null;
        this.PriceUom = null;
        this.PriceMethod = null;
        this.Frequency = null;
        this.ChargeType = null;
        this.PriceType = null;
        this.PriceMatrices = null;
        this.NumberOfMatrices = null;
        this.DefaultSellingTerm = null;
        this.DefaultQuantity = null;
        this.Sequence = null;
        this.Taxable = false;
        this.TaxCodeId = null;
        this.TaxCode = null;
        this.TaxInclusive = false;
    }
};
__decorate([
    Expose({ name: 'Apttus_Config2__ExpirationDate__c' }),
    __metadata("design:type", Date)
], PriceListItem.prototype, "ExpirationDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__EffectiveDate__c' }),
    __metadata("design:type", Date)
], PriceListItem.prototype, "EffectiveDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ContractPrice__c' }),
    __metadata("design:type", Number)
], PriceListItem.prototype, "ContractPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ListPrice__c' }),
    __metadata("design:type", Number)
], PriceListItem.prototype, "ListPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Active__c' }),
    __metadata("design:type", Boolean)
], PriceListItem.prototype, "Active", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductId__c' }),
    __metadata("design:type", String)
], PriceListItem.prototype, "ProductId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceListId__c' }),
    __metadata("design:type", String)
], PriceListItem.prototype, "PriceListId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceListId__r' }),
    Type(() => PriceList),
    __metadata("design:type", PriceList)
], PriceListItem.prototype, "PriceList", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceUom__c' }),
    __metadata("design:type", String)
], PriceListItem.prototype, "PriceUom", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceMethod__c' }),
    __metadata("design:type", String)
], PriceListItem.prototype, "PriceMethod", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Frequency__c'
    }),
    Expose({ name: 'Apttus_Config2__Frequency__c' }),
    __metadata("design:type", String)
], PriceListItem.prototype, "Frequency", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ChargeType__c' }),
    __metadata("design:type", String)
], PriceListItem.prototype, "ChargeType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__PriceType__c'
    }),
    Expose({ name: 'Apttus_Config2__PriceType__c' }),
    __metadata("design:type", String)
], PriceListItem.prototype, "PriceType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceMatrices__r' }),
    Type(() => PriceMatrix),
    __metadata("design:type", Array)
], PriceListItem.prototype, "PriceMatrices", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__NumberOfMatrices__c' }),
    __metadata("design:type", Number)
], PriceListItem.prototype, "NumberOfMatrices", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__DefaultSellingTerm__c' }),
    __metadata("design:type", Number)
], PriceListItem.prototype, "DefaultSellingTerm", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__DefaultQuantity__c' }),
    __metadata("design:type", Number)
], PriceListItem.prototype, "DefaultQuantity", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Sequence__c' }),
    __metadata("design:type", Number)
], PriceListItem.prototype, "Sequence", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Taxable__c' }),
    __metadata("design:type", Boolean)
], PriceListItem.prototype, "Taxable", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__TaxCodeId__c' }),
    __metadata("design:type", String)
], PriceListItem.prototype, "TaxCodeId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__TaxCodeId__r' }),
    Type(() => TaxCode),
    __metadata("design:type", Object)
], PriceListItem.prototype, "TaxCode", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__TaxInclusive__c' }),
    __metadata("design:type", Boolean)
], PriceListItem.prototype, "TaxInclusive", void 0);
PriceListItem = PriceListItem_1 = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__PriceListItem__c',
        aqlName: 'cpq_PriceListItem',
        filter: () => [new AFilter(PriceListItem_1, null, [
                new AFilter(PriceListItem_1, [
                    new ACondition(PriceListItem_1, 'EffectiveDate', 'Null', null),
                    new ACondition(PriceListItem_1, 'EffectiveDate', 'LessEqual', 'Today')
                ], null, 'OR'),
                new AFilter(PriceListItem_1, [
                    new ACondition(PriceListItem_1, 'ExpirationDate', 'Null', null),
                    new ACondition(PriceListItem_1, 'ExpirationDate', 'GreaterThan', 'Today')
                ], null, 'OR')
            ], 'AND')]
    })
], PriceListItem);

let CategoryTranslation = class CategoryTranslation extends AObject {
    constructor() {
        super(...arguments);
        this.CategoryHierarchy = null;
        this.Label = null;
        this.Language = null;
        this.Name = null;
    }
};
__decorate([
    Expose({ name: 'Apttus_Config2__CategoryHierarchy__c' }),
    __metadata("design:type", String)
], CategoryTranslation.prototype, "CategoryHierarchy", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Label__c' }),
    __metadata("design:type", String)
], CategoryTranslation.prototype, "Label", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Language__c' }),
    __metadata("design:type", String)
], CategoryTranslation.prototype, "Language", void 0);
__decorate([
    Expose({ name: 'Name' }),
    __metadata("design:type", String)
], CategoryTranslation.prototype, "Name", void 0);
CategoryTranslation = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__CategoryTranslation__c',
        aqlName: 'cpq_CategoryTranslation'
    })
], CategoryTranslation);

let Category = class Category extends AObject {
    constructor() {
        super(...arguments);
        this.AncestorId = null;
        this.PrimordialId = null;
        this.Description = null;
        this.HierarchyId = null;
        this.IsLeaf = null;
        this.Label = null;
        this.ProductCount = null;
        this.Name = null;
        this.Translation = null;
        this.IsHidden = null;
        this.IncludeInTotalsView = null;
    }
};
__decorate([
    Expose({ name: 'Apttus_Config2__AncestorId__c' }),
    __metadata("design:type", String)
], Category.prototype, "AncestorId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PrimordialId__c' }),
    __metadata("design:type", String)
], Category.prototype, "PrimordialId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Description__c' }),
    __metadata("design:type", String)
], Category.prototype, "Description", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__HierarchyId__c' }),
    __metadata("design:type", String)
], Category.prototype, "HierarchyId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsLeaf__c' }),
    __metadata("design:type", String)
], Category.prototype, "IsLeaf", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Label__c' }),
    __metadata("design:type", String)
], Category.prototype, "Label", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductCount__c' }),
    __metadata("design:type", Number)
], Category.prototype, "ProductCount", void 0);
__decorate([
    Expose({ name: 'Name' }),
    __metadata("design:type", String)
], Category.prototype, "Name", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Translation__r' }),
    Type(() => CategoryTranslation),
    __metadata("design:type", Array)
], Category.prototype, "Translation", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsHidden__c' }),
    __metadata("design:type", Boolean)
], Category.prototype, "IsHidden", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IncludeInTotalsView__c' }),
    __metadata("design:type", Boolean)
], Category.prototype, "IncludeInTotalsView", void 0);
Category = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__ClassificationHierarchy__c',
        aqlName: 'cpq_ClassificationHierarchy',
        route: 'categories'
    })
], Category);

let ProductCategory = class ProductCategory extends AObject {
    constructor() {
        super(...arguments);
        this.ClassificationId = null;
        this.Classification = null;
        this.Default = null;
        this.DefaultQuantity = null;
        this.MaxQuantity = null;
        this.MinQuantity = null;
        this.Sequence = null;
        this.ProductId = null;
    }
};
__decorate([
    AField({
        soql: 'Apttus_Config2__ClassificationId__c',
        aql: 'ClassificationId'
    }),
    __metadata("design:type", String)
], ProductCategory.prototype, "ClassificationId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ClassificationId__r',
        aql: 'ClassificationId',
        expand: 'shallow'
    }),
    Type(() => Category),
    __metadata("design:type", Category)
], ProductCategory.prototype, "Classification", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Default__c'
    }),
    __metadata("design:type", Boolean)
], ProductCategory.prototype, "Default", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__DefaultQuantity__c',
        aql: 'DefaultQuantity'
    }),
    __metadata("design:type", Number)
], ProductCategory.prototype, "DefaultQuantity", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__MaxQuantity__c',
        aql: 'MaxQuantity'
    }),
    __metadata("design:type", Number)
], ProductCategory.prototype, "MaxQuantity", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__MinQuantity__c',
        aql: 'MinQuantity'
    }),
    __metadata("design:type", Number)
], ProductCategory.prototype, "MinQuantity", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Sequence__c',
        aql: 'Sequence'
    }),
    __metadata("design:type", Number)
], ProductCategory.prototype, "Sequence", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductId__c',
        aql: 'ProductId'
    }),
    __metadata("design:type", String)
], ProductCategory.prototype, "ProductId", void 0);
ProductCategory = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__ProductClassification__c',
        aqlName: 'cpq_ProductClassification'
    })
], ProductCategory);

let ProductTranslation = class ProductTranslation extends AObject {
    constructor() {
        super(...arguments);
        this.Description = null;
        this.Family = null;
        this.Language = null;
        this.Name = null;
        this.ProductId = null;
        this.ProductCode = null;
    }
};
__decorate([
    Expose({ name: 'Apttus_Config2__Description__c' }),
    __metadata("design:type", String)
], ProductTranslation.prototype, "Description", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Family__c' }),
    __metadata("design:type", String)
], ProductTranslation.prototype, "Family", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Language__c' }),
    __metadata("design:type", String)
], ProductTranslation.prototype, "Language", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Name__c' }),
    __metadata("design:type", String)
], ProductTranslation.prototype, "Name", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductId__c' }),
    __metadata("design:type", String)
], ProductTranslation.prototype, "ProductId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductCode__c' }),
    __metadata("design:type", String)
], ProductTranslation.prototype, "ProductCode", void 0);
ProductTranslation = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__ProductTranslation__c',
        aqlName: 'cpq_ProductTranslation'
    })
], ProductTranslation);

let AttributeGroupTranslation = class AttributeGroupTranslation extends AObject {
    constructor() {
        super(...arguments);
        this.Language = null;
        this.Name = null;
        this.ProductAttributeGroupId = null;
    }
};
__decorate([
    Expose({ name: 'Apttus_Config2__Language__c' }),
    __metadata("design:type", String)
], AttributeGroupTranslation.prototype, "Language", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Name__c' }),
    __metadata("design:type", String)
], AttributeGroupTranslation.prototype, "Name", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductAttributeGroupId__c' }),
    __metadata("design:type", String)
], AttributeGroupTranslation.prototype, "ProductAttributeGroupId", void 0);
AttributeGroupTranslation = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__AttributeGroupTranslation__c',
        aqlName: 'cpq_AttributeGroupTranslation'
    })
], AttributeGroupTranslation);

let AttributeValueMatrix = class AttributeValueMatrix extends AObject {
    constructor() {
        super(...arguments);
        this.AccountScope = null;
        this.AccountScopeOper = null;
        this.Active = null;
        this.ApplicationType = null;
        this.DefaultProductAttributeScopeId = null;
        // @AField({
        //     soql: 'Apttus_Config2__DefaultProductAttributeScopeId__r',
        //     aql: 'DefaultProductAttributeScopeId'
        // })
        // ProductAttributeGroup = new ProductAttributeGroup();
        this.Description = null;
        this.EffectiveDate = null;
        this.ExpirationDate = null;
        this.ProductFamilyScope = null;
        this.ProductFamilyScopeOper = null;
        this.ProductGroupScope = null;
        this.ProductGroupScopeOper = null;
        this.ProductScope = null;
        this.ProductScopeOper = null;
        this.TreatNullAsWildcard = null;
    }
};
__decorate([
    Expose({ name: 'Apttus_Config2__AccountScope__c' }),
    __metadata("design:type", String)
], AttributeValueMatrix.prototype, "AccountScope", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AccountScopeOper__c' }),
    __metadata("design:type", String)
], AttributeValueMatrix.prototype, "AccountScopeOper", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Active__c' }),
    __metadata("design:type", Boolean)
], AttributeValueMatrix.prototype, "Active", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ApplicationType__c' }),
    __metadata("design:type", String)
], AttributeValueMatrix.prototype, "ApplicationType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__DefaultProductAttributeScopeId__c' }),
    __metadata("design:type", String)
], AttributeValueMatrix.prototype, "DefaultProductAttributeScopeId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Description__c' }),
    __metadata("design:type", String)
], AttributeValueMatrix.prototype, "Description", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__EffectiveDate__c' }),
    __metadata("design:type", Date)
], AttributeValueMatrix.prototype, "EffectiveDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ExpirationDate__c' }),
    __metadata("design:type", Date)
], AttributeValueMatrix.prototype, "ExpirationDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductFamilyScope__c' }),
    __metadata("design:type", String)
], AttributeValueMatrix.prototype, "ProductFamilyScope", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductFamilyScopeOper__c' }),
    __metadata("design:type", String)
], AttributeValueMatrix.prototype, "ProductFamilyScopeOper", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductGroupScope__c' }),
    __metadata("design:type", String)
], AttributeValueMatrix.prototype, "ProductGroupScope", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductGroupScopeOper__c' }),
    __metadata("design:type", String)
], AttributeValueMatrix.prototype, "ProductGroupScopeOper", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductScope__c' }),
    __metadata("design:type", String)
], AttributeValueMatrix.prototype, "ProductScope", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductScopeOper__c' }),
    __metadata("design:type", String)
], AttributeValueMatrix.prototype, "ProductScopeOper", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__TreatNullAsWildcard__c' }),
    __metadata("design:type", Boolean)
], AttributeValueMatrix.prototype, "TreatNullAsWildcard", void 0);
AttributeValueMatrix = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__AttributeValueMatrix__c',
        aqlName: 'cpq_AttributeValueMatrix'
    })
], AttributeValueMatrix);
let AttributeValueMatrixEntry = class AttributeValueMatrixEntry extends AObject {
    constructor() {
        super(...arguments);
        this.AttributeValueMatrixId = null;
        // @AField({
        //     soql: 'Apttus_Config2__AttributeValueMatrixId__r',
        //     aql: 'AttributeValueMatrixId'
        // })
        // AttributeValueMatrix = new AttributeValueMatrix();
        this.Color = null;
        this.Vendor = null;
    }
};
__decorate([
    Expose({ name: 'Apttus_Config2__AttributeValueMatrixId__c' }),
    __metadata("design:type", String)
], AttributeValueMatrixEntry.prototype, "AttributeValueMatrixId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Color__c' }),
    __metadata("design:type", String)
], AttributeValueMatrixEntry.prototype, "Color", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Vendor__c' }),
    __metadata("design:type", String)
], AttributeValueMatrixEntry.prototype, "Vendor", void 0);
AttributeValueMatrixEntry = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__AttributeValueMatrixEntry__c',
        aqlName: 'cpq_AttributeValueMatrixEntry'
    })
], AttributeValueMatrixEntry);

let ProductAttributeMatrixView = class ProductAttributeMatrixView extends AObject {
    constructor() {
        super(...arguments);
        this.Active = null;
        this.AttributeValueMatrixId = null;
        this.AttributeValueMatrix = null;
        this.Columns = null;
        this.Hash = null;
        this.Keys = null;
        this.ProductId = null;
        this.ProductAttributeScopeId = null;
    }
};
__decorate([
    Expose({ name: 'Apttus_Config2__Active__c' }),
    __metadata("design:type", Boolean)
], ProductAttributeMatrixView.prototype, "Active", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AttributeValueMatrixId__c' }),
    __metadata("design:type", String)
], ProductAttributeMatrixView.prototype, "AttributeValueMatrixId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AttributeValueMatrixId__r' }),
    Type(() => AttributeValueMatrix),
    __metadata("design:type", AttributeValueMatrix)
], ProductAttributeMatrixView.prototype, "AttributeValueMatrix", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Columns__c' }),
    __metadata("design:type", String)
], ProductAttributeMatrixView.prototype, "Columns", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Hash__c' }),
    __metadata("design:type", String)
], ProductAttributeMatrixView.prototype, "Hash", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Keys__c' }),
    __metadata("design:type", String)
], ProductAttributeMatrixView.prototype, "Keys", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductId__c' }),
    __metadata("design:type", String)
], ProductAttributeMatrixView.prototype, "ProductId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductAttributeScope__c' }),
    __metadata("design:type", String)
], ProductAttributeMatrixView.prototype, "ProductAttributeScopeId", void 0);
ProductAttributeMatrixView = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__ProductAttributeMatrixView__c',
        aqlName: 'cpq_ProductAttributeMatrixView'
    })
], ProductAttributeMatrixView);

let ProductAttributeGroup = class ProductAttributeGroup extends AObject {
    constructor() {
        super(...arguments);
        this.Name = null;
        this.AttributeValueMatrixId = null;
        this.BusinessObject = null;
        this.Description = null;
        this.TwoColumnAttributeDisplay = null;
        this.ThreeColumnAttributeDisplay = null;
        this.Attributes = null;
        this.Translation = null;
        this.ProductAttributeMatrixes = null;
    }
};
__decorate([
    Expose({ name: 'Name' }),
    __metadata("design:type", String)
], ProductAttributeGroup.prototype, "Name", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AttributeValueMatrixId__c' }),
    __metadata("design:type", String)
], ProductAttributeGroup.prototype, "AttributeValueMatrixId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BusinessObject__c' }),
    __metadata("design:type", String)
], ProductAttributeGroup.prototype, "BusinessObject", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Description__c' }),
    __metadata("design:type", String)
], ProductAttributeGroup.prototype, "Description", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__TwoColumnAttributeDisplay__c' }),
    __metadata("design:type", Boolean)
], ProductAttributeGroup.prototype, "TwoColumnAttributeDisplay", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ThreeColumnAttributeDisplay__c' }),
    __metadata("design:type", Boolean)
], ProductAttributeGroup.prototype, "ThreeColumnAttributeDisplay", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Attributes__r' }),
    Type(() => ProductAttribute),
    __metadata("design:type", Array)
], ProductAttributeGroup.prototype, "Attributes", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Translation__r' }),
    Type(() => AttributeGroupTranslation),
    __metadata("design:type", Array)
], ProductAttributeGroup.prototype, "Translation", void 0);
__decorate([
    Expose({ name: 'ProductAttributeMatrixViews' }),
    Type(() => ProductAttributeMatrixView),
    __metadata("design:type", Array)
], ProductAttributeGroup.prototype, "ProductAttributeMatrixes", void 0);
ProductAttributeGroup = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__ProductAttributeGroup__c',
        aqlName: 'cpq_ProductAttributeGroup'
    })
], ProductAttributeGroup);

let ProductAttributeGroupMember = class ProductAttributeGroupMember extends AObject {
    constructor() {
        super(...arguments);
        this.AttributeGroup = new ProductAttributeGroup();
        this.FieldUpdateCriteriaIds = null;
        this.ProductId = null;
        this.Sequence = null;
    }
};
__decorate([
    Expose({ name: 'Apttus_Config2__AttributeGroupId__c' }),
    __metadata("design:type", String)
], ProductAttributeGroupMember.prototype, "AttributeGroupId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AttributeGroupId__r' }),
    Type(() => ProductAttributeGroup),
    __metadata("design:type", ProductAttributeGroup)
], ProductAttributeGroupMember.prototype, "AttributeGroup", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__FieldUpdateCriteriaIds__c' }),
    __metadata("design:type", String)
], ProductAttributeGroupMember.prototype, "FieldUpdateCriteriaIds", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductId__c' }),
    __metadata("design:type", String)
], ProductAttributeGroupMember.prototype, "ProductId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Sequence__c' }),
    __metadata("design:type", Number)
], ProductAttributeGroupMember.prototype, "Sequence", void 0);
ProductAttributeGroupMember = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__ProductAttributeGroupMember__c',
        aqlName: 'cpq_ProductAttributeGroupMember'
    })
], ProductAttributeGroupMember);

let FeatureSet = class FeatureSet extends AObject {
    constructor() {
        super(...arguments);
        this.Name = null;
        this.Description = null;
        this.Sequence = null;
    }
};
__decorate([
    Expose({ name: 'Name' }),
    __metadata("design:type", String)
], FeatureSet.prototype, "Name", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Description__c' }),
    __metadata("design:type", String)
], FeatureSet.prototype, "Description", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Sequence__c' }),
    __metadata("design:type", Number)
], FeatureSet.prototype, "Sequence", void 0);
FeatureSet = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__FeatureSet__c',
        aqlName: 'cpq_FeatureSet'
    })
], FeatureSet);
let Feature = class Feature extends AObject {
    constructor() {
        super(...arguments);
        this.Name = null;
        this.Description = null;
        this.FeatureSet = new FeatureSet();
        this.Sequence = null;
        this.FeatureSetId = null;
    }
};
__decorate([
    Expose({ name: 'Name' }),
    __metadata("design:type", String)
], Feature.prototype, "Name", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Description__c' }),
    __metadata("design:type", String)
], Feature.prototype, "Description", void 0);
__decorate([
    Type(() => FeatureSet),
    Expose({ name: 'Apttus_Config2__FeatureSetId__r' }),
    __metadata("design:type", FeatureSet)
], Feature.prototype, "FeatureSet", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Sequence__c' }),
    __metadata("design:type", Number)
], Feature.prototype, "Sequence", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__FeatureSetId__c' }),
    __metadata("design:type", String)
], Feature.prototype, "FeatureSetId", void 0);
Feature = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__Feature__c',
        aqlName: 'cpq_Feature'
    })
], Feature);
let ProductFeatureValue = class ProductFeatureValue extends AObject {
    constructor() {
        super(...arguments);
        this.Value = null;
        this.ProductId = null;
        this.IsIncluded = null;
        this.Feature = new Feature();
    }
};
__decorate([
    Expose({ name: 'Apttus_Config2__Value__c' }),
    __metadata("design:type", String)
], ProductFeatureValue.prototype, "Value", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductId__c' }),
    __metadata("design:type", String)
], ProductFeatureValue.prototype, "ProductId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsIncluded__c' }),
    __metadata("design:type", Boolean)
], ProductFeatureValue.prototype, "IsIncluded", void 0);
__decorate([
    Type(() => Feature),
    Expose({ name: 'Apttus_Config2__FeatureId__r' }),
    __metadata("design:type", Feature)
], ProductFeatureValue.prototype, "Feature", void 0);
ProductFeatureValue = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__ProductFeatureValue__c',
        aqlName: 'cpq_ProductFeatureValue'
    })
], ProductFeatureValue);

let ProductGroup = class ProductGroup extends AObject {
    constructor() {
        super(...arguments);
        this.Name = null;
        this.Description = null;
        this.GroupType = null;
        this.IncentiveId = null;
    }
};
__decorate([
    Expose({ name: 'Name' }),
    __metadata("design:type", String)
], ProductGroup.prototype, "Name", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Description__c' }),
    __metadata("design:type", String)
], ProductGroup.prototype, "Description", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__GroupType__c' }),
    __metadata("design:type", String)
], ProductGroup.prototype, "GroupType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IncentiveId__c' }),
    __metadata("design:type", String)
], ProductGroup.prototype, "IncentiveId", void 0);
ProductGroup = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__ProductGroup__c',
        aqlName: 'cpq_ProductGroup'
    })
], ProductGroup);
let ProductGroupMember = class ProductGroupMember extends AObject {
    constructor() {
        super(...arguments);
        this.ProductId = null;
        this.ProductGroupId = null;
        this.ProductGroup = new ProductGroup();
        this.Ratio = null;
        this.Sequence = null;
    }
};
__decorate([
    Expose({ name: 'Apttus_Config2__ProductId__c' }),
    __metadata("design:type", String)
], ProductGroupMember.prototype, "ProductId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductGroupId__c' }),
    __metadata("design:type", String)
], ProductGroupMember.prototype, "ProductGroupId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductGroupId__r' }),
    __metadata("design:type", ProductGroup)
], ProductGroupMember.prototype, "ProductGroup", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Ratio__c' }),
    __metadata("design:type", String)
], ProductGroupMember.prototype, "Ratio", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Sequence__c' }),
    __metadata("design:type", String)
], ProductGroupMember.prototype, "Sequence", void 0);
ProductGroupMember = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__ProductGroupMember__c',
        aqlName: 'cpq_ProductGroupMember'
    })
], ProductGroupMember);

let AssetAttributeValue = class AssetAttributeValue extends AObject {
    constructor() {
        super(...arguments);
        this.LineItemId = null;
    }
};
__decorate([
    AField({
        soql: 'Apttus_Config2__AssetLineItemId__c',
        aql: 'LineItemId'
    }),
    __metadata("design:type", String)
], AssetAttributeValue.prototype, "LineItemId", void 0);
AssetAttributeValue = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__AssetAttributeValue__c',
        aqlName: 'cpq_AssetAttributeValue',
        dynamic: true
    })
], AssetAttributeValue);

/** @ignore  */
const _moment$6 = moment;
let AssetLineItem = class AssetLineItem extends AObject {
    constructor() {
        super(...arguments);
        this.AdjustedPrice = null;
        this.AllowedActions = null;
        this.AssetARR = null;
        this.AssetCode = null;
        this.AssetMRR = null;
        this.AssetNumber = null;
        this.AssetStatus = null;
        this.AutoRenew = null;
        this.AutoRenewalType = null;
        this.AvailableBalance = null;
        this.BaseCost = null;
        this.BaseExtendedCost = null;
        this.BaseExtendedPrice = null;
        this.BasePrice = null;
        this.BasePriceMethod = null;
        this.BillingEndDate = null;
        this.BillingFrequency = null;
        this.BillingStartDate = null;
        this.BillThroughDate = null;
        this.BillToAccountId = null;
        this.BundleAssetId = null;
        this.BusinessLineItemId = null;
        this.BusinessObjectId = null;
        this.BusinessObjectType = null;
        this.CancelledDate = null;
        this.ChargeType = null;
        this.Comments = null;
        this.DeltaPrice = null;
        this.DeltaQuantity = null;
        this.Description = null;
        this.EndDate = null;
        this.ExtendedCost = null;
        this.ExtendedDescription = null;
        this.ExtendedPrice = null;
        this.HasAttributes = null;
        this.HasOptions = null;
        this.HideInvoiceDisplay = null;
        this.IsInactive = null;
        this.InitialActivationDate = null;
        this.IsOptionRollupLine = null;
        this.IsPrimaryLine = null;
        this.IsPrimaryRampLine = null;
        this.IsPrimaryService = null;
        this.IsReadOnly = null;
        this.IsRenewalPending = null;
        this.IsRenewed = null;
        this.IsUsageTierModifiable = null;
        this.ItemSequence = null;
        this.LastRenewEndDate = null;
        this.LineNumber = null;
        this.LineType = null;
        this.ListPrice = null;
        this.MaxUsageQuantity = null;
        this.MinUsageQuantity = null;
        this.MustUpgrade = null;
        this.Name = null;
        this.NetPrice = null;
        this.NetUnitPrice = null;
        this.NextRenewEndDate = null;
        this.OptionId = null;
        this.OptionCost = null;
        this.OptionPrice = null;
        this.OriginalStartDate = null;
        this.ParentAssetId = null;
        this.ParentBundleNumber = null;
        this.PriceGroup = null;
        this.PriceIncludedInBundle = null;
        this.PriceListId = null;
        this.PriceListItemId = null;
        this.PriceMethod = null;
        this.PriceType = null;
        this.PricingDate = null;
        this.Frequency = null;
        this.Term = null;
        this.PriceUom = null;
        this.PrimaryLineNumber = null;
        this.ProductId = null;
        this.ProductType = null;
        this.PurchaseDate = null;
        this.Quantity = null;
        this.RenewalAdjustmentAmount = null;
        this.RenewalAdjustmentType = null;
        this.RenewalDate = null;
        this.RenewalFrequency = null;
        this.RenewalTerm = null;
        this.SellingFrequency = null;
        this.SellingTerm = null;
        this.SellingUom = null;
        this.ShipToAccountId = null;
        this.AccountId = null;
        this.StartDate = null;
    }
    get DaysToRenew() {
        if (this.PriceType && this.PriceType === 'Recurring') {
            let endDate = _moment$6(this.EndDate);
            // need to consider end date too so using + 1 to calculate the value
            return endDate.diff(_moment$6(), 'days') + 1;
        }
        else {
            return null;
        }
    }
};
__decorate([
    Expose({ name: 'Apttus_Config2__AdjustedPrice__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "AdjustedPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AllowedActions__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "AllowedActions", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AssetARR__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "AssetARR", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AssetCode__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "AssetCode", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AssetMRR__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "AssetMRR", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AssetNumber__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "AssetNumber", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AssetStatus__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "AssetStatus", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AutoRenew__c' }),
    __metadata("design:type", Boolean)
], AssetLineItem.prototype, "AutoRenew", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AutoRenewalType__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "AutoRenewalType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AvailableBalance__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "AvailableBalance", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BaseCost__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "BaseCost", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BaseExtendedCost__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "BaseExtendedCost", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BaseExtendedPrice__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "BaseExtendedPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BasePrice__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "BasePrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BasePriceMethod__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "BasePriceMethod", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BillingEndDate__c' }),
    __metadata("design:type", Date)
], AssetLineItem.prototype, "BillingEndDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BillingFrequency__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "BillingFrequency", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BillingStartDate__c' }),
    __metadata("design:type", Date)
], AssetLineItem.prototype, "BillingStartDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BillThroughDate__c' }),
    __metadata("design:type", Date)
], AssetLineItem.prototype, "BillThroughDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BillToAccountId__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "BillToAccountId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BundleAssetId__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "BundleAssetId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BusinessLineItemId__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "BusinessLineItemId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BusinessObjectId__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "BusinessObjectId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BusinessObjectType__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "BusinessObjectType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__CancelledDate__c' }),
    __metadata("design:type", Date)
], AssetLineItem.prototype, "CancelledDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ChargeType__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "ChargeType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Comments__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "Comments", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__DeltaPrice__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "DeltaPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__DeltaQuantity__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "DeltaQuantity", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Description__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "Description", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__EndDate__c' }),
    __metadata("design:type", Date)
], AssetLineItem.prototype, "EndDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ExtendedCost__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "ExtendedCost", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ExtendedDescription__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "ExtendedDescription", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ExtendedPrice__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "ExtendedPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__HasAttributes__c' }),
    __metadata("design:type", Boolean)
], AssetLineItem.prototype, "HasAttributes", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__HasOptions__c' }),
    __metadata("design:type", Boolean)
], AssetLineItem.prototype, "HasOptions", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__HideInvoiceDisplay__c' }),
    __metadata("design:type", Boolean)
], AssetLineItem.prototype, "HideInvoiceDisplay", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsInactive__c' }),
    __metadata("design:type", Boolean)
], AssetLineItem.prototype, "IsInactive", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__InitialActivationDate__c' }),
    __metadata("design:type", Date)
], AssetLineItem.prototype, "InitialActivationDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsOptionRollupLine__c' }),
    __metadata("design:type", Boolean)
], AssetLineItem.prototype, "IsOptionRollupLine", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsPrimaryLine__c' }),
    __metadata("design:type", Boolean)
], AssetLineItem.prototype, "IsPrimaryLine", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsPrimaryRampLine__c' }),
    __metadata("design:type", Boolean)
], AssetLineItem.prototype, "IsPrimaryRampLine", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsPrimaryService__c' }),
    __metadata("design:type", Boolean)
], AssetLineItem.prototype, "IsPrimaryService", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsReadOnly__c' }),
    __metadata("design:type", Boolean)
], AssetLineItem.prototype, "IsReadOnly", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsRenewalPending__c' }),
    __metadata("design:type", Boolean)
], AssetLineItem.prototype, "IsRenewalPending", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsRenewed__c' }),
    __metadata("design:type", Boolean)
], AssetLineItem.prototype, "IsRenewed", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsUsageTierModifiable__c' }),
    __metadata("design:type", Boolean)
], AssetLineItem.prototype, "IsUsageTierModifiable", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ItemSequence__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "ItemSequence", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__LastRenewEndDate__c' }),
    __metadata("design:type", Date)
], AssetLineItem.prototype, "LastRenewEndDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__LineNumber__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "LineNumber", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__LineType__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "LineType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ListPrice__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "ListPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__MaxUsageQuantity__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "MaxUsageQuantity", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__MinUsageQuantity__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "MinUsageQuantity", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__MustUpgrade__c' }),
    __metadata("design:type", Boolean)
], AssetLineItem.prototype, "MustUpgrade", void 0);
__decorate([
    Expose({ name: 'Name' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "Name", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__NetPrice__c',
        aggregate: ['SUM']
    }),
    Expose({ name: 'Apttus_Config2__NetPrice__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "NetPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__NetUnitPrice__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "NetUnitPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__NextRenewEndDate__c' }),
    __metadata("design:type", Date)
], AssetLineItem.prototype, "NextRenewEndDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__OptionId__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "OptionId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__OptionCost__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "OptionCost", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__OptionPrice__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "OptionPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__OriginalStartDate__c' }),
    __metadata("design:type", Date)
], AssetLineItem.prototype, "OriginalStartDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ParentAssetId__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "ParentAssetId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ParentBundleNumber__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "ParentBundleNumber", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceGroup__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "PriceGroup", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceIncludedInBundle__c' }),
    __metadata("design:type", Boolean)
], AssetLineItem.prototype, "PriceIncludedInBundle", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceListId__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "PriceListId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceListItemId__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "PriceListItemId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceMethod__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "PriceMethod", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceType__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "PriceType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PricingDate__c' }),
    __metadata("design:type", Date)
], AssetLineItem.prototype, "PricingDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Frequency__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "Frequency", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Term__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "Term", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceUom__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "PriceUom", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PrimaryLineNumber__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "PrimaryLineNumber", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductId__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "ProductId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductType__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "ProductType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PurchaseDate__c' }),
    __metadata("design:type", Date)
], AssetLineItem.prototype, "PurchaseDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Quantity__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "Quantity", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__RenewalAdjustmentAmount__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "RenewalAdjustmentAmount", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__RenewalAdjustmentType__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "RenewalAdjustmentType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__RenewalDate__c' }),
    __metadata("design:type", Date)
], AssetLineItem.prototype, "RenewalDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__RenewalFrequency__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "RenewalFrequency", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__RenewalTerm__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "RenewalTerm", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__SellingFrequency__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "SellingFrequency", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__SellingTerm__c' }),
    __metadata("design:type", Number)
], AssetLineItem.prototype, "SellingTerm", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__SellingUom__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "SellingUom", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ShipToAccountId__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "ShipToAccountId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AccountId__c' }),
    __metadata("design:type", String)
], AssetLineItem.prototype, "AccountId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__StartDate__c' }),
    __metadata("design:type", Date)
], AssetLineItem.prototype, "StartDate", void 0);
AssetLineItem = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__AssetLineItem__c',
        aqlName: 'cpq_AssetLineItem'
    })
], AssetLineItem);
let AssetLineItemExtended = class AssetLineItemExtended extends AssetLineItem {
    constructor() {
        super(...arguments);
        this.AttributeValueId = null;
        this.AttributeValue = null;
        this.PriceListItem = null;
        this.Product = new Product();
    }
    /**
     * check if secondary charge type has recurring or usage price type
     * @returns true if there is no recurring or usage price type
     */
    onlyHasOneTimePriceType(childRecords) {
        let mainAsset = this;
        let childRecordAssetArray = get(childRecords, mainAsset.Id);
        let selectedAsset = filter(childRecordAssetArray, (asset) => asset.BundleAssetId === mainAsset.Id && asset.LineType !== 'Option' && (asset.PriceType === 'Recurring' || asset.PriceType === 'Usage'));
        return this.PriceType === 'One Time'
            && selectedAsset.length === 0;
    }
    canRenew(childRecords) {
        return this.IsPrimaryLine && !this.onlyHasOneTimePriceType(childRecords) && !this.IsInactive;
    }
    canTerminate(childRecords) {
        return this.IsPrimaryLine && !this.onlyHasOneTimePriceType(childRecords) && !this.IsInactive;
    }
    canBuyMore() {
        return this.Product.ConfigurationType !== 'Bundle';
    }
    canChangeConfiguration() {
        return (this.Product.ConfigurationType === 'Bundle' || this.Product.HasAttributes) && this.AssetStatus !== 'Cancelled' && this.PriceType !== 'One Time';
    }
};
__decorate([
    Expose({ name: 'Apttus_Config2__AttributeValueId__c' }),
    __metadata("design:type", String)
], AssetLineItemExtended.prototype, "AttributeValueId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AttributeValueId__r' }),
    Type(() => AssetAttributeValue),
    __metadata("design:type", AssetAttributeValue)
], AssetLineItemExtended.prototype, "AttributeValue", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceListItemId__r' }),
    Type(() => PriceListItem),
    __metadata("design:type", PriceListItem)
], AssetLineItemExtended.prototype, "PriceListItem", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductId__r' }),
    Type(() => Product),
    __metadata("design:type", Object)
], AssetLineItemExtended.prototype, "Product", void 0);
AssetLineItemExtended = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__AssetLineItem__c',
        aqlName: 'cpq_AssetLineItem'
    })
], AssetLineItemExtended);

/** Enum contains line status  */
var LineStatus;
(function (LineStatus) {
    LineStatus["New"] = "New";
    LineStatus["Existing"] = "Existing";
    LineStatus["Renew"] = "Renewed";
    LineStatus["Cancel"] = "Cancelled";
    LineStatus["Increment"] = "Incremented";
    LineStatus["Amend"] = "Amended";
    LineStatus["Upgrade"] = "Upgraded";
    LineStatus["Activate"] = "Activated";
})(LineStatus || (LineStatus = {}));

/** Enum contains Cart error message  */
var CartError;
(function (CartError) {
    CartError["TOO_MANY_ATTEMPTS"] = "CART.TOO_MANY_ATTEMPTS";
    CartError["SERVER_ERROR"] = "CART.SERVER_ERROR";
    CartError["CLIENT_PRICE_INVALID"] = "CART.CLIENT_PRICE_INVALID";
})(CartError || (CartError = {}));

let ProductOptionGroup = class ProductOptionGroup extends AObject {
    constructor() {
        super(...arguments);
        this.Name = null;
        this.ContentType = null;
        this.Sequence = null;
        this.Options = null;
        this.OptionGroupId = null;
        this.OptionGroup = null;
        this.DetailPage = null;
        this.IsHidden = null;
        this.IsLeaf = null;
        this.IsPicklist = null;
        this.Left = null;
        this.Level = null;
        this.MaxOptions = null;
        this.MaxTotalQuantity = null;
        this.MaxTotalQuantityExpressionId = null;
        this.MinOptions = null;
        this.MinTotalQuantity = null;
        this.MinTotalQuantityExpressionId = null;
        this.ModifiableType = null;
        this.ParentOptionGroupId = null;
        this.ProductId = null;
        this.ProductAttributeGroupMemberId = null;
        this.Right = null;
        this.RootOptionGroupId = null;
        this.RootSequence = null;
    }
    validate() {
        this.clearError();
        const options = compact(map(get(this, 'Options'), o => get(o, 'ComponentProduct').get('item')));
        const total = sumBy(options, 'Quantity');
        // Validate Max quantity
        if (!get(this, 'IsHidden')) {
            const reference = { key: this.Id, value: this.Name };
            let childErrors = [];
            forEach(get(this, 'ChildOptionGroups'), g => {
                childErrors = concat(childErrors, g.errors);
            });
            if (!isEmpty(compact(childErrors)))
                this.setError('ERROR.OPTION_GROUP.ERROR', null, 'error', childErrors, reference);
            if (!isNil(get(this, 'MaxTotalQuantity')) && total > this.MaxTotalQuantity)
                this.setError('ERROR.OPTION_GROUP.MAX_TOTAL_QUANTITY', { value: this.MaxTotalQuantity }, 'error', null, reference);
            // Validate Max Quantity
            if (!isNil(get(this, 'MinTotalQuantity')) && total < this.MinTotalQuantity)
                this.setError('ERROR.OPTION_GROUP.MIN_TOTAL_QUANTITY', { value: this.MinTotalQuantity }, 'error', null, reference);
            // Validate min options
            if (!isNil(get(this, 'MinOptions')) && get(options, 'length', 0) < this.MinOptions)
                this.setError('ERROR.OPTION_GROUP.MIN_OPTIONS', { value: this.MinOptions }, 'error', null, reference);
            // Validate max options
            if (!isNil(get(this, 'MaxOptions')) && get(options, 'length', 0) > this.MaxOptions)
                this.setError('ERROR.OPTION_GROUP.MAX_OPTIONS', { value: this.MaxOptions }, 'error', null, reference);
            // Validate Required options
            let requiredProdOptionCom = filter(this.Options, (o) => o.Required);
            if (some(requiredProdOptionCom, (reqCom) => !(!isNil(get(reqCom, 'ComponentProduct._metadata.item')) && get(reqCom, 'ComponentProduct._metadata.item.LineStatus') !== LineStatus.Cancel))) {
                let prodMissing = Array();
                forEach(requiredProdOptionCom, (reqCom) => {
                    if (!(!isNil(get(reqCom, 'ComponentProduct._metadata.item')) && get(reqCom, 'ComponentProduct._metadata.item.LineStatus') !== LineStatus.Cancel))
                        prodMissing.push(get(reqCom, 'ComponentProduct.Name'));
                });
                this.setError('ERROR.OPTION_GROUP.REQUIRED_OPTION_MISSING', { value: prodMissing.toString() }, 'error', null, reference);
            }
        }
    }
};
__decorate([
    Expose({ name: 'Name' }),
    __metadata("design:type", String)
], ProductOptionGroup.prototype, "Name", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ContentType__c' }),
    __metadata("design:type", String)
], ProductOptionGroup.prototype, "ContentType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Sequence__c' }),
    __metadata("design:type", Number)
], ProductOptionGroup.prototype, "Sequence", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Options__r' }),
    Type(() => ProductOptionComponent),
    __metadata("design:type", Array)
], ProductOptionGroup.prototype, "Options", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__OptionGroupId__c' }),
    __metadata("design:type", String)
], ProductOptionGroup.prototype, "OptionGroupId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__OptionGroupId__r' }),
    Type(() => Category),
    __metadata("design:type", Category)
], ProductOptionGroup.prototype, "OptionGroup", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__DetailPage__c' }),
    __metadata("design:type", String)
], ProductOptionGroup.prototype, "DetailPage", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsHidden__c' }),
    __metadata("design:type", Boolean)
], ProductOptionGroup.prototype, "IsHidden", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsLeaf__c' }),
    __metadata("design:type", Boolean)
], ProductOptionGroup.prototype, "IsLeaf", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsPicklist__c' }),
    __metadata("design:type", Boolean)
], ProductOptionGroup.prototype, "IsPicklist", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Left__c' }),
    __metadata("design:type", Number)
], ProductOptionGroup.prototype, "Left", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Level__c' }),
    __metadata("design:type", Number)
], ProductOptionGroup.prototype, "Level", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__MaxOptions__c' }),
    __metadata("design:type", Number)
], ProductOptionGroup.prototype, "MaxOptions", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__MaxTotalQuantity__c' }),
    __metadata("design:type", Number)
], ProductOptionGroup.prototype, "MaxTotalQuantity", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__MaxTotalQuantityExpressionId__c' }),
    __metadata("design:type", String)
], ProductOptionGroup.prototype, "MaxTotalQuantityExpressionId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__MinOptions__c' }),
    __metadata("design:type", Number)
], ProductOptionGroup.prototype, "MinOptions", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__MinTotalQuantity__c' }),
    __metadata("design:type", Number)
], ProductOptionGroup.prototype, "MinTotalQuantity", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__MinTotalQuantityExpressionId__c' }),
    __metadata("design:type", String)
], ProductOptionGroup.prototype, "MinTotalQuantityExpressionId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ModifiableType__c' }),
    __metadata("design:type", String)
], ProductOptionGroup.prototype, "ModifiableType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ParentOptionGroupId__c' }),
    __metadata("design:type", String)
], ProductOptionGroup.prototype, "ParentOptionGroupId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductId__c' }),
    __metadata("design:type", String)
], ProductOptionGroup.prototype, "ProductId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductAttributeGroupMemberId__c' }),
    __metadata("design:type", String)
], ProductOptionGroup.prototype, "ProductAttributeGroupMemberId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Right__c' }),
    __metadata("design:type", Number)
], ProductOptionGroup.prototype, "Right", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__RootOptionGroupId__c' }),
    __metadata("design:type", String)
], ProductOptionGroup.prototype, "RootOptionGroupId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__RootSequence__c' }),
    __metadata("design:type", Number)
], ProductOptionGroup.prototype, "RootSequence", void 0);
ProductOptionGroup = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__ProductOptionGroup__c',
        aqlName: 'cpq_ProductOptionGroup'
    })
], ProductOptionGroup);
let ProductOptionComponent = class ProductOptionComponent extends AObject {
    constructor() {
        super(...arguments);
        this.Name = null;
        this.ParentProductId = null;
        this.ComponentProductId = null;
        this.ProductOptionGroupId = null;
        this.ProductOptionGroup = null;
        this.MinQuantity = null;
        this.AllowCloning = null;
        this.AutoUpdateQuantity = null;
        this.ConfigType = null;
        this.Default = null;
        this.DefaultQuantity = null;
        this.DefaultQuantityExpressionId = null;
        this.InclusionCriteria = null;
        this.MaxQuantity = null;
        this.MaxQuantityExpressionId = null;
        this.MinQuantityExpressionId = null;
        this.Modifiable = null;
        this.RelationshipType = null;
        this.Required = null;
        this.Sequence = null;
        this.OptionPrices = [new ProductOptionPrice()];
        this._isOpen = false;
    }
};
__decorate([
    Expose({ name: 'Name' }),
    __metadata("design:type", String)
], ProductOptionComponent.prototype, "Name", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ParentProductId__c' }),
    __metadata("design:type", String)
], ProductOptionComponent.prototype, "ParentProductId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ComponentProductId__c' }),
    __metadata("design:type", String)
], ProductOptionComponent.prototype, "ComponentProductId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ComponentProductId__r' }),
    Type(() => Product),
    __metadata("design:type", Product)
], ProductOptionComponent.prototype, "ComponentProduct", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductOptionGroupId__c' }),
    __metadata("design:type", String)
], ProductOptionComponent.prototype, "ProductOptionGroupId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductOptionGroupId__r' }),
    Type(() => ProductOptionGroup),
    __metadata("design:type", ProductOptionGroup)
], ProductOptionComponent.prototype, "ProductOptionGroup", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__MinQuantity__c' }),
    __metadata("design:type", Number)
], ProductOptionComponent.prototype, "MinQuantity", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AllowCloning__c' }),
    __metadata("design:type", Boolean)
], ProductOptionComponent.prototype, "AllowCloning", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AutoUpdateQuantity__c' }),
    __metadata("design:type", Boolean)
], ProductOptionComponent.prototype, "AutoUpdateQuantity", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ConfigType__c' }),
    __metadata("design:type", String)
], ProductOptionComponent.prototype, "ConfigType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Default__c' }),
    __metadata("design:type", Boolean)
], ProductOptionComponent.prototype, "Default", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__DefaultQuantity__c' }),
    __metadata("design:type", Number)
], ProductOptionComponent.prototype, "DefaultQuantity", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__DefaultQuantityExpressionId__c' }),
    __metadata("design:type", String)
], ProductOptionComponent.prototype, "DefaultQuantityExpressionId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__InclusionCriteria__c' }),
    __metadata("design:type", String)
], ProductOptionComponent.prototype, "InclusionCriteria", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__MaxQuantity__c' }),
    __metadata("design:type", Number)
], ProductOptionComponent.prototype, "MaxQuantity", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__MaxQuantityExpressionId__c' }),
    __metadata("design:type", Number)
], ProductOptionComponent.prototype, "MaxQuantityExpressionId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__MinQuantityExpressionId__c' }),
    __metadata("design:type", String)
], ProductOptionComponent.prototype, "MinQuantityExpressionId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Modifiable__c' }),
    __metadata("design:type", Boolean)
], ProductOptionComponent.prototype, "Modifiable", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__RelationshipType__c' }),
    __metadata("design:type", String)
], ProductOptionComponent.prototype, "RelationshipType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Required__c' }),
    __metadata("design:type", Boolean)
], ProductOptionComponent.prototype, "Required", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Sequence__c' }),
    __metadata("design:type", Number)
], ProductOptionComponent.prototype, "Sequence", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__OptionPrices__r' }),
    Type(() => ProductOptionPrice),
    __metadata("design:type", Array)
], ProductOptionComponent.prototype, "OptionPrices", void 0);
ProductOptionComponent = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__ProductOptionComponent__c',
        aqlName: 'cpq_ProductOptionComponent'
    })
], ProductOptionComponent);
let ProductOptionPrice = class ProductOptionPrice extends AObject {
    constructor() {
        super(...arguments);
        this.AdjustmentAmount = null;
        this.AdjustmentType = null;
        this.AllocateGroupAdjustment = null;
        this.AllowManualAdjustment = null;
        this.ChargeType = null;
        this.ContractPrice = null;
        this.HideInvoiceDisplay = null;
        this.IsQuantityReadOnly = null;
        this.IsSellingTermReadOnly = null;
        this.PriceIncludedInBundle = null;
        this.PriceListId = null;
        this.PriceOverride = null;
        this.ProductOptionId = null;
        this.RollupPriceMethod = null;
        this.Sequence = null;
    }
};
__decorate([
    Expose({ name: 'Apttus_Config2__AdjustmentAmount__c' }),
    __metadata("design:type", Number)
], ProductOptionPrice.prototype, "AdjustmentAmount", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AdjustmentType__c' }),
    __metadata("design:type", String)
], ProductOptionPrice.prototype, "AdjustmentType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AllocateGroupAdjustment__c' }),
    __metadata("design:type", Boolean)
], ProductOptionPrice.prototype, "AllocateGroupAdjustment", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AllowManualAdjustment__c' }),
    __metadata("design:type", Boolean)
], ProductOptionPrice.prototype, "AllowManualAdjustment", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ChargeType__c' }),
    __metadata("design:type", String)
], ProductOptionPrice.prototype, "ChargeType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ContractPrice__c' }),
    __metadata("design:type", Number)
], ProductOptionPrice.prototype, "ContractPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__HideInvoiceDisplay__c' }),
    __metadata("design:type", Boolean)
], ProductOptionPrice.prototype, "HideInvoiceDisplay", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsQuantityReadOnly__c' }),
    __metadata("design:type", Boolean)
], ProductOptionPrice.prototype, "IsQuantityReadOnly", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsSellingTermReadOnly__c' }),
    __metadata("design:type", Boolean)
], ProductOptionPrice.prototype, "IsSellingTermReadOnly", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceIncludedInBundle__c' }),
    __metadata("design:type", Boolean)
], ProductOptionPrice.prototype, "PriceIncludedInBundle", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceListId__c' }),
    __metadata("design:type", String)
], ProductOptionPrice.prototype, "PriceListId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceOverride__c' }),
    __metadata("design:type", Number)
], ProductOptionPrice.prototype, "PriceOverride", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductOptionId__c' }),
    __metadata("design:type", String)
], ProductOptionPrice.prototype, "ProductOptionId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__RollupPriceMethod__c' }),
    __metadata("design:type", String)
], ProductOptionPrice.prototype, "RollupPriceMethod", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Sequence__c' }),
    __metadata("design:type", Number)
], ProductOptionPrice.prototype, "Sequence", void 0);
ProductOptionPrice = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__ProductOptionPrice__c',
        aqlName: 'cpq_ProductOptionPrice'
    })
], ProductOptionPrice);

let Product = class Product extends AObject {
    constructor() {
        super(...arguments);
        this.IconId = null;
        this.Name = null;
        this.ConfigurationType = null;
        this.Uom = null;
        this.Description = null;
        this.Family = null;
        this.ProductCode = null;
        this.IsActive = null;
        this.HasAttributes = null;
        this.HasDefaults = null;
        this.HasOptions = null;
        this.ExpirationDate = null;
        this.EffectiveStartDate = null;
        this.EffectiveDate = null;
        this.Version = null;
        this.Categories = null;
        this.PriceLists = null;
        this.ProductFeatureValues = null;
        this.AssetLineItems = null;
        this.OptionGroups = null;
        this.AttributeGroups = null;
        this.ProductGroups = null;
        this.ProductAttributeMatrixViews = null;
        this.Translation = null;
    }
    validate() {
        const errors = this.get('error');
        this.clearError();
        let childErrors = [];
        const handleComponent = (c) => {
            if (filter(this.get('cartItems'), item => get(item, 'ProductOption.ComponentProductId') === c.ComponentProductId && get(item, 'ProductOption.ProductOptionGroupId') === get(c, 'ProductOptionGroupId')).length > 0)
                forEach(get(c, 'ComponentProduct.OptionGroups', []), handleGroup);
        };
        const handleGroup = (g) => {
            if (get(g, 'hasErrors'))
                childErrors = concat(g.errors);
            forEach(get(g, 'ChildOptionGroups', []), handleGroup);
            forEach(get(g, 'Options'), handleComponent);
        };
        forEach(get(this, 'OptionGroups', []), (og) => handleGroup(og));
        if (!isEmpty(childErrors) || !isEmpty(errors)) {
            this.setError('ERROR.PRODUCT.HAS_ERRORS', null, 'error', childErrors ? childErrors : errors);
        }
    }
};
__decorate([
    Expose({ name: 'Apttus_Config2__IconId__c' }),
    __metadata("design:type", String)
], Product.prototype, "IconId", void 0);
__decorate([
    Expose({ name: 'Name' }),
    __metadata("design:type", String)
], Product.prototype, "Name", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ConfigurationType__c' }),
    __metadata("design:type", String)
], Product.prototype, "ConfigurationType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Uom__c' }),
    __metadata("design:type", String)
], Product.prototype, "Uom", void 0);
__decorate([
    Expose({ name: 'Description' }),
    __metadata("design:type", String)
], Product.prototype, "Description", void 0);
__decorate([
    Expose({ name: 'Family' }),
    __metadata("design:type", String)
], Product.prototype, "Family", void 0);
__decorate([
    Expose({ name: 'ProductCode' }),
    __metadata("design:type", String)
], Product.prototype, "ProductCode", void 0);
__decorate([
    Expose({ name: 'IsActive' }),
    __metadata("design:type", Boolean)
], Product.prototype, "IsActive", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__HasAttributes__c' }),
    __metadata("design:type", Boolean)
], Product.prototype, "HasAttributes", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__HasDefaults__c' }),
    __metadata("design:type", Boolean)
], Product.prototype, "HasDefaults", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__HasOptions__c' }),
    __metadata("design:type", Boolean)
], Product.prototype, "HasOptions", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ExpirationDate__c' }),
    __metadata("design:type", Date)
], Product.prototype, "ExpirationDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__EffectiveStartDate__c' }),
    __metadata("design:type", Date)
], Product.prototype, "EffectiveStartDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__EffectiveDate__c' }),
    __metadata("design:type", Date)
], Product.prototype, "EffectiveDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Version__c' }),
    __metadata("design:type", Number)
], Product.prototype, "Version", void 0);
__decorate([
    Type(() => ProductCategory),
    Expose({ name: 'Apttus_Config2__Categories__r' }),
    __metadata("design:type", Array)
], Product.prototype, "Categories", void 0);
__decorate([
    Type(() => PriceListItem),
    Expose({ name: 'Apttus_Config2__PriceLists__r' }),
    __metadata("design:type", Array)
], Product.prototype, "PriceLists", void 0);
__decorate([
    Type(() => ProductFeatureValue),
    Expose({ name: 'Apttus_Config2__ProductFeatureValues__r' }),
    __metadata("design:type", Array)
], Product.prototype, "ProductFeatureValues", void 0);
__decorate([
    Type(() => AssetLineItemExtended),
    Expose({ name: 'Apttus_Config2__AssetLineItems__r' }),
    __metadata("design:type", Array)
], Product.prototype, "AssetLineItems", void 0);
__decorate([
    Type(() => ProductOptionGroup),
    Expose({ name: 'Apttus_Config2__OptionGroups__r' }),
    __metadata("design:type", Array)
], Product.prototype, "OptionGroups", void 0);
__decorate([
    Type(() => ProductAttributeGroupMember),
    Expose({ name: 'Apttus_Config2__AttributeGroups__r' }),
    __metadata("design:type", Array)
], Product.prototype, "AttributeGroups", void 0);
__decorate([
    Type(() => ProductGroupMember),
    Expose({ name: 'Apttus_Config2__ProductGroups__r' }),
    __metadata("design:type", Array)
], Product.prototype, "ProductGroups", void 0);
__decorate([
    Type(() => ProductAttributeMatrixView),
    Expose({ name: 'Apttus_Config2__ProductAttributeMatrixViews__r' }),
    __metadata("design:type", Array)
], Product.prototype, "ProductAttributeMatrixViews", void 0);
__decorate([
    Type(() => ProductTranslation),
    Expose({ name: 'Apttus_Config2__Translation__r' }),
    __metadata("design:type", Array)
], Product.prototype, "Translation", void 0);
Product = __decorate([
    ATable({
        sobjectName: 'Product2',
        route: 'products'
    })
], Product);
class ProductResult {
    constructor() {
        this.Products = null;
        this.TotalCount = null;
    }
}
__decorate([
    Type(() => Product),
    Expose({ name: 'Products' }),
    __metadata("design:type", Array)
], ProductResult.prototype, "Products", void 0);
__decorate([
    Expose({ name: 'TotalCount' }),
    __metadata("design:type", Number)
], ProductResult.prototype, "TotalCount", void 0);

let AccountLocation = class AccountLocation extends AObject {
    constructor() {
        super(...arguments);
        this.Name = null;
        this.City = null;
        this.Country = null;
        this.County = null;
        this.IsDefault = false;
        this.PostalCode = null;
        this.State = null;
        this.Street = null;
        this.Type = null;
        this.AccountId = null;
        this.BillingContactFilterCriteria = null;
        this.BillingContactFormat = null;
        this.BillingDayOfMonth = null;
        this.BillingPreferenceId = null;
        this.CreditMemoEmailTemplate = null;
        this.DefaultCreditMemoTemplate = null;
        this.DefaultInvoiceStatementTemplate = null;
        this.DefaultInvoiceTemplate = null;
        this.InvoiceEmailTemplate = null;
        this.InvoiceSeparately = null;
        this.PaymentTermId = null;
        this.CertificateId = null;
        this.TaxExempt = null;
        this.TaxExemptStatus = null;
    }
};
__decorate([
    AField({
        soql: 'Name',
        aql: 'Name'
    }),
    __metadata("design:type", String)
], AccountLocation.prototype, "Name", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__City__c',
        aql: 'City'
    }),
    __metadata("design:type", String)
], AccountLocation.prototype, "City", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Country__c',
        aql: 'Country'
    }),
    __metadata("design:type", String)
], AccountLocation.prototype, "Country", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__County__c',
        aql: 'County'
    }),
    __metadata("design:type", String)
], AccountLocation.prototype, "County", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__IsDefault__c',
        aql: 'IsDefault'
    }),
    __metadata("design:type", Boolean)
], AccountLocation.prototype, "IsDefault", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__PostalCode__c',
        aql: 'PostalCode'
    }),
    __metadata("design:type", Number)
], AccountLocation.prototype, "PostalCode", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__State__c',
        aql: 'State'
    }),
    __metadata("design:type", String)
], AccountLocation.prototype, "State", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Street__c',
        aql: 'Street'
    }),
    __metadata("design:type", String)
], AccountLocation.prototype, "Street", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Type__c',
        aql: 'Type'
    }),
    __metadata("design:type", String)
], AccountLocation.prototype, "Type", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__AccountId__c',
        aql: 'AccountId'
    }),
    __metadata("design:type", String)
], AccountLocation.prototype, "AccountId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__BillingContactFilterCriteria__c',
        aql: 'BillingContactFilterCriteria'
    }),
    __metadata("design:type", String)
], AccountLocation.prototype, "BillingContactFilterCriteria", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__BillingContactFormat__c',
        aql: 'BillingContactFormat'
    }),
    __metadata("design:type", String)
], AccountLocation.prototype, "BillingContactFormat", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__BillingDayOfMonth__c',
        aql: 'BillingDayOfMonth'
    }),
    __metadata("design:type", String)
], AccountLocation.prototype, "BillingDayOfMonth", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__BillingPreferenceId__c',
        aql: 'BillingPreferenceId'
    }),
    __metadata("design:type", String)
], AccountLocation.prototype, "BillingPreferenceId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__CreditMemoEmailTemplate__c',
        aql: 'CreditMemoEmailTemplate'
    }),
    __metadata("design:type", String)
], AccountLocation.prototype, "CreditMemoEmailTemplate", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__DefaultCreditMemoTemplate__c',
        aql: 'DefaultCreditMemoTemplate'
    }),
    __metadata("design:type", String)
], AccountLocation.prototype, "DefaultCreditMemoTemplate", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__DefaultInvoiceStatementTemplate__c',
        aql: 'DefaultInvoiceStatementTemplate'
    }),
    __metadata("design:type", String)
], AccountLocation.prototype, "DefaultInvoiceStatementTemplate", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__DefaultInvoiceTemplate__c',
        aql: 'DefaultInvoiceTemplate'
    }),
    __metadata("design:type", String)
], AccountLocation.prototype, "DefaultInvoiceTemplate", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__InvoiceEmailTemplate__c',
        aql: 'InvoiceEmailTemplate'
    }),
    __metadata("design:type", String)
], AccountLocation.prototype, "InvoiceEmailTemplate", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__InvoiceSeparately__c',
        aql: 'InvoiceSeparately'
    }),
    __metadata("design:type", String)
], AccountLocation.prototype, "InvoiceSeparately", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__PaymentTermId__c',
        aql: 'PaymentTermId'
    }),
    __metadata("design:type", String)
], AccountLocation.prototype, "PaymentTermId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__CertificateId__c',
        aql: 'CertificateId'
    }),
    __metadata("design:type", String)
], AccountLocation.prototype, "CertificateId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__TaxExempt__c',
        aql: 'TaxExempt'
    }),
    __metadata("design:type", String)
], AccountLocation.prototype, "TaxExempt", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__TaxExemptStatus__c',
        aql: 'TaxExemptStatus'
    }),
    __metadata("design:type", String)
], AccountLocation.prototype, "TaxExemptStatus", void 0);
AccountLocation = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__AccountLocation__c',
        aqlName: 'cpq_AccountLocation'
    })
], AccountLocation);

let Contact = class Contact extends AObject {
    constructor() {
        super(...arguments);
        this.FirstName = null;
        this.LastName = null;
        this.Name = null;
        this.AccountId = null;
        this.Account = null;
        this.Phone = null;
        this.Email = null;
        this.MailingAddress = null;
        this.MailingStreet = null;
        this.MailingState = null;
        this.MailingStateCode = null;
        this.MailingCity = null;
        this.MailingPostalCode = null;
        this.MailingCountryCode = null;
        this.MailingCountry = null;
        this.OtherAddress = null;
        this.OtherStreet = null;
        this.OtherState = null;
        this.OtherStateCode = null;
        this.OtherCity = null;
        this.OtherPostalCode = null;
        this.OtherCountryCode = null;
        this.OtherCountry = null;
        this.Title = null;
    }
};
__decorate([
    AField({
        soql: 'FirstName',
        aql: 'FirstName',
        view: ['Compact']
    }),
    __metadata("design:type", String)
], Contact.prototype, "FirstName", void 0);
__decorate([
    AField({
        soql: 'LastName',
        aql: 'LastName',
        view: ['Compact']
    }),
    __metadata("design:type", String)
], Contact.prototype, "LastName", void 0);
__decorate([
    AField({
        soql: 'Name',
        aql: 'Name',
        view: ['Compact']
    }),
    __metadata("design:type", String)
], Contact.prototype, "Name", void 0);
__decorate([
    AField({
        soql: 'AccountId',
        aql: 'ParentCustomerId',
        view: ['Compact']
    }),
    __metadata("design:type", String)
], Contact.prototype, "AccountId", void 0);
__decorate([
    AField({
        soql: 'Account',
        aql: 'ParentCustomerId'
    }),
    Type(() => Account),
    __metadata("design:type", Account)
], Contact.prototype, "Account", void 0);
__decorate([
    AField({
        soql: 'Phone',
        view: ['Compact']
    }),
    __metadata("design:type", String)
], Contact.prototype, "Phone", void 0);
__decorate([
    AField({
        soql: 'Email',
        view: ['Compact']
    }),
    __metadata("design:type", String)
], Contact.prototype, "Email", void 0);
__decorate([
    AField({
        soql: 'MailingAddress',
        view: ['Compact']
    }),
    __metadata("design:type", String)
], Contact.prototype, "MailingAddress", void 0);
__decorate([
    AField({
        soql: 'MailingStreet'
    }),
    __metadata("design:type", String)
], Contact.prototype, "MailingStreet", void 0);
__decorate([
    AField({
        soql: 'MailingState'
    }),
    __metadata("design:type", String)
], Contact.prototype, "MailingState", void 0);
__decorate([
    AField({
        soql: 'MailingStateCode'
    }),
    __metadata("design:type", String)
], Contact.prototype, "MailingStateCode", void 0);
__decorate([
    AField({
        soql: 'MailingCity'
    }),
    __metadata("design:type", String)
], Contact.prototype, "MailingCity", void 0);
__decorate([
    AField({
        soql: 'MailingPostalCode'
    }),
    __metadata("design:type", Number)
], Contact.prototype, "MailingPostalCode", void 0);
__decorate([
    AField({
        soql: 'MailingCountryCode'
    }),
    __metadata("design:type", String)
], Contact.prototype, "MailingCountryCode", void 0);
__decorate([
    AField({
        soql: 'MailingCountry'
    }),
    __metadata("design:type", String)
], Contact.prototype, "MailingCountry", void 0);
__decorate([
    AField({
        soql: 'OtherAddress',
        view: ['Compact']
    }),
    __metadata("design:type", String)
], Contact.prototype, "OtherAddress", void 0);
__decorate([
    AField({
        soql: 'OtherStreet'
    }),
    __metadata("design:type", String)
], Contact.prototype, "OtherStreet", void 0);
__decorate([
    AField({
        soql: 'OtherState'
    }),
    __metadata("design:type", String)
], Contact.prototype, "OtherState", void 0);
__decorate([
    AField({
        soql: 'OtherStateCode'
    }),
    __metadata("design:type", String)
], Contact.prototype, "OtherStateCode", void 0);
__decorate([
    AField({
        soql: 'OtherCity'
    }),
    __metadata("design:type", String)
], Contact.prototype, "OtherCity", void 0);
__decorate([
    AField({
        soql: 'OtherPostalCode',
        view: ['Compact']
    }),
    __metadata("design:type", Number)
], Contact.prototype, "OtherPostalCode", void 0);
__decorate([
    AField({
        soql: 'OtherCountryCode'
    }),
    __metadata("design:type", String)
], Contact.prototype, "OtherCountryCode", void 0);
__decorate([
    AField({
        soql: 'OtherCountry',
        view: ['Compact']
    }),
    __metadata("design:type", String)
], Contact.prototype, "OtherCountry", void 0);
__decorate([
    AField({
        soql: 'Title',
        view: ['Compact']
    }),
    __metadata("design:type", String)
], Contact.prototype, "Title", void 0);
Contact = __decorate([
    ATable({ sobjectName: 'Contact', aqlName: 'crm_Contact' })
], Contact);

let UserBase = class UserBase extends AObject {
    constructor() {
        super(...arguments);
        this.FirstName = null;
        this.Title = null;
        this.LastName = null;
        this.Email = null;
        this.Username = null;
        this.Alias = null;
        this.Name = null;
    }
};
__decorate([
    AField({
        soql: 'FirstName',
        aql: 'FirstName'
    }),
    __metadata("design:type", String)
], UserBase.prototype, "FirstName", void 0);
__decorate([
    AField({
        soql: 'Title'
    }),
    __metadata("design:type", String)
], UserBase.prototype, "Title", void 0);
__decorate([
    AField({
        soql: 'LastName',
        aql: 'LastName'
    }),
    __metadata("design:type", String)
], UserBase.prototype, "LastName", void 0);
__decorate([
    AField({
        soql: 'Email',
        aql: 'Email'
    }),
    __metadata("design:type", String)
], UserBase.prototype, "Email", void 0);
__decorate([
    AField({
        soql: 'Username',
        aql: 'UserName'
    }),
    __metadata("design:type", String)
], UserBase.prototype, "Username", void 0);
__decorate([
    AField({
        soql: 'Alias'
    }),
    __metadata("design:type", String)
], UserBase.prototype, "Alias", void 0);
__decorate([
    AField({
        soql: 'Name',
        aql: 'Name'
    }),
    __metadata("design:type", String)
], UserBase.prototype, "Name", void 0);
UserBase = __decorate([
    ATable({ sobjectName: 'User', defaultFields: false, aqlName: 'crm_User' })
], UserBase);
let User = class User extends UserBase {
    constructor() {
        super(...arguments);
        this.LocaleSidKey = null;
        this.EmailEncodingKey = null;
        this.LanguageLocaleKey = null;
        this.CommunityNickname = null;
        this.CountryCode = null;
        this.TimeZoneSidKey = null;
        this.LastLoginDate = null;
        this.CurrencyIsoCode = null;
        this.DefaultCurrencyIsoCode = null;
        this.Contact = null;
        this.ContactId = null;
        this.SmallPhotoUrl = null;
        this.FullPhotoUrl = null;
    }
};
__decorate([
    AField({
        soql: 'LocaleSidKey'
    }),
    __metadata("design:type", String)
], User.prototype, "LocaleSidKey", void 0);
__decorate([
    AField({
        soql: 'EmailEncodingKey'
    }),
    __metadata("design:type", String)
], User.prototype, "EmailEncodingKey", void 0);
__decorate([
    AField({
        soql: 'LanguageLocaleKey'
    }),
    __metadata("design:type", String)
], User.prototype, "LanguageLocaleKey", void 0);
__decorate([
    AField({
        soql: 'CommunityNickname'
    }),
    __metadata("design:type", String)
], User.prototype, "CommunityNickname", void 0);
__decorate([
    AField({
        soql: 'CountryCode'
    }),
    __metadata("design:type", String)
], User.prototype, "CountryCode", void 0);
__decorate([
    AField({
        soql: 'TimeZoneSidKey'
    }),
    __metadata("design:type", String)
], User.prototype, "TimeZoneSidKey", void 0);
__decorate([
    AField({
        soql: 'LastLoginDate'
    }),
    __metadata("design:type", Date)
], User.prototype, "LastLoginDate", void 0);
__decorate([
    AField({
        soql: 'CurrencyIsoCode'
    }),
    __metadata("design:type", String)
], User.prototype, "CurrencyIsoCode", void 0);
__decorate([
    AField({
        soql: 'DefaultCurrencyIsoCode'
    }),
    __metadata("design:type", String)
], User.prototype, "DefaultCurrencyIsoCode", void 0);
__decorate([
    AField({
        soql: 'Contact',
        aql: 'ContactId'
    }),
    Type(() => Contact),
    __metadata("design:type", Contact)
], User.prototype, "Contact", void 0);
__decorate([
    AField({
        soql: 'ContactId',
        aql: 'ContactId'
    }),
    __metadata("design:type", String)
], User.prototype, "ContactId", void 0);
__decorate([
    AField({
        soql: 'SmallPhotoUrl'
    }),
    __metadata("design:type", String)
], User.prototype, "SmallPhotoUrl", void 0);
__decorate([
    AField({
        soql: 'FullPhotoUrl'
    }),
    __metadata("design:type", String)
], User.prototype, "FullPhotoUrl", void 0);
User = __decorate([
    ATable({ sobjectName: 'User', defaultFields: false, aqlName: null })
], User);

let AccountBase = class AccountBase extends AObject {
    constructor() {
        super(...arguments);
        this.Name = null;
        this.BillingAddress = null;
        this.ShippingAddress = null;
        this.BillingStreet = null;
        this.ParentId = null;
        this.BillingState = null;
        this.BillingStateCode = null;
        this.BillingCity = null;
        this.BillingPostalCode = null;
        this.BillingCountry = null;
        this.BillingCountryCode = null;
        this.ShippingStreet = null;
        this.ShippingState = null;
        this.ShippingStateCode = null;
        this.ShippingCity = null;
        this.ShippingPostalCode = null;
        this.ShippingCountry = null;
        this.ShippingCountryCode = null;
        this.PriceListId = null;
        this.PriceList = null;
        this.Phone = null;
        this.OwnerId = null;
        this.Owner = new UserBase();
        this.Industry = null;
    }
};
__decorate([
    Expose({ name: 'Name' }),
    __metadata("design:type", String)
], AccountBase.prototype, "Name", void 0);
__decorate([
    AField({
        soql: 'BillingAddress',
        view: ['Compact']
    }),
    Expose({ name: 'BillingAddress' }),
    __metadata("design:type", Object)
], AccountBase.prototype, "BillingAddress", void 0);
__decorate([
    AField({
        soql: 'ShippingAddress',
        view: ['Compact']
    }),
    Expose({ name: 'ShippingAddress' }),
    __metadata("design:type", Object)
], AccountBase.prototype, "ShippingAddress", void 0);
__decorate([
    Expose({ name: 'BillingStreet' }),
    __metadata("design:type", String)
], AccountBase.prototype, "BillingStreet", void 0);
__decorate([
    Expose({ name: 'ParentId' }),
    __metadata("design:type", String)
], AccountBase.prototype, "ParentId", void 0);
__decorate([
    Expose({ name: 'BillingState' }),
    __metadata("design:type", String)
], AccountBase.prototype, "BillingState", void 0);
__decorate([
    Expose({ name: 'BillingStateCode ' }),
    __metadata("design:type", String)
], AccountBase.prototype, "BillingStateCode", void 0);
__decorate([
    Expose({ name: 'BillingCity' }),
    __metadata("design:type", String)
], AccountBase.prototype, "BillingCity", void 0);
__decorate([
    Expose({ name: 'BillingPostalCode' }),
    __metadata("design:type", String)
], AccountBase.prototype, "BillingPostalCode", void 0);
__decorate([
    Expose({ name: 'BillingCountry' }),
    __metadata("design:type", String)
], AccountBase.prototype, "BillingCountry", void 0);
__decorate([
    Expose({ name: 'BillingCountryCode ' }),
    __metadata("design:type", String)
], AccountBase.prototype, "BillingCountryCode", void 0);
__decorate([
    Expose({ name: 'ShippingStreet' }),
    __metadata("design:type", String)
], AccountBase.prototype, "ShippingStreet", void 0);
__decorate([
    Expose({ name: 'ShippingState' }),
    __metadata("design:type", String)
], AccountBase.prototype, "ShippingState", void 0);
__decorate([
    Expose({ name: 'ShippingStateCode ' }),
    __metadata("design:type", String)
], AccountBase.prototype, "ShippingStateCode", void 0);
__decorate([
    Expose({ name: 'ShippingCity' }),
    __metadata("design:type", String)
], AccountBase.prototype, "ShippingCity", void 0);
__decorate([
    Expose({ name: 'ShippingPostalCode' }),
    __metadata("design:type", String)
], AccountBase.prototype, "ShippingPostalCode", void 0);
__decorate([
    Expose({ name: 'ShippingCountry' }),
    __metadata("design:type", String)
], AccountBase.prototype, "ShippingCountry", void 0);
__decorate([
    Expose({ name: 'ShippingCountryCode ' }),
    __metadata("design:type", String)
], AccountBase.prototype, "ShippingCountryCode", void 0);
__decorate([
    AField({
        soql: 'PriceListId__c',
        view: ['Compact']
    }),
    Expose({ name: 'PriceListId__c' }),
    __metadata("design:type", String)
], AccountBase.prototype, "PriceListId", void 0);
__decorate([
    Expose({ name: 'PriceListId__r' }),
    Type(() => PriceList),
    __metadata("design:type", PriceList)
], AccountBase.prototype, "PriceList", void 0);
__decorate([
    AField({
        soql: 'Phone',
        view: ['Compact']
    }),
    Expose({ name: 'Phone' }),
    __metadata("design:type", Number)
], AccountBase.prototype, "Phone", void 0);
__decorate([
    AField({
        soql: 'OwnerId',
        view: ['Compact'],
        compactLabel: 'Owner'
    }),
    Expose({ name: 'OwnerId' }),
    __metadata("design:type", String)
], AccountBase.prototype, "OwnerId", void 0);
__decorate([
    Expose({ name: 'Owner' }),
    Type(() => UserBase),
    __metadata("design:type", UserBase)
], AccountBase.prototype, "Owner", void 0);
__decorate([
    AField({
        soql: 'Industry',
        view: ['Compact']
    }),
    Expose({ name: 'Industry' }),
    __metadata("design:type", String)
], AccountBase.prototype, "Industry", void 0);
AccountBase = __decorate([
    ATable({
        sobjectName: 'Account',
        aqlName: 'crm_Account',
        route: 'accounts'
    })
], AccountBase);
let Account = class Account extends AccountBase {
    constructor() {
        super(...arguments);
        this.ChildAccounts = null;
        this.AccountLocations = null;
    }
};
__decorate([
    Expose({ name: 'ChildAccounts' }),
    Type(() => AccountBase),
    __metadata("design:type", Array)
], Account.prototype, "ChildAccounts", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AccountLocations__r' }),
    Type(() => AccountLocation),
    __metadata("design:type", Array)
], Account.prototype, "AccountLocations", void 0);
Account = __decorate([
    ATable({
        sobjectName: 'Account',
        aqlName: 'crm_Account',
        route: 'accounts'
    })
], Account);

let StoreBanner = class StoreBanner extends AObject {
    constructor() {
        super(...arguments);
        this.Link = null;
        this.StorefrontId = null;
        this.Subtitle = null;
        this.Title = null;
        this.Image = null;
    }
};
__decorate([
    AField({
        soql: 'Apttus_WebStore__Link__c',
        aql: 'Link'
    }),
    __metadata("design:type", String)
], StoreBanner.prototype, "Link", void 0);
__decorate([
    AField({
        soql: 'Apttus_WebStore__StorefrontId__c',
        aql: 'StorefrontId'
    }),
    __metadata("design:type", String)
], StoreBanner.prototype, "StorefrontId", void 0);
__decorate([
    AField({
        soql: 'Apttus_WebStore__Subtitle__c',
        aql: 'Subtitle'
    }),
    __metadata("design:type", String)
], StoreBanner.prototype, "Subtitle", void 0);
__decorate([
    AField({
        soql: 'Apttus_WebStore__Title__c',
        aql: 'Title'
    }),
    __metadata("design:type", String)
], StoreBanner.prototype, "Title", void 0);
__decorate([
    AField({
        soql: 'Apttus_WebStore__Image__c',
        aql: 'Image'
    }),
    __metadata("design:type", String)
], StoreBanner.prototype, "Image", void 0);
StoreBanner = __decorate([
    ATable({
        sobjectName: 'Apttus_WebStore__StorefrontBanner__c',
        aqlName: 'dcm_StorefrontBanner'
    })
], StoreBanner);

let Storefront = class Storefront extends AObject {
    constructor() {
        super(...arguments);
        this.Name = null;
        this.DefaultPriceListId = null;
        this.DefaultPriceList = null;
        this.Logo = null;
        this.DefaultLocale = null;
        this.StoreBanners = null;
        this.EnableABO = null;
        this.EnablePromotions = null;
        this.AssetActions = null;
        this.DefaultAccountforGuestUsers = null;
        this.DefaultAccountforGuestUsersId = null;
        this.EnableRequestQuote = null;
        this.EnableTaxCalculations = null;
        this.TranslationURL = null;
        this.ChannelType = null;
        this.ConfigurationLayout = null;
    }
};
__decorate([
    AField({
        soql: 'Name',
        aql: 'Name'
    }),
    __metadata("design:type", String)
], Storefront.prototype, "Name", void 0);
__decorate([
    AField({
        soql: 'Apttus_WebStore__DefaultPriceListId__c',
        aql: 'DefaultPriceListId'
    }),
    __metadata("design:type", String)
], Storefront.prototype, "DefaultPriceListId", void 0);
__decorate([
    AField({
        soql: 'Apttus_WebStore__DefaultPriceListId__r',
        aql: 'DefaultPriceListId'
    }),
    Type(() => PriceList),
    __metadata("design:type", PriceList)
], Storefront.prototype, "DefaultPriceList", void 0);
__decorate([
    AField({
        soql: 'Apttus_WebStore__Logo__c',
        aql: 'Logo'
    }),
    __metadata("design:type", String)
], Storefront.prototype, "Logo", void 0);
__decorate([
    AField({
        soql: 'Apttus_WebStore__DefaultLocale__c'
    }),
    __metadata("design:type", String)
], Storefront.prototype, "DefaultLocale", void 0);
__decorate([
    AField({
        soql: 'Apttus_WebStore__StoreBanners__r',
        aql: 'StorefrontId'
    }),
    Type(() => StoreBanner),
    __metadata("design:type", Array)
], Storefront.prototype, "StoreBanners", void 0);
__decorate([
    AField({
        soql: 'Apttus_WebStore__EnableABO__c'
    }),
    __metadata("design:type", Boolean)
], Storefront.prototype, "EnableABO", void 0);
__decorate([
    AField({
        soql: 'Apttus_WebStore__EnablePromotions__c'
    }),
    __metadata("design:type", Boolean)
], Storefront.prototype, "EnablePromotions", void 0);
__decorate([
    AField({
        soql: 'Apttus_WebStore__AssetActions__c'
    }),
    __metadata("design:type", String)
], Storefront.prototype, "AssetActions", void 0);
__decorate([
    AField({
        soql: 'Apttus_WebStore__DefaultAccountforGuestUsers__r'
    }),
    Type(() => Account),
    __metadata("design:type", Account)
], Storefront.prototype, "DefaultAccountforGuestUsers", void 0);
__decorate([
    AField({
        soql: 'Apttus_WebStore__DefaultAccountforGuestUsers__c'
    }),
    __metadata("design:type", String)
], Storefront.prototype, "DefaultAccountforGuestUsersId", void 0);
__decorate([
    AField({
        soql: 'Apttus_WebStore__EnableRequestQuote__c'
    }),
    __metadata("design:type", Boolean)
], Storefront.prototype, "EnableRequestQuote", void 0);
__decorate([
    AField({
        soql: 'Apttus_WebStore__EnableTaxCalculations__c'
    }),
    __metadata("design:type", Boolean)
], Storefront.prototype, "EnableTaxCalculations", void 0);
__decorate([
    AField({
        soql: 'Apttus_WebStore__TranslationURL__c'
    }),
    __metadata("design:type", String)
], Storefront.prototype, "TranslationURL", void 0);
__decorate([
    AField({
        soql: 'Apttus_WebStore__ChannelType__c'
    }),
    __metadata("design:type", String)
], Storefront.prototype, "ChannelType", void 0);
__decorate([
    AField({
        soql: 'Apttus_WebStore__ConfigurationLayout__c'
    }),
    __metadata("design:type", String)
], Storefront.prototype, "ConfigurationLayout", void 0);
Storefront = __decorate([
    ATable({
        sobjectName: 'Apttus_WebStore__Storefront__c',
        aqlName: 'dcm_Storefront',
        route: 'storefronts'
    })
], Storefront);

/**
 * @ignore
 */
class UserApiService {
    constructor(apiService) {
        this.apiService = apiService;
        this.state = new BehaviorSubject(null);
        this.refresh();
    }
    refresh() {
        this.apiService.refreshToken()
            .pipe(switchMap(() => this.apiService.get(`/users/active`, User)), take(1))
            .subscribe(user => this.publish(user));
    }
    publish(user) {
        this.state.next(user);
    }
    active() {
        return this.state
            .pipe(filter$1(user => !isNil(user)));
    }
}
UserApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: UserApiService, deps: [{ token: i1.ApiService }], target: i0.ɵɵFactoryTarget.Injectable });
UserApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: UserApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: UserApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.ApiService }]; } });

/**
 * User service provides different methods for user related operation.
 * <h3>Usage</h3>
 *
 ```typescript
 import { UserService } from '@congacommerce/ecommerce';

 constructor(private userService: UserService) {}

 // or

 export class MyService extends AObjectService {
     private userService: UserService = this.injector.get(UserService);
  }
 ```
*/
class UserService extends AObjectService {
    constructor() {
        super(...arguments);
        this.CACHE_KEY = 'User';
        this.type = User;
        this.userApi = this.injector.get(UserApiService);
    }
    /**
     * Method gets active user
     *
     * ### Example:
     ```typescript
     import { UserService, User } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     export class MyComponent implements OnInit{
         user: User;
         user$: Observable<User>
         constructor(private userService: UserService){}
         
         this.userService.getCurrentUser().subscribe(user => this.user = user);
         // or
         this.user$ = this.userService.getCurrentUser();
     
     }
     ```
     *
     * @returns active user
     *
     */
    getCurrentUser() {
        return this.userApi.active();
    }
    /**
     * Method sets the currency for the current user
     *
     * ### Example:
     ```typescript
     import { UserService, User } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     export class MyComponent implements OnInit{
         user: User;
         user$: Observable<User>
         constructor(private userService: UserService){}
         
         this.userService.setCurrency(value).subscribe(user => this.user = user);
         // or
         this.user$ = this.userService.setCurrency(value);
     
     }
     ```
     *
     * @param currencyIsoCode the iso code of the currency to set (i.e. 'USD')
     * @param commit set to true to commit the change to the db.
     * @returns current user with currency
     *
     */
    setCurrency(currencyIsoCode, commit = false) {
        this.cacheService._set('currency', currencyIsoCode, true);
        if (commit === true) {
            return this.me().pipe(take(1), map$1(user => {
                user.DefaultCurrencyIsoCode = LocaleCurrency.getCurrency(currencyIsoCode);
                return user;
            }), mergeMap(user => this.update([user])), map$1(userList => _.first(userList)), tap(() => this.userApi.refresh()));
        }
        else {
            return this.me()
                .pipe(tap(user => {
                user.DefaultCurrencyIsoCode = LocaleCurrency.getCurrency(currencyIsoCode);
                this.userApi.publish(user);
            }));
        }
    }
    /**
     * Primary method for retrieving the current user record
     *
     * ### Example:
     ```typescript
     import { UserService, User } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     export class MyComponent implements OnInit{
         user: User;
         user$: Observable<User>
         constructor(private userService: UserService){}
         
         this.userService.me().subscribe(user => this.user = user);
         // or
         this.user$ = this.userService.me();
     
     }
     ```
     *
     * @returns an observable of type User
    */
    me() {
        return this.getCurrentUser();
    }
    /**
     * Used for determining if the current user is a guest user.
     *
     * ### Example:
     ```typescript
     import { UserService, User } from '@congacommerce/ecommerce';
     export class MyComponent implements OnInit{
         isGuest: boolean;
         constructor(private userService: UserService){}
         
         this.isGuest = this.userService.isGuest();
     
     }
     ```
     *
     * @returns a boolean observable. Will be true if the user is a guest user.
     */
    isGuest() {
        return this.me().pipe(take(1), map$1(u => u.Alias === 'guest' || !u.Id));
    }
    /**
     * Method is used to create a guest user record prior to registration. Will set the defaults on the record to browser defaults.
     *
     * ### Example:
     ```typescript
     import { UserService, User } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     export class MyComponent implements OnInit{
         guestUser: User;
         guestUser$: Observable<User>
         constructor(private userService: UserService){}
         
         this.userService.initializeGuestUser().subscribe(user => this.user = user);
         // or
         this.user$ = this.userService.initializeGuestUser();
     
     }
     ```
     *
     * @returns a user record containing the browser defaults (will not be committed to db).
     */
    initializeGuestUser() {
        let u = new User();
        let userLang = this.getBrowserLocale();
        u.CountryCode = this.configurationService.get('defaultCountry');
        u.LanguageLocaleKey = userLang;
        u.LocaleSidKey = u.LanguageLocaleKey;
        u.EmailEncodingKey = 'UTF-8';
        u.Alias = 'guest';
        return of(u);
    }
    /**
     * @ignore
     */
    getLocale() {
        return this.me().pipe(map$1(user => {
            if (this.cacheService._get('locale'))
                return this.cacheService._get('locale');
            else if (user.LocaleSidKey)
                return user.LocaleSidKey;
            else if (this.configurationService.get('defaultLanguage'))
                return this.configurationService.get('defaultLanguage');
            else
                return this.getBrowserLocale(false);
        }));
    }
    /**
     * @ignore
     */
    getLanguage() {
        return this.me().pipe(map$1(user => {
            if (this.cacheService._get('locale'))
                return this.cacheService._get('locale');
            else if (user.LanguageLocaleKey)
                return user.LanguageLocaleKey;
            else if (this.configurationService.get('defaultLanguage'))
                return this.configurationService.get('defaultLanguage');
            else
                return this.getBrowserLocale(false);
        }));
    }
    /**
     * Retrieves the browser locale for the current user
     *
     * ### Example:
     ```typescript
     import { UserService, User } from '@congacommerce/ecommerce';
     export class MyComponent implements OnInit{
         lang:string;
         constructor(private userService: UserService){}
         
         getBrowserLocale(){
             this.lang = this.userService.getBrowserLocale();
            }
     }
     ```
     *
     * @param underscore when set to true, will replace dash ('-') with an underscore ('_')
     *
     */
    getBrowserLocale(underscore = true) {
        let userLang = this.configurationService.get('defaultLanguage', navigator.language);
        if (underscore)
            return userLang.replace('-', '_');
        else
            return userLang;
    }
    /**
    * Retrieves the current user locale to support salesforce and other environment
    *
    * ### Example:
    ```typescript
    import { UserService, User } from '@congacommerce/ecommerce';
    export class MyComponent implements OnInit{
        lang:string;
        constructor(private userService: UserService){}
        
        getCurrentUserLanguage(){
            this.lang = this.userService.getCurrentUserLocale();
        }
    
    }
    ```
    *
    * @param underscore when set to true, will replace dash ('-') with an underscore ('_')
    * @returns it return replaced string for current user locale
    */
    getCurrentUserLocale(underscore = true) {
        return this.getLocale().pipe(map$1((result) => {
            let userLang = result;
            if (underscore)
                return userLang.replace('-', '_');
            else
                return userLang.replace('_', '-');
        }));
    }
    /**
     * Method sets the locale for the current user.
     *
     * ### Example:
     ```typescript
     import { UserService, User } from '@congacommerce/ecommerce';
     export class MyComponent implements OnInit{
         constructor(private userService: UserService){}
         
         setLocale(value:string){
             this.userService.setLocale(value);
         }
     }
     ```
     *
     * @param locale locale to set on current user
     * @param commit (Optional) Set to true to commit the locale to the user record
     *
     */
    setLocale(locale, commit = false) {
        this.cacheService._set('locale', locale, true);
        if (commit === true) {
            return this.me().pipe(take(1), map$1(user => {
                user.DefaultCurrencyIsoCode = LocaleCurrency.getCurrency(locale);
                user.LanguageLocaleKey = locale;
                user.LocaleSidKey = locale;
                return user;
            }), mergeMap(user => this.update([user])), map$1(() => this.cacheService.refresh(this.CACHE_KEY)));
        }
        else {
            return of(this.cacheService.refresh(this.CACHE_KEY));
        }
    }
    /**
     * Primary method for authenticating community users. Uses the SOAP Api to retrieve a session id and associate it with
     * any future calls.
     *
     * ### Example:
     ```typescript
     import { UserService, User } from '@congacommerce/ecommerce';
     export class MyComponent implements OnInit{
         constructor(private userService: UserService){}
         
         login(username:string, password:string){
             this.userService.login(username,password);
         }
     
     }
      ```
     *
     * @param username The username of the user to login
     * @param password The password of the user to login
     *
     */
    login(username, password) {
        return this.platformService.login(username, password).pipe(mergeMap(() => this.cacheService.clear()));
    }
    /**
     * Method will trigger the oauth process for a connected app.
     * NOTE: You must implement the redirect / callback process and set the returned access token on the force service manually using this.forceService.setAccessToken(...);
     *
     * ### Example:
     ```typescript
     import { UserService, User } from '@congacommerce/ecommerce';
     export class MyComponent implements OnInit{
         constructor(private userService: UserService){}
         
           samlLogin() {
               this.userService.loginOauth();
            }
        }
    ```
     *
     */
    loginOauth() {
        this.platformService.loginOauth();
    }
    /**
     * Method will trigger a password reset for the given username
     *
     * ### Example:
     ```typescript
     import { UserService, User } from '@congacommerce/ecommerce';
     export class MyComponent implements OnInit{
         constructor(private userService: UserService){}
         
           resetPassword() {
               this.userService.sendPasswordResetEmail();
            }
        }
    ```
     *
     * @param username the username to trigger the password reset for.
     *
     * @returns an observable of type user
     */
    sendPasswordResetEmail(username) {
        return this.platformService.post('resetPassword', { email: username });
    }
    /**
     * Primary logout method.
     *
     * ### Example:
     ```typescript
     import { UserService, User } from '@congacommerce/ecommerce';
     export class MyComponent implements OnInit{
         constructor(private userService: UserService){}
         
           logOut() {
               this.userService.logout();
            }
        }
    ```
     *
     * @returns a void observable when the process has completed.
     */
    logout() {
        return this.platformService.logout().pipe(mergeMap(() => this.cacheService.clear()));
    }
    /**
     * Method is used to set a password for the current user.
     *
     * ### Example:
     ```typescript
     import { UserService, User } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';

     export class MyComponent implements OnInit{
        
         user: User;
         user$: Observable<User>
         constructor(private userService: UserService){}
         
           changePassword(pwd:string) {
              this.userService.setPassword(pwd).subscribe(user => this.user = user);
                // or
              this.user$ = this.userService.setPassword(pwd);
            }
        }
    ```
     *
     * @param newPassword the new password to set on the current user.
     * @returns an observable of the current user
     */
    setPassword(newPassword) {
        return this.platformService.post('changePassword', { password: newPassword }).pipe(mergeMap(res => this.me()));
    }
    /**
     * Method is used to determine if the user has authenticated and an access token exists.
     *
     * ### Example:
     ```typescript
     import { UserService, User } from '@congacommerce/ecommerce';
     export class MyComponent implements OnInit{
        isUserLoggedIn:boolean;
        isUserLoggedIn$:Observable<boolean>;
         constructor(private userService: UserService){}
         
           checkLoginState():boolean {
               this.userService.isLoggedIn().subscribe(res=> isUserLoggedIn = res);
               // or
               isUserLoggedIn$ = this.userService.isLoggedIn();
            }
        }
    ```
     *
     * @returns a boolean observable
     */
    isLoggedIn() {
        return this.me().pipe(map$1(res => (res.Id && !_.isNil(res.Alias) && res.Alias !== 'guest') ? true : false));
    }
    /**
    * Method generates an alias for the current record based on the first name and last name.
    *
    * ### Example:
     ```typescript
     import { UserService, User } from '@congacommerce/ecommerce';
     export class MyComponent implements OnInit{
         constructor(private userService: UserService){}
         
           setUserAlias(value) {
               this.userService.setAlias(value);
            }
        }
    ```
    *
    * @param user the user record to set the alias value on
    *
    */
    setAlias(user) {
        if (user.FirstName && user.FirstName.trim().length >= 1 && user.LastName && user.LastName && user.LastName.trim().length >= 1)
            user.Alias = user.FirstName.substring(0, 1) + user.LastName.substring(0, 7);
        else
            user.Alias = '';
    }
    /**
     * Method sets the timezonesidkey for a given user record
     *
     * ### Example:
      ```typescript
      import { UserService, User } from '@congacommerce/ecommerce';
      export class MyComponent implements OnInit{
          constructor(private userService: UserService){}
          
            setTimezone(value) {
                this.userService.setTimezone(value);
             }
         }
    ```
     *
     * @param user the user record to set the timezonesidkey on
     *
     */
    setTimezone(user) {
        user.TimeZoneSidKey = this.configurationService.get('defaults.timeZoneSidKey', 'America/New_York');
        // user.TimeZoneSidKey = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    /**
     * Method sets the defaults like language, locale & email encoding type for user
     *
     * ### Example:
     ```typescript
      import { UserService, User } from '@congacommerce/ecommerce';
      export class MyComponent implements OnInit{
          constructor(private userService: UserService){}
          
            setDefaultUserData(value) {
                this.userService.setUserDefaults(value);
             }
         }
    ```
     *
     * @param user the user record to set the defaults on
     *
     */
    setUserDefaults(user) {
        user.LanguageLocaleKey = this.getBrowserLocale();
        user.LocaleSidKey = user.LanguageLocaleKey;
        user.EmailEncodingKey = 'UTF-8';
    }
    /**
     * Primary method for registering a given user record. Set any defaults on the user record passed in as the first argument.
     * Will associate an account and a profile with the user record based on the community settings.
     *
     * ### Example:
      ```typescript
      import { UserService, User } from '@congacommerce/ecommerce';
      export class MyComponent implements OnInit{
          constructor(private userService: UserService){}
          
            registration(value) {
                this.userService.register(value);
             }
         }
    ```
     *
     * @param user A user record with defaults set
     * @returns an observable of the register user
     */
    register(user) {
        this.setAlias(user);
        this.setTimezone(user);
        this.setUserDefaults(user);
        delete user.Contact;
        return this.platformService.post('register', {
            u: JSON.stringify(user)
        });
    }
    /**
     * Primary method for updating the current user.
     *
     * ### Example:
       ```typescript
       import { UserService, User } from '@congacommerce/ecommerce';
       export class MyComponent implements OnInit{
           constructor(private userService: UserService){}
           
             updateUserInfo(value) {
                 this.userService.updateCurrentUser(value);
              }
          }
     ```
     *
     * @param user the user record to be updated.
     * @returns an observable of the updated current user
     */
    updateCurrentUser(user) {
        return this.update([user]).pipe(map$1(res => _.first(res)), tap(res => this.userApi.publish(res)));
    }
}
UserService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: UserService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
UserService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: UserService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: UserService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * The storefront record is the backbone to the customer experience. It drives catalog, pricing and interface.
 *
 * <h3>Usage</h3>
 *
 ```typescript
 import { StorefrontService } from '@congacommerce/ecommerce';

 constructor(private storeFrontService: StorefrontService) {}

 // or

 export class MyService extends AObjectService {
     private storeFrontService: StorefrontService = this.injector.get(StorefrontService);
  }
 ```
 */
class StorefrontService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = Storefront;
        this.userService = this.injector.get(UserService);
        this.state = new BehaviorSubject(null);
    }
    onInit() {
        this.refresh();
    }
    /**
     * This method is responsible for fetching the active storefront record.
     *
     * ### Example:
       ```typescript
       import { StorefrontService } from '@congacommerce/ecommerce';
       export class MyComponent implements OnInit{
           constructor(private storeFrontService: StorefrontService) {}
           
           this.storeFrontService.refresh();
       }
       ```
     */
    refresh() {
        this.userService.me().pipe(switchMap(() => this.platformService.apiService.get('/storefronts/active?cacheStrategy=performance&children=StoreBanners')), take(1)).subscribe(data => this.state.next(data));
    }
    /**
     * @ignore
     */
    active() {
        return this.state;
    }
    /**
     * Retrieves the storefront record
     * ### Example:
     ```typescript
     import { StorefrontService, Storefront } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
  
     export class MyComponent implements OnInit{
      storefront: Storefront;
      storefront$: Observable<Storefront>;
  
      constructor(private storefrontService: StorefrontService){}
  
      ngOnInit(){
          this.storefrontService.getStorefront().subscribe(s => this.storefront = s);
          // or
          this.storefront$ = this.storefrontService.getStorefront();
      }
  }
     ```
     * @returns an Observable containing the storefront record
     */
    getStorefront() {
        return this.state.pipe(filter$1(d => !isNil(d)), map$1(data => plainToClass(this.type, get(data, 'Storefront'))));
    }
    /**
     * @ignore
     */
    getTurboEnvironment() {
        return this.getSetting('Turbo');
    }
    /**
     * @ignore
     */
    getDeferredPrice() {
        return this.getSetting('DeferPricing');
    }
    /**
     * @ignore
     */
    isFavoriteDisabled() {
        return this.getSetting('DisableFavorites');
    }
    /**
     * @ignore
     */
    getSetting(key) {
        return this.state.pipe(filter$1(r => !isNil(r)), map$1(res => get(res, key)));
    }
}
StorefrontService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: StorefrontService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
StorefrontService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: StorefrontService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: StorefrontService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * This service is responsible to provide locale data translation for categories, products and product attribute groups based on salesforce translation object.
 * It also provides support for language translation of labels based on the salesforce locale settings.
 *
 * <h3>Usage</h3>
 *
 ```typescript
 import { TranslatorLoaderService } from '@congacommerce/ecommerce';

 constructor(private translateService: TranslatorLoaderService) {}

 // or

 export class MyService extends AObjectService {
     private translateService: TranslatorLoaderService = this.injector.get(TranslatorLoaderService);
  }
 ```
 */
class TranslatorLoaderService {
    constructor(platformService, storefrontService, userService, httpClient, configService) {
        this.platformService = platformService;
        this.storefrontService = storefrontService;
        this.userService = userService;
        this.httpClient = httpClient;
        this.configService = configService;
    }
    /**
     * Retrieves translated labels based on current language and by configuring storefront Translation URL value.
     * ### Example:
     ```typescript
    import { TranslatorLoaderService } from '@congacommerce/ecommerce';

    @NgModule({
        declarations: [
        AppComponent
    ],
    imports: [
        TranslateModule.forRoot({
        loader: {provide: TranslateLoader, useClass: TranslatorLoaderService}
        })
    ],
    providers: [],
    bootstrap: [AppComponent]
    })
     export class AppModule { }
     ```
     * @param lang parameter specifying the language for translation.
     * @returns an Observable containing the json string.
     */
    getTranslation(lang) {
        const localTranslation$ = this.httpClient.get(`${this.configService.resourceLocation()}assets/i18n/${lang}.json`);
        // Get the storefront record to determine remote translation file to use
        return this.storefrontService.getStorefront()
            .pipe(switchMap(storefront => {
            const url = get(storefront, 'TranslationURL');
            const externalTranslation$ = this.isValidURL(url)
                // If the storefront translation url is structured as a url, do a direct http get to that url
                ? this.httpClient.get(get(storefront, 'TranslationURL'))
                // Otherwise assume its the value of a visualforce page and call the GetTranslateLabels endpoint
                : this.platformService.post('GetTranslateLabels', {
                    language: lang,
                    sfTranslateURL: url
                }, 'APTS_TranslatorService', false, 0, '');
            return combineLatest([localTranslation$, externalTranslation$])
                .pipe(map$1(([local, remote]) => merge(local, remote)));
        }), 
        // If an error occurs, use the local sdk translation files
        catchError(err => localTranslation$));
    }
    /**
     * @ignore
     */
    isValidURL(value) {
        const regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
        return regexp.test(value);
    }
    /**
     * Method provides locale data translation for categories, products and product attribute groups based on the salesforce translation object.
     * Also translates product data, with data translations for underlying attribute groups, option groups and product option components for complex bundles.
     * ### Example:
     ```typescript
     import { TranslatorLoaderService } from '@congacommerce/ecommerce';
     export class MyComponent implements OnInit{
         data;
         data$;
         constructor(private translateService: TranslatorLoaderService) {}
         
         getTranslation(record){
              this.translateService.translateData(record).subscribe(user => this.data = user);
                // or
              this.data$ = this.translateService.translateData(record);
            }
     }
     ```
     *
     * @param recordList An array of Category, Product or Product Attribute Group data to be translated.
     * @param categories Category list to translate option groups for a bundle.
     * @returns an observable containing an array of translated Categories, Products or Product Attribute Groups.
     */
    translateData(recordList, categories = null) {
        return this.userService.me().pipe(map$1(user => {
            const language = get(user, 'LanguageLocaleKey');
            this.translateRecords(recordList, language, categories);
            return recordList;
        }));
    }
    /**
     * @ignore
     */
    translateRecords(recordList, language, categories = null) {
        const getTranslations = (recordList) => {
            forEach(recordList, record => {
                if (record instanceof Product) {
                    this.translateProduct(record, language, categories);
                }
                if (record instanceof Category || record instanceof ProductAttributeGroup) {
                    this.applyTranslation(record, get(record, 'Translation', []), language);
                }
                if (has(record, 'Categories')) {
                    getTranslations(map(record.Categories, cat => cat.Classification));
                }
            });
        };
        getTranslations(recordList);
    }
    /**
     * @ignore
     */
    applyTranslation(record, translationRecords, languageLocaleKey) {
        if (!(isEmpty(translationRecords) || isNil(languageLocaleKey))) {
            const translationRecord = find(translationRecords, res => !isNil(get(res, 'Language')) && res.Language.toLowerCase() === languageLocaleKey.toLocaleLowerCase());
            if (translationRecord) {
                assign(record, pick(translationRecord, filter(keys(record), item => item !== 'Id')));
            }
        }
        return record;
    }
    /**
     * @ignore
     */
    translateProduct(product, language, categories) {
        const optionGroups = get(product, 'OptionGroups', []);
        const attributeGroups = map(get(product, 'AttributeGroups', []), 'AttributeGroup');
        // Translate product data
        this.applyTranslation(product, get(product, 'Translation', []), language);
        // Translate product option groups
        forEach(optionGroups, group => {
            const category = find(categories, cat => cat.Id === group.OptionGroupId);
            if (!isEmpty(category) && !isEmpty(category.Translation)) {
                this.applyTranslation(get(group, 'OptionGroup'), get(category, 'Translation', []), language);
            }
        });
        // Translate product attribute groups
        this.translateRecords(attributeGroups, language);
        // Recursively translate attribute groups, option groups and product option components for a bundle.
        if (!isEmpty(optionGroups)) {
            forEach(optionGroups, group => {
                forEach(get(group, 'Options', []), (option) => {
                    this.translateProduct(get(option, 'ComponentProduct'), language, categories);
                });
            });
        }
    }
}
TranslatorLoaderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TranslatorLoaderService, deps: [{ token: i1.PlatformService }, { token: StorefrontService }, { token: UserService }, { token: i3.HttpClient }, { token: i1.ConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
TranslatorLoaderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TranslatorLoaderService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TranslatorLoaderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.PlatformService }, { type: StorefrontService }, { type: UserService }, { type: i3.HttpClient }, { type: i1.ConfigurationService }]; } });

let ProductAttributeValue = class ProductAttributeValue extends AObject {
    constructor() {
        super(...arguments);
        this.Apttus_Config2__LineItemId__c = null;
    }
    get LineItemId() {
        return get(this, 'Apttus_Config2__LineItemId__c');
    }
};
ProductAttributeValue = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__ProductAttributeValue__c',
        aqlName: 'cpq_ProductAttributeValue',
        dynamic: true
    })
], ProductAttributeValue);

let SummaryGroup = class SummaryGroup extends AObject {
    constructor() {
        super(...arguments);
        this.Name = null;
        this.GroupType = null;
        this.LineNumber = null;
        this.LineType = null;
        this.ChargeType = null;
        this.BaseExtendedCost = null;
        this.OptionCost = null;
        this.ExtendedCost = null;
        this.ExtendedListPrice = null;
        this.BaseExtendedPrice = null;
        this.OptionPrice = null;
        this.ExtendedRollupPrice = null;
        this.ExtendedPrice = null;
        this.NetPrice = null;
    }
};
__decorate([
    Expose({ name: 'Name' }),
    __metadata("design:type", String)
], SummaryGroup.prototype, "Name", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__GroupType__c' }),
    __metadata("design:type", String)
], SummaryGroup.prototype, "GroupType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__LineNumber__c' }),
    __metadata("design:type", Number)
], SummaryGroup.prototype, "LineNumber", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__LineType__c' }),
    __metadata("design:type", String)
], SummaryGroup.prototype, "LineType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ChargeType__c' }),
    __metadata("design:type", String)
], SummaryGroup.prototype, "ChargeType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BaseExtendedCost__c' }),
    __metadata("design:type", Number)
], SummaryGroup.prototype, "BaseExtendedCost", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__OptionCost__c' }),
    __metadata("design:type", Number)
], SummaryGroup.prototype, "OptionCost", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ExtendedCost__c' }),
    __metadata("design:type", Number)
], SummaryGroup.prototype, "ExtendedCost", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ExtendedListPrice__c' }),
    __metadata("design:type", Number)
], SummaryGroup.prototype, "ExtendedListPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BaseExtendedPrice__c' }),
    __metadata("design:type", Number)
], SummaryGroup.prototype, "BaseExtendedPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__OptionPrice__c' }),
    __metadata("design:type", Number)
], SummaryGroup.prototype, "OptionPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ExtendedRollupPrice__c' }),
    __metadata("design:type", Number)
], SummaryGroup.prototype, "ExtendedRollupPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ExtendedPrice__c' }),
    __metadata("design:type", Number)
], SummaryGroup.prototype, "ExtendedPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__NetPrice__c' }),
    __metadata("design:type", Number)
], SummaryGroup.prototype, "NetPrice", void 0);
SummaryGroup = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__SummaryGroup__c',
        aqlName: 'cpq_SummaryGroup'
    })
], SummaryGroup);

let Incentive = class Incentive extends AObject {
    constructor() {
        super(...arguments);
        this.Name = null;
        this.ExpirationDate = null;
        this.IncentiveCode = null;
        this.Description = null;
        this.AutoApply = null;
    }
};
__decorate([
    Expose({ name: 'Name' }),
    __metadata("design:type", String)
], Incentive.prototype, "Name", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ExpirationDate__c' }),
    __metadata("design:type", Date)
], Incentive.prototype, "ExpirationDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IncentiveCode__c' }),
    __metadata("design:type", String)
], Incentive.prototype, "IncentiveCode", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Description__c' }),
    __metadata("design:type", String)
], Incentive.prototype, "Description", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AutoApply__c' }),
    __metadata("design:type", String)
], Incentive.prototype, "AutoApply", void 0);
Incentive = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__Incentive__c',
        aqlName: ''
    })
], Incentive);

let AdjustmentItem = class AdjustmentItem extends AObject {
    constructor() {
        super(...arguments);
        this.IncentiveAdjustmentAmount = null;
        this.AdjustmentAmount = null;
        this.IncentiveId = null;
        this.Incentive = null;
        this.IncentiveCode = null;
        this.LineItemId = null;
        this.LineItem = null;
        this.Type = null;
        this.LineType = null;
    }
};
__decorate([
    Expose({ name: 'Apttus_Config2__IncentiveAdjustmentAmount__c' }),
    __metadata("design:type", String)
], AdjustmentItem.prototype, "IncentiveAdjustmentAmount", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AdjustmentAmount__c' }),
    __metadata("design:type", Number)
], AdjustmentItem.prototype, "AdjustmentAmount", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IncentiveId__c' }),
    __metadata("design:type", String)
], AdjustmentItem.prototype, "IncentiveId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IncentiveId__r' }),
    Type(() => Incentive),
    __metadata("design:type", Incentive)
], AdjustmentItem.prototype, "Incentive", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IncentiveCode__c' }),
    __metadata("design:type", String)
], AdjustmentItem.prototype, "IncentiveCode", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__LineItemId__c' }),
    __metadata("design:type", String)
], AdjustmentItem.prototype, "LineItemId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__LineItemId__r' }),
    Type(() => CartItem),
    __metadata("design:type", CartItem)
], AdjustmentItem.prototype, "LineItem", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Type__c' }),
    __metadata("design:type", String)
], AdjustmentItem.prototype, "Type", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__LineType__c' }),
    __metadata("design:type", String)
], AdjustmentItem.prototype, "LineType", void 0);
AdjustmentItem = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__AdjustmentLineItem__c',
        aqlName: ''
    })
], AdjustmentItem);

let TaxBreakup = class TaxBreakup extends AObject {
    constructor() {
        super(...arguments);
        this.BreakupType = null;
        this.LineItemId = null;
        this.LineItem = null;
        this.Sequence = null;
        this.TaxAmount = null;
        this.TaxAppliesTo = null;
        this.TaxRate = null;
        this.TaxType = null;
    }
};
__decorate([
    Expose({ name: 'Apttus_Config2__BreakupType__c' }),
    __metadata("design:type", String)
], TaxBreakup.prototype, "BreakupType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__LineItemId__c' }),
    __metadata("design:type", String)
], TaxBreakup.prototype, "LineItemId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__LineItemId__r' }),
    Type(() => CartItem),
    __metadata("design:type", CartItem)
], TaxBreakup.prototype, "LineItem", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Sequence__c' }),
    __metadata("design:type", Number)
], TaxBreakup.prototype, "Sequence", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__TaxAmount__c' }),
    __metadata("design:type", Number)
], TaxBreakup.prototype, "TaxAmount", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__TaxAppliesTo__c' }),
    __metadata("design:type", String)
], TaxBreakup.prototype, "TaxAppliesTo", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__TaxRate__c' }),
    __metadata("design:type", Number)
], TaxBreakup.prototype, "TaxRate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__TaxType__c' }),
    __metadata("design:type", String)
], TaxBreakup.prototype, "TaxType", void 0);
TaxBreakup = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__TaxBreakup__c',
        aqlName: 'cpq_TaxBreakup'
    })
], TaxBreakup);

let CartItem = class CartItem extends AObject {
    constructor() {
        super(...arguments);
        this.Name = null;
        this.AssetLineItemId = null;
        this.AssetLineItem = null;
        this.LineNumber = null;
        this.PrimaryLineNumber = null;
        this.IncentiveCode = null;
        this.Product = null;
        this.Option = null;
        this.ProductId = null;
        this.TotalQuantity = null;
        this.ItemSequence = null;
        this.StartDate = null;
        this.EndDate = null;
        this.PricingFrequency = null;
        this.ConfigurationId = null;
        this.ListPrice = null;
        this.BasePrice = null;
        this.ExtendedPrice = null;
        this.BaseExtendedPrice = null;
        this.NetPrice = null;
        this.NetUnitPrice = null;
        this.PriceListItemId = null;
        this.HasOptions = null;
        this.HasAttributes = null;
        this.LineType = null;
        this.PriceListId = null;
        this.IsPrimaryLine = null;
        this.IsOptionRollupLine = false;
        this.ConfigStatus = 'NA';
        this.ConstraintCheckStatus = 'NA';
        this.PricingStatus = null;
        this.ProductOptionId = null;
        this.OptionId = null;
        this.AttributeValueId = null;
        this.ParentBundleNumber = null;
        this.PricingTerm = null;
        this.SellingTerm = null;
        this.AddedByRuleInfo = null;
        this.ProductOption = null;
        this.AttributeValue = null;
        this.CurrencyIsoCode = null;
        this.PriceListItem = null;
        this.PriceList = null;
        this.SummaryGroup = null;
        this.IncentiveAdjustmentAmount = null;
        this.LineStatus = null;
        this.CouponCode = null;
        this.ChargeType = null;
        this.PriceType = null;
        this.Taxable = false;
        this.TaxCodeId = null;
        this.TaxCode = null;
        this.TaxInclusive = false;
        this.ShipToAccountId = null;
        this.BillToAccountId = null;
        this.AdjustmentLineItems = null;
        this.TaxBreakups = null;
        this.ExtendedDescription = null;
        this.ClassificationId = null;
        this.ClassificationHierarchy = null;
        this.ClassificationHierarchyInfo = null;
        this.ProductVersion = null;
        this._quantity = null;
    }
    get Quantity() {
        return this._quantity;
    }
    set Quantity(value) {
        this._quantity = value;
    }
};
__decorate([
    Expose({ name: 'Name' }),
    __metadata("design:type", Number)
], CartItem.prototype, "Name", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AssetLineItemId__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "AssetLineItemId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AssetLineItemId__r' }),
    Type(() => AssetLineItemExtended),
    __metadata("design:type", AssetLineItemExtended)
], CartItem.prototype, "AssetLineItem", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__LineNumber__c' }),
    __metadata("design:type", Number)
], CartItem.prototype, "LineNumber", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PrimaryLineNumber__c' }),
    __metadata("design:type", Number)
], CartItem.prototype, "PrimaryLineNumber", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IncentiveCode__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "IncentiveCode", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductId__r' }),
    Type(() => Product),
    __metadata("design:type", Product)
], CartItem.prototype, "Product", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__OptionId__r' }),
    Type(() => Product),
    __metadata("design:type", Product)
], CartItem.prototype, "Option", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductId__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "ProductId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Quantity__c' }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], CartItem.prototype, "Quantity", null);
__decorate([
    Expose({ name: 'Apttus_Config2__TotalQuantity__c' }),
    __metadata("design:type", Number)
], CartItem.prototype, "TotalQuantity", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ItemSequence__c' }),
    __metadata("design:type", Number)
], CartItem.prototype, "ItemSequence", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__StartDate__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "StartDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__EndDate__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "EndDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Frequency__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "PricingFrequency", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ConfigurationId__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "ConfigurationId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ListPrice__c' }),
    __metadata("design:type", Number)
], CartItem.prototype, "ListPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BasePrice__c' }),
    __metadata("design:type", Number)
], CartItem.prototype, "BasePrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ExtendedPrice__c' }),
    __metadata("design:type", Number)
], CartItem.prototype, "ExtendedPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BaseExtendedPrice__c' }),
    __metadata("design:type", Number)
], CartItem.prototype, "BaseExtendedPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__NetPrice__c' }),
    __metadata("design:type", Number)
], CartItem.prototype, "NetPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__NetUnitPrice__c' }),
    __metadata("design:type", Number)
], CartItem.prototype, "NetUnitPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceListItemId__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "PriceListItemId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__HasOptions__c' }),
    __metadata("design:type", Boolean)
], CartItem.prototype, "HasOptions", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__HasAttributes__c' }),
    __metadata("design:type", Boolean)
], CartItem.prototype, "HasAttributes", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__LineType__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "LineType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceListId__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "PriceListId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsPrimaryLine__c' }),
    __metadata("design:type", Boolean)
], CartItem.prototype, "IsPrimaryLine", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsOptionRollupLine__c' }),
    __metadata("design:type", Boolean)
], CartItem.prototype, "IsOptionRollupLine", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ConfigStatus__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "ConfigStatus", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ConstraintCheckStatus__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "ConstraintCheckStatus", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PricingStatus__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "PricingStatus", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductOptionId__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "ProductOptionId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__OptionId__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "OptionId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AttributeValueId__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "AttributeValueId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ParentBundleNumber__c' }),
    __metadata("design:type", Number)
], CartItem.prototype, "ParentBundleNumber", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Term__c' }),
    __metadata("design:type", Number)
], CartItem.prototype, "PricingTerm", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__SellingTerm__c' }),
    __metadata("design:type", Number)
], CartItem.prototype, "SellingTerm", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AddedByRuleInfo__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "AddedByRuleInfo", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductOptionId__r' }),
    Type(() => ProductOptionComponent),
    __metadata("design:type", ProductOptionComponent)
], CartItem.prototype, "ProductOption", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AttributeValueId__r' }),
    Type(() => ProductAttributeValue),
    __metadata("design:type", ProductAttributeValue)
], CartItem.prototype, "AttributeValue", void 0);
__decorate([
    Expose({ name: 'CurrencyIsoCode' }),
    __metadata("design:type", String)
], CartItem.prototype, "CurrencyIsoCode", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceListItemId__r' }),
    Type(() => PriceListItem),
    __metadata("design:type", PriceListItem)
], CartItem.prototype, "PriceListItem", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceListId__r' }),
    Type(() => PriceList),
    __metadata("design:type", PriceList)
], CartItem.prototype, "PriceList", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__SummaryGroupId__r' }),
    Type(() => SummaryGroup),
    __metadata("design:type", SummaryGroup)
], CartItem.prototype, "SummaryGroup", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IncentiveAdjustmentAmount__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "IncentiveAdjustmentAmount", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__LineStatus__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "LineStatus", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__CouponCode__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "CouponCode", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ChargeType__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "ChargeType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceType__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "PriceType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Taxable__c' }),
    __metadata("design:type", Boolean)
], CartItem.prototype, "Taxable", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__TaxCodeId__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "TaxCodeId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__TaxCodeId__r' }),
    Type(() => TaxCode),
    __metadata("design:type", Object)
], CartItem.prototype, "TaxCode", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__TaxInclusive__c' }),
    __metadata("design:type", Boolean)
], CartItem.prototype, "TaxInclusive", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ShipToAccountId__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "ShipToAccountId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BillToAccountId__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "BillToAccountId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AdjustmentLineItems__r' }),
    Type(() => AdjustmentItem),
    __metadata("design:type", Array)
], CartItem.prototype, "AdjustmentLineItems", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__TaxBreakups__r' }),
    Type(() => TaxBreakup),
    __metadata("design:type", Array)
], CartItem.prototype, "TaxBreakups", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ExtendedDescription__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "ExtendedDescription", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ClassificationId__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "ClassificationId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ClassificationHierarchy__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "ClassificationHierarchy", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ClassificationHierarchyInfo__c' }),
    __metadata("design:type", String)
], CartItem.prototype, "ClassificationHierarchyInfo", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductVersion__c' }),
    __metadata("design:type", Number)
], CartItem.prototype, "ProductVersion", void 0);
CartItem = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__LineItem__c',
        aqlName: 'cpq_LineItem'
    })
], CartItem);

let QuoteAttributeValue = class QuoteAttributeValue extends AObject {
    constructor() {
        super(...arguments);
        this.LineItemId = null;
    }
};
__decorate([
    AField({
        soql: 'Apttus_QPConfig__LineItemId__c',
        aql: 'LineItemId'
    }),
    __metadata("design:type", String)
], QuoteAttributeValue.prototype, "LineItemId", void 0);
QuoteAttributeValue = __decorate([
    ATable({
        sobjectName: 'Apttus_QPConfig__ProposalProductAttributeValue__c',
        aqlName: '',
        dynamic: true
    })
], QuoteAttributeValue);

let QuoteAdjustmentItem = class QuoteAdjustmentItem extends AObject {
    constructor() {
        super(...arguments);
        this.IncentiveAdjustmentAmount = null;
        this.AdjustmentAmount = null;
        this.IncentiveId = null;
        this.Incentive = new Incentive();
        this.IncentiveCode = null;
        this.LineItemId = null;
        this.Type = null;
    }
};
__decorate([
    AField({
        soql: 'Apttus_QPConfig__IncentiveAdjustmentAmount__c'
    }),
    __metadata("design:type", String)
], QuoteAdjustmentItem.prototype, "IncentiveAdjustmentAmount", void 0);
__decorate([
    AField({
        soql: 'Apttus_QPConfig__AdjustmentAmount__c'
    }),
    __metadata("design:type", Number)
], QuoteAdjustmentItem.prototype, "AdjustmentAmount", void 0);
__decorate([
    AField({
        soql: 'Apttus_QPConfig__IncentiveId__c'
    }),
    __metadata("design:type", String)
], QuoteAdjustmentItem.prototype, "IncentiveId", void 0);
__decorate([
    AField({
        soql: 'Apttus_QPConfig__IncentiveId__r'
    }),
    Type(() => Incentive),
    __metadata("design:type", Incentive)
], QuoteAdjustmentItem.prototype, "Incentive", void 0);
__decorate([
    AField({
        soql: 'Apttus_QPConfig__IncentiveCode__c'
    }),
    __metadata("design:type", String)
], QuoteAdjustmentItem.prototype, "IncentiveCode", void 0);
__decorate([
    AField({
        soql: 'Apttus_QPConfig__LineItemId__c'
    }),
    __metadata("design:type", String)
], QuoteAdjustmentItem.prototype, "LineItemId", void 0);
__decorate([
    AField({
        soql: 'Apttus_QPConfig__Type__c'
    }),
    __metadata("design:type", String)
], QuoteAdjustmentItem.prototype, "Type", void 0);
QuoteAdjustmentItem = __decorate([
    ATable({
        sobjectName: 'Apttus_QPConfig__ProposalAdjustmentLineItem__c',
        aqlName: ''
    })
], QuoteAdjustmentItem);

let ProposalTaxBreakup = class ProposalTaxBreakup extends AObject {
    constructor() {
        super(...arguments);
        this.BreakupType = null;
        this.LineItemId = null;
        this.LineItem = new QuoteLineItem();
        this.Sequence = null;
        this.TaxAmount = null;
        this.TaxAppliesTo = null;
        this.TaxRate = null;
        this.TaxType = null;
    }
};
__decorate([
    AField({
        soql: 'Apttus_QPConfig__BreakupType__c',
        aql: 'BreakupType'
    }),
    __metadata("design:type", String)
], ProposalTaxBreakup.prototype, "BreakupType", void 0);
__decorate([
    AField({
        soql: 'Apttus_QPConfig__LineItemId__c',
        aql: 'LineItemId'
    }),
    __metadata("design:type", String)
], ProposalTaxBreakup.prototype, "LineItemId", void 0);
__decorate([
    AField({
        soql: 'Apttus_QPConfig__LineItemId__r',
        aql: 'LineItemId'
    }),
    Type(() => QuoteLineItem),
    __metadata("design:type", Object)
], ProposalTaxBreakup.prototype, "LineItem", void 0);
__decorate([
    AField({
        soql: 'Apttus_QPConfig__Sequence__c',
        aql: 'Sequence'
    }),
    __metadata("design:type", Number)
], ProposalTaxBreakup.prototype, "Sequence", void 0);
__decorate([
    AField({
        soql: 'Apttus_QPConfig__TaxAmount__c',
        aql: 'TaxAmount'
    }),
    __metadata("design:type", Number)
], ProposalTaxBreakup.prototype, "TaxAmount", void 0);
__decorate([
    AField({
        soql: 'Apttus_QPConfig__TaxAppliesTo__c',
        aql: 'TaxAppliesTo'
    }),
    __metadata("design:type", String)
], ProposalTaxBreakup.prototype, "TaxAppliesTo", void 0);
__decorate([
    AField({
        soql: 'Apttus_QPConfig__TaxRate__c',
        aql: 'TaxRate'
    }),
    __metadata("design:type", Number)
], ProposalTaxBreakup.prototype, "TaxRate", void 0);
__decorate([
    AField({
        soql: 'Apttus_QPConfig__TaxType__c',
        aql: 'TaxType'
    }),
    __metadata("design:type", String)
], ProposalTaxBreakup.prototype, "TaxType", void 0);
ProposalTaxBreakup = __decorate([
    ATable({
        sobjectName: 'Apttus_QPConfig__ProposalTaxBreakup__c',
        aqlName: 'cpq_ProposalTaxBreakup'
    })
], ProposalTaxBreakup);

let QuoteLineItem = class QuoteLineItem extends AObject {
    constructor() {
        super(...arguments);
        this.Product = null;
        this.SellingTerm = null;
        this.Quantity2 = null;
        this.HasOptions = null;
        this.LineType = null;
        this.IsPrimaryLine = null;
        this.PrimaryLineNumber = null;
        this.ItemSequence = null;
        this.AdjustedPrice = null;
        this.NetPrice = null;
        this.ExtNetPrice = null;
        this.BasePrice = null;
        this.ListPrice = null;
        this.AttributeValue = null;
        this.ProductOptionId = null;
        this.ProductOption = null;
        this.StartDate = null;
        this.EndDate = null;
        this.LineNumber = null;
        this.ParentBundleNumber = null;
        this.ProposalId = null;
        this.IncentiveAdjustmentAmount = null;
        this.PriceListItem = null;
        this.PriceType = null;
        this.LineStatus = null;
        this.Option = null;
        this.OptionId = null;
        this.IsOptionRollupLine = null;
        this.IsPrimaryRampLine = null;
        this.ChargeType = null;
        this.Taxable = false;
        this.AdjustmentLineItems = null;
        this.ExtendedPrice = null;
        this.BaseExtendedPrice = null;
        this.PricingFrequency = null;
        this.TaxBreakups = null;
    }
    get Quantity() {
        return this.Quantity2;
    }
};
__decorate([
    Expose({ name: 'Apttus_Proposal__Product__r' }),
    Type(() => Product),
    __metadata("design:type", Product)
], QuoteLineItem.prototype, "Product", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__SellingTerm__c' }),
    __metadata("design:type", Number)
], QuoteLineItem.prototype, "SellingTerm", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__Quantity2__c' }),
    __metadata("design:type", Number)
], QuoteLineItem.prototype, "Quantity2", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__HasOptions__c' }),
    __metadata("design:type", Boolean)
], QuoteLineItem.prototype, "HasOptions", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__LineType__c' }),
    __metadata("design:type", String)
], QuoteLineItem.prototype, "LineType", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__IsPrimaryLine__c' }),
    __metadata("design:type", String)
], QuoteLineItem.prototype, "IsPrimaryLine", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__PrimaryLineNumber__c' }),
    __metadata("design:type", Number)
], QuoteLineItem.prototype, "PrimaryLineNumber", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__ItemSequence__c' }),
    __metadata("design:type", Number)
], QuoteLineItem.prototype, "ItemSequence", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__AdjustedPrice__c' }),
    __metadata("design:type", Number)
], QuoteLineItem.prototype, "AdjustedPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__NetPrice__c' }),
    __metadata("design:type", Number)
], QuoteLineItem.prototype, "NetPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Ext_Net_Price__c' }),
    __metadata("design:type", Number)
], QuoteLineItem.prototype, "ExtNetPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__BasePrice__c' }),
    __metadata("design:type", Number)
], QuoteLineItem.prototype, "BasePrice", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__ListPrice__c' }),
    __metadata("design:type", Number)
], QuoteLineItem.prototype, "ListPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__AttributeValueId__r' }),
    Type(() => QuoteAttributeValue),
    __metadata("design:type", QuoteAttributeValue)
], QuoteLineItem.prototype, "AttributeValue", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__ProductOptionId__c' }),
    __metadata("design:type", String)
], QuoteLineItem.prototype, "ProductOptionId", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__ProductOptionId__r' }),
    Type(() => ProductOptionComponent),
    __metadata("design:type", ProductOptionComponent)
], QuoteLineItem.prototype, "ProductOption", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__StartDate__c' }),
    __metadata("design:type", String)
], QuoteLineItem.prototype, "StartDate", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__EndDate__c' }),
    __metadata("design:type", String)
], QuoteLineItem.prototype, "EndDate", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__LineNumber__c' }),
    __metadata("design:type", Number)
], QuoteLineItem.prototype, "LineNumber", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__ParentBundleNumber__c' }),
    __metadata("design:type", Number)
], QuoteLineItem.prototype, "ParentBundleNumber", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Proposal__c' }),
    __metadata("design:type", String)
], QuoteLineItem.prototype, "ProposalId", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__IncentiveAdjustmentAmount__c' }),
    __metadata("design:type", Number)
], QuoteLineItem.prototype, "IncentiveAdjustmentAmount", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__PriceListItemId__r' }),
    Type(() => PriceListItem),
    __metadata("design:type", PriceListItem)
], QuoteLineItem.prototype, "PriceListItem", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__PriceType__c' }),
    __metadata("design:type", String)
], QuoteLineItem.prototype, "PriceType", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__LineStatus__c' }),
    __metadata("design:type", String)
], QuoteLineItem.prototype, "LineStatus", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__OptionId__r' }),
    Type(() => Product),
    __metadata("design:type", Product)
], QuoteLineItem.prototype, "Option", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__OptionId__c' }),
    __metadata("design:type", String)
], QuoteLineItem.prototype, "OptionId", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__IsOptionRollupLine__c' }),
    __metadata("design:type", Boolean)
], QuoteLineItem.prototype, "IsOptionRollupLine", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__IsPrimaryRampLine__c' }),
    __metadata("design:type", Boolean)
], QuoteLineItem.prototype, "IsPrimaryRampLine", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__ChargeType__c' }),
    __metadata("design:type", String)
], QuoteLineItem.prototype, "ChargeType", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__Taxable__c' }),
    __metadata("design:type", Boolean)
], QuoteLineItem.prototype, "Taxable", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__AdjustmentLineItems__r' }),
    Type(() => QuoteAdjustmentItem),
    __metadata("design:type", Array)
], QuoteLineItem.prototype, "AdjustmentLineItems", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__ExtendedPrice__c' }),
    __metadata("design:type", Number)
], QuoteLineItem.prototype, "ExtendedPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__BaseExtendedPrice__c' }),
    __metadata("design:type", Number)
], QuoteLineItem.prototype, "BaseExtendedPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__Frequency__c' }),
    __metadata("design:type", Number)
], QuoteLineItem.prototype, "PricingFrequency", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__TaxBreakups__r' }),
    Type(() => ProposalTaxBreakup),
    __metadata("design:type", Array)
], QuoteLineItem.prototype, "TaxBreakups", void 0);
QuoteLineItem = __decorate([
    ATable({
        sobjectName: 'Apttus_Proposal__Proposal_Line_Item__c',
        aqlName: 'cpq_QuoteLineItem'
    })
], QuoteLineItem);

let OrderAttributeValue = class OrderAttributeValue extends AObject {
    constructor() {
        super(...arguments);
        this.LineItemId = null;
    }
};
__decorate([
    AField({
        soql: 'Apttus_Config2__LineItemId__c',
        aql: 'LineItemId'
    }),
    __metadata("design:type", String)
], OrderAttributeValue.prototype, "LineItemId", void 0);
OrderAttributeValue = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__OrderProductAttributeValue__c',
        aqlName: 'ord_OrderProductAttributeValue',
        dynamic: true
    })
], OrderAttributeValue);

let OrderAdjustmentItem = class OrderAdjustmentItem extends AObject {
    constructor() {
        super(...arguments);
        this.IncentiveAdjustmentAmount = null;
        this.AdjustmentAmount = null;
        this.IncentiveId = null;
        this.Incentive = new Incentive();
        this.IncentiveCode = null;
        this.LineItemId = null;
        this.Type = null;
        this.LineType = null;
    }
};
__decorate([
    AField({
        soql: 'Apttus_Config2__IncentiveAdjustmentAmount__c'
    }),
    __metadata("design:type", String)
], OrderAdjustmentItem.prototype, "IncentiveAdjustmentAmount", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__AdjustmentAmount__c'
    }),
    __metadata("design:type", Number)
], OrderAdjustmentItem.prototype, "AdjustmentAmount", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__IncentiveId__c'
    }),
    __metadata("design:type", String)
], OrderAdjustmentItem.prototype, "IncentiveId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__IncentiveId__r'
    }),
    Type(() => Incentive),
    __metadata("design:type", Incentive)
], OrderAdjustmentItem.prototype, "Incentive", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__IncentiveCode__c'
    }),
    __metadata("design:type", String)
], OrderAdjustmentItem.prototype, "IncentiveCode", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__LineItemId__c'
    }),
    __metadata("design:type", String)
], OrderAdjustmentItem.prototype, "LineItemId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Type__c'
    }),
    __metadata("design:type", String)
], OrderAdjustmentItem.prototype, "Type", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__LineType__c'
    }),
    __metadata("design:type", String)
], OrderAdjustmentItem.prototype, "LineType", void 0);
OrderAdjustmentItem = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__OrderAdjustmentLineItem__c',
        aqlName: ''
    })
], OrderAdjustmentItem);

let OrderTaxBreakup = class OrderTaxBreakup extends AObject {
    constructor() {
        super(...arguments);
        this.BreakupType = null;
        this.OrderLineItemId = null;
        this.OrderLineItem = null;
        this.Sequence = null;
        this.TaxAmount = null;
        this.TaxAppliesTo = null;
        this.TaxRate = null;
        this.TaxType = null;
    }
};
__decorate([
    AField({
        soql: 'Apttus_Config2__BreakupType__c',
        aql: 'BreakupType'
    }),
    __metadata("design:type", String)
], OrderTaxBreakup.prototype, "BreakupType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__OrderLineItemId__c',
        aql: 'OrderLineItemId'
    }),
    __metadata("design:type", String)
], OrderTaxBreakup.prototype, "OrderLineItemId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__OrderLineItemId__r',
        aql: 'OrderLineItemId'
    }),
    Type(() => OrderLineItem),
    __metadata("design:type", Object)
], OrderTaxBreakup.prototype, "OrderLineItem", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Sequence__c',
        aql: 'Sequence'
    }),
    __metadata("design:type", Number)
], OrderTaxBreakup.prototype, "Sequence", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__TaxAmount__c',
        aql: 'TaxAmount'
    }),
    __metadata("design:type", Number)
], OrderTaxBreakup.prototype, "TaxAmount", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__TaxAppliesTo__c',
        aql: 'TaxAppliesTo'
    }),
    __metadata("design:type", String)
], OrderTaxBreakup.prototype, "TaxAppliesTo", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__TaxRate__c',
        aql: 'TaxRate'
    }),
    __metadata("design:type", Number)
], OrderTaxBreakup.prototype, "TaxRate", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__TaxType__c',
        aql: 'TaxType'
    }),
    __metadata("design:type", String)
], OrderTaxBreakup.prototype, "TaxType", void 0);
OrderTaxBreakup = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__OrderTaxBreakup__c',
        aqlName: 'cpq_OrderTaxBreakup'
    })
], OrderTaxBreakup);

let OrderLineItem = class OrderLineItem extends AObject {
    constructor() {
        super(...arguments);
        this.AdjustedPrice = null;
        this.AdjustmentAmount = null;
        this.AdjustmentType = null;
        this.AutoRenew = null;
        this.AutoRenewalTerm = null;
        this.AutoRenewalType = null;
        this.BaseCost = null;
        this.BaseCostOverride = null;
        this.BaseExtendedCost = null;
        this.BaseExtendedPrice = null;
        this.BasePrice = null;
        this.BasePriceOverride = null;
        this.BasePriceMethod = null;
        this.BaseProductId = null;
        // })
        // @Expose({ name: l: 'Apttus_Config2__BaseProductId__r' })
        // // BaseProduct: Product = new Product();
        this.BillingFrequency = null;
        this.BillingRule = null;
        // @Expose({ name: l: 'Apttus_Config2__BillToAccountId__r' })
        // BillToAccount: Account = new Account();
        this.BillToAccountId = null;
        this.CancelledDate = null;
        // @Expose({ name: l: 'Apttus_Config2__classificationId__r' })
        // Classification: Category = new Category();
        this.ClassificationId = null;
        this.ClassificationHierarchy = null;
        this.ChargeType = null;
        this.Comments = null;
        this.CommitmentQuantity = null;
        // @Expose({ name: l: 'Apttus_Config2__configurationId__r' })
        // Configuration: Cart = new Cart();
        this.ConfigurationId = null;
        this.ContractNumbers = null;
        this.Cost = null;
        this.CouponCode = null;
        this.DeltaPrice = null;
        this.DeltaQuantity = null;
        this.Description = null;
        this.EndDate = null;
        this.ExtendedCost = null;
        this.ExtendedDescription = null;
        this.ExtendedPrice = null;
        this.ExtendedQuantity = null;
        this.FlatOptionPrice = null;
        this.FulfilledQuantity = null;
        this.GroupAdjustmentPercent = null;
        this.Guidance = null;
        this.HasAttributes = null;
        this.HasIncentives = null;
        this.HasOptions = null;
        this.HideInvoiceDisplay = null;
        this.ImpactARR = null;
        this.ImpactMRR = null;
        this.ImpactTCV = null;
        this.IncentiveAdjustmentAmount = null;
        this.IncentiveCode = null;
        this.IncentiveExtendedPrice = null;
        this.IncentiveType = null;
        this.IsAssetPricing = null;
        this.IsCustomPricing = null;
        this.IsOptionRollupLine = null;
        this.IsPrimaryLine = null;
        this.IsPrimaryRampLine = null;
        this.IsUsageTierModifiable = null;
        this.ItemSequence = null;
        this.LineNumber = null;
        this.LineStatus = null;
        this.LineType = null;
        this.ListPrice = null;
        this.MaxUsageQuantity = null;
        this.MinUsageQuantity = null;
        this.NetAdjustmentPercent = null;
        this.NetPrice = null;
        this.NetUnitPrice = null;
        this.Option = null;
        this.ProductOptionId = null;
        this.ProductOption = null;
        this.OptionCost = null;
        this.OptionPrice = null;
        this.OrderId = null;
        this.OrderARR = null;
        this.OrderMRR = null;
        this.OrderTCV = null;
        this.ParentBundleNumber = null;
        this.PriceAdjustment = null;
        this.PriceAdjustmentAmount = null;
        this.PriceAdjustmentType = null;
        this.PriceGroup = null;
        this.PriceIncludedInBundle = null;
        this.PriceListItem = null;
        this.PriceMethod = null;
        this.PriceType = null;
        this.PricingDate = null;
        this.PricingFrequency = null;
        this.Term = null;
        this.PriceUom = null;
        this.PrimaryLineNumber = null;
        this.Product = null;
        this.ProductId = null;
        this.Uom = null;
        this.Quantity = null;
        this.ActivatedDate = null;
        this.ReadyForBillingDate = null;
        this.FulfilledDate = null;
        this.ReadyForRevRecDate = null;
        this.RebateAmount = null;
        this.RenewalAdjustmentAmount = null;
        this.RenewalAdjustmentType = null;
        this.SellingFrequency = null;
        this.SellingTerm = null;
        // @Expose({ name: : 'Apttus_Config2__ShipToAccountId__r' })
        // ShipToAccount: Account = new Account();
        this.StartDate = null;
        this.Status = null;
        this.SubType = null;
        this.Taxable = null;
        this.TaxCodeId = null;
        this.TaxCode = null;
        this.TaxInclusive = null;
        this.Type = null;
        this.DerivedFromId = null;
        this.AttributeValue = null;
        this.AdjustmentLineItems = null;
        this.OrderTaxBreakups = null;
        this.OptionId = null;
    }
};
__decorate([
    Expose({ name: 'Apttus_Config2__AdjustedPrice__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "AdjustedPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AdjustmentAmount__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "AdjustmentAmount", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AdjustmentType__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "AdjustmentType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AutoRenew__c' }),
    __metadata("design:type", Boolean)
], OrderLineItem.prototype, "AutoRenew", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AutoRenewalTerm__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "AutoRenewalTerm", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AutoRenewalType__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "AutoRenewalType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BaseCost__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "BaseCost", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BaseCostOverride__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "BaseCostOverride", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BaseExtendedCost__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "BaseExtendedCost", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BaseExtendedPrice__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "BaseExtendedPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BasePrice__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "BasePrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BasePriceOverride__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "BasePriceOverride", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BasePriceMethod__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "BasePriceMethod", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BaseProductId__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "BaseProductId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BillingFrequency__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "BillingFrequency", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BillingRule__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "BillingRule", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BillToAccountId__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "BillToAccountId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__CancelledDate__c' }),
    __metadata("design:type", Date)
], OrderLineItem.prototype, "CancelledDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ClassificationId__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "ClassificationId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ClassificationHierarchy__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "ClassificationHierarchy", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ChargeType__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "ChargeType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Comments__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "Comments", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__CommitmentQuantity__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "CommitmentQuantity", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ConfigurationId__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "ConfigurationId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ContractNumbers__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "ContractNumbers", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Cost__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "Cost", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__CouponCode__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "CouponCode", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__DeltaPrice__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "DeltaPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__DeltaQuantity__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "DeltaQuantity", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Description__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "Description", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__EndDate__c' }),
    __metadata("design:type", Date)
], OrderLineItem.prototype, "EndDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ExtendedCost__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "ExtendedCost", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ExtendedDescription__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "ExtendedDescription", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ExtendedPrice__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "ExtendedPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ExtendedQuantity__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "ExtendedQuantity", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__FlatOptionPrice__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "FlatOptionPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__FulfilledQuantity__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "FulfilledQuantity", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__GroupAdjustmentPercent__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "GroupAdjustmentPercent", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Guidance__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "Guidance", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__HasAttributes__c' }),
    __metadata("design:type", Boolean)
], OrderLineItem.prototype, "HasAttributes", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__HasIncentives__c' }),
    __metadata("design:type", Boolean)
], OrderLineItem.prototype, "HasIncentives", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__HasOptions__c' }),
    __metadata("design:type", Boolean)
], OrderLineItem.prototype, "HasOptions", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__HideInvoiceDisplay__c' }),
    __metadata("design:type", Boolean)
], OrderLineItem.prototype, "HideInvoiceDisplay", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ImpactARR__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "ImpactARR", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ImpactMRR__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "ImpactMRR", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ImpactTCV__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "ImpactTCV", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IncentiveAdjustmentAmount__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "IncentiveAdjustmentAmount", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IncentiveCode__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "IncentiveCode", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IncentiveExtendedPrice__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "IncentiveExtendedPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IncentiveType__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "IncentiveType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsAssetPricing__c' }),
    __metadata("design:type", Boolean)
], OrderLineItem.prototype, "IsAssetPricing", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsCustomPricing__c' }),
    __metadata("design:type", Boolean)
], OrderLineItem.prototype, "IsCustomPricing", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsOptionRollupLine__c' }),
    __metadata("design:type", Boolean)
], OrderLineItem.prototype, "IsOptionRollupLine", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsPrimaryLine__c' }),
    __metadata("design:type", Boolean)
], OrderLineItem.prototype, "IsPrimaryLine", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsPrimaryRampLine__c' }),
    __metadata("design:type", Boolean)
], OrderLineItem.prototype, "IsPrimaryRampLine", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsUsageTierModifiable__c' }),
    __metadata("design:type", Boolean)
], OrderLineItem.prototype, "IsUsageTierModifiable", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ItemSequence__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "ItemSequence", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__LineNumber__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "LineNumber", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__LineStatus__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "LineStatus", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__LineType__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "LineType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ListPrice__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "ListPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__MaxUsageQuantity__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "MaxUsageQuantity", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__MinUsageQuantity__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "MinUsageQuantity", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__NetAdjustmentPercent__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "NetAdjustmentPercent", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__NetPrice__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "NetPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__NetUnitPrice__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "NetUnitPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__OptionId__r' }),
    Type(() => Product),
    __metadata("design:type", Product)
], OrderLineItem.prototype, "Option", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductOptionId__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "ProductOptionId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductOptionId__r' }),
    Type(() => ProductOptionComponent),
    __metadata("design:type", ProductOptionComponent)
], OrderLineItem.prototype, "ProductOption", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__OptionCost__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "OptionCost", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__OptionPrice__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "OptionPrice", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__OrderId__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "OrderId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__OrderARR__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "OrderARR", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__OrderMRR__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "OrderMRR", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__OrderTCV__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "OrderTCV", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ParentBundleNumber__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "ParentBundleNumber", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceAdjustment__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "PriceAdjustment", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceAdjustmentAmount__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "PriceAdjustmentAmount", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceAdjustmentType__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "PriceAdjustmentType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceGroup__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "PriceGroup", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceIncludedInBundle__c' }),
    __metadata("design:type", Boolean)
], OrderLineItem.prototype, "PriceIncludedInBundle", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceListItemId__r' }),
    Type(() => PriceListItem),
    __metadata("design:type", PriceListItem)
], OrderLineItem.prototype, "PriceListItem", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceMethod__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "PriceMethod", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceType__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "PriceType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PricingDate__c' }),
    __metadata("design:type", Date)
], OrderLineItem.prototype, "PricingDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Frequency__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "PricingFrequency", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Term__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "Term", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceUom__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "PriceUom", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PrimaryLineNumber__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "PrimaryLineNumber", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductId__r' }),
    Type(() => Product),
    __metadata("design:type", Product)
], OrderLineItem.prototype, "Product", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ProductId__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "ProductId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Uom__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "Uom", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Quantity__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "Quantity", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ActivatedDate__c' }),
    __metadata("design:type", Date)
], OrderLineItem.prototype, "ActivatedDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ReadyForBillingDate__c' }),
    __metadata("design:type", Date)
], OrderLineItem.prototype, "ReadyForBillingDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__FulfilledDate__c' }),
    __metadata("design:type", Date)
], OrderLineItem.prototype, "FulfilledDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ReadyForRevRecDate__c' }),
    __metadata("design:type", Date)
], OrderLineItem.prototype, "ReadyForRevRecDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__RebateAmount__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "RebateAmount", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__RenewalAdjustmentAmount__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "RenewalAdjustmentAmount", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__RenewalAdjustmentType__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "RenewalAdjustmentType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__SellingFrequency__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "SellingFrequency", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__SellingTerm__c' }),
    __metadata("design:type", Number)
], OrderLineItem.prototype, "SellingTerm", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__StartDate__c' }),
    __metadata("design:type", Date)
], OrderLineItem.prototype, "StartDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Status__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "Status", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__SubType__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "SubType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Taxable__c' }),
    __metadata("design:type", Boolean)
], OrderLineItem.prototype, "Taxable", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__TaxCodeId__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "TaxCodeId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__TaxCodeId__r' }),
    Type(() => TaxCode),
    __metadata("design:type", Object)
], OrderLineItem.prototype, "TaxCode", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__TaxInclusive__c' }),
    __metadata("design:type", Boolean)
], OrderLineItem.prototype, "TaxInclusive", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Type__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "Type", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__DerivedFromId__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "DerivedFromId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AttributeValueId__r' }),
    Type(() => OrderAttributeValue),
    __metadata("design:type", OrderAttributeValue)
], OrderLineItem.prototype, "AttributeValue", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AdjustmentLineItems__r' }),
    Type(() => OrderAdjustmentItem),
    __metadata("design:type", Array)
], OrderLineItem.prototype, "AdjustmentLineItems", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__OrderTaxBreakups__r' }),
    Type(() => OrderTaxBreakup),
    __metadata("design:type", Array)
], OrderLineItem.prototype, "OrderTaxBreakups", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__OptionId__c' }),
    __metadata("design:type", String)
], OrderLineItem.prototype, "OptionId", void 0);
OrderLineItem = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__OrderLineItem__c',
        aqlName: 'ord_OrderLineItem'
    })
], OrderLineItem);

/** @ignore  */
function MailFactory(toAddresses, subject, plainBody) {
    return {
        toAddresses: toAddresses,
        ccAddresses: null,
        replyTo: null,
        displayName: null,
        subject: subject,
        bccSender: false,
        useSignature: false,
        plainBody: plainBody,
        htmlBody: null,
        templateName: null,
        contactId: null,
        whatId: null
    };
}
/** @ignore  */
function TemplateMailFactory(templateName, whatId, contactId, toAddresses, ccAddresses, attachmentIds) {
    return {
        toAddresses: toAddresses,
        ccAddresses: ccAddresses,
        replyTo: null,
        displayName: null,
        subject: null,
        bccSender: false,
        useSignature: false,
        plainBody: null,
        htmlBody: null,
        templateName: templateName,
        contactId: contactId,
        whatId: whatId,
        attachmentIds: attachmentIds
    };
}

let AuthConfig = class AuthConfig extends AObject {
    constructor() {
        super(...arguments);
        this.Url = null;
        this.AuthOptionsSaml = null;
        this.AuthOptionsAuthProvider = null;
        this.AuthOptionsCertificate = null;
        this.AuthOptionsUsernamePassword = null;
        this.AuthProvidersForConfig = null;
    }
};
__decorate([
    AField({
        soql: 'Url'
    }),
    __metadata("design:type", String)
], AuthConfig.prototype, "Url", void 0);
__decorate([
    AField({
        soql: 'AuthOptionsSaml'
    }),
    __metadata("design:type", Boolean)
], AuthConfig.prototype, "AuthOptionsSaml", void 0);
__decorate([
    AField({
        soql: 'AuthOptionsAuthProvider'
    }),
    __metadata("design:type", Boolean)
], AuthConfig.prototype, "AuthOptionsAuthProvider", void 0);
__decorate([
    AField({
        soql: 'AuthOptionsCertificate'
    }),
    __metadata("design:type", Boolean)
], AuthConfig.prototype, "AuthOptionsCertificate", void 0);
__decorate([
    AField({
        soql: 'AuthOptionsUsernamePassword'
    }),
    __metadata("design:type", Boolean)
], AuthConfig.prototype, "AuthOptionsUsernamePassword", void 0);
__decorate([
    AField({
        soql: 'AuthProvidersForConfig'
    }),
    Type(() => AuthConfigProviders),
    __metadata("design:type", Array)
], AuthConfig.prototype, "AuthProvidersForConfig", void 0);
AuthConfig = __decorate([
    ATable({
        sobjectName: 'AuthConfig'
    })
], AuthConfig);
let AuthConfigProviders = class AuthConfigProviders extends AObject {
    constructor() {
        super(...arguments);
        this.AuthProvider = null;
    }
};
__decorate([
    AField({
        soql: 'AuthProvider'
    }),
    Type(() => SamlSSOConfig),
    __metadata("design:type", SamlSSOConfig)
], AuthConfigProviders.prototype, "AuthProvider", void 0);
AuthConfigProviders = __decorate([
    ATable({
        sobjectName: 'AuthConfigProviders'
    })
], AuthConfigProviders);
let SamlSSOConfig = class SamlSSOConfig extends AObject {
    constructor() {
        super(...arguments);
        this.Name = null;
    }
};
__decorate([
    AField({
        soql: 'Name'
    }),
    __metadata("design:type", String)
], SamlSSOConfig.prototype, "Name", void 0);
SamlSSOConfig = __decorate([
    ATable({
        sobjectName: 'SamlSsoConfig',
        defaultFields: false
    })
], SamlSSOConfig);

var PriceRuleSet_1, PriceRule_1;
let PriceRuleSet = PriceRuleSet_1 = class PriceRuleSet extends AObject {
    constructor() {
        super(...arguments);
        this.Active = null;
        this.AdjustmentAppliesTo = null;
        this.UseType = null;
        this.ApplicationMethod = null;
        this.Category = null;
        this.ChargeType = null;
        this.Description = null;
        this.EffectiveDate = null;
        this.ExpirationDate = null;
        this.HasCriteria = null;
        this.IncentiveId = null;
        this.PriceListId = null;
        this.ProductCategory = null;
        this.ProductFamily = null;
        this.ProductGroupId = null;
        this.Criteria = null;
        this.ExclusionCriteria = null;
        this.Sequence = null;
        this.StopProcessingMoreRules = null;
        this.Type = null;
    }
};
__decorate([
    AField({
        soql: 'Apttus_Config2__Active__c',
        aql: 'Active'
    }),
    __metadata("design:type", Boolean)
], PriceRuleSet.prototype, "Active", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__AdjustmentAppliesTo__c',
        aql: 'AdjustmentAppliesTo'
    }),
    __metadata("design:type", String)
], PriceRuleSet.prototype, "AdjustmentAppliesTo", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__UseType__c',
        aql: 'UseType'
    }),
    __metadata("design:type", String)
], PriceRuleSet.prototype, "UseType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ApplicationMethod__c',
        aql: 'ApplicationMethod'
    }),
    __metadata("design:type", String)
], PriceRuleSet.prototype, "ApplicationMethod", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Category__c',
        aql: 'Category'
    }),
    __metadata("design:type", String)
], PriceRuleSet.prototype, "Category", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ChargeType__c',
        aql: 'ChargeType'
    }),
    __metadata("design:type", String)
], PriceRuleSet.prototype, "ChargeType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Description__c',
        aql: 'Description'
    }),
    __metadata("design:type", String)
], PriceRuleSet.prototype, "Description", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__EffectiveDate__c',
        aql: 'EffectiveDate'
    }),
    __metadata("design:type", Date)
], PriceRuleSet.prototype, "EffectiveDate", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ExpirationDate__c',
        aql: 'ExpirationDate'
    }),
    __metadata("design:type", Date)
], PriceRuleSet.prototype, "ExpirationDate", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__HasCriteria__c',
        aql: 'HasCriteria'
    }),
    __metadata("design:type", Boolean)
], PriceRuleSet.prototype, "HasCriteria", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__IncentiveId__c',
        aql: 'IncentiveId'
    }),
    __metadata("design:type", String)
], PriceRuleSet.prototype, "IncentiveId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__PriceListId__c',
        aql: 'PriceListId'
    }),
    __metadata("design:type", String)
], PriceRuleSet.prototype, "PriceListId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductCategory__c',
        aql: 'ProductCategory'
    }),
    __metadata("design:type", String)
], PriceRuleSet.prototype, "ProductCategory", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductFamily__c',
        aql: 'ProductFamily'
    }),
    __metadata("design:type", String)
], PriceRuleSet.prototype, "ProductFamily", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductGroupId__c',
        aql: 'ProductGroupId'
    }),
    __metadata("design:type", String)
], PriceRuleSet.prototype, "ProductGroupId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Criteria__c',
        aql: 'Criteria'
    }),
    __metadata("design:type", String)
], PriceRuleSet.prototype, "Criteria", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ExclusionCriteria__c',
        aql: 'ExclusionCriteria'
    }),
    __metadata("design:type", String)
], PriceRuleSet.prototype, "ExclusionCriteria", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Sequence__c',
        aql: 'Sequence'
    }),
    __metadata("design:type", Number)
], PriceRuleSet.prototype, "Sequence", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__StopProcessingMoreRules__c',
        aql: 'StopProcessingMoreRules'
    }),
    __metadata("design:type", Boolean)
], PriceRuleSet.prototype, "StopProcessingMoreRules", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Type__c',
        aql: 'Type'
    }),
    __metadata("design:type", String)
], PriceRuleSet.prototype, "Type", void 0);
PriceRuleSet = PriceRuleSet_1 = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__PriceRuleset__c',
        aqlName: 'cpq_PriceRuleset',
        filter: () => [
            new AFilter(PriceRuleSet_1, [
                new ACondition(PriceRuleSet_1, 'Active', 'Equal', true),
                new ACondition(PriceRuleSet_1, 'UseType', 'Equal', 'Line Item')
            ], [
                new AFilter(PriceRuleSet_1, [
                    new ACondition(PriceRuleSet_1, 'EffectiveDate', 'Null', null),
                    new ACondition(PriceRuleSet_1, 'EffectiveDate', 'LessEqual', 'Today')
                ], null, 'OR'),
                new AFilter(PriceRuleSet_1, [
                    new ACondition(PriceRuleSet_1, 'ExpirationDate', 'Null', null),
                    new ACondition(PriceRuleSet_1, 'ExpirationDate', 'GreaterThan', 'Today')
                ], null, 'OR')
            ])
        ]
    })
], PriceRuleSet);
let PriceRule = PriceRule_1 = class PriceRule extends AObject {
    constructor() {
        super(...arguments);
        this.Active = null;
        this.AdjustmentAppliesTo = null;
        this.AdjustmentChargeType = null;
        this.AllowableAction = null;
        this.AllowRemovalOfAdjustment = null;
        this.ApplicationMethod = null;
        this.BeneficiaryId = null;
        this.BeneficiaryType = null;
        this.BenefitType = null;
        this.ChargeTypeCriteria = null;
        this.ChargeTypeCriteriaOper = null;
        this.CountryCriteria = null;
        this.CountryCriteriaOper = null;
        this.CustomPricePointSource = null;
        this.Description = null;
        /*  @AField({
             soql : 'Apttus_Config2__Dimension1Id__c',
         })
         Dimension1Id: string = null; */
        this.Dimension1 = new PriceDimension();
        this.Dimension1ValueType = null;
        /* @AField({
            soql : 'Apttus_Config2__Dimension2Id__c',
        })
        Dimension2Id: string = null; */
        this.Dimension2 = new PriceDimension();
        this.Dimension2ValueType = null;
        /* @AField({
            soql : 'Apttus_Config2__Dimension3Id__c',
        })
        Dimension3Id: string = null; */
        this.Dimension3 = new PriceDimension();
        this.Dimension3ValueType = null;
        /*   @AField({
              soql : 'Apttus_Config2__Dimension4Id__c',
          })
          Dimension4Id: string = null; */
        this.Dimension4 = new PriceDimension();
        this.Dimension4ValueType = null;
        /*     @AField({
                soql : 'Apttus_Config2__Dimension5Id__c',
            })
            Dimension5Id: string = null; */
        this.Dimension5 = new PriceDimension();
        this.Dimension5ValueType = null;
        /*  @AField({
             soql : 'Apttus_Config2__Dimension6Id__c',
         })
         Dimension6Id: string = null; */
        this.Dimension6 = new PriceDimension();
        this.Dimension6ValueType = null;
        this.EffectiveDate = null;
        this.ExpirationDate = null;
        this.ForEveryXCriteriaDimensionId = null;
        this.ForEveryXCriteriaDimensionType = null;
        this.ForEveryXCriteriaDimensionValue = null;
        this.FutureBenefitValidityOffset = null;
        this.FutureBenefitValidityType = null;
        this.InitialRows = null;
        this.MetricValueSource = null;
        this.MilestoneCriteria = null;
        this.MilestoneStatusCriteriaOper = null;
        this.NumberOfEntries = null;
        this.PriceListCriteria = null;
        this.PriceListCriteriaOper = null;
        this.ProductCriteria = null;
        this.ProductCriteriaOper = null;
        this.ProductFamilyCriteria = null;
        this.ProductFamilyCriteriaOper = null;
        this.ProductGroupCriteria = null;
        this.ProductGroupCriteriaOper = null;
        this.RegionCriteria = null;
        this.RegionCriteriaOper = null;
        this.Criteria = null;
        /*     @AField({
                soql : 'Apttus_Config2__RulesetId__c',
            })
            RulesetId: string = null; */
        this.Ruleset = new PriceRuleSet();
        this.RuleSubType = null;
        this.RuleType = null;
        this.Sequence = null;
        this.StopProcessingMoreRules = null;
        this.TierMetricRollupDuration = null;
        this.TierMetricType = null;
        this.RuleEntries = [new PriceRuleEntry()];
    }
};
__decorate([
    AField({
        soql: 'Apttus_Config2__Active__c',
        aql: 'Active'
    }),
    __metadata("design:type", Boolean)
], PriceRule.prototype, "Active", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__AdjustmentAppliesTo__c',
        aql: 'AdjustmentAppliesTo'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "AdjustmentAppliesTo", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__AdjustmentChargeType__c',
        aql: 'AdjustmentChargeType'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "AdjustmentChargeType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__AllowableAction__c',
        aql: 'AllowableAction'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "AllowableAction", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__AllowRemovalOfAdjustment__c',
        aql: 'AllowRemovalOfAdjustment'
    }),
    __metadata("design:type", Boolean)
], PriceRule.prototype, "AllowRemovalOfAdjustment", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ApplicationMethod__c',
        aql: 'ApplicationMethod'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "ApplicationMethod", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__BeneficiaryId__c',
        aql: 'BeneficiaryId'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "BeneficiaryId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__BeneficiaryType__c',
        aql: 'BeneficiaryType'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "BeneficiaryType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__BenefitType__c',
        aql: 'BenefitType'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "BenefitType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ChargeTypeCriteria__c',
        aql: 'ChargeTypeCriteria'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "ChargeTypeCriteria", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ChargeTypeCriteriaOper__c',
        aql: 'ChargeTypeCriteriaOper'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "ChargeTypeCriteriaOper", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__CountryCriteria__c',
        aql: 'CountryCriteria'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "CountryCriteria", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__CountryCriteriaOper__c',
        aql: 'CountryCriteriaOper'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "CountryCriteriaOper", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__CustomPricePointSource__c',
        aql: 'CustomPricePointSource'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "CustomPricePointSource", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Description__c',
        aql: 'Description'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "Description", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension1Id__r',
        aql: 'Dimension1Id'
    }),
    __metadata("design:type", PriceDimension)
], PriceRule.prototype, "Dimension1", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension1ValueType__c',
        aql: 'Dimension1ValueType'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "Dimension1ValueType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension2Id__r',
        aql: 'Dimension2Id'
    }),
    __metadata("design:type", PriceDimension)
], PriceRule.prototype, "Dimension2", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension2ValueType__c',
        aql: 'Dimension2ValueType'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "Dimension2ValueType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension3Id__r',
        aql: 'Dimension3Id'
    }),
    __metadata("design:type", PriceDimension)
], PriceRule.prototype, "Dimension3", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension3ValueType__c',
        aql: 'Dimension3ValueType'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "Dimension3ValueType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension4Id__r',
        aql: 'Dimension4Id'
    }),
    __metadata("design:type", PriceDimension)
], PriceRule.prototype, "Dimension4", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension4ValueType__c',
        aql: 'Dimension4ValueType'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "Dimension4ValueType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension5Id__r',
        aql: 'Dimension5Id'
    }),
    __metadata("design:type", PriceDimension)
], PriceRule.prototype, "Dimension5", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension5ValueType__c',
        aql: 'Dimension5ValueType'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "Dimension5ValueType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension6Id__r',
        aql: 'Dimension6Id'
    }),
    __metadata("design:type", PriceDimension)
], PriceRule.prototype, "Dimension6", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension6ValueType__c',
        aql: 'Dimension6ValueType'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "Dimension6ValueType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__EffectiveDate__c',
        aql: 'EffectiveDate'
    }),
    __metadata("design:type", Date)
], PriceRule.prototype, "EffectiveDate", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ExpirationDate__c',
        aql: 'ExpirationDate'
    }),
    __metadata("design:type", Date)
], PriceRule.prototype, "ExpirationDate", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ForEveryXCriteriaDimensionId__c',
        aql: 'ForEveryXCriteriaDimensionId'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "ForEveryXCriteriaDimensionId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ForEveryXCriteriaDimensionType__c',
        aql: 'ForEveryXCriteriaDimensionType'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "ForEveryXCriteriaDimensionType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ForEveryXCriteriaDimensionValue__c',
        aql: 'ForEveryXCriteriaDimensionValue'
    }),
    __metadata("design:type", Number)
], PriceRule.prototype, "ForEveryXCriteriaDimensionValue", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__FutureBenefitValidityOffset__c',
        aql: 'FutureBenefitValidityOffset'
    }),
    __metadata("design:type", Number)
], PriceRule.prototype, "FutureBenefitValidityOffset", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__FutureBenefitValidityType__c',
        aql: 'FutureBenefitValidityType'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "FutureBenefitValidityType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__InitialRows__c',
        aql: 'InitialRows'
    }),
    __metadata("design:type", Number)
], PriceRule.prototype, "InitialRows", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__MetricValueSource__c',
        aql: 'MetricValueSource'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "MetricValueSource", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__MilestoneCriteria__c',
        aql: 'MilestoneCriteria'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "MilestoneCriteria", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__MilestoneStatusCriteriaOper__c',
        aql: 'MilestoneStatusCriteriaOper'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "MilestoneStatusCriteriaOper", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__NumberOfEntries__c',
        aql: 'NumberOfEntries'
    }),
    __metadata("design:type", Number)
], PriceRule.prototype, "NumberOfEntries", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__PriceListCriteria__c',
        aql: 'PriceListCriteriaOper'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "PriceListCriteria", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__PriceListCriteriaOper__c',
        aql: 'PriceListCriteriaOper'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "PriceListCriteriaOper", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductCriteria__c',
        aql: 'ProductCriteria'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "ProductCriteria", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductCriteriaOper__c',
        aql: 'ProductCriteriaOper'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "ProductCriteriaOper", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductFamilyCriteria__c',
        aql: 'ProductCriteriaOper'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "ProductFamilyCriteria", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductFamilyCriteriaOper__c',
        aql: 'ProductFamilyCriteriaOper'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "ProductFamilyCriteriaOper", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductGroupCriteria__c',
        aql: 'ProductGroupCriteria'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "ProductGroupCriteria", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductGroupCriteriaOper__c',
        aql: 'ProductGroupCriteriaOper'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "ProductGroupCriteriaOper", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__RegionCriteria__c',
        aql: 'RegionCriteria'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "RegionCriteria", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__RegionCriteriaOper__c',
        aql: 'RegionCriteriaOper'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "RegionCriteriaOper", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Criteria__c',
        aql: 'Criteria'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "Criteria", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__RulesetId__r',
        aql: 'RulesetId'
    }),
    __metadata("design:type", PriceRuleSet)
], PriceRule.prototype, "Ruleset", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__RuleSubType__c',
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "RuleSubType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__RuleType__c',
        aql: 'RuleType'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "RuleType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Sequence__c',
        aql: 'Sequence'
    }),
    __metadata("design:type", Number)
], PriceRule.prototype, "Sequence", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__StopProcessingMoreRules__c',
        aql: 'StopProcessingMoreRules'
    }),
    __metadata("design:type", Boolean)
], PriceRule.prototype, "StopProcessingMoreRules", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__TierMetricRollupDuration__c',
        aql: 'TierMetricRollupDuration'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "TierMetricRollupDuration", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__TierMetricType__c',
        aql: 'TierMetricType'
    }),
    __metadata("design:type", String)
], PriceRule.prototype, "TierMetricType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__RuleEntries__r',
    }),
    Type(() => PriceRuleEntry),
    __metadata("design:type", Array)
], PriceRule.prototype, "RuleEntries", void 0);
PriceRule = PriceRule_1 = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__PriceRule__c',
        aqlName: 'cpq_PriceRule',
        filter: () => [
            new AFilter(PriceRule_1, [
                new ACondition(PriceRuleSet, 'Active', 'Equal', true),
                new ACondition(PriceRuleSet, 'RuleSet.UseType', 'Equal', 'Line Item')
            ], [
                new AFilter(PriceRuleSet, [
                    new ACondition(PriceRuleSet, 'RuleSet.EffectiveDate', 'Null', null),
                    new ACondition(PriceRuleSet, 'RuleSet.EffectiveDate', 'LessEqual', 'Today')
                ], null, 'OR'),
                new AFilter(PriceRuleSet, [
                    new ACondition(PriceRuleSet, 'RuleSet.ExpirationDate', 'Null', null),
                    new ACondition(PriceRuleSet, 'RuleSet.ExpirationDate', 'GreaterThan', 'Today')
                ], null, 'OR')
            ])
        ]
    })
], PriceRule);
let PriceRuleEntry = class PriceRuleEntry extends AObject {
    constructor() {
        super(...arguments);
        this.AdjustmentAmount = null;
        this.AdjustmentReason = null;
        this.AdjustmentType = null;
        this.AdjustmentValueSource = null;
        this.AdjustmentValueType = null;
        this.BandSize = null;
        this.ChargeTypes = null;
        this.Condition = null;
        this.Dimension1ListValue = null;
        this.Dimension1Value = null;
        this.Dimension2ListValue = null;
        this.Dimension2Value = null;
        this.Dimension3ListValue = null;
        this.Dimension3Value = null;
        this.Dimension4ListValue = null;
        this.Dimension4Value = null;
        this.Dimension5ListValue = null;
        this.Dimension5Value = null;
        this.Dimension6ListValue = null;
        this.Dimension6Value = null;
        this.EndFactor = null;
        this.InclusionMethod = null;
        this.LoyaltyLevel = null;
        this.MatchInAsset = null;
        this.MatchProductGroupId = null;
        this.MaxProducts = null;
        this.MaxQuantity = null;
        this.MinProducts = null;
        this.MinQuantity = null;
        this.PriceOverride = null;
        this.PriceRuleId = null;
        this.ProductCategory = null;
        this.ProductFamilies = null;
        this.ProductFamily = null;
        this.ProductGroupId = null;
        this.ProductGroups = null;
        this.Products = null;
        this.Quantity = null;
        this.Sequence = null;
        this.StartFactor = null;
        this.Term = null;
        this.TermPeriodStart = null;
    }
};
__decorate([
    AField({
        soql: 'Apttus_Config2__AdjustmentAmount__c',
        aql: 'AdjustmentAmount'
    }),
    __metadata("design:type", Number)
], PriceRuleEntry.prototype, "AdjustmentAmount", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__AdjustmentReason__c',
        aql: 'AdjustmentReason'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "AdjustmentReason", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__AdjustmentType__c',
        aql: 'AdjustmentType'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "AdjustmentType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__AdjustmentValueSource__c',
        aql: 'AdjustmentValueSource'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "AdjustmentValueSource", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__AdjustmentValueType__c',
        aql: 'AdjustmentValueType'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "AdjustmentValueType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__BandSize__c',
        aql: 'BandSize'
    }),
    __metadata("design:type", Number)
], PriceRuleEntry.prototype, "BandSize", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ChargeTypes__c',
        aql: 'ChargeTypes'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "ChargeTypes", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Condition__c',
        aql: 'Condition'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "Condition", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension1ListValue__c',
        aql: 'Dimension1ListValue'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "Dimension1ListValue", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension1Value__c',
        aql: 'Dimension1Value'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "Dimension1Value", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension2ListValue__c',
        aql: 'Dimension2ListValue'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "Dimension2ListValue", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension2Value__c',
        aql: 'Dimension2Value'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "Dimension2Value", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension3ListValue__c',
        aql: 'Dimension3ListValue'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "Dimension3ListValue", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension3Value__c',
        aql: 'Dimension3Value'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "Dimension3Value", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension4ListValue__c',
        aql: 'Dimension4ListValue'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "Dimension4ListValue", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension4Value__c',
        aql: 'Dimension4Value'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "Dimension4Value", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension5ListValue__c',
        aql: 'Dimension5ListValue'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "Dimension5ListValue", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension5Value__c',
        aql: 'Dimension5Value'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "Dimension5Value", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension6ListValue__c',
        aql: 'Dimension6ListValue'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "Dimension6ListValue", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Dimension6Value__c',
        aql: 'Dimension6Value'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "Dimension6Value", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__EndFactor__c',
        aql: 'EndFactor'
    }),
    __metadata("design:type", Number)
], PriceRuleEntry.prototype, "EndFactor", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__InclusionMethod__c',
        aql: 'InclusionMethod'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "InclusionMethod", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__LoyaltyLevel__c',
        aql: 'LoyaltyLevel'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "LoyaltyLevel", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__MatchInAsset__c',
        aql: 'MatchInAsset'
    }),
    __metadata("design:type", Boolean)
], PriceRuleEntry.prototype, "MatchInAsset", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__MatchProductGroupId__c',
        aql: 'MatchProductGroupId'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "MatchProductGroupId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__MaxProducts__c',
        aql: 'MaxProducts'
    }),
    __metadata("design:type", Number)
], PriceRuleEntry.prototype, "MaxProducts", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__MaxQuantity__c',
        aql: 'MaxQuantity'
    }),
    __metadata("design:type", Number)
], PriceRuleEntry.prototype, "MaxQuantity", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__MinProducts__c',
        aql: 'MinProducts'
    }),
    __metadata("design:type", Number)
], PriceRuleEntry.prototype, "MinProducts", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__MinQuantity__c',
        aql: 'MinQuantity'
    }),
    __metadata("design:type", Number)
], PriceRuleEntry.prototype, "MinQuantity", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__PriceOverride__c',
        aql: 'PriceOverride'
    }),
    __metadata("design:type", Number)
], PriceRuleEntry.prototype, "PriceOverride", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__PriceRuleId__c',
        aql: 'PriceRuleId'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "PriceRuleId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductCategory__c',
        aql: 'ProductCategory'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "ProductCategory", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductFamilies__c',
        aql: 'ProductFamilies'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "ProductFamilies", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductFamily__c',
        aql: 'ProductFamily'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "ProductFamily", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductGroupId__c',
        aql: 'ProductGroupId'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "ProductGroupId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductGroups__c',
        aql: 'ProductGroups'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "ProductGroups", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Products__c',
        aql: 'Products'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "Products", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Quantity__c',
        aql: 'Quantity'
    }),
    __metadata("design:type", Number)
], PriceRuleEntry.prototype, "Quantity", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Sequence__c',
        aql: 'Sequence'
    }),
    __metadata("design:type", Number)
], PriceRuleEntry.prototype, "Sequence", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__StartFactor__c',
        aql: 'StartFactor'
    }),
    __metadata("design:type", Number)
], PriceRuleEntry.prototype, "StartFactor", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Term__c',
        aql: 'Term'
    }),
    __metadata("design:type", Number)
], PriceRuleEntry.prototype, "Term", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__TermPeriodStart__c',
        aql: 'TermPeriodStart'
    }),
    __metadata("design:type", String)
], PriceRuleEntry.prototype, "TermPeriodStart", void 0);
PriceRuleEntry = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__PriceRuleEntry__c',
        aqlName: 'cpq_PriceRuleEntry'
    })
], PriceRuleEntry);

class Price {
    constructor(localCurrencyPipe, netPrice = 0, basePrice = 0, listPrice = 0, listExtendedPrice = 0, baseExtendedPrice = 0) {
        this.localCurrencyPipe = localCurrencyPipe;
        this.netPrice = netPrice;
        this.basePrice = basePrice;
        this.listPrice = listPrice;
        this.listExtendedPrice = listExtendedPrice;
        this.baseExtendedPrice = baseExtendedPrice;
    }
    get netPrice$() {
        return this.localCurrencyPipe.transform(this.netPrice);
    }
    get basePrice$() {
        return this.localCurrencyPipe.transform(this.basePrice);
    }
    get discountPrice$() {
        return this.localCurrencyPipe.transform(this.discountPrice);
    }
    get listPrice$() {
        return this.localCurrencyPipe.transform(this.listPrice);
    }
    get listExtendedPrice$() {
        return this.localCurrencyPipe.transform(this.listExtendedPrice);
    }
    get baseExtendedPrice$() {
        return this.localCurrencyPipe.transform(this.baseExtendedPrice);
    }
    get discountPrice() {
        return this.listPrice - this.basePrice;
    }
    addPrice(p) {
        if (p) {
            this.netPrice += p.netPrice;
            this.basePrice += p.basePrice;
            this.listPrice += p.listPrice;
            this.listExtendedPrice += p.listExtendedPrice;
            this.baseExtendedPrice += p.baseExtendedPrice;
        }
        return this;
    }
}

let CurrencyType = class CurrencyType extends AObject {
    constructor() {
        super(...arguments);
        this.ConversionRate = 1;
        this.DecimalPlaces = 2;
        this.IsActive = true;
        this.IsCorporate = false;
        this.IsoCode = 'USD';
    }
    get _currency() {
        const code = cc.code(this.IsoCode);
        return (code) ? code : null;
    }
};
__decorate([
    AField({
        soql: 'ConversionRate'
    }),
    __metadata("design:type", Number)
], CurrencyType.prototype, "ConversionRate", void 0);
__decorate([
    AField({
        soql: 'DecimalPlaces'
    }),
    __metadata("design:type", Number)
], CurrencyType.prototype, "DecimalPlaces", void 0);
__decorate([
    AField({
        soql: 'IsActive'
    }),
    __metadata("design:type", Boolean)
], CurrencyType.prototype, "IsActive", void 0);
__decorate([
    AField({
        soql: 'IsCorporate'
    }),
    __metadata("design:type", Boolean)
], CurrencyType.prototype, "IsCorporate", void 0);
__decorate([
    AField({
        soql: 'IsoCode'
    }),
    __metadata("design:type", String)
], CurrencyType.prototype, "IsoCode", void 0);
CurrencyType = __decorate([
    ATable({
        sobjectName: 'CurrencyType',
        aqlName: null
    })
], CurrencyType);

let Attachment = class Attachment extends AObject {
    constructor() {
        super(...arguments);
        // @AField({
        //     soql: 'Body'
        // })
        // Body: string = null;
        this.BodyLength = null;
        this.Description = null;
        this.Name = null;
        this.ParentId = null;
        this.ContentType = null;
        this.CreatedById = null;
    }
};
__decorate([
    AField({
        soql: 'BodyLength'
    }),
    __metadata("design:type", Number)
], Attachment.prototype, "BodyLength", void 0);
__decorate([
    AField({
        soql: 'Description'
    }),
    __metadata("design:type", String)
], Attachment.prototype, "Description", void 0);
__decorate([
    AField({
        soql: 'Name'
    }),
    __metadata("design:type", String)
], Attachment.prototype, "Name", void 0);
__decorate([
    AField({
        soql: 'ParentId'
    }),
    __metadata("design:type", String)
], Attachment.prototype, "ParentId", void 0);
__decorate([
    AField({
        soql: 'ContentType'
    }),
    __metadata("design:type", String)
], Attachment.prototype, "ContentType", void 0);
__decorate([
    AField({
        soql: 'CreatedById'
    }),
    Type(() => UserBase),
    __metadata("design:type", Object)
], Attachment.prototype, "CreatedById", void 0);
Attachment = __decorate([
    ATable({
        sobjectName: 'Attachment',
        aqlName: 'cmn_Attachment'
    })
], Attachment);

let Classification = class Classification extends AObject {
    constructor() {
        super(...arguments);
        this.HierarchyLabel = null;
        this.Type = null;
        // CategoryHierarchies: ChildRecord = new ChildRecord(new Category(), () => `(Apttus_Config2__AncestorId__c <> null OR Apttus_Config2__IsLeaf__c = \'no\')`);
        this.CategoryHierarchies = [new Category()];
        this.Name = null;
    }
};
__decorate([
    Expose({ name: 'Apttus_Config2__HierarchyLabel__c' }),
    __metadata("design:type", String)
], Classification.prototype, "HierarchyLabel", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Type__c' }),
    __metadata("design:type", String)
], Classification.prototype, "Type", void 0);
__decorate([
    Type(() => Category),
    Expose({ name: 'Apttus_Config2__CategoryHierarchies__r' }),
    __metadata("design:type", Array)
], Classification.prototype, "CategoryHierarchies", void 0);
__decorate([
    Expose({ name: 'Name' }),
    __metadata("design:type", String)
], Classification.prototype, "Name", void 0);
Classification = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__ClassificationName__c',
        aqlName: null
    })
], Classification);

let ProductAttributeRule = class ProductAttributeRule extends AObject {
    constructor() {
        super(...arguments);
        this.AccountScope = null;
        this.AccountScopeOper = null;
        this.Active = null;
        this.ConditionCriteria = null;
        this.ConditionCriteriaExpression = null;
        this.Description = null;
        this.EffectiveDate = null;
        this.ExpirationDate = null;
        this.ProductFamilyScope = null;
        this.ProductFamilyScopeOper = null;
        this.ProductGroupScope = null;
        this.ProductGroupScopeOper = null;
        this.ProductScope = null;
        this.ProductScopeOper = null;
        this.ProductAttributeRuleActions = null;
    }
};
__decorate([
    AField({
        soql: 'Apttus_Config2__AccountScope__c',
        aql: 'AccountScope'
    }),
    __metadata("design:type", String)
], ProductAttributeRule.prototype, "AccountScope", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__AccountScopeOper__c',
        aql: 'AccountScopeOper'
    }),
    __metadata("design:type", String)
], ProductAttributeRule.prototype, "AccountScopeOper", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Active__c',
        aql: 'Active'
    }),
    __metadata("design:type", Boolean)
], ProductAttributeRule.prototype, "Active", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ConditionCriteria__c',
        aql: 'ConditionCriteria'
    }),
    __metadata("design:type", String)
], ProductAttributeRule.prototype, "ConditionCriteria", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ConditionCriteriaExpression__c',
        aql: 'ConditionCriteriaExpression'
    }),
    __metadata("design:type", String)
], ProductAttributeRule.prototype, "ConditionCriteriaExpression", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Description__c',
        aql: 'Description'
    }),
    __metadata("design:type", String)
], ProductAttributeRule.prototype, "Description", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__EffectiveDate__c',
        aql: 'EffectiveDate'
    }),
    __metadata("design:type", Date)
], ProductAttributeRule.prototype, "EffectiveDate", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ExpirationDate__c',
        aql: 'ExpirationDate'
    }),
    __metadata("design:type", Date)
], ProductAttributeRule.prototype, "ExpirationDate", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductFamilyScope__c',
        aql: 'ProductFamilyScope'
    }),
    __metadata("design:type", String)
], ProductAttributeRule.prototype, "ProductFamilyScope", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductFamilyScopeOper__c',
        aql: 'ProductFamilyScopeOper'
    }),
    __metadata("design:type", String)
], ProductAttributeRule.prototype, "ProductFamilyScopeOper", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductGroupScope__c',
        aql: 'ProductGroupScope'
    }),
    __metadata("design:type", String)
], ProductAttributeRule.prototype, "ProductGroupScope", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductGroupScopeOper__c',
        aql: 'ProductGroupScopeOper'
    }),
    __metadata("design:type", String)
], ProductAttributeRule.prototype, "ProductGroupScopeOper", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductScope__c',
        aql: 'ProductScope'
    }),
    __metadata("design:type", String)
], ProductAttributeRule.prototype, "ProductScope", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductScopeOper__c',
        aql: 'ProductScopeOper'
    }),
    __metadata("design:type", String)
], ProductAttributeRule.prototype, "ProductScopeOper", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductAttributeRuleActions__r'
    }),
    Type(() => ProductAttributeRuleAction),
    __metadata("design:type", Array)
], ProductAttributeRule.prototype, "ProductAttributeRuleActions", void 0);
ProductAttributeRule = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__ProductAttributeRule__c',
        aqlName: 'cpq_ProductAttributeRule'
    })
], ProductAttributeRule);
let ProductAttributeRuleView = class ProductAttributeRuleView extends AObject {
    constructor() {
        super(...arguments);
        this.ProductAttributeRule = null;
    }
};
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductAttributeRuleId__c'
    }),
    __metadata("design:type", String)
], ProductAttributeRuleView.prototype, "ProductAttributeRuleId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductAttributeRuleId__r',
        aql: 'ProductAttributeRuleId'
    }),
    Type(() => ProductAttributeRule),
    __metadata("design:type", ProductAttributeRule)
], ProductAttributeRuleView.prototype, "ProductAttributeRule", void 0);
ProductAttributeRuleView = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__ProductAttributeRuleView__c',
        aqlName: 'cpq_ProductAttributeRuleView'
    })
], ProductAttributeRuleView);
let ProductAttributeRuleAction = class ProductAttributeRuleAction extends AObject {
    constructor() {
        super(...arguments);
        this.AccountScope = null;
        this.AccountScopeOper = null;
        this.Action = null;
        this.ActionCriteria = null;
        this.ActionCriteriaExpression = null;
        this.Message = null;
        this.ProductAttributeRuleId = null;
        // @AField({
        //     soql: 'Apttus_Config2__ProductAttributeRuleId__r',
        //     aql:'ProductAttributeRuleId'
        // })
        // ProductAttributeRule: ProductAttributeRule = (this._lookups) ? new ProductAttributeRule() : undefined;
        this.ProductFamilyScope = null;
        this.ProductGroupScope = null;
        this.ProductGroupScopeOper = null;
        this.ProductScope = null;
        this.ProductScopeOper = null;
        this.Field = null;
        this.ValueExpression = null;
    }
    get FieldVal() {
        return (this.Field) ? this.Field.substring(this.Field.indexOf('.') + 1) : '';
    }
    get Values() {
        return (this.ValueExpression && this.ValueExpression.length > 0) ? this.ValueExpression.replace(/'/g, '').split(';') : [];
    }
};
__decorate([
    AField({
        soql: 'Apttus_Config2__AccountScope__c',
        aql: 'AccountScope'
    }),
    __metadata("design:type", String)
], ProductAttributeRuleAction.prototype, "AccountScope", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__AccountScopeOper__c',
        aql: 'AccountScopeOper'
    }),
    __metadata("design:type", String)
], ProductAttributeRuleAction.prototype, "AccountScopeOper", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Action__c',
        aql: 'Action'
    }),
    __metadata("design:type", String)
], ProductAttributeRuleAction.prototype, "Action", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ActionCriteria__c',
        aql: 'ActionCriteria'
    }),
    __metadata("design:type", String)
], ProductAttributeRuleAction.prototype, "ActionCriteria", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ActionCriteriaExpression__c',
        aql: 'ActionCriteriaExpression'
    }),
    __metadata("design:type", String)
], ProductAttributeRuleAction.prototype, "ActionCriteriaExpression", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Message__c',
        aql: 'Message'
    }),
    __metadata("design:type", String)
], ProductAttributeRuleAction.prototype, "Message", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductAttributeRuleId__c'
    }),
    __metadata("design:type", String)
], ProductAttributeRuleAction.prototype, "ProductAttributeRuleId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductFamilyScope__c',
        aql: 'ProductFamilyScope'
    }),
    __metadata("design:type", String)
], ProductAttributeRuleAction.prototype, "ProductFamilyScope", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductGroupScope__c',
        aql: 'ProductGroupScope'
    }),
    __metadata("design:type", String)
], ProductAttributeRuleAction.prototype, "ProductGroupScope", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductGroupScopeOper__c',
        aql: 'ProductGroupScopeOper'
    }),
    __metadata("design:type", String)
], ProductAttributeRuleAction.prototype, "ProductGroupScopeOper", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductScope__c',
        aql: 'ProductScope'
    }),
    __metadata("design:type", String)
], ProductAttributeRuleAction.prototype, "ProductScope", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductScopeOper__c',
        aql: 'ProductScopeOper'
    }),
    __metadata("design:type", String)
], ProductAttributeRuleAction.prototype, "ProductScopeOper", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Field__c',
        aql: 'Field'
    }),
    __metadata("design:type", String)
], ProductAttributeRuleAction.prototype, "Field", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ValueExpression__c',
        aql: 'ValueExpression'
    }),
    __metadata("design:type", String)
], ProductAttributeRuleAction.prototype, "ValueExpression", void 0);
ProductAttributeRuleAction = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__ProductAttributeRuleAction__c',
        aqlName: null
    })
], ProductAttributeRuleAction);

let ProductInformation = class ProductInformation extends AObject {
    constructor() {
        super(...arguments);
        this.Type = null;
        this.Name = null;
        this.Sequence = null;
        this.ProductId = null;
        this.InformationType = null;
        this.FileId = null;
        this.EmbedCode = null;
        this.Description = null;
        this.ContentUrl = null;
        this.ClassificationId = null;
        this.Attachments = [new Attachment()];
    }
};
__decorate([
    AField({
        soql: 'Apttus_Config2__Type__c'
    }),
    __metadata("design:type", String)
], ProductInformation.prototype, "Type", void 0);
__decorate([
    AField({
        soql: 'Name',
        aql: 'Name'
    }),
    __metadata("design:type", String)
], ProductInformation.prototype, "Name", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Sequence__c'
    }),
    __metadata("design:type", Number)
], ProductInformation.prototype, "Sequence", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductId__c',
        aql: 'ProductId'
    }),
    __metadata("design:type", String)
], ProductInformation.prototype, "ProductId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__InformationType__c',
        aql: 'InformationType'
    }),
    __metadata("design:type", String)
], ProductInformation.prototype, "InformationType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__FileId__c',
        aql: 'FileId'
    }),
    __metadata("design:type", String)
], ProductInformation.prototype, "FileId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__EmbedCode__c',
        aql: 'EmbedCode'
    }),
    __metadata("design:type", String)
], ProductInformation.prototype, "EmbedCode", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Description__c',
        aql: 'Description'
    }),
    __metadata("design:type", String)
], ProductInformation.prototype, "Description", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ContentUrl__c',
        aql: 'ContentUrl'
    }),
    __metadata("design:type", String)
], ProductInformation.prototype, "ContentUrl", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ClassificationId__c'
    }),
    __metadata("design:type", String)
], ProductInformation.prototype, "ClassificationId", void 0);
__decorate([
    AField({
        soql: 'Attachments',
    }),
    Type(() => Attachment),
    __metadata("design:type", Array)
], ProductInformation.prototype, "Attachments", void 0);
ProductInformation = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__ProductInformation__c',
        aqlName: 'cpq_ProductInformation'
    })
], ProductInformation);

let PriceListCategory = class PriceListCategory extends AObject {
    constructor() {
        super(...arguments);
        this.PriceListId = null;
        this.HierarchyId = null;
    }
};
__decorate([
    Expose({ name: 'Apttus_Config2__PriceListId__c' }),
    __metadata("design:type", String)
], PriceListCategory.prototype, "PriceListId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__HierarchyId__c' }),
    __metadata("design:type", String)
], PriceListCategory.prototype, "HierarchyId", void 0);
PriceListCategory = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__PriceListCategory__c',
        aqlName: 'cpq_PriceListCategory'
    })
], PriceListCategory);

/**
 * Batch Action model describes a batch action object. Batch actions are actions that can be taken on several selected items.
 */
class BatchAction {
    /**
     * Creates a new batch action object with the given parameters.
     * @param displayLabel The string value to show on the display label.
     * @param iconName The Open Iconic icon name shown on with the display label.
     * @param actionMethod The method that is fired when this action is triggered.
     */
    constructor(displayLabel, iconName, actionMethod) {
        /**
         * Determines if this action should be disabled.
         */
        this.disabled = true;
        /**
         * Determines if this action should be visible.
         */
        this.visible = true;
        /**
         * The tooltip text to show on disabled actions.
         */
        this.tooltipText = 'Action Disabled';
        this.displayLabel = displayLabel;
        this.iconName = iconName;
        this.actionMethod = actionMethod;
    }
    /**
     * Gets the display name for this batch action.
     */
    getDisplayName() {
        return this.displayLabel;
    }
    getTranslationKey() {
        if (this.displayLabel === 'Compare')
            return 'COMMON.COMPARE';
        else if (this.displayLabel === 'Renew')
            return 'COMMON.RENEW';
        else if (this.displayLabel === 'Terminate')
            return 'COMMON.TERMINATE';
        else if (this.displayLabel === 'Save Favorite')
            return 'COMMON.SAVE_FAVORITE';
        else if (this.displayLabel === 'Clone')
            return 'COMMON.CLONE';
    }
    /**
     * Gets the Open Iconic icon name for this batch action.
     */
    getIconName() {
        return this.iconName;
    }
    /**
     * Gets the action method for this batch action.
     */
    getActionMethod() {
        return this.actionMethod;
    }
    /**
     * Gets the disabled state of this batch action.
     */
    isDisabled() {
        return this.disabled;
    }
    /**
      * Gets the visible state of this batch action.
    */
    isVisible() {
        return this.visible;
    }
    /**
     * Setter for the disabled state of this batch action.
     * @param disabled Disabled state of this batch action.
     */
    setDisabled(disabled) {
        this.disabled = disabled;
    }
    /**
  * Setter for the visible state of this batch action.
  * @param visible Visible state of this batch action.
  */
    setVisible(visible) {
        this.visible = visible;
    }
    /**
     * Gets the tooltip text for this batch action.
     */
    getTooltipText() {
        return this.tooltipText;
    }
    /**
     * Sets the tooltip text on this batch action when it is disabled.
     * @param text Text to display on the tooltip.
     */
    setTooltipText(text) {
        this.tooltipText = text;
    }
}

let Note = class Note extends AObject {
    constructor() {
        super(...arguments);
        this.Body = null;
        this.IsDeleted = false;
        this.IsPrivate = false;
        this.Title = null;
        this.OwnerId = null;
        this.ParentId = null;
        this.CreatedBy = null;
    }
};
__decorate([
    AField({
        soql: 'Body'
    }),
    __metadata("design:type", String)
], Note.prototype, "Body", void 0);
__decorate([
    AField({
        soql: 'IsDeleted'
    }),
    __metadata("design:type", Boolean)
], Note.prototype, "IsDeleted", void 0);
__decorate([
    AField({
        soql: 'IsPrivate'
    }),
    __metadata("design:type", Boolean)
], Note.prototype, "IsPrivate", void 0);
__decorate([
    AField({
        soql: 'Title'
    }),
    __metadata("design:type", String)
], Note.prototype, "Title", void 0);
__decorate([
    AField({
        soql: 'OwnerId'
    }),
    __metadata("design:type", String)
], Note.prototype, "OwnerId", void 0);
__decorate([
    AField({
        soql: 'ParentId'
    }),
    __metadata("design:type", String)
], Note.prototype, "ParentId", void 0);
__decorate([
    AField({
        soql: 'CreatedBy'
    }),
    Type(() => User),
    __metadata("design:type", User)
], Note.prototype, "CreatedBy", void 0);
Note = __decorate([
    ATable({
        sobjectName: 'Note',
        aqlName: ''
    })
], Note);

let QuoteAttachment = class QuoteAttachment extends AObject {
    constructor() {
        super(...arguments);
        this.Body = null;
        this.BodyLength = null;
        this.Description = null;
        this.Name = null;
        this.ParentId = null;
        this.ContentType = null;
    }
};
__decorate([
    AField({
        soql: 'Body'
    }),
    __metadata("design:type", String)
], QuoteAttachment.prototype, "Body", void 0);
__decorate([
    AField({
        soql: 'BodyLength'
    }),
    __metadata("design:type", Number)
], QuoteAttachment.prototype, "BodyLength", void 0);
__decorate([
    AField({
        soql: 'Description'
    }),
    __metadata("design:type", String)
], QuoteAttachment.prototype, "Description", void 0);
__decorate([
    AField({
        soql: 'Name'
    }),
    __metadata("design:type", String)
], QuoteAttachment.prototype, "Name", void 0);
__decorate([
    AField({
        soql: 'ParentId'
    }),
    __metadata("design:type", String)
], QuoteAttachment.prototype, "ParentId", void 0);
__decorate([
    AField({
        soql: 'ContentType'
    }),
    __metadata("design:type", String)
], QuoteAttachment.prototype, "ContentType", void 0);
QuoteAttachment = __decorate([
    ATable({
        sobjectName: 'Attachment',
        aqlName: 'cmn_Attachment'
    })
], QuoteAttachment);

let Opportunity = class Opportunity extends AObject {
    constructor() {
        super(...arguments);
        this.Name = null;
    }
};
__decorate([
    AField({
        soql: 'Name'
    }),
    __metadata("design:type", String)
], Opportunity.prototype, "Name", void 0);
Opportunity = __decorate([
    ATable({
        sobjectName: 'Opportunity'
    })
], Opportunity);

let Quote = class Quote extends AObject {
    constructor() {
        super(...arguments);
        this.Name = null;
        this.ABOType = null;
        this.Accept = null;
        this.Account = null;
        this.AccountId = null;
        /*@AField({
          soql: 'Apttus_Proposal__Account__r'
        })
        @Type(() => Account)
        AccountR: Account = null;*/
        this.Amount = null;
        this.Approval_Stage = null;
        this.AutoActivateOrder = false;
        this.AutoCreateBill = false;
        this.AutoCreateRevenue = false;
        this.BillingPreferenceId = null;
        this.BillToAccountId = null;
        this.BillToAccount = new Account();
        this.configurationFinalizedDate = null;
        this.configurationSyncDate = null;
        this.configure = null;
        this.configureNG = null;
        this.createAgreement = null;
        this.Description = null;
        this.Discount_Percent = null;
        this.ExpectedEndDate = null;
        this.ExpectedStartDate = null;
        this.Generate = null;
        this.Grand_Total = null;
        this.Internal_Deadline = null;
        this.IsSystemGenerated = false;
        this.IsTaskPending = false;
        this.LocationId = null;
        this.MakePrimary = null;
        this.Net_Amount = null;
        this.OpportunityId = null;
        this.Opportunity = null;
        this.Payment_Term = null;
        this.PaymentTermId = null;
        this.PODate = null;
        this.PONumber = null;
        this.Present = null;
        this.Presented_Date = null;
        this.Preview = null;
        this.PriceListId = null;
        this.PriceList = null;
        this.PricingDate = null;
        this.Primary = false;
        this.Primary_Contact = new Contact();
        this.Primary_ContactId = null;
        this.Proposal_Approval_Date = null;
        this.Proposal_Category = null;
        this.Proposal_Expiration_Date = null;
        this.Proposal_Name = null;
        this.ReadyForActivationDate = null;
        this.ReadyForBillingDate = null;
        this.ReadyForFulfillmentDate = null;
        this.ReadyForRevRecDate = null;
        this.ReadyToGenerate = false;
        this.ReadyToPresent = false;
        this.Request_Approval = null;
        this.RFP_Intake_Date = null;
        this.RFP_Response_Due_Date = null;
        this.RFP_Stage = null;
        this.RFP_Value = null;
        this.Risk_Factors = null;
        this.Sales_Tax_Percent = null;
        this.Sales_Tax_Amount = null;
        this.Shipping_Handling = null;
        this.ShipToAccountId = null;
        this.ShipToAccount = new Account();
        this.Special_Terms = null;
        this.Strategic_Importance = null;
        this.SubmitForApproval = null;
        this.SyncAssetChangesToQuote = false;
        this.SyncWithOpportunity = null;
        this.Valid_Until_Date = null;
        this.R00N70000001yUfBEAU = null;
        this.CurrencyIsoCode = null;
        this.Attachments = null;
        this.Notes = null;
        this.OwnerId = null;
        this.Owner = new UserBase();
        this.CreatedBy = new User();
        this.ProposalSummaryGroups = null;
    }
    get QuoteLineItems() {
        return this.R00N70000001yUfBEAU;
    }
};
__decorate([
    Expose({ name: 'Name' }),
    __metadata("design:type", String)
], Quote.prototype, "Name", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__ABOType__c' }),
    __metadata("design:type", String)
], Quote.prototype, "ABOType", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__Accept__c' }),
    __metadata("design:type", String)
], Quote.prototype, "Accept", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Account__r' }),
    Type(() => Account),
    __metadata("design:type", Account)
], Quote.prototype, "Account", void 0);
__decorate([
    AField({
        soql: 'Apttus_Proposal__Account__c',
        view: ['Compact']
    }),
    Expose({ name: 'Apttus_Proposal__Account__c' }),
    __metadata("design:type", String)
], Quote.prototype, "AccountId", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Amount__c' }),
    __metadata("design:type", Number)
], Quote.prototype, "Amount", void 0);
__decorate([
    AField({
        soql: 'Apttus_Proposal__Approval_Stage__c',
        aql: 'ApprovalStage',
        view: ['Compact']
    }),
    Expose({ name: 'Apttus_Proposal__Approval_Stage__c' }),
    __metadata("design:type", String)
], Quote.prototype, "Approval_Stage", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__AutoActivateOrder__c' }),
    __metadata("design:type", Boolean)
], Quote.prototype, "AutoActivateOrder", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__AutoCreateBill__c' }),
    __metadata("design:type", Boolean)
], Quote.prototype, "AutoCreateBill", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__AutoCreateRevenue__c' }),
    __metadata("design:type", Boolean)
], Quote.prototype, "AutoCreateRevenue", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__BillingPreferenceId__c' }),
    __metadata("design:type", String)
], Quote.prototype, "BillingPreferenceId", void 0);
__decorate([
    AField({
        soql: 'Apttus_QPConfig__BillToAccountId__c',
        view: ['Compact']
    }),
    Expose({ name: 'Apttus_QPConfig__BillToAccountId__c' }),
    __metadata("design:type", String)
], Quote.prototype, "BillToAccountId", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__BillToAccountId__r' }),
    Type(() => Account),
    __metadata("design:type", Account)
], Quote.prototype, "BillToAccount", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__configurationFinalizedDate__c' }),
    __metadata("design:type", Date)
], Quote.prototype, "configurationFinalizedDate", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__configurationSyncDate__c' }),
    __metadata("design:type", Date)
], Quote.prototype, "configurationSyncDate", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__configure__c' }),
    __metadata("design:type", String)
], Quote.prototype, "configure", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__configureNG__c' }),
    __metadata("design:type", String)
], Quote.prototype, "configureNG", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__createAgreement__c' }),
    __metadata("design:type", String)
], Quote.prototype, "createAgreement", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Description__c' }),
    __metadata("design:type", String)
], Quote.prototype, "Description", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Discount_Percent__c' }),
    __metadata("design:type", Number)
], Quote.prototype, "Discount_Percent", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__ExpectedEndDate__c' }),
    __metadata("design:type", Date)
], Quote.prototype, "ExpectedEndDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__ExpectedStartDate__c' }),
    __metadata("design:type", Date)
], Quote.prototype, "ExpectedStartDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Generate__c' }),
    __metadata("design:type", String)
], Quote.prototype, "Generate", void 0);
__decorate([
    AField({
        soql: 'Apttus_Proposal__Grand_Total__c',
        aql: 'GrandTotal',
        aggregate: ['SUM']
    }),
    Expose({ name: 'Apttus_Proposal__Grand_Total__c' }),
    __metadata("design:type", Number)
], Quote.prototype, "Grand_Total", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Internal_Deadline__c' }),
    __metadata("design:type", Date)
], Quote.prototype, "Internal_Deadline", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__IsSystemGenerated__c' }),
    __metadata("design:type", Boolean)
], Quote.prototype, "IsSystemGenerated", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__IsTaskPending__c' }),
    __metadata("design:type", Boolean)
], Quote.prototype, "IsTaskPending", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__LocationId__c' }),
    __metadata("design:type", String)
], Quote.prototype, "LocationId", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__MakePrimary__c' }),
    __metadata("design:type", String)
], Quote.prototype, "MakePrimary", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Net_Amount__c' }),
    __metadata("design:type", Number)
], Quote.prototype, "Net_Amount", void 0);
__decorate([
    AField({
        soql: 'Apttus_Proposal__Opportunity__c',
        aql: 'OpportunityId',
        view: ['Compact']
    }),
    Expose({ name: 'Apttus_Proposal__Opportunity__c' }),
    __metadata("design:type", String)
], Quote.prototype, "OpportunityId", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Opportunity__r' }),
    Type(() => Opportunity),
    __metadata("design:type", Opportunity)
], Quote.prototype, "Opportunity", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Payment_Term__c' }),
    __metadata("design:type", String)
], Quote.prototype, "Payment_Term", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__PaymentTermId__c' }),
    __metadata("design:type", String)
], Quote.prototype, "PaymentTermId", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__PODate__c' }),
    __metadata("design:type", Date)
], Quote.prototype, "PODate", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__PONumber__c' }),
    __metadata("design:type", String)
], Quote.prototype, "PONumber", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Present__c' }),
    __metadata("design:type", String)
], Quote.prototype, "Present", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Presented_Date__c' }),
    __metadata("design:type", Date)
], Quote.prototype, "Presented_Date", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Preview__c' }),
    __metadata("design:type", String)
], Quote.prototype, "Preview", void 0);
__decorate([
    AField({
        soql: 'Apttus_QPConfig__PriceListId__c',
        aql: 'PriceListId',
        view: ['Compact']
    }),
    Expose({
        name: 'Apttus_QPConfig__PriceListId__c'
    }),
    __metadata("design:type", String)
], Quote.prototype, "PriceListId", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__PriceListId__r' }),
    Type(() => PriceList),
    __metadata("design:type", PriceList)
], Quote.prototype, "PriceList", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__PricingDate__c' }),
    __metadata("design:type", Date)
], Quote.prototype, "PricingDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Primary__c' }),
    __metadata("design:type", Boolean)
], Quote.prototype, "Primary", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Primary_Contact__r' }),
    Type(() => Contact),
    __metadata("design:type", Contact)
], Quote.prototype, "Primary_Contact", void 0);
__decorate([
    AField({
        soql: 'Apttus_Proposal__Primary_Contact__c',
        view: ['Compact']
    }),
    Expose({ name: 'Apttus_Proposal__Primary_Contact__c' }),
    __metadata("design:type", String)
], Quote.prototype, "Primary_ContactId", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Proposal_Approval_Date__c' }),
    __metadata("design:type", Date)
], Quote.prototype, "Proposal_Approval_Date", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Proposal_Category__c' }),
    __metadata("design:type", String)
], Quote.prototype, "Proposal_Category", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Proposal_Expiration_Date__c' }),
    __metadata("design:type", Date)
], Quote.prototype, "Proposal_Expiration_Date", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Proposal_Name__c' }),
    __metadata("design:type", String)
], Quote.prototype, "Proposal_Name", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__ReadyForActivationDate__c' }),
    __metadata("design:type", Date)
], Quote.prototype, "ReadyForActivationDate", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__ReadyForBillingDate__c' }),
    __metadata("design:type", Date)
], Quote.prototype, "ReadyForBillingDate", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__ReadyForFulfillmentDate__c' }),
    __metadata("design:type", Date)
], Quote.prototype, "ReadyForFulfillmentDate", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__ReadyForRevRecDate__c' }),
    __metadata("design:type", Date)
], Quote.prototype, "ReadyForRevRecDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__ReadyToGenerate__c' }),
    __metadata("design:type", Boolean)
], Quote.prototype, "ReadyToGenerate", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__ReadyToPresent__c' }),
    __metadata("design:type", Boolean)
], Quote.prototype, "ReadyToPresent", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Request_Approval__c' }),
    __metadata("design:type", String)
], Quote.prototype, "Request_Approval", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__RFP_Intake_Date__c' }),
    __metadata("design:type", Date)
], Quote.prototype, "RFP_Intake_Date", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__RFP_Response_Due_Date__c' }),
    __metadata("design:type", String)
], Quote.prototype, "RFP_Response_Due_Date", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__RFP_Stage__c' }),
    __metadata("design:type", String)
], Quote.prototype, "RFP_Stage", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__RFP_Value__c' }),
    __metadata("design:type", Number)
], Quote.prototype, "RFP_Value", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Risk_Factors__c' }),
    __metadata("design:type", String)
], Quote.prototype, "Risk_Factors", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Sales_Tax_Percent__c' }),
    __metadata("design:type", Number)
], Quote.prototype, "Sales_Tax_Percent", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Sales_Tax_Amount__c' }),
    __metadata("design:type", Number)
], Quote.prototype, "Sales_Tax_Amount", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Shipping_Handling__c' }),
    __metadata("design:type", Number)
], Quote.prototype, "Shipping_Handling", void 0);
__decorate([
    AField({
        soql: 'Apttus_QPConfig__ShipToAccountId__c',
        view: ['Compact']
    }),
    Expose({ name: 'Apttus_QPConfig__ShipToAccountId__c' }),
    __metadata("design:type", String)
], Quote.prototype, "ShipToAccountId", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__ShipToAccountId__r' }),
    Type(() => Account),
    __metadata("design:type", Account)
], Quote.prototype, "ShipToAccount", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Special_Terms__c' }),
    __metadata("design:type", String)
], Quote.prototype, "Special_Terms", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Strategic_Importance__c' }),
    __metadata("design:type", String)
], Quote.prototype, "Strategic_Importance", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__SubmitForApproval__c' }),
    __metadata("design:type", String)
], Quote.prototype, "SubmitForApproval", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__SyncAssetChangesToQuote__c' }),
    __metadata("design:type", Boolean)
], Quote.prototype, "SyncAssetChangesToQuote", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__SyncWithOpportunity__c' }),
    __metadata("design:type", String)
], Quote.prototype, "SyncWithOpportunity", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__Valid_Until_Date__c' }),
    __metadata("design:type", Date)
], Quote.prototype, "Valid_Until_Date", void 0);
__decorate([
    Expose({ name: 'Apttus_Proposal__R00N70000001yUfBEAU__r' }),
    Type(() => QuoteLineItem),
    __metadata("design:type", Array)
], Quote.prototype, "R00N70000001yUfBEAU", void 0);
__decorate([
    Type(() => QuoteLineItem),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], Quote.prototype, "QuoteLineItems", null);
__decorate([
    Expose({ name: 'CurrencyIsoCode' }),
    __metadata("design:type", String)
], Quote.prototype, "CurrencyIsoCode", void 0);
__decorate([
    Expose({ name: 'Attachments' }),
    Type(() => Attachment),
    __metadata("design:type", Array)
], Quote.prototype, "Attachments", void 0);
__decorate([
    Expose({ name: 'Notes' }),
    Type(() => Note),
    __metadata("design:type", Array)
], Quote.prototype, "Notes", void 0);
__decorate([
    AField({
        soql: 'OwnerId',
        view: ['Compact'],
        compactLabel: 'Owner'
    }),
    Expose({ name: 'OwnerId' }),
    __metadata("design:type", String)
], Quote.prototype, "OwnerId", void 0);
__decorate([
    Expose({ name: 'Owner' }),
    Type(() => UserBase),
    __metadata("design:type", UserBase)
], Quote.prototype, "Owner", void 0);
__decorate([
    Expose({ name: 'CreatedBy' }),
    Type(() => User),
    __metadata("design:type", User)
], Quote.prototype, "CreatedBy", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__ProposalSummaryGroups__r' }),
    Type(() => SummaryGroup),
    __metadata("design:type", Array)
], Quote.prototype, "ProposalSummaryGroups", void 0);
Quote = __decorate([
    ATable({
        sobjectName: 'Apttus_Proposal__Proposal__c',
        aqlName: 'cpq_Quote'
    })
], Quote);

let ConstraintRuleCondition = class ConstraintRuleCondition extends AObject {
    constructor() {
        super(...arguments);
        this.ConditionCriteria = null;
        this.ConstraintRuleId = null;
        this.ConstraintRule = null;
        this.EditCriteria = null;
        this.ProductFieldValueA = null;
        this.ProductFieldValueB = null;
        this.ProductFieldValueC = null;
        this.ProductFieldValueD = null;
        this.MatchInAsset = null;
        this.MatchInCartOptions = null;
        this.MatchInLocation = null;
        this.MatchInOptions = null;
        this.MatchInPrimaryLines = null;
        this.MatchMaxProducts = null;
        this.MatchMinProducts = null;
        this.MatchRule = null;
        this.ProductFieldOperatorA = null;
        this.ProductFieldOperatorB = null;
        this.ProductFieldOperatorC = null;
        this.ProductFieldOperatorD = null;
        this.ProductId = null;
        this.Product = null;
        this.ProductCategory = null;
        this.ProductFamily = null;
        this.ProductFieldA = null;
        this.ProductFieldB = null;
        this.ProductFieldC = null;
        this.ProductFieldD = null;
        this.ProductGroupId = null;
        this.ProductOptionGroupId = null;
        this.ProductScope = null;
        this.Sequence = null;
    }
};
__decorate([
    AField({
        soql: 'Apttus_Config2__ConditionCriteria__c',
        aql: 'ConditionCriteria'
    }),
    __metadata("design:type", String)
], ConstraintRuleCondition.prototype, "ConditionCriteria", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ConstraintRuleId__c',
        aql: 'ConstraintRuleId'
    }),
    __metadata("design:type", String)
], ConstraintRuleCondition.prototype, "ConstraintRuleId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ConstraintRuleId__r',
        expand: 'deep'
    }),
    Type(() => ConstraintRule),
    __metadata("design:type", ConstraintRule)
], ConstraintRuleCondition.prototype, "ConstraintRule", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__EditCriteria__c'
    }),
    __metadata("design:type", String)
], ConstraintRuleCondition.prototype, "EditCriteria", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductFieldValueA__c',
        aql: 'ProductFieldA'
    }),
    __metadata("design:type", String)
], ConstraintRuleCondition.prototype, "ProductFieldValueA", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductFieldValueB__c',
        aql: 'ProductFieldB'
    }),
    __metadata("design:type", String)
], ConstraintRuleCondition.prototype, "ProductFieldValueB", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductFieldValueC__c',
        aql: 'ProductFieldC'
    }),
    __metadata("design:type", String)
], ConstraintRuleCondition.prototype, "ProductFieldValueC", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductFieldValueD__c',
        aql: 'ProductFieldD'
    }),
    __metadata("design:type", String)
], ConstraintRuleCondition.prototype, "ProductFieldValueD", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__MatchInAsset__c',
        aql: 'MatchInAsset'
    }),
    __metadata("design:type", Boolean)
], ConstraintRuleCondition.prototype, "MatchInAsset", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__MatchInCartOptions__c',
        aql: 'MatchInCartOptions'
    }),
    __metadata("design:type", Boolean)
], ConstraintRuleCondition.prototype, "MatchInCartOptions", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__MatchInLocation__c',
        aql: 'MatchInLocation'
    }),
    __metadata("design:type", Boolean)
], ConstraintRuleCondition.prototype, "MatchInLocation", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__MatchInOptions__c',
        aql: 'MatchInOptions'
    }),
    __metadata("design:type", Boolean)
], ConstraintRuleCondition.prototype, "MatchInOptions", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__MatchInPrimaryLines__c',
        aql: 'MatchInPrimaryLines'
    }),
    __metadata("design:type", Boolean)
], ConstraintRuleCondition.prototype, "MatchInPrimaryLines", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__MatchMaxProducts__c',
        aql: 'MatchMaxProducts'
    }),
    __metadata("design:type", Number)
], ConstraintRuleCondition.prototype, "MatchMaxProducts", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__MatchMinProducts__c',
        aql: 'MatchMinProducts'
    }),
    __metadata("design:type", Number)
], ConstraintRuleCondition.prototype, "MatchMinProducts", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__MatchRule__c',
        aql: 'MatchRule'
    }),
    __metadata("design:type", String)
], ConstraintRuleCondition.prototype, "MatchRule", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductFieldOperatorA__c',
        aql: 'ProductFieldOperatorA'
    }),
    __metadata("design:type", String)
], ConstraintRuleCondition.prototype, "ProductFieldOperatorA", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductFieldOperatorB__c',
        aql: 'ProductFieldOperatorB'
    }),
    __metadata("design:type", String)
], ConstraintRuleCondition.prototype, "ProductFieldOperatorB", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductFieldOperatorC__c',
        aql: 'ProductFieldOperatorC'
    }),
    __metadata("design:type", String)
], ConstraintRuleCondition.prototype, "ProductFieldOperatorC", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductFieldOperatorD__c',
        aql: 'ProductFieldOperatorD'
    }),
    __metadata("design:type", String)
], ConstraintRuleCondition.prototype, "ProductFieldOperatorD", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductId__c',
        aql: 'ProductId'
    }),
    __metadata("design:type", String)
], ConstraintRuleCondition.prototype, "ProductId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductId__r',
        aql: 'ProductId'
    }),
    Type(() => Product),
    __metadata("design:type", Product)
], ConstraintRuleCondition.prototype, "Product", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductCategory__c',
        aql: 'ProductCategory'
    }),
    __metadata("design:type", String)
], ConstraintRuleCondition.prototype, "ProductCategory", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductFamily__c',
        aql: 'ProductFamily'
    }),
    __metadata("design:type", String)
], ConstraintRuleCondition.prototype, "ProductFamily", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductFieldA__c',
        aql: 'ProductFieldA'
    }),
    __metadata("design:type", String)
], ConstraintRuleCondition.prototype, "ProductFieldA", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductFieldB__c',
        aql: 'ProductFieldB'
    }),
    __metadata("design:type", String)
], ConstraintRuleCondition.prototype, "ProductFieldB", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductFieldC__c',
        aql: 'ProductFieldC'
    }),
    __metadata("design:type", String)
], ConstraintRuleCondition.prototype, "ProductFieldC", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductFieldD__c',
        aql: 'ProductFieldD'
    }),
    __metadata("design:type", String)
], ConstraintRuleCondition.prototype, "ProductFieldD", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductGroupId__c',
        aql: 'ProductGroupId'
    }),
    __metadata("design:type", String)
], ConstraintRuleCondition.prototype, "ProductGroupId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductOptionGroupId__c',
        aql: 'ProductOptionGroupId'
    }),
    __metadata("design:type", String)
], ConstraintRuleCondition.prototype, "ProductOptionGroupId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ProductScope__c',
        aql: 'ProductScope'
    }),
    __metadata("design:type", String)
], ConstraintRuleCondition.prototype, "ProductScope", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Sequence__c',
        aql: 'Sequence'
    }),
    __metadata("design:type", Number)
], ConstraintRuleCondition.prototype, "Sequence", void 0);
ConstraintRuleCondition = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__ConstraintRuleCondition__c',
        aqlName: 'cpq_ConstraintRuleCondition'
    })
], ConstraintRuleCondition);

let ConstraintRuleAction = class ConstraintRuleAction extends AObject {
    constructor() {
        super(...arguments);
        this.ProductId = null;
        this.ActionType = null;
        this.AutoInclude = null;
        this.ConstraintRuleId = null;
        this.EditCriteria = null;
        this.AutoExclude = null;
        this.MatchInAsset = null;
        this.MatchInCartOptions = null;
        this.MatchInOptions = null;
        this.MatchInPrimaryLines = null;
        this.IncludeMaxProducts = null;
        this.Message = null;
        this.IncludeMatchRule = null;
        this.IncludeMinProducts = null;
        this.ProductCategory = null;
        this.ProductFamily = null;
        this.ProductGroupId = null;
        this.ProductGroup = new ProductGroup();
        this.ProductScope = null;
        this.RepeatInclusion = null;
        this.Sequence = null;
        this.ActionIntent = null;
        this.ActionDisposition = null;
    }
};
__decorate([
    Expose({
        name: 'Apttus_Config2__ProductId__c'
    }),
    __metadata("design:type", String)
], ConstraintRuleAction.prototype, "ProductId", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__ProductId__r'
    }),
    Type(() => Product),
    __metadata("design:type", Product)
], ConstraintRuleAction.prototype, "Product", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__ActionType__c'
    }),
    __metadata("design:type", String)
], ConstraintRuleAction.prototype, "ActionType", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__AutoInclude__c'
    }),
    __metadata("design:type", Boolean)
], ConstraintRuleAction.prototype, "AutoInclude", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__ConstraintRuleId__c'
    }),
    __metadata("design:type", String)
], ConstraintRuleAction.prototype, "ConstraintRuleId", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__EditCriteria__c'
    }),
    __metadata("design:type", String)
], ConstraintRuleAction.prototype, "EditCriteria", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__AutoExclude__c'
    }),
    __metadata("design:type", Boolean)
], ConstraintRuleAction.prototype, "AutoExclude", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__MatchInAsset__c'
    }),
    __metadata("design:type", Boolean)
], ConstraintRuleAction.prototype, "MatchInAsset", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__MatchInCartOptions__c'
    }),
    __metadata("design:type", Boolean)
], ConstraintRuleAction.prototype, "MatchInCartOptions", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__MatchInOptions__c'
    }),
    __metadata("design:type", Boolean)
], ConstraintRuleAction.prototype, "MatchInOptions", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__MatchInPrimaryLines__c'
    }),
    __metadata("design:type", Boolean)
], ConstraintRuleAction.prototype, "MatchInPrimaryLines", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__IncludeMaxProducts__c'
    }),
    __metadata("design:type", Number)
], ConstraintRuleAction.prototype, "IncludeMaxProducts", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__Message__c'
    }),
    __metadata("design:type", String)
], ConstraintRuleAction.prototype, "Message", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__IncludeMatchRule__c'
    }),
    __metadata("design:type", String)
], ConstraintRuleAction.prototype, "IncludeMatchRule", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__IncludeMinProducts__c'
    }),
    __metadata("design:type", Number)
], ConstraintRuleAction.prototype, "IncludeMinProducts", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__ProductCategory__c'
    }),
    __metadata("design:type", String)
], ConstraintRuleAction.prototype, "ProductCategory", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__ProductFamily__c'
    }),
    __metadata("design:type", String)
], ConstraintRuleAction.prototype, "ProductFamily", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__ProductGroupId__c'
    }),
    __metadata("design:type", String)
], ConstraintRuleAction.prototype, "ProductGroupId", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__ProductGroupId__r'
    }),
    __metadata("design:type", ProductGroup)
], ConstraintRuleAction.prototype, "ProductGroup", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__ProductScope__c'
    }),
    __metadata("design:type", String)
], ConstraintRuleAction.prototype, "ProductScope", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__RepeatInclusion__c'
    }),
    __metadata("design:type", String)
], ConstraintRuleAction.prototype, "RepeatInclusion", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__Sequence__c'
    }),
    __metadata("design:type", Number)
], ConstraintRuleAction.prototype, "Sequence", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__ActionIntent__c'
    }),
    __metadata("design:type", String)
], ConstraintRuleAction.prototype, "ActionIntent", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__ActionDisposition__c'
    }),
    __metadata("design:type", String)
], ConstraintRuleAction.prototype, "ActionDisposition", void 0);
ConstraintRuleAction = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__ConstraintRuleAction__c',
        aqlName: 'cpq_ConstraintRuleAction'
    })
], ConstraintRuleAction);

let ConstraintRule = class ConstraintRule extends AObject {
    constructor() {
        super(...arguments);
        this.ConstraintRuleConditions = [];
        this.ConstraintRuleActions = [];
        this.Name = null;
        this.EffectiveDate = null;
        this.ExpirationDate = null;
        this.ConditionAssociation = null;
        this.Sequence = null;
        this.UpdateView = null;
        this.IsBundleContext = null;
        this.Active = null;
    }
};
__decorate([
    AField({
        soql: 'Apttus_Config2__ConstraintRuleConditions__r',
        aql: 'ConstraintRuleId',
        expand: 'shallow'
    }),
    Type(() => ConstraintRuleCondition),
    __metadata("design:type", Array)
], ConstraintRule.prototype, "ConstraintRuleConditions", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ConstraintRuleActions__r',
        aql: 'ConstraintRuleId',
        expand: 'deep'
    }),
    Type(() => ConstraintRuleAction),
    __metadata("design:type", Array)
], ConstraintRule.prototype, "ConstraintRuleActions", void 0);
__decorate([
    AField({
        soql: 'Name',
        aql: 'Name'
    }),
    __metadata("design:type", String)
], ConstraintRule.prototype, "Name", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__EffectiveDate__c',
        aql: 'EffectiveDate'
    }),
    __metadata("design:type", Date)
], ConstraintRule.prototype, "EffectiveDate", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ExpirationDate__c',
        aql: 'ExpirationDate'
    }),
    __metadata("design:type", Date)
], ConstraintRule.prototype, "ExpirationDate", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ConditionAssociation__c',
        aql: 'ConditionAssociation'
    }),
    __metadata("design:type", String)
], ConstraintRule.prototype, "ConditionAssociation", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Sequence__c',
        aql: 'Sequence'
    }),
    __metadata("design:type", Number)
], ConstraintRule.prototype, "Sequence", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__UpdateView__c'
    }),
    __metadata("design:type", String)
], ConstraintRule.prototype, "UpdateView", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__IsBundleContext__c',
        aql: 'IsBundleContext'
    }),
    __metadata("design:type", Boolean)
], ConstraintRule.prototype, "IsBundleContext", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__Active__c',
        aql: 'Active'
    }),
    __metadata("design:type", Boolean)
], ConstraintRule.prototype, "Active", void 0);
ConstraintRule = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__ConstraintRule__c',
        aqlName: 'cpq_ConstraintRule'
    })
], ConstraintRule);

let AppliedRuleInfo = class AppliedRuleInfo extends AObject {
    constructor() {
        super(...arguments);
        this.ConfigurationId = null;
        this.ConstraintRuleId = null;
        this.CriteriaFields = null;
        this.HasCriteriaInCondition = null;
        this.Invalid = null;
        this.IsSourceLineRequired = null;
        this.MatchInLocation = null;
        this.NeedProcessing = null;
        this.PrimaryLineNumber = null;
        this.SourceLineNumber = null;
        this.WasFinalized = null;
    }
};
__decorate([
    Expose({ name: 'Apttus_Config2__ConfigurationId__c' }),
    __metadata("design:type", String)
], AppliedRuleInfo.prototype, "ConfigurationId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ConstraintRuleId__c' }),
    __metadata("design:type", String)
], AppliedRuleInfo.prototype, "ConstraintRuleId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__CriteriaFields__c' }),
    __metadata("design:type", String)
], AppliedRuleInfo.prototype, "CriteriaFields", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__HasCriteriaInCondition__c' }),
    __metadata("design:type", Boolean)
], AppliedRuleInfo.prototype, "HasCriteriaInCondition", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Invalid__c' }),
    __metadata("design:type", Boolean)
], AppliedRuleInfo.prototype, "Invalid", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsSourceLineRequired__c' }),
    __metadata("design:type", Boolean)
], AppliedRuleInfo.prototype, "IsSourceLineRequired", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__MatchInLocation__c' }),
    __metadata("design:type", Boolean)
], AppliedRuleInfo.prototype, "MatchInLocation", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__NeedProcessing__c' }),
    __metadata("design:type", Boolean)
], AppliedRuleInfo.prototype, "NeedProcessing", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PrimaryLineNumber__c' }),
    __metadata("design:type", Number)
], AppliedRuleInfo.prototype, "PrimaryLineNumber", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__SourceLineNumber__c' }),
    __metadata("design:type", Number)
], AppliedRuleInfo.prototype, "SourceLineNumber", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__WasFinalized__c' }),
    __metadata("design:type", Boolean)
], AppliedRuleInfo.prototype, "WasFinalized", void 0);
AppliedRuleInfo = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__AppliedRuleInfo__c',
        aqlName: 'cpq_AppliedRuleInfo'
    })
], AppliedRuleInfo);

let AppliedRuleActionInfo = class AppliedRuleActionInfo extends AObject {
    constructor() {
        super(...arguments);
        this.ActionProductIds = null;
        this.AffectedPrimaryNumbers = null;
        this.AffectedProductIds = null;
        this.AllowedMax = null;
        this.AppliedRuleInfoId = null;
        this.AutoExecuted = null;
        this.ConfigurationId = null;
        this.ConstraintRuleActionId = null;
        this.ConstraintRuleAction = null;
        this.CriteriaFields = null;
        this.HideMessage = null;
        this.Ignored = null;
        this.IsPrompt = null;
        this.IsTargetOption = null;
        this.IsTargetPrimaryLine = null;
        this.Message = null;
        this.MessageType = null;
        this.Pending = null;
        this.RequiredMin = null;
        this.SuggestedProductIds = null;
        this.TargetBundleNumber = null;
        this.TriggeringPrimaryNumbers = null;
        this.TriggeringProductIds = null;
    }
};
__decorate([
    Expose({ name: 'Apttus_Config2__ActionProductIds__c' }),
    __metadata("design:type", String)
], AppliedRuleActionInfo.prototype, "ActionProductIds", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AffectedPrimaryNumbers__c' }),
    __metadata("design:type", String)
], AppliedRuleActionInfo.prototype, "AffectedPrimaryNumbers", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AffectedProductIds__c' }),
    __metadata("design:type", String)
], AppliedRuleActionInfo.prototype, "AffectedProductIds", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AllowedMax__c' }),
    __metadata("design:type", Number)
], AppliedRuleActionInfo.prototype, "AllowedMax", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AppliedRuleInfoId__c' }),
    __metadata("design:type", String)
], AppliedRuleActionInfo.prototype, "AppliedRuleInfoId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AutoExecuted__c' }),
    __metadata("design:type", Boolean)
], AppliedRuleActionInfo.prototype, "AutoExecuted", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ConfigurationId__c' }),
    __metadata("design:type", String)
], AppliedRuleActionInfo.prototype, "ConfigurationId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ConstraintRuleActionId__c' }),
    __metadata("design:type", String)
], AppliedRuleActionInfo.prototype, "ConstraintRuleActionId", void 0);
__decorate([
    Type(() => ConstraintRuleAction),
    Expose({ name: 'Apttus_Config2__ConstraintRuleActionId__r' }),
    __metadata("design:type", ConstraintRuleAction)
], AppliedRuleActionInfo.prototype, "ConstraintRuleAction", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__CriteriaFields__c' }),
    __metadata("design:type", String)
], AppliedRuleActionInfo.prototype, "CriteriaFields", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__HideMessage__c' }),
    __metadata("design:type", Boolean)
], AppliedRuleActionInfo.prototype, "HideMessage", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Ignored__c' }),
    __metadata("design:type", Boolean)
], AppliedRuleActionInfo.prototype, "Ignored", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsPrompt__c' }),
    __metadata("design:type", Boolean)
], AppliedRuleActionInfo.prototype, "IsPrompt", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsTargetOption__c' }),
    __metadata("design:type", Boolean)
], AppliedRuleActionInfo.prototype, "IsTargetOption", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsTargetPrimaryLine__c' }),
    __metadata("design:type", Boolean)
], AppliedRuleActionInfo.prototype, "IsTargetPrimaryLine", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Message__c' }),
    __metadata("design:type", String)
], AppliedRuleActionInfo.prototype, "Message", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__MessageType__c' }),
    __metadata("design:type", String)
], AppliedRuleActionInfo.prototype, "MessageType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Pending__c' }),
    __metadata("design:type", Boolean)
], AppliedRuleActionInfo.prototype, "Pending", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__RequiredMin__c' }),
    __metadata("design:type", Number)
], AppliedRuleActionInfo.prototype, "RequiredMin", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__SuggestedProductIds__c' }),
    __metadata("design:type", String)
], AppliedRuleActionInfo.prototype, "SuggestedProductIds", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__TargetBundleNumber__c' }),
    __metadata("design:type", Number)
], AppliedRuleActionInfo.prototype, "TargetBundleNumber", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__TriggeringPrimaryNumbers__c' }),
    __metadata("design:type", String)
], AppliedRuleActionInfo.prototype, "TriggeringPrimaryNumbers", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__TriggeringProductIds__c' }),
    __metadata("design:type", String)
], AppliedRuleActionInfo.prototype, "TriggeringProductIds", void 0);
AppliedRuleActionInfo = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__AppliedRuleActionInfo__c',
        aqlName: 'cpq_AppliedRuleActionInfo'
    })
], AppliedRuleActionInfo);

let Order = class Order extends AObject {
    constructor() {
        super(...arguments);
        this.Name = null;
        this.Accept = null;
        this.AutoActivateOrder = true;
        this.BillingPreferenceId = null;
        this.BillToAccountId = null;
        this.BillToAccount = new Account();
        this.CancelledDate = null;
        this.CompletedDate = null;
        this.ConfigurationSyncDate = null;
        this.Description = null;
        this.IsTaskPending = false;
        this.OrderDate = null;
        this.OrderEndDate = null;
        this.OrderReferenceNumber = null;
        this.OrderStartDate = null;
        this.OrderAmount = null;
        this.OriginalOrderNumber = null;
        this.ParentOrderId = null;
        this.PODate = null;
        this.PONumber = null;
        this.PriceListId = null;
        this.PriceList = new PriceList();
        this.PricingDate = null;
        this.PrimaryContact = new Contact();
        this.PrimaryContactId = null;
        this.ActivatedDate = null;
        this.ReadyForBillingDate = null;
        this.FulfilledDate = null;
        this.ReadyForRevRecDate = null;
        this.RelatedOpportunityId = null;
        this.ShipToAccountId = null;
        this.ShipToAccount = new Account();
        this.SoldToAccountId = null;
        this.SoldToAccount = new Account();
        this.Source = null;
        this.Status = null;
        this.Type = null;
        this.OrderLineItems = null;
        this.Attachments = null;
        this.Notes = null;
        this.Proposal = null;
        this.ProposalId = null;
        this.Location = new AccountLocation();
        // @AField({
        //     soql: 'Apttus_Config2__LocationId__c',
        //     aql: 'LocationId'
        // })
        // LocationId: string = null;
        this.Owner = new UserBase();
        this.CurrencyIsoCode = null;
        this.OwnerId = null;
        this.CreatedBy = new User();
        this.PaymentStatus = 'Pending';
    }
    validate() { }
};
__decorate([
    Expose({ name: 'Name' }),
    __metadata("design:type", String)
], Order.prototype, "Name", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Accept__c' }),
    __metadata("design:type", String)
], Order.prototype, "Accept", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AutoActivateOrder__c' }),
    __metadata("design:type", Object)
], Order.prototype, "AutoActivateOrder", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BillingPreferenceId__c' }),
    __metadata("design:type", String)
], Order.prototype, "BillingPreferenceId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__BillToAccountId__c',
        view: ['Compact']
    }),
    Expose({ name: 'Apttus_Config2__BillToAccountId__c' }),
    __metadata("design:type", String)
], Order.prototype, "BillToAccountId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BillToAccountId__r' }),
    Type(() => Account),
    __metadata("design:type", Account)
], Order.prototype, "BillToAccount", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__CancelledDate__c' }),
    __metadata("design:type", Date)
], Order.prototype, "CancelledDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__CompletedDate__c' }),
    __metadata("design:type", Date)
], Order.prototype, "CompletedDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ConfigurationSyncDate__c' }),
    __metadata("design:type", Date)
], Order.prototype, "ConfigurationSyncDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Description__c' }),
    __metadata("design:type", String)
], Order.prototype, "Description", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsTaskPending__c' }),
    __metadata("design:type", Boolean)
], Order.prototype, "IsTaskPending", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__OrderDate__c' }),
    __metadata("design:type", Date)
], Order.prototype, "OrderDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__OrderEndDate__c' }),
    __metadata("design:type", Date)
], Order.prototype, "OrderEndDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__OrderReferenceNumber__c' }),
    __metadata("design:type", String)
], Order.prototype, "OrderReferenceNumber", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__OrderStartDate__c' }),
    __metadata("design:type", Date)
], Order.prototype, "OrderStartDate", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__OrderAmount__c',
        view: ['Compact'],
        aggregate: ['SUM']
    }),
    Expose({ name: 'Apttus_Config2__OrderAmount__c' }),
    __metadata("design:type", String)
], Order.prototype, "OrderAmount", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__OriginalOrderNumber__c'
    }),
    __metadata("design:type", String)
], Order.prototype, "OriginalOrderNumber", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__ParentOrderId__c'
    }),
    __metadata("design:type", String)
], Order.prototype, "ParentOrderId", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__PODate__c'
    }),
    __metadata("design:type", Date)
], Order.prototype, "PODate", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__PONumber__c'
    }),
    __metadata("design:type", String)
], Order.prototype, "PONumber", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__PriceListId__c',
        aql: 'PriceListId',
        view: ['Compact']
    }),
    Expose({
        name: 'Apttus_Config2__PriceListId__c'
    }),
    __metadata("design:type", String)
], Order.prototype, "PriceListId", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__PriceListId__r'
    }),
    Type(() => PriceList),
    __metadata("design:type", PriceList)
], Order.prototype, "PriceList", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__PricingDate__c'
    }),
    __metadata("design:type", Date)
], Order.prototype, "PricingDate", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__PrimaryContactId__r'
    }),
    Type(() => Contact),
    __metadata("design:type", Contact)
], Order.prototype, "PrimaryContact", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__PrimaryContactId__c',
        aql: 'PrimaryContactId',
        view: ['Compact']
    }),
    Expose({
        name: 'Apttus_Config2__PrimaryContactId__c'
    }),
    __metadata("design:type", String)
], Order.prototype, "PrimaryContactId", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__ActivatedDate__c'
    }),
    __metadata("design:type", Date)
], Order.prototype, "ActivatedDate", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__ReadyForBillingDate__c'
    }),
    __metadata("design:type", Date)
], Order.prototype, "ReadyForBillingDate", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__FulfilledDate__c'
    }),
    __metadata("design:type", Date)
], Order.prototype, "FulfilledDate", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__ReadyForRevRecDate__c'
    }),
    __metadata("design:type", Date)
], Order.prototype, "ReadyForRevRecDate", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__RelatedOpportunityId__c'
    }),
    __metadata("design:type", String)
], Order.prototype, "RelatedOpportunityId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ShipToAccountId__c',
        aql: 'ShipToAccountId',
        view: ['Compact']
    }),
    Expose({
        name: 'Apttus_Config2__ShipToAccountId__c'
    }),
    __metadata("design:type", String)
], Order.prototype, "ShipToAccountId", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__ShipToAccountId__r'
    }),
    Type(() => Account),
    __metadata("design:type", Account)
], Order.prototype, "ShipToAccount", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__SoldToAccountId__c',
        aql: 'SoldToAccountId',
        view: ['Compact']
    }),
    Expose({
        name: 'Apttus_Config2__SoldToAccountId__c'
    }),
    __metadata("design:type", String)
], Order.prototype, "SoldToAccountId", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__SoldToAccountId__r'
    }),
    Type(() => Account),
    __metadata("design:type", Account)
], Order.prototype, "SoldToAccount", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__Source__c'
    }),
    __metadata("design:type", String)
], Order.prototype, "Source", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__Status__c'
    }),
    __metadata("design:type", String)
], Order.prototype, "Status", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__Type__c'
    }),
    __metadata("design:type", String)
], Order.prototype, "Type", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__OrderLineItems__r'
    }),
    Type(() => OrderLineItem),
    __metadata("design:type", Array)
], Order.prototype, "OrderLineItems", void 0);
__decorate([
    Expose({
        name: 'Attachments'
    }),
    Type(() => Attachment),
    __metadata("design:type", Array)
], Order.prototype, "Attachments", void 0);
__decorate([
    Expose({
        name: 'Notes'
    }),
    Type(() => Note),
    __metadata("design:type", Array)
], Order.prototype, "Notes", void 0);
__decorate([
    Expose({
        name: 'Apttus_QPConfig__ProposalId__r'
    }),
    Type(() => Quote),
    __metadata("design:type", Quote)
], Order.prototype, "Proposal", void 0);
__decorate([
    Expose({
        name: 'Apttus_QPConfig__ProposalId__c'
    }),
    __metadata("design:type", String)
], Order.prototype, "ProposalId", void 0);
__decorate([
    Expose({
        name: 'Apttus_Config2__LocationId__r'
    }),
    __metadata("design:type", AccountLocation)
], Order.prototype, "Location", void 0);
__decorate([
    Expose({
        name: 'Owner'
    }),
    Type(() => UserBase),
    __metadata("design:type", UserBase)
], Order.prototype, "Owner", void 0);
__decorate([
    Expose({
        name: 'CurrencyIsoCode'
    }),
    __metadata("design:type", String)
], Order.prototype, "CurrencyIsoCode", void 0);
__decorate([
    AField({
        soql: 'OwnerId',
        aql: 'CreatedById',
        view: ['Compact'],
        compactLabel: 'Owner'
    }),
    Expose({
        name: 'OwnerId'
    }),
    __metadata("design:type", String)
], Order.prototype, "OwnerId", void 0);
__decorate([
    Expose({
        name: 'CreatedBy'
    }),
    Type(() => User),
    __metadata("design:type", User)
], Order.prototype, "CreatedBy", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__PaymentStatus__c',
        view: ['Compact']
    }),
    Expose({
        name: 'Apttus_Config2__PaymentStatus__c'
    }),
    __metadata("design:type", String)
], Order.prototype, "PaymentStatus", void 0);
Order = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__Order__c',
        aqlName: 'ord_Order'
    })
], Order);

let Cart = class Cart extends AObject {
    constructor() {
        super(...arguments);
        this.Name = null;
        this.Account = null;
        this.AccountId = null;
        this.Status = null;
        this.OrderId = null;
        this.Order = new Order();
        this.NumberOfItems = null;
        this.EffectiveDate = null;
        this.BillToAccountId = null;
        this.BillToAccount = null;
        this.Comments = null;
        this.EffectivePriceList = null;
        this.EffectivePriceListId = null;
        this.PriceList = null;
        this.PriceListId = null;
        this.Proposald = null;
        this.ProposaldId = null;
        this.BusinessObjectId = null;
        this.BusinessObjectRefId = null;
        this.CollaborationRequestId = null;
        this.ParentConfigurationId = null;
        this.BusinessObjectType = null;
        this.ShipToAccountId = null;
        this.ShipToAccount = null;
        this.OwnerId = null;
        this.CreatedBy = new User();
        this.IsTransient = true;
        this.LineItems = null;
        this.SummaryGroups = null;
        this.IsPricePending = false;
        this.CouponCodes = null;
        this.AppliedRuleActionInfos = null;
        this.Applied_Rule_Infos = null;
        this.Owner = null;
    }
    validate() {
        let errors = new Array();
        // Validate the option groups
        _.forEach(_.filter(this.LineItems, { HasOptions: true }), item => {
            const reference = {
                key: _.get(item, 'Product.Name'),
                value: `/products/${_.get(item, 'ProductId')}/${_.get(item, 'Id')}`
            };
            const optionGroups = _.get(item, 'LineType') === 'Option' ? _.get(item, 'Option.OptionGroups') : _.get(item, 'Product.OptionGroups');
            _.forEach(_.filter(optionGroups, { IsHidden: false }), option => {
                const children = _.filter(_.get(this, 'LineItems'), child => _.get(child, 'ParentBundleNumber') === _.get(item, 'PrimaryLineNumber') && _.get(child, 'ProductOption.ProductOptionGroupId') === _.get(option, 'Id'));
                const total = _.sumBy(children, 'Quantity');
                // Validate Max quantity
                if (!_.isNil(_.get(option, 'MaxTotalQuantity')) && total > option.MaxTotalQuantity)
                    item.setError('ERROR.OPTION_GROUP.MAX_TOTAL_QUANTITY', { value: option.MaxTotalQuantity }, 'error', null, reference);
                else
                    item.clearError('ERROR.OPTION_GROUP.MAX_TOTAL_QUANTITY');
                // Validate Max Quantity
                if (!_.isNil(_.get(option, 'MinTotalQuantity')) && total < option.MinTotalQuantity)
                    item.setError('ERROR.OPTION_GROUP.MIN_TOTAL_QUANTITY', { value: option.MinTotalQuantity }, 'error', null, reference);
                else
                    item.clearError('ERROR.OPTION_GROUP.MIN_TOTAL_QUANTITY');
                // Validate min options
                if (!_.isNil(_.get(option, 'MinOptions')) && _.get(children, 'length', 0) < option.MinOptions)
                    item.setError('ERROR.OPTION_GROUP.MIN_OPTIONS', { value: option.MinOptions }, 'error', null, reference);
                else
                    item.clearError('ERROR.OPTION_GROUP.MIN_OPTIONS');
                // Validate max options
                if (!_.isNil(_.get(option, 'MaxOptions')) && _.get(children, 'length', 0) > option.MaxOptions)
                    item.setError('ERROR.OPTION_GROUP.MAX_OPTIONS', { value: option.MaxOptions }, 'error', null, reference);
                else
                    item.clearError('ERROR.OPTION_GROUP.MAX_OPTIONS');
                errors = _.compact(_.concat(errors, item.errors));
            });
        });
        const qtyErrors = _.filter(this.LineItems, r => r.Quantity === 0 || !r.Quantity);
        _.isEmpty(qtyErrors) ? this.clearError('INVALID_QUANTITY') : this.setError('INVALID_QUANTITY');
        _.isEmpty(errors) ? this.clearError() : this.setError(`ERROR.CART.VALIDATE`, null, 'error', errors);
    }
};
__decorate([
    Expose({ name: 'Name' }),
    __metadata("design:type", String)
], Cart.prototype, "Name", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AccountId__r' }),
    Type(() => Account),
    __metadata("design:type", Account)
], Cart.prototype, "Account", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AccountId__c' }),
    __metadata("design:type", String)
], Cart.prototype, "AccountId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Status__c' }),
    __metadata("design:type", String)
], Cart.prototype, "Status", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__OrderId__c' }),
    __metadata("design:type", String)
], Cart.prototype, "OrderId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__OrderId__r' }),
    Type(() => Order),
    __metadata("design:type", Order)
], Cart.prototype, "Order", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__NumberOfItems__c' }),
    __metadata("design:type", Number)
], Cart.prototype, "NumberOfItems", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__EffectiveDate__c' }),
    __metadata("design:type", String)
], Cart.prototype, "EffectiveDate", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BillToAccountId__c' }),
    __metadata("design:type", String)
], Cart.prototype, "BillToAccountId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BillToAccountId__r' }),
    Type(() => Account),
    __metadata("design:type", Account)
], Cart.prototype, "BillToAccount", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Comments__c' }),
    __metadata("design:type", String)
], Cart.prototype, "Comments", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__EffectivePriceListId__r' }),
    Type(() => PriceList),
    __metadata("design:type", PriceList)
], Cart.prototype, "EffectivePriceList", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__EffectivePriceListId__c' }),
    __metadata("design:type", String)
], Cart.prototype, "EffectivePriceListId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceListId__r' }),
    Type(() => PriceList),
    __metadata("design:type", PriceList)
], Cart.prototype, "PriceList", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceListId__c' }),
    __metadata("design:type", String)
], Cart.prototype, "PriceListId", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__Proposald__r' }),
    Type(() => Quote),
    __metadata("design:type", Quote)
], Cart.prototype, "Proposald", void 0);
__decorate([
    Expose({ name: 'Apttus_QPConfig__Proposald__c' }),
    __metadata("design:type", String)
], Cart.prototype, "ProposaldId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BusinessObjectId__c' }),
    __metadata("design:type", String)
], Cart.prototype, "BusinessObjectId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BusinessObjectRefId__c' }),
    __metadata("design:type", String)
], Cart.prototype, "BusinessObjectRefId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__CollaborationRequestId__c' }),
    __metadata("design:type", String)
], Cart.prototype, "CollaborationRequestId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ParentConfigurationId__c' }),
    __metadata("design:type", String)
], Cart.prototype, "ParentConfigurationId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__BusinessObjectType__c' }),
    __metadata("design:type", String)
], Cart.prototype, "BusinessObjectType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ShipToAccountId__c' }),
    __metadata("design:type", String)
], Cart.prototype, "ShipToAccountId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ShipToAccountId__r' }),
    Type(() => Account),
    __metadata("design:type", Account)
], Cart.prototype, "ShipToAccount", void 0);
__decorate([
    Expose({ name: 'OwnerId' }),
    __metadata("design:type", String)
], Cart.prototype, "OwnerId", void 0);
__decorate([
    Expose({ name: 'CreatedBy' }),
    Type(() => User),
    __metadata("design:type", User)
], Cart.prototype, "CreatedBy", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsTransient__c' }),
    __metadata("design:type", Boolean)
], Cart.prototype, "IsTransient", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__LineItems__r' }),
    Type(() => CartItem),
    __metadata("design:type", Array)
], Cart.prototype, "LineItems", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__SummaryGroups__r' }),
    Type(() => SummaryGroup),
    __metadata("design:type", Array)
], Cart.prototype, "SummaryGroups", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsPricePending__c' }),
    __metadata("design:type", Boolean)
], Cart.prototype, "IsPricePending", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__CouponCodes__c' }),
    __metadata("design:type", String)
], Cart.prototype, "CouponCodes", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__AppliedRuleActionInfos__r' }),
    Type(() => AppliedRuleActionInfo),
    __metadata("design:type", Array)
], Cart.prototype, "AppliedRuleActionInfos", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Applied_Rule_Infos__r' }),
    Type(() => AppliedRuleInfo),
    __metadata("design:type", Array)
], Cart.prototype, "Applied_Rule_Infos", void 0);
__decorate([
    Expose({ name: 'Owner' }),
    Type(() => UserBase),
    __metadata("design:type", UserBase)
], Cart.prototype, "Owner", void 0);
Cart = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__ProductConfiguration__c',
        route: 'carts'
    })
], Cart);

/**
 * Line Item Service returns the details of  line items related to the CartItem , AssetLineItem ,QuoteLineItem , OrderLineItem.
 * <h3>Usage</h3>
 *
 ```typescript
import { LineItemService, AObjectService} from '@congacommerce/ecommerce';

export class MyComponent implements OnInit{
constructor( private lineItemService: LineItemService)
}
// or
export class MyService extends AObjectService {
     private lineItemService: LineItemService = this.injector.get(LineItemService);
 }
```
*/
class LineItemService extends AObjectService {
    /**
     * The method takes a line item and returns the categorized line item.
     *
     * ### Example:
     ```typescript
     import { LineItemService, Quote } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';

     export class MyComponent implements OnInit{
           lineItems: Array<ItemGroup>;

           constructor(private lineItemService: LineItemService){}

           ngOnInit(){
                lineItems: LineItemService.groupItems(lineItems),
           }
      }
     ```
     *
     * @param item Array of type Cart item, Asset line item, Quote line item Or Order line item
     * @return an Array of ItemGroup interface type.
     */
    static groupItems(items) {
        const output = _.map(_.compact(Object.values(_.groupBy(items, 'LineNumber'))), (line => {
            line = _.compact(line);
            const mainLine = _.minBy(_.filter(line, (i) => i.IsPrimaryLine && i.LineType === 'Product/Service'), 'ItemSequence') || _.find(line, i => i.IsPrimaryLine);
            if (!_.isNil(mainLine)) {
                return {
                    MainLine: mainLine,
                    Children: _.filter(line, i => _.get(i, 'PrimaryLineNumber') !== _.get(mainLine, 'PrimaryLineNumber') || _.get(i, 'ItemSequence') !== _.get(mainLine, 'PrimaryLineNumber')),
                    PrimaryLines: new Array(_.minBy(_.filter(line, (i) => i.IsPrimaryLine && i.LineType === 'Product/Service'), 'ItemSequence')),
                    SecondaryLines: _.filter(line, (i) => !i.IsPrimaryLine && i.LineType !== 'Option'),
                    RollupLines: _.filter(line, (i) => i.IsOptionRollupLine),
                    Options: TreeUtils.arrayToTree(_.filter(line, (i) => i.LineType === 'Option'), {
                        parentProperty: 'ParentBundleNumber',
                        childrenProperty: '_metadata.children',
                        customID: 'PrimaryLineNumber'
                    }),
                    Flat: line
                };
            }
            else
                return null;
        }));
        return _.compact(output);
    }
    /**
     * Method takes a line item and returns the full list of line items related to it. Can be any line item within the bundle.
     *
     * ### Example:
     ```typescript
     import { LineItemService, Quote } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';

     export class MyComponent implements OnInit{
           option: Array<CartItem | AssetLineItem | QuoteLineItem | OrderLineItem>;
           option$: Observable<Array<CartItem | AssetLineItem | QuoteLineItem | OrderLineItem>>;

           constructor(private lineItemService: LineItemService){}

           ngOnInit(){
                this.lineItemService.getOptionsForItem(relatedTo, cart)().subscribe(q => this.option = q);
                // or
                this.option$ = this.lineItemService.getOptionsForItem(relatedTo, cart)();
           }
      }
     ```
     *
     * @param item the primary line item to get the related cart items for
     * @param relatedTo An optional context object to avoid additional network callouts
     * @returns An observable of related Line items.  //cartItems$ = this.cartItemService.getOptionsForItem(relatedTo, cart);
     */
    getOptionsForItem(item, relatedTo) {
        // If the item is a cart item and has a related asset
        const service = this.metadataService.getAObjectServiceForType(item);
        if (service && item) {
            let field = 'ConfigurationId';
            if (item instanceof AssetLineItem)
                field = 'BusinessObjectId';
            else if (item instanceof QuoteLineItem)
                field = 'Proposal';
            else if (item instanceof OrderLineItem)
                field = 'OrderId';
            const item$ = service.get([_.get(item, 'Id')]).pipe(map$1(res => res[0]));
            return (!_.isNil(relatedTo)
                && ((item instanceof CartItem)
                    && relatedTo instanceof Cart
                    && item.ConfigurationId === relatedTo.Id))
                ? of(_.filter(_.get(relatedTo, 'LineItems', []), i => _.isEqual(_.get(i, 'LineNumber'), item.LineNumber)))
                : item$.pipe(mergeMap((i) => service.where([
                    new ACondition(service.type, 'LineNumber', 'Equal', i.LineNumber),
                    new ACondition(service.type, field, 'Equal', _.get(i, field))
                ])));
        }
        else
            return of(null);
    }
}
LineItemService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LineItemService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
LineItemService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LineItemService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LineItemService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * @ignore
 */
class AppLoader {
    constructor(translationService, userService, httpClient, configService) {
        this.translationService = translationService;
        this.userService = userService;
        this.httpClient = httpClient;
        this.configService = configService;
    }
    init() {
        const defaultLang = this.userService.getBrowserLocale(true), cachedLang = localStorage.getItem(PlatformConstants.PREFERRED_LANGUAGE), cachedTranslations = new Map(Object.entries(JSON.parse(localStorage.getItem(PlatformConstants.TRANSLATION_LABELS)) || {}));
        this.httpClient.get(`${this.configService.resourceLocation()}assets/i18n/${defaultLang}.json`)
            .pipe(switchMap(translations => {
            this.translationService.setTranslation(defaultLang, translations);
            cachedTranslations.has(cachedLang) && this.translationService.setTranslation(cachedLang, cachedTranslations.get(cachedLang));
            this.translationService.setDefaultLang(defaultLang);
            this.translationService.use(cachedLang || defaultLang);
            return this.userService.getLanguage();
        }), take(1), switchMap(lang => combineLatest(of(lang), this.translationService.currentLoader.getTranslation(lang))))
            .subscribe(([lang, translations]) => {
            this.translationService.setTranslation(lang, translations);
            this.translationService.use(lang);
            const translationsMap = new Map(Object.entries(JSON.parse(localStorage.getItem(PlatformConstants.TRANSLATION_LABELS)) || {}));
            translationsMap.set(lang, translations);
            localStorage.setItem(PlatformConstants.PREFERRED_LANGUAGE, lang);
            localStorage.setItem(PlatformConstants.TRANSLATION_LABELS, JSON.stringify(Array.from(translationsMap).reduce((obj, [key, value]) => Object.assign(obj, { [key]: value }), {})));
        });
    }
}
AppLoader.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AppLoader, deps: [{ token: i5.TranslateService }, { token: UserService }, { token: i3.HttpClient }, { token: i1.ConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
AppLoader.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AppLoader, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AppLoader, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i5.TranslateService }, { type: UserService }, { type: i3.HttpClient }, { type: i1.ConfigurationService }]; } });

/**
 * When user tries to hit the application with the URl directly the guard checks if the user is loggedIn user
 * or not. If user is not loggedIn then it redirects to login screen, otherwise it redirects to the page which user was trying to load.
 */
class LoginGuard {
    constructor(userService, router, storefrontService, ngZone) {
        this.userService = userService;
        this.router = router;
        this.storefrontService = storefrontService;
        this.ngZone = ngZone;
    }
    canActivate(route, state) {
        return this.userService.isLoggedIn()
            .pipe(switchMap(loggedIn => {
            // If not logged in, redirect to login without error
            if (!loggedIn) {
                const stateUrl = route.queryParams.loggedOut ? null : state.url;
                route.queryParams = {};
                return this.redirectToLogin(route, stateUrl);
            }
            else {
                return this.storefrontService.getStorefront();
            }
        }), switchMap((storefront) => {
            if (!storefront)
                return this.redirectToLogin(route);
            else
                return of(true);
        }), catchError(e => {
            // If there is an error logout and redirect to login page.
            return this.redirectToLogin(route, null, e);
        }));
    }
    /**
     * Redirects users to the login page after logging them out and displays an optional error message.
     * @param route The route snapshot.
     * @param error The optional error message to show.
     * @ignore
     */
    redirectToLogin(route, redirectUrl, error) {
        return this.userService.logout()
            .pipe(map$1(() => {
            let myRoute;
            let params;
            if (!_.isNil(_.get(route, `data.redirectUrl`)))
                myRoute = `${_.get(route, 'data.redirectUrl')}`;
            else
                myRoute = '/u/login';
            if (!_.isNil(error)) {
                params = { errorMessage: error };
                _.assign(params, route.queryParams);
            }
            if (!_.isNil(redirectUrl)) {
                params = { redirectUrl: window.location.hash ? window.location.href : window.location.pathname.replace(/^\//, "") };
            }
            this.ngZone.run(() => {
                const activeRoute = window.location.origin;
                const paramsInfo = Object.assign({}, params);
                if (_.isEmpty(paramsInfo.redirectUrl) || paramsInfo.redirectUrl === activeRoute)
                    delete paramsInfo.redirectUrl;
                this.router.navigate([myRoute], {
                    queryParams: paramsInfo ? paramsInfo : route.queryParams,
                    fragment: route.fragment
                });
            });
            return false;
        }));
    }
}
LoginGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LoginGuard, deps: [{ token: UserService }, { token: i2.Router }, { token: StorefrontService }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Injectable });
LoginGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LoginGuard, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LoginGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: UserService }, { type: i2.Router }, { type: StorefrontService }, { type: i0.NgZone }]; } });
/**
 * This guard is for guest users, When user tries to hit the application with the URl directly the guard checks if the user is guest user
 * or not.Then it redirects to  the page which user was trying to load.
 */
class GuestGuard {
    constructor(userService, router, ngZone) {
        this.userService = userService;
        this.router = router;
        this.ngZone = ngZone;
    }
    canActivate(route, state) {
        return this.userService.isLoggedIn()
            .pipe(map$1(loggedIn => {
            if (!_.isNil(_.get(route, `data.redirectUrl`)) && loggedIn) {
                this.ngZone.run(() => {
                    this.router.navigate([`${_.get(route, 'data.redirectUrl')}`], {
                        queryParams: route.queryParams,
                        fragment: route.fragment
                    });
                });
            }
            return !loggedIn;
        }), catchError(e => {
            return throwError(e);
        }));
    }
}
GuestGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: GuestGuard, deps: [{ token: UserService }, { token: i2.Router }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Injectable });
GuestGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: GuestGuard, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: GuestGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: UserService }, { type: i2.Router }, { type: i0.NgZone }]; } });
/**
 * This guard is mainly to check if the session is expired. When user tries to hit the application with the URl directly the guard checks if the user session is expired. Then if expired it
 * redirects to the home screen with toaster error message says "Session is Expired".
 */
class SessionGuard {
    constructor(userService, router, translateService, toastr, ngZone) {
        this.userService = userService;
        this.router = router;
        this.translateService = translateService;
        this.toastr = toastr;
        this.ngZone = ngZone;
    }
    canActivate(route, state) {
        return this.userService.isLoggedIn()
            .pipe(map$1(loggedIn => {
            if (!loggedIn && localStorage.getItem(PlatformConstants.TOKEN_EXPIRED)) {
                let params;
                if (!route.queryParams.redirectUrl) {
                    params = { redirectUrl: window.location.hash ? window.location.href : state.url };
                }
                else {
                    params = route.queryParams;
                }
                this.ngZone.run(() => {
                    this.router.navigate(['/'], {
                        queryParams: params,
                        fragment: route.fragment
                    });
                });
                this.toastr.error(this.translateService.instant('ERROR.SESSION_EXPIRATION'));
                localStorage.removeItem(PlatformConstants.TOKEN_EXPIRED);
            }
            return true;
        }), catchError(e => {
            return throwError(e);
        }));
    }
}
SessionGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SessionGuard, deps: [{ token: UserService }, { token: i2.Router }, { token: i5.TranslateService }, { token: i4.ToastrService }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Injectable });
SessionGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SessionGuard, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SessionGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: UserService }, { type: i2.Router }, { type: i5.TranslateService }, { type: i4.ToastrService }, { type: i0.NgZone }]; } });

/** @ignore */
var AccessLevel;
(function (AccessLevel) {
    AccessLevel["FULL_ACCESS"] = "Full access";
})(AccessLevel || (AccessLevel = {}));

/**
 * @ignore
 */
function init(service) {
    return () => service.init();
}
/**
 * @ignore
 */
class CommerceModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('CommerceModule is already loaded. Import it in the AppModule only');
        }
    }
    static forRoot(config, providers = []) {
        return {
            ngModule: CommerceModule,
            providers: [
                { provide: 'configuration', useValue: config },
                { provide: APP_INITIALIZER, useFactory: init, deps: [AppLoader], multi: true }
            ]
        };
    }
}
CommerceModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CommerceModule, deps: [{ token: CommerceModule, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.NgModule });
CommerceModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CommerceModule, imports: [CommonModule,
        ApttusModule,
        FormsModule,
        LaddaModule,
        RouterModule, i5.TranslateModule], exports: [ApttusModule, CommonModule, LaddaModule, RouterModule, FormsModule, TranslateModule] });
CommerceModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CommerceModule, providers: [], imports: [[
            CommonModule,
            ApttusModule,
            FormsModule,
            LaddaModule,
            RouterModule,
            TranslateModule.forChild()
        ], ApttusModule, CommonModule, LaddaModule, RouterModule, FormsModule, TranslateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CommerceModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ApttusModule,
                        FormsModule,
                        LaddaModule,
                        RouterModule,
                        TranslateModule.forChild()
                    ],
                    declarations: [],
                    providers: [],
                    exports: [ApttusModule, CommonModule, LaddaModule, RouterModule, FormsModule, TranslateModule]
                }]
        }], ctorParameters: function () { return [{ type: CommerceModule, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }]; } });

/**
 * @ignore
 */
class ActionQueue {
    constructor() {
        // The Array of Behavior Subjects mapped to an observable
        this.subjectQueue = [];
    }
    /**
     * @param action The observable action to add to the queue
     * @param callback A callback function. Existing callback functions will be overwritten and not be executed
     * @returns The observable once it has been executed by the queue.
     */
    queueAction(action, callback) {
        this.callback = callback;
        // Get the last item from the queue
        const lastSubject = this.subjectQueue[this.subjectQueue.length - 1];
        // Create a new subject and push it to the queue
        const subject = new BehaviorSubject(null);
        this.subjectQueue.push(subject);
        if (lastSubject)
            return lastSubject.pipe(skip(1), mergeMap(() => action, 1), tap(() => subject.next(() => { })), tap(() => this.subjectQueue.shift()), tap(data => this.onComplete(data)), catchError((e) => this.onError(e)));
        else
            return action.pipe(tap(() => subject.next(() => { })), tap(() => this.subjectQueue.shift()), tap(data => this.onComplete(data)), catchError((e) => this.onError(e)));
    }
    onError(e) {
        this.responseData = null;
        this.subjectQueue = [];
        return of(e);
    }
    onComplete(data) {
        this.responseData = compact(concat(this.responseData, data));
        if (this.subjectQueue.length === 0) {
            this.callback(this.responseData);
            this.responseData = undefined;
        }
    }
}
ActionQueue.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ActionQueue, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ActionQueue.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ActionQueue, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ActionQueue, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/** @ignore  */
const _moment$5 = moment;
/**
 * Price lists are the core object for defining the catalog seen by the end user. Categories, products and pricing are all derived from the selected price list.
 * <h3>Usage</h3>
 *
 ```typescript
 import { PriceListService, AObjectService} from '@congacommerce/ecommerce';
 
 export class MyComponent implements OnInit{
 constructor( private priceListService: PriceListService)
 }
 // or
 export class MyService extends AObjectService {
      private priceListService: PriceListService = this.injector.get(PriceListService);
  }
 ```
 */
class PriceListService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = PriceList;
        this.storefrontService = this.injector.get(StorefrontService);
        this.apiService = this.injector.get(ApiService);
        this.userService = this.injector.get(UserService);
        this.priceList = new BehaviorSubject(null);
    }
    onInit() {
        this.refreshPriceList();
    }
    /**
     * @ignore
     */
    refreshPriceList() {
        this.userService.getCurrentUser().pipe(take(1), switchMap(() => this.platformService.apiService.get('/pricelists/active', this.type)))
            .subscribe(res => {
            const priceListResponse = plainToClass(this.type, res, { excludeExtraneousValues: true });
            this.priceList.next(priceListResponse);
        });
    }
    /**
     * Method returns the current price list id. If the account is associated with based on price list, this will return the price list id that price list is based on.
     *### Example:
     ```typescript
     import { PriceListService, PriceList } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         priceListId: string;
         priceListId$: Observable<string>;
     
         constructor(private pricelistService: PriceListService){}
     
         getPriceListId(){
             this.pricelistService.getPriceListId().subscribe(a => this.priceListId = a);
             // or
             this.priceListId$ = this.pricelistService.getPriceListId();
         }
     }
     ```
     * @returns a hot string observable containing the current price list id.
     */
    getPriceListId() {
        return this.priceList.pipe(filter$1(r => r != null), map$1(r => get(r, 'BasedOnPriceListId', r.Id)));
    }
    /**
     * Method returns the current effective price list id.
     * ### Example:
     ```typescript
     import { PriceListService, PriceList } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         priceListId: string;
         priceListId$: Observable<string>;
     
         constructor(private pricelistService: PriceListService){}
     
         getEffectivePriceListId(){
             this.pricelistService.getEffectivePriceListId().subscribe(a => this.priceListId = a);
             // or
             this.priceListId$ = this.pricelistService.getEffectivePriceListId();
         }
     }
     ```
     * @returns a hot string observable containing the current effective price list id.
     */
    getEffectivePriceListId() {
        return this.priceList.pipe(filter$1(r => r != null), map$1(r => get(r, 'Id')));
    }
    /**
     * Method returns the entire price list instance of the currently selected price list.
     *
     * ### Example:
     ```typescript
     import { PriceListService, PriceList } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         priceList: PriceList;
         priceList$: Observable<PriceList>;
     
         constructor(private pricelistService: PriceListService){}
     
         getPriceLists(){
             this.pricelistService.getPriceList().subscribe(a => this.priceList = a);
             // or
             this.priceList$ = this.pricelistService.getPriceList();
         }
     }
     ```
     * @returns a hot observable containing the price list instance.
     */
    getPriceList() {
        return this.priceList.pipe(filter$1(r => r != null));
    }
    /**
     * Method returns the entire price list instance of the current effective price list.
     *
     * ### Example:
      ```typescript
      import { PriceListService, PriceList } from '@congacommerce/ecommerce';
      import { Observable } from 'rxjs/Observable';
      
      export class MyComponent implements OnInit{
          priceList: PriceList;
          priceList$: Observable<PriceList>;
      
          constructor(private pricelistService: PriceListService){}
      
          getEffectivePriceList(){
              this.pricelistService.getEffectivePriceList().subscribe(a => this.priceList = a);
              // or
              this.priceList$ = this.pricelistService.getEffectivePriceList();
          }
      }
      ```
     * @returns a hot observable containing the effective price list instance.
     */
    getEffectivePriceList() {
        return this.priceList.pipe(filter$1(r => r != null), map$1(r => get(r, 'BasedOnPriceList', r)));
    }
    /**
     * @ignore
     */
    isValidPriceList(pl) {
        if (pl) {
            const today = _moment$5(new Date()).valueOf();
            const isPlExpired = (!isNil(get(pl, 'ExpirationDate')) && get(pl, 'ExpirationDate') < today) || (!isNil(get(pl, 'EffectiveDate')) && get(pl, 'EffectiveDate') > today);
            return get(pl, 'Active') && !isPlExpired;
        }
        else
            return false;
    }
}
PriceListService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceListService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
PriceListService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceListService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceListService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * The service is responsible for turbo API call out.
 * <h3>Usage</h3>
 *
 ```typescript
 import { TurboApiService } from '@congacommerce/ecommerce';

 constructor(private turboService: TurboApiService) {}

 // or

 export class MyService extends AObjectService {
     private turboService: TurboApiService = this.injector.get(TurboApiService);
  }
 ```
 */
class TurboApiService extends ApiService {
    constructor(storefrontService, configurationService, _httpClient, sanitizer) {
        super(configurationService, _httpClient, sanitizer);
        this.storefrontService = storefrontService;
    }
    /**
     * The method takes the API path and returns the API path by adding the turbo endpoint.
     *
     * ### Example:
     ```typescript
     import { TurboApiService } from '@congacommerce/ecommerce';
     export class MyComponent implements OnInit{
        url:string
         constructor(private turboService: TurboApiService) {}
         
         getApiEndPoint(){
             this.url = this.turboService.getEndpoint();
            }
     }
     ```
     */
    getEndpoint(location) {
        if (!startsWith(location, '/'))
            location = '/' + location;
        return this.storefrontService.getTurboEnvironment()
            .pipe(map$1(url => url + location));
    }
    /** @ignore  */
    mapResult(result) {
        return result;
    }
}
TurboApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TurboApiService, deps: [{ token: StorefrontService }, { token: i1.ConfigurationService }, { token: i3.HttpClient }, { token: i4$1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Injectable });
TurboApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TurboApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TurboApiService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: StorefrontService }, { type: i1.ConfigurationService }, { type: i3.HttpClient }, { type: i4$1.DomSanitizer }]; } });

/**
 * Category allows in organizing products in a way that makes it easy for visitors to find out what they're looking for
 * <h3>Usage</h3>
 *
 ```typescript
 import { CategoryService, AObjectService} from '@congacommerce/ecommerce';
 
 export class MyComponent implements OnInit{
 constructor( private categoryService: CategoryService)
 }
 // or
 export class MyService extends AObjectService {
      private categoryService: CategoryService = this.injector.get(CategoryService);
  }
 ```
 */
class CategoryService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = Category;
        this.turboService = this.injector.get(TurboApiService);
        this.plService = this.injector.get(PriceListService, 'priceListService');
        this.translatorService = this.injector.get(TranslatorLoaderService, 'translatorService');
        this.productCategoryService = this.injector.get(ProductCategoryService, 'productCategoryService');
        this.state = new BehaviorSubject(null);
    }
    /** @ignore */
    onInit() {
        this.refresh();
    }
    /** @ignore */
    refresh() {
        this.plService.refreshPriceList();
        this.plService.getPriceListId()
            .pipe(switchMap(priceListId => this.turboService.get(`/pricing/dataadmin/turbo/search/pricelists/${priceListId}/categories?fetchTranslations=true&pageNumber=1&pageSize=1000`)), switchMap(data => {
            const categories = get(data, 'Categories');
            const categoryList = plainToClass(this.type, categories, { excludeExtraneousValues: true });
            return this.translatorService.translateData(categoryList);
        })).subscribe((categories) => this.state.next(categories));
    }
    /**
        * The  Primary method to get all the categories based on pricelist. This is a hot observable that will be updated when the state of the category changes.
        *
        * ### Example:
        ```typescript
       import { CategoryService } from '@congacommerce/ecommerce';

       export class MyComponent implements OnInit{
       categories: Array<Category>;
       categories$: Observable<Category>; // can be used in the template with {{(categories$ | async) as categories}}

       constructor(private categoryService: CategoryService){}

           ngOnInit(){
               this.categoryService.getCategories().subscribe(result => this.categories = category);
               // or
               this.cart$ = this.categoryService.getCategories();
           }
       }
       ```
       * @override
       * @returns A hot observable containing the Array of categories
       */
    getCategories() {
        return this.state.pipe(filter$1(r => !isNil(r)));
    }
    /**
     * The  method to get the Category By Name. This is a hot observable that will be updated when the state of the category changes.
     *
     * ### Example:
     ```typescript
    import { CategoryService } from '@congacommerce/ecommerce';

    export class MyComponent implements OnInit{
    category: Category;
    category$: Observable<Category>; // can be used in the template with {{(category$ | async)?.Label}}

    constructor(private categoryService: CategoryService){}

        ngOnInit(){
            this.categoryService.getCategoryByName('Electronics').subscribe(category => this.category = category);
            // or
            this.cart$ = this.categoryService.getCategoryByName();
        }
    }
    ```
    * @override
    * @returns A hot observable containing the single category instance
    * @param categoryName the name of the category to be passed as string.
    */
    getCategoryByName(categoryName) {
        return this.getCategories().pipe(map$1(categoryList => find(categoryList, (c) => c.Name === categoryName)));
    }
    /**
     * @ignore
     */
    getCategoriesByProductId(productId) {
        return this.platformService.apiService.get(`Apttus_Config2__ProductClassification__c?condition[0]=ProductId,Equal,${productId}&lookups=Classification`, this.productCategoryService.type);
    }
    /**
     * @ignore
     */
    getCategoryTree() {
        return this.getCategories().pipe(map$1(data => {
            const tree = TreeUtils.arrayToTree(data, {
                parentProperty: 'AncestorId',
                childrenProperty: 'Children',
                customID: 'Id'
            });
            return tree;
        }));
    }
    /**
     *
     * @ignore
     */
    getOptionCategories(productOptionGroups) {
        const rootCategoryIds = productOptionGroups.map(optionGroup => optionGroup.RootOptionGroupId);
        const obsv$ = this.where(null, 'AND', [
            new AFilter(this.type, [
                new ACondition(this.type, 'PrimordialId', 'In', rootCategoryIds),
                new ACondition(this.type, 'Id', 'In', rootCategoryIds)
            ], null, 'OR')
        ]);
        return obsv$.pipe(mergeMap(categories => this.translatorService.translateData(categories)));
    }
    /**
     * @ignore
     */
    getCategoryBranch(categoryId) {
        return this.getCategories().pipe(map$1(data => this.getCategoryBranchSync(categoryId, data)));
    }
    /**
     * @ignore
     */
    getCategoryBranchSync(categoryId, categoryList) {
        let categoryArray = new Array();
        let list = categoryList;
        let recursive = (_categoryId) => {
            for (let category of list) {
                if (category.Id === _categoryId) {
                    categoryArray.unshift(category);
                    if (category.AncestorId)
                        recursive(category.AncestorId);
                }
            }
        };
        recursive(categoryId);
        return categoryArray;
    }
    /**
     * This method fetches all the children categories recursively for the categoryIds.
     * ### Example:
      ```typescript
     import { CategoryService, Category } from '@congacommerce/ecommerce';
 
     export class MyComponent implements OnInit{
     category: Array<Category>;
     category$: Observable<Array<Category>>;
 
     constructor(private categoryService: CategoryService){}
 
         getCategoryBranchChildren(categoryIdList: Array<string>){
             this.categoryService.getCategoryBranchChildren(categoryIdList).subscribe(category => this.category = category);
             // or
             this.cart$ = this.categoryService.getCategoryBranchChildren(categoryIdList);
         }
     }
     ```
     * @returns an  observable containing the array of categories
     * @param category Ids is an isnatnce of string.
     */
    getCategoryBranchChildren(categoryIdList) {
        const isIdList = categoryIdList.every(SalesforceUtils.isValid);
        return this.getCategories().pipe(map$1(data => {
            let categoryArray = data.filter(d => includes(categoryIdList, (isIdList) ? d.Id : d.Name));
            let recursive = (_categoryId) => {
                const children = data.filter(category => category.AncestorId === _categoryId);
                categoryArray = categoryArray.concat(children);
                const nonLeafs = children.filter(child => child.IsLeaf !== 'Yes');
                if (get(nonLeafs, 'length', 0) > 0)
                    nonLeafs.forEach(child => recursive(child.Id));
            };
            categoryIdList.forEach(c => recursive(c));
            return categoryArray;
        }));
    }
    /**
     * @ignore
     */
    getCategoryBranchForProduct(product) {
        if (get(product, 'Categories.length', 0) > 0) {
            const validCategories = product.Categories.filter(r => r.Classification.PrimordialId != null || r.Classification.AncestorId != null);
            if (validCategories && validCategories.length > 0) {
                let category = validCategories[0];
                return this.getCategoryBranch(category.Classification.Id);
            }
            else
                return of(null);
        }
        else
            return of(null);
    }
    /**
     * @ignore
     */
    getCategoryBranchForProductSync(product) {
        if (get(product, 'Categories.length', 0) > 0) {
            const validCategories = product.Categories.filter(r => r.Classification.PrimordialId != null || r.Classification.AncestorId != null);
            if (validCategories && validCategories.length > 0) {
                let category = validCategories[0];
                return this.getCategoryBranchSync(category.ClassificationId, this.state.value);
            }
            else
                return null;
        }
        else
            return null;
    }
    /**
     * @ignore
     */
    getSubcategories(categoryId, limit = 1000) {
        if (categoryId) {
            return this.getCategories().pipe(map$1(data => data.filter((d) => SalesforceUtils.isEqual(d.AncestorId, categoryId)).slice(0, limit)));
        }
        else
            return of(null);
    }
    /**
     * @ignore
     */
    getRelatedCategories(categoryId, limit = 1000) {
        return this.getCategories().pipe(map$1(data => {
            const category = find(data, (d) => d.Id === categoryId);
            return data.filter(d => d.Id === categoryId || d.AncestorId === category.AncestorId).slice(0, limit);
        }));
    }
    /**
     * @ignore
     */
    getRootCategories() {
        return this.getCategories().pipe(map$1(data => data.filter(c => c.AncestorId == null)));
    }
}
CategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CategoryService, providedIn: 'root' });
__decorate([
    MemoizeAll(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Observable)
], CategoryService.prototype, "getCategoriesByProductId", null);
__decorate([
    Delay(1),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Array)
], CategoryService.prototype, "getCategoryBranchForProductSync", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CategoryService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], propDecorators: { getCategoriesByProductId: [], getCategoryBranchForProductSync: [] } });
/** @ignore */
class ProductCategoryService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = ProductCategory;
    }
}
ProductCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ProductCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductCategoryService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductCategoryService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/** @ignore  */
const _moment$4 = moment;
/**
 * A Cart contains the product and custom cart items that a user may wish to purchase.
 * <h3>Usage</h3>
 *
 ```typescript
 import { CartService, AObjectService} from '@congacommerce/ecommerce';
 
 export class MyComponent implements OnInit{
 constructor( private cartService: CartService)
 }
 // or
 export class MyService extends AObjectService {
      private cartService: CartService = this.injector.get(CartService);
  }
 ```
 */
class CartService extends AObjectService {
    constructor() {
        super(...arguments);
        this.onCartError = new EventEmitter();
        this.type = Cart;
        this.state = new BehaviorSubject(null);
        this.cartLookups = `AccountId,PriceListId,OrderId,Proposald,Account.PriceListId,Account.OwnerId,ShipToAccountId,BillToAccountId`;
        this.cartChildren = `SummaryGroups,Applied_Rule_Infos,AppliedRuleActionInfos`;
        this.lineItemLookups = `ProductId,OptionId,PriceListItemId,AttributeValueId,AssetLineItemId,ProductOptionId`;
        this.lineItemChildren = `AdjustmentLineItems,TaxBreakups`;
        this.apiService = this.injector.get(ApiService);
        this.userService = this.injector.get(UserService);
        this.configService = this.injector.get(ConfigurationService);
        this.storefrontService = this.injector.get(StorefrontService);
        this.categoryService = this.injector.get(CategoryService);
        this.ngZone = this.injector.get(NgZone);
        this.actionQueue = this.injector.get(ActionQueue);
    }
    onInit() {
        this.refreshCart();
        this.storefrontService.getDeferredPrice().pipe(take(1)).subscribe(response => CartService.DeferredPrice = response);
    }
    /**
     * The Static method fetched the Current Cart's Id stored in local storage.
     * ### Example:
     ```typescript
     import { CartService, Cart} from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         cartId: string;
     
         getCurrentCart(){
             this.cartId = CartService.getCurrentCartId();
         }
     }
     ```
     **/
    static getCurrentCartId() {
        if (localStorage.getItem(this.STORAGE_KEY))
            return localStorage.getItem(this.STORAGE_KEY);
        else
            return 'active';
    }
    /**
     * The Static used to clear cart id from local storage.
     * ### Example:
     ```typescript
     import { CartService, Cart} from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
     
         deleteCart(){
             CartService.deleteLocalCart();
         }
     }
     ```
     **/
    static deleteLocalCart() {
        localStorage.removeItem(this.STORAGE_KEY);
    }
    /**
     * The Static used to clear cart id from local storage.
     * ### Example:
     ```typescript
     import { CartService, Cart} from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
     
         setCurrentCart(Id:string){
             CartService.setCurrentCartId(cartId);
         }
     }
     ```
     **/
    static setCurrentCartId(cartId) {
        localStorage.setItem(this.STORAGE_KEY, cartId);
    }
    /**
     * @ignore
     */
    getQueryParams() {
        const params = [];
        this.configService.get('skipPricing') && params.push('price=skip');
        this.configService.get('skipRules') && params.push('rules=skip');
        params.push(`children=${this.lineItemChildren}`);
        params.push(`lookups=${this.lineItemLookups}`);
        return params.join('&');
    }
    /**
     * The isPricepending method checks the cart is pricepending flag and return the boolean value.
     * ### Example:
     ```typescript
     import { CartService, Cart} from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         isPricePending: Boolean;
     
         constructor(private cartService: CartService){}
     
         isPricePending(cart: Cart ){
             this.isPricePending = this.cartService.isPricePending(cart);
         }
     }
     ```
     * @param cart  instance of cart
     * @returns boolean value of cart is Pricepending flag.
     */
    isPricePending(cart) {
        return get(cart, 'IsPricePending', false);
    }
    loadHeader() {
        const cart$ = this.apiService.get(`/carts/${CartService.getCurrentCartId()}?lookups=${this.cartLookups}&children=${this.cartChildren}&alias=false`, this.type, false).pipe(take(1));
        cart$.subscribe((cart) => {
            if (get(this.state, 'value.LineItems'))
                set(cart, 'LineItems', get(this.state, 'value.LineItems'));
            if (CartService.DeferredPrice && this.state.value && this.state.value.get('IsPriced'))
                cart.set('IsPriced', this.state.value.get('IsPriced'));
            this.publish(cart);
        });
    }
    getCartLineItems(cartId) {
        if (!isNil(cartId)) {
            return this.apiService.post('/Apttus_Config2__LineItem__c/query', {
                'alias': false,
                'conditions': [
                    {
                        'field': 'ConfigurationId',
                        'filterOperator': 'Equal',
                        'value': cartId
                    }
                ],
                'lookups': [
                    {
                        'field': 'Product',
                        'children': [
                            {
                                'field': 'OptionGroups'
                            }
                        ]
                    },
                    {
                        'field': 'Option',
                        'children': [
                            {
                                'field': 'OptionGroups'
                            }
                        ]
                    },
                    {
                        'field': 'ProductOption'
                    },
                    {
                        'field': 'AttributeValue'
                    },
                    {
                        'field': 'AssetLineItem'
                    },
                    {
                        'field': 'PriceListItem'
                    }
                ],
                'children': [{
                        'field': 'AdjustmentLineItems'
                    }]
            }, this.metadataService.getTypeByApiName('Apttus_Config2__LineItem__c'), null, false);
        }
        else {
            return of(null);
        }
    }
    /**
     * @ignore
     */
    reprice() {
        (!CartService.DeferredPrice) ? this.priceCart() : this.refreshCart();
    }
    /**
     * Refreshes a cart based on the given id.
     * ### Example:
     ```typescript
     import { CartService } from '@congacommerce/ecommerce';
     export class MyComponent implements OnInit{
         constructor(private cartService: CartService){}
     
         refreshCart(){
             this.cartService.refreshCart().subscribe(
                 () => {...},
                 err => {...}
             );
         }
     }
     ```
     * @override
     */
    refreshCart() {
        let attempts = 0;
        return this.userService
            .isLoggedIn()
            .pipe(switchMap(loggedIn => {
            const cart$ = this.apiService.get(`/carts/${CartService.getCurrentCartId()}?lookups=${this.cartLookups}&children=${this.cartChildren}&alias=false`, this.type, false);
            const obsv$ = cart$
                .pipe(switchMap(cart => {
                if (!isNil(get(cart, 'Id')))
                    return this.getCartLineItems(cart.Id)
                        .pipe(map$1(lines => {
                        set(cart, 'LineItems', lines);
                        return cart;
                    }));
                else
                    return of(cart);
            }));
            return obsv$.pipe(map$1((cart) => {
                if (loggedIn && !isNil(get(cart, 'Id')))
                    CartService.setCurrentCartId(get(cart, 'Id'));
                else if (isNil(cart) && localStorage.getItem(CartService.STORAGE_KEY)) {
                    CartService.deleteLocalCart();
                    this.refreshCart();
                }
                if (get(cart, 'IsPricePending') === true && this.configService.get('pricingMode') !== 'turbo') {
                    if (attempts <= this.configService.get('cartRetryLimit', 3)) {
                        throw new Error('Cart Pending');
                    }
                }
                return cart;
            }), retryWhen(errors => errors.pipe(tap(e => {
                if (e.message === 'Cart Pending')
                    attempts += 1;
                else
                    throw e;
            }), delay(500))));
        }), take(1)).subscribe(c => this.publish(c));
    }
    /**
       * Publish method is used to emit the state of the cart .
       * Publish method is used to emit the state of the cart.
       * ### Example:
       ```typescript
       import { CartService, Cart } from '@congacommerce/ecommerce';
       export class MyComponent implements OnInit{
           constructor(private cartService: CartService){}
       
           publishCart(cart: Cart){
               this.cartService.publish(cart);
           }
       }
       ```
       * @override
       * @param cart instance of cart.
       */
    publish(cart) {
        this.ngZone.run(() => this.state.next(cloneDeep(cart)));
    }
    republish(pending = false) {
        this.state.value.IsPricePending = pending;
        if (pending)
            this.ngZone.run(() => this.state.next(this.state.value));
        else
            this.loadHeader();
    }
    /**
     * @ignore
     */
    getChildCart(cartId = CartService.getCurrentCartId()) {
        // API request to get child cart record
        const cartHeader$ = this.apiService.get(`/carts?condition[0]=ParentConfigurationId,Equal,${cartId}&alias=false`, this.type).pipe(map$1(cartList => first(cartList)));
        // API request to get all line items for child carts related to the given parent cart
        const cartItems$ = this.apiService.get(`/cartitems?condition[0]=Configuration.ParentConfigurationId,Equal,${cartId}&lookups=Product&alias=false`);
        // Combine the lines and the cart header
        return combineLatest([cartHeader$, cartItems$])
            .pipe(map$1(([cartHeader, cartItems]) => {
            const lineItems = plainToClass(this.metadataService.getTypeByApiName('Apttus_Config2__LineItem__c'), cartItems);
            set(cartHeader, 'LineItems', lineItems);
            return cartHeader;
        }));
    }
    remove(cartId) {
        const obsv$ = cartId instanceof Array
            ? this.apiService.post(`/carts/delete`, cartId.map(cId => ({ Id: cId })))
            : this.apiService.delete(`/carts/${cartId}`);
        return obsv$.pipe(map$1(deleteList => every(deleteList, l => get(l, 'success') === true)), tap(c => this.refreshCart()));
    }
    mergeCartItems(cartItemList) {
        if (!isNil(cartItemList) && !isEmpty(cartItemList)) {
            const keyFn = (r) => r.LineNumber + '.' + r.PrimaryLineNumber + '.' + r.ItemSequence;
            remove(this.state.value.LineItems, (l) => includes(map(cartItemList, 'LineNumber'), l.LineNumber) && l.LineType === 'Option' && !includes(cartItemList, (i) => keyFn(i) === keyFn(l)));
            this.state.value.LineItems = values(merge(keyBy(this.state.value.LineItems, keyFn), keyBy(cartItemList, keyFn)));
            this.republish(true);
            const configId = get(first(cartItemList), 'ConfigurationId');
            if (!isNil(configId))
                localStorage.setItem(CartService.STORAGE_KEY, configId);
        }
    }
    onAdd(cartItemList) {
        const lineNumbers = uniq(map(cartItemList, 'LineNumber'));
        this.mergeCartItems(cartItemList);
        if (this.configService.get('skipPricing') === true && !CartService.DeferredPrice)
            this.priceCart(this.configService.get('pricingMode'), lineNumbers);
        else
            this.republish(false);
    }
    /**
     *
     * @ignore
     */
    addItem(cartRequestList) {
        const addItemResp$ = this.getMyCart().pipe(take(1), switchMap(data => (isNil(get(data, 'Id'))) ? this.createNewCart() : of(data)), switchMap((cart) => this.apiService.post(`/carts/${get(cart, 'Id')}/items?${this.getQueryParams()}&alias=false`, cartRequestList)), map$1(result => {
            if (isEmpty(result.LineItems)) {
                throw 'Failed to add item(s)';
            }
            else {
                return plainToClass(this.metadataService.getTypeByApiName('Apttus_Config2__LineItem__c'), result.LineItems);
            }
        }), catchError((e) => {
            throw new Array();
        }));
        return this.actionQueue.queueAction(addItemResp$, bind(this.onAdd, this)).pipe(tap(cartItemList => {
            this.mergeCartItems(cartItemList);
        }));
    }
    /**
    *
    * @ignore
    */
    updateItem(cartItemId, cartRequestList, isEmbedded = false) {
        // Get child cart record if the bundle is loaded in embedded mode.
        const childCart$ = isEmbedded ? this.getChildCart() : of(null);
        const updateItem$ = childCart$.pipe(switchMap((childCart) => {
            if (isEmbedded && childCart) {
                return this.cloneCart(childCart.Id, CartService.getCurrentCartId());
            }
            else {
                return this.apiService.put(`/carts/${CartService.getCurrentCartId()}/items/${cartItemId}?${this.getQueryParams()}&alias=false`, cartRequestList);
            }
        }));
        return updateItem$.pipe(map$1(result => {
            if (isEmpty(result.LineItems)) {
                throw 'Failed to update item(s)';
            }
            else if (isEmbedded) {
                return result.LineItems;
            }
            else
                return plainToClass(this.metadataService.getTypeByApiName('Apttus_Config2__LineItem__c'), result.LineItems);
        }), tap(response => this.onAdd(response)));
    }
    /**
   * @param cartId Cart identifier of the cart to be cloned. If the param is not specified, it creates a clone of active cart in the application.
   * @param targetId Optional param to specify the target cart to be cloned to.
   * @param cloneBusinessObject boolean specifies if the business object on cart must be cloned. Defaulted to false.
   * @returns Observable of the cloned cart when operation completes.
   */
    cloneCart(cartId = CartService.getCurrentCartId(), targetId = null, cloneBusinessObject = false) {
        const params = [];
        targetId && params.push(`&target=${targetId}`);
        cloneBusinessObject && params.push(`&businessObject=${cloneBusinessObject}`);
        return this.apiService.post(`/carts/${cartId}/clone?children=LineItems${params.join('')}&alias=false`, null, this.type, null, false)
            .pipe(tap((res) => {
            if (CartService.getCurrentCartId() === 'active') {
                CartService.setCurrentCartId(res.ParentConfigurationId);
            }
        }));
    }
    updateItems(cartItems) {
        this.republish(true);
        return this.cacheService.buffer('cart-item-update', cartItems, data => {
            const lineItems = map(uniqBy(flatten(data), 'Id'), cartItem => {
                set(cartItem, 'Apttus_Config2__PricingStatus__c', 'Pending');
                return cartItem;
            });
            const updateItemsResp$ = this.apiService
                .put(`/carts/${CartService.getCurrentCartId()}/items?${this.getQueryParams()}&alias=false`, lineItems)
                .pipe(map$1(response => plainToClass(this.metadataService.getTypeByApiName('Apttus_Config2__LineItem__c'), response.LineItems)));
            return this.actionQueue.queueAction(updateItemsResp$, bind(this.onAdd, this));
        }, allItems => {
            filter(allItems, a => includes(map(cartItems, 'Id'), a.Id));
        }, 1000);
    }
    /**
       * The primary method to get the user's current cart. This is a hot observable that will be updated when the state of the cart changes.
       *
       * ### Example:
  ```typescript
  import { CartService } from '@congacommerce/ecommerce';
  
  export class MyComponent implements OnInit{
      cart: Cart;
      cart$: Observable<Cart>; // can be used in the template with {{(cart$ | async)?.Name}}
  
      constructor(private cartService: CartService){}
  
      ngOnInit(){
          this.cartService.getMyCart().subscribe(cart => this.cart = cart);
          // or
          this.cart$ = this.cartService.getMyCart();
      }
  }
  ```
       * @override
       * @returns A hot observable containing the single cart instance
       * @param pending true / false will trigger a reprice operation if there are any pending line items
       */
    getMyCart(pending = false) {
        return this.state.pipe(filter$1(c => !isNil(c)));
    }
    /**
       * Creates a new cart. Will set the account id, price list id, effective price list id on the cart and set the status to 'New'
       *
       * ### Example:
  ```typescript
  import { CartService } from '@congacommerce/ecommerce';
  
  export class MyComponent{
  
      constructor(private cartService: CartService){}
  
      createNewCart(){
          const cart = new Cart();
          cart.Apttus_Config2__Status__c = 'Finalized';
          this.cartService.createNewCart(cart).subscribe(c => {...});
      }
  }
  ```
       *
       * @override
       * @param cartData an instance of a cart with any prepopulated parameters
       * @returns a cold cart observable with the populated cart after inserting into the database
       */
    createNewCart(cartData = new Cart(), insert = true, active = true) {
        return this.apiService.post(`/carts?lookups=${this.cartLookups}&alias=false`, cartData.strip(), this.type, null, false).pipe(map$1(cList => first(cList)), tap(c => CartService.setCurrentCartId(get(c, 'Id'))), tap(c => this.publish(c)), take(1));
    }
    /**
       * Deletes a specified cart instance from the database
       *
       * ### Example:
  ```typescript
  import { CartService } from '@congacommerce/ecommerce';
  
  export class MyComponent{
      private cart: Cart;
      constructor(private cartService: CartService){}
  
      deleteCart(){
          this.cartService.deleteCart(cart).subscribe(c => {...});
      }
  }
  ```
       * @override
       * @param cart the cart instance to delete
       * @returns a cold boolean observable representing the success state of the delete operation
       */
    deleteCart(cart) {
        const cartId = (cart instanceof Array) ? map(cart, 'Id') : get(cart, 'Id');
        const obsv$ = cartId instanceof Array
            ? this.apiService.post(`/carts/delete`, cartId.map(cId => ({ Id: cId })))
            : this.apiService.delete(`/carts/${cartId}`);
        return obsv$.pipe(map$1(deleteList => every(deleteList, l => get(l, 'success') === true)), tap(c => this.refreshCart()));
    }
    /**
       * setActiveCart: Method sets the selected cart as active and deactivates any other carts
       *
       * ### Example:
  ```typescript
  import { CartService, Cart } from '@congacommerce/ecommerce';
  
  export class MyComponent implements OnInit{
  
      constructor(private cartService: CartService){}
  
      setActive(cart: Cart){
          this.cartService.setCartActive(cart).subscribe(success => {...});
      }
  }
  ```
       * @override
       * @param cart Instance of the cart to be set active
       * @param priceCart Determines whether to run pricing engine for the cart or skip pricing
       * @return Observable<boolean> returns a boolean observable containing true if the cart was successfully set active.
       */
    setCartActive(cart, priceCart = false) {
        cart.EffectiveDate = _moment$4(new Date()).format();
        const lineItemRes$ = priceCart ? this.getCartLineItems(get(cart, 'Id')) : of(null);
        return combineLatest([
            this.apiService.put(`/carts?alias=false&lookups=PriceListId`, cart.strip(), this.type, false),
            lineItemRes$
        ]).pipe(map$1(([cartList, lineItemRes]) => {
            const cart = first(cartList);
            CartService.setCurrentCartId(get(cart, 'Id'));
            if (priceCart) {
                cart.LineItems = lineItemRes;
                this.state.next(cart);
                this.priceCart();
            }
            else
                this.refreshCart();
            return cart;
        }), tap(() => this.categoryService.refresh()));
    }
    /**
       * Adding a Product to Cart is the most common Cart action. Will trigger a reprice operation asynchronously.
       *
       * ### Example:
  ```typescript
  import { CartService, Product, ProductAttributeValue } from '@congacommerce/ecommerce';
  
  export class MyComponent implements OnInit{
  
      constructor(private cartService: CartService){}
  
      addProductToCart(product: Product, quantity: number, productAttributeValueList: Array<ProductAttributeValue>): void{
          this.cartService.addProductToCart(product, quantity, productAttributeValueList, null, true, true).subscribe(
              () => {...},
              err => {...}
          )
      }
  }
  ```
       * @override
       * @param product Product object for method
       * @param quantity number value for quantity
       * @param merge true/false on whether to merge this product with the same product already in the cart
       * @param attributeValues an array of product attribute values associated with the product
       * @param productOptions an array of product option form instances associated with the prodcut
       * @param trigger when set to false, will not notify other components that a product has been added to the cart
       * @param cartItems an array of cart items.
       * @param bundle flag indicates if the product is a bundle with option groups and product option components.
       * @return a void observable when the operation is complete
       */
    addProductToCart(product, quantity = 1, cartItems, bundle = false) {
        const cartItem = find(cartItems, { IsPrimaryLine: true });
        const request = map(cartItems, (item) => ({
            LineItem: item.toApiJsonFromExpose(),
            ProductAttributes: get(item, 'HasAttributes') ? get(item, 'AttributeValue') : null
        }));
        const isEmbedded = (product.HasAttributes || product.HasOptions) && bundle;
        if (get(cartItem, 'Id'))
            return this.updateItem(get(cartItem, 'Id'), request, isEmbedded);
        else if (!isEmpty(request))
            return this.addItem(request);
        else
            return this.addItem([{ ProductId: product.Id, Quantity: quantity, ProductName: product.Name }]);
    }
    /**
     * Adds an option product to a bundle product that is already in the current active cart.
     * ### Example:
  ```typescript
  import { CartService, CartItem, Product } from '@congacommerce/ecommerce';
  
  export class MyComponent {
  
        constructor(private cartService: CartService) {}
  
        addOption(cartItem: CartItem, option: Product, quantity: number) {
          this.cartService.addOptionToBundle(cartItem.Id, {
            ProductId: option.Id,
            Quantity: quantity;
          }).subscribe(
            cartItems => {...},
            err => {...}
          );
        }
  }
  ```
     * @param bundleId Id of the CartLineItem object for the bundle product which is getting the option added to it.
     * @param payload CartRequest object that has the productId of the option product and the quantity to add to the bundle.
     * @returns observable of cart items.
     */
    addOptionToBundle(bundleId, payload) {
        const resp$ = this.apiService
            .post(`carts/${CartService.getCurrentCartId()}/items/${bundleId}/options?${this.getQueryParams()}&alias=false`, payload);
        return this.actionQueue.queueAction(resp$, bind(() => {
            this.refreshCart();
        }));
    }
    /**
       * Update fields on the items specified in the cart item array. Will trigger a reprice cart operation.
       *
       * ### Example:
  ```typescript
  import { CartService, CartItem } from '@congacommerce/ecommerce';
  
  export class MyComponent implements OnInit{
  
      constructor(private cartService: CartService){}
  
      updateCartItems(cartItem: CartItem, quantity: number): void{
          cartItem.Quantity = quantity;
          this.cartService.updateCartItems([cartItem]).subscribe(
              () => {...},
              err => {...}
          );
      }
  }
  ```
       * @override
       * @param cartItemList an array of cart items. Matches based on the id and updates the related cart items with the new fields.
       * @returns observable of updated cart items.
       */
    updateCartItems(cartItemList) {
        return this.getMyCart()
            .pipe(take(1), switchMap(cart => {
            const itemsAndOptions = 
            // Flatten the 2d array into a 1d array
            flatten(
            // map will return a 2d array of cart items and their options with the updated end dates
            map(cartItemList, cartItem => {
                set(cartItem, 'PricingStatus', 'Pending');
                // Get the list of options for the cart item
                const options = map(filter(cart.LineItems, lineItem => lineItem.LineType === 'Option' && lineItem.ParentBundleNumber === cartItem.PrimaryLineNumber), item => item.toApiJsonFromExpose());
                // Set the end of the options to match the cart item
                forEach(options, o => {
                    set(o, 'Apttus_Config2__EndDate__c', get(cartItem, 'EndDate'));
                });
                return concat(options, cartItem.toApiJsonFromExpose());
            }));
            return this.updateItems(itemsAndOptions);
        }));
    }
    /**
       * Removes the specified cart item from the cart. Will trigger a reprice cart operation.
       *
       * ### Example:
  ```typescript
  import { CartService, CartItem } from '@congacommerce/ecommerce';
  
  export class MyComponent implements OnInit{
  
      constructor(private cartService: CartService){}
  
      removeCartItem(cartItem: CartItem): void{
          cartItem.Apttus_Config2__Quantity__c = quantity;
          this.cartService.removeCartItem(cartItem).subscribe(
              () => {...},
              err => {...}
          );
      }
  }
  ```
       * @override
       * @param cartItem the instance of the cart item to remove
       * @param trigger when set to false, will not notify other components that a product has been added to the cart
       * @returns a void observable when the operation completes
       */
    removeCartItem(cartItem, async = true, trigger = true) {
        let cartItems = new Array();
        cartItems.push({ 'Id': cartItem.Id });
        return this.removeCartItems(cartItems).pipe(map$1(() => { }));
    }
    /**
     * Deletes multiple cart items from the cart.
     * @param cartItems Array of cart items to be deleted from the cart.
     * @returns a void observable when the operation completes
     */
    removeCartItems(cartItems) {
        const cartItemIds = map(cartItems, 'Id');
        const removeCartItems$ = this.apiService.post(`/carts/${CartService.getCurrentCartId()}/items/delete?${this.getQueryParams()}`, map(cartItemIds, (c) => ({ Id: c }))).pipe(tap(c => {
            const lines = get(this.state, 'value.LineItems');
            const lineNumbers = map(filter(lines, (l) => includes(cartItemIds, l.Id)), 'LineNumber');
            const PrimaryLineItem = filter(lines, (i) => includes(cartItemIds, i.Id) && i.LineType === 'Product/Service');
            if (PrimaryLineItem.length > 0) {
                remove(get(this.state, 'value.LineItems', []), o => includes(lineNumbers, o.LineNumber));
            }
            else {
                remove(get(this.state, 'value.LineItems', []), o => includes(cartItemIds, o.Id));
            }
        }));
        return this.actionQueue.queueAction(removeCartItems$, bind(() => {
            (this.configService.get('skipPricing') && !CartService.DeferredPrice) ? this.priceCart() : this.republish();
            if (CartService.DeferredPrice)
                this.state.value.set('IsPriced', true);
        }));
    }
    /**
       * priceCart method triggers the server-side pricing engine for the cart
       *
       * ### Example:
  ```typescript
  import { CartService } from '@congacommerce/ecommerce';
  
  export class MyComponent implements OnInit{
  
      constructor(private cartService: CartService){}
  
      priceCart(pricingMode): void{
          this.cartApi.priceCart(pricingMode).subscribe(
              () => {...},
              err => {...}
          );
      }
  }
  ```
     * Price active cart and publishing its state to all subscribing components.
     * @param pricingMode Pass the pricing mode you want to run pricing with. It can be turbo OR default pricing.
     * @param lineNumbers lineitem line number which needs to be priced.
     */
    priceCart(pricingMode = this.configService.get('pricingMode'), lineNumbers) {
        let lineParam = '';
        if (!isNil(lineNumbers) && isNil(this.state.value.CouponCodes)) {
            lineParam = '&lineNumbers=' + join(compact(lineNumbers), ',');
        }
        this.apiService
            .post(`/carts/${CartService.getCurrentCartId()}/price?mode=${pricingMode}&alias=false${lineParam}`, null, this.type, null, false)
            .pipe(take(1))
            .subscribe(priceResponse => {
            if (pricingMode === 'turbo' && typeof priceResponse !== 'boolean') {
                const cart = this.state.value;
                forEach(get(priceResponse, 'LineItems'), (cli) => {
                    if (isNil(cli.Id)) {
                        const sfCLI = find(cart.LineItems, (li) => (li.ExtendedDescription === cli.ExtendedDescription && li.ExtendedDescription !== null));
                        if (sfCLI)
                            cli.Id = sfCLI.Id;
                    }
                    set(cli, 'Product', defaultTo(get(find(cart.LineItems, r => r.Id === cli.Id), 'Product'), get(cli, 'Product')));
                    set(cli, 'AttributeValue', defaultTo(get(find(cart.LineItems, r => r.Id === cli.Id), 'AttributeValue'), get(cli, 'AttributeValue')));
                    set(cli, 'ProductOption', defaultTo(get(find(cart.LineItems, r => r.Id === cli.Id), 'ProductOption'), get(cli, 'ProductOption')));
                    set(cli, 'AssetLineItem', defaultTo(get(find(cart.LineItems, r => r.Id === cli.Id), 'AssetLineItem'), get(cli, 'AssetLineItem')));
                });
                const tbCartItemIds = map(get(priceResponse, 'LineItems'), item => item.Id);
                forEach(get(cart, 'LineItems'), (cli) => {
                    if (includes(tbCartItemIds, cli.Id)) {
                        set(cli, 'AdjustmentLineItems', null);
                        set(cli, 'IncentiveAdjustmentAmount', null);
                        set(cli, 'IncentiveCode', null);
                    }
                });
                // New charge line items added due to pricing on the cart.
                const newLines = filter(get(priceResponse, 'LineItems'), lineItem => isNil(lineItem.Id));
                const tpResponse = filter(get(priceResponse, 'LineItems'), item => !isNil(item.Id));
                const mergedItems = isEmpty(lineParam) ? tpResponse : compact(values(merge(keyBy(cart.LineItems, 'Id'), keyBy(tpResponse, 'Id'))));
                cart.LineItems = plainToClass(this.metadataService.getTypeByApiName('Apttus_Config2__LineItem__c'), concat(mergedItems, newLines), { ignoreDecorators: true });
                set(cart, 'SummaryGroups', get(priceResponse, 'SummaryGroups'));
                if (!cart.Id)
                    cart.Id = CartService.getCurrentCartId();
                cart.IsPricePending = false;
                if (CartService.DeferredPrice)
                    cart.set('IsPriced', false);
                this.publish(cart);
            }
            else {
                this.refreshCart();
            }
        });
    }
    /**
      * Retrieves the Cart by passing the Cart Id.
      * @param cartId cartId Cart identifier of the cart to be retrieved.
      * @returns Observable of the cart when operation completes.
      */
    getCartWithId(cartId) {
        return this.get([cartId]).pipe(map$1(first));
    }
    /**
      * Abandons the Cart by passing the Cart Id.
      * @param cartId cartId Cart identifier of the cart to be abandoned.
      * @return returns a boolean observable containing true if the cart was successfully abandoned.
      */
    abandonCart(cartId) {
        return this.platformService.apiService.post(`/carts/${cartId}/abandon`);
    }
    /**
   * To render the iFrame, a business object Id must be determined by the client.
   * The Business Object Id can be retrieved from a child cart associated with the primary cart.
   * To retrieve this child cart, this method will be invoked.
   * @param lineNo lineitem line number which needs to be edited.
   * @returns returns Observable of the child cart when operation completes.
   */
    childCart() {
        return this.getMyCart()
            .pipe(take(1), switchMap(data => (isNil(get(data, 'Id'))) ? this.createNewCart() : of(data)), mergeMap((cart) => this.apiService.get(`/carts/${cart.Id}/children`)));
    }
    /**
     * This method gives right state of the cart pricing to client.
     * Returns boolean response,
     * TRUE: Cart is price pending and recent attempt to price the cart has failed.
     * FALSE: Cart is succesfully priced and recent attempt to price the cart is succesfull.
     */
    getCartPriceStatus() {
        return this.getMyCart()
            .pipe(map$1(c => {
            return c.hasErrors && filter(c.errors, er => er.message === 'Pricing Failed').length > 0
                && (c.IsPricePending || c.LineItems.filter(i => i.PricingStatus !== 'Complete').length > 0);
        }));
    }
    /**
     * This method clones a list of primary cart lines.
     * The cloned items get added to the active cart.
     * @param lineItems Array of cart items to be cloned on the active cart.
     * @returns observable of cloned cart items.
     */
    clonePrimaryLines(lineItems) {
        const lineNumbers = map(lineItems, item => item.LineNumber);
        return this.getMyCart().pipe(take(1), switchMap(cart => this.apiService.post(`/carts/${get(cart, 'Id')}/items/clone`, lineNumbers)), map$1(res => {
            const resp = plainToClass(this.metadataService.getTypeByApiName('Apttus_Config2__LineItem__c'), get(res, 'LineItems'), { ignoreDecorators: true });
            return resp;
        }), tap(lineItems => this.onAdd(lineItems)));
    }
}
CartService.STORAGE_KEY = 'local-cart';
CartService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CartService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CartService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CartService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CartService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * ProductAttributeGroupService contains method to get the list of product attribute groups for the list of products/product Ids passed.
 * <h3>Usage</h3>
 *
 ```typescript
 import { ProductAttributeGroupService, AObjectService} from '@congacommerce/ecommerce';
 
 export class MyComponent implements OnInit{
 constructor( private productAttributeGroupService: ProductAttributeGroupService)
 }
 // or
 export class MyService extends AObjectService {
      private productAttributeGroupService: ProductAttributeGroupService = this.injector.get(ProductAttributeGroupService);
  }
 ```
 */
class ProductAttributeGroupService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = ProductAttributeGroup;
        this.productAttributeService = this.injector.get(ProductAttributeService);
        this.translatorService = this.injector.get(TranslatorLoaderService);
        this.productAttributeGrpMemberService = this.injector.get(ProductAttributeGroupMemberService);
    }
    /**
     * Method returns an observable containing array of product attribute groups for the list of products/product Ids passed.
     * ### Example:
```typescript
import { ProductAttributeGroupService, Product, ProductAttributeGroup } from '@congacommerce/ecommerce';
import { Observable } from 'rxjs/Observable';

export class MyComponent implements OnInit{
    attributeGroupList: Array<ProductAttributeGroup>;
    attributeGroupList$: Observable<Array<ProductAttributeGroup>>;

    constructor(private productAttributeGroupService: ProductAttributeGroupService){}

    getProductAttributeGroups(productList: Array<string | Product>){
        this.productAttributeGroupService.getProductAttributeGroups(productList).subscribe(attributeGroups => this.attributeGroupList = attributeGroups);
        // or
        this.attributeGroupList$ = this.productAttributeGroupService.getProductAttributeGroups(productList);
    }
}
```
     * @param productList An array of products or a string of product Ids for which the product attribute group information needs to be acquired.
     * @returns An observable containing array of product attribute groups.
     */
    getProductAttributeGroups(productList = []) {
        let obsv$ = of([]);
        if (productList.every(item => typeof item === 'string')) {
            obsv$ = this.where(null, 'AND', null, null, null, [
                new AJoin(this.productAttributeGrpMemberService.type, 'Id', 'AttributeGroupId', [
                    new ACondition(this.productAttributeGrpMemberService.type, 'ProductId', 'In', productList)
                ])
            ]);
        }
        else {
            obsv$ = this.get(uniq(flatten(productList.map((p) => get(p, 'AttributeGroups', []).map(g => g.AttributeGroup.Id)))));
        }
        return obsv$.pipe(switchMap(productAttributeGroupList => this.translatorService.translateData(productAttributeGroupList)), switchMap(translatedProductAttributeGroupList => {
            const productAttributes = compact(flatten(translatedProductAttributeGroupList.map(group => group.ProductAttributes)));
            return this.productAttributeService.setDescribeInformationOnProductAttributes(productAttributes).pipe(map$1(attrs => translatedProductAttributeGroupList));
        }));
    }
}
ProductAttributeGroupService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductAttributeGroupService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ProductAttributeGroupService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductAttributeGroupService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductAttributeGroupService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });
/** @ignore */
class ProductAttributeGroupMemberService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = ProductAttributeGroupMember;
    }
}
ProductAttributeGroupMemberService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductAttributeGroupMemberService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ProductAttributeGroupMemberService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductAttributeGroupMemberService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductAttributeGroupMemberService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * Product attributes represent a characteristic of a product that can have different values like color, vendor etc.
 * <h3>Usage</h3>
 *
 ```typescript
 import { ProductAttributeService, AObjectService} from '@congacommerce/ecommerce';
 
 export class MyComponent implements OnInit{
 constructor( private productAttributeService: ProductAttributeService)
 }
 // or
 export class MyService extends AObjectService {
      private productAttributeService: ProductAttributeService = this.injector.get(ProductAttributeService);
  }
 ```
 */
class ProductAttributeService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = ProductAttribute;
        this.productAttributeGrpMemberService = this.injector.get(ProductAttributeGroupMemberService);
    }
    /**
     * Method gets a list of product attributes for a given product. Can further filter the list by a group.
     * ### Example:
```typescript
import { ProductAttributeService, ProductAttribute, Product } from '@congacommerce/ecommerce';
import { Observable } from 'rxjs/Observable';

export class MyComponent implements OnInit{
    productAttributeList: Array<ProductAttribute>;
    productAttributeList$: Observable<Array<ProductAttribute>>;

    constructor(private productAttributeService: ProductAttributeService){}

    getProductAttributes(product: Product){
        this.productAttributeService.getProductAttributes(product).subscribe(attributeList => this.productAttributeList = attributeList);
        // or
        this.productAttributeList$ = this.productAttributeService.getProductAttributes(product);
    }
}
```
     * @param product the instance of the product for which to get the attributes for
     * @param attributeGroupName an optional argument of a specific group name with which to get attributes for.
     * @returns A hot observable containing list of product attributes for the given product.
     */
    getProductAttributes(product, attributeGroupName) {
        const conditions = [];
        if (isNil(product))
            return of([]);
        else {
            conditions.push(new ACondition(this.productAttributeGrpMemberService.type, 'ProductId', 'Equal', product.Id));
            if (attributeGroupName != null)
                conditions.push(new ACondition(this.productAttributeGrpMemberService.type, 'AttributeGroup.Name', 'Equal', attributeGroupName));
            return this.where(null, 'AND', null, [new ASort(this.type, 'Sequence', 'ASC')], null, [new AJoin(this.productAttributeGrpMemberService.type, 'AttributeGroupId', 'AttributeGroupId', conditions)]);
        }
    }
    /**
     * Method returns ProductAttributeValue with default attribute values for a given list of ProductAttributes.
     * ### Example:
```typescript
import { ProductAttributeService, ProductAttributeValue } from '@congacommerce/ecommerce';
import { Observable, of } from 'rxjs/Observable';

export class MyComponent implements OnInit{
    pav: ProductAttributeValue;
    pav$: Observable<ProductAttributeValue>;

    constructor(private productAttributeService: ProductAttributeService){}

    getAttributeValueDefaults(product: Product){
        this.productAttributeService.getAttributeValueDefaults(attributeList).subscribe(result => this.pav$ = result);
        // or
        this.pav$$ = of(this.productAttributeService.getAttributeValueDefaults(attributeList));
    }
}
```
     * @param productAttributeList accepts an array of ProductAttributes.
     * @returns object of instance of an ProductAttributeValue.
     */
    getAttributeValueDefaults(productAttributeList) {
        const attributeValue = new ProductAttributeValue();
        productAttributeList.forEach(attribute => attributeValue[attribute.Field] = SalesforceUtils.getDefaultValue(get(attribute, '_describe')));
        return attributeValue;
    }
    /**
    * Method returns an array of product attributes.
    * Adds an additional property to all attributes returned called '_.describe'. This property contains metadata information about the attribute.
    * ### Example:
```typescript
import { ProductAttributeService, ProductAttribute, Product } from '@congacommerce/ecommerce';
import { Observable } from 'rxjs/Observable';

export class MyComponent implements OnInit{
    productAttributeList: Array<ProductAttribute>;
    productAttributeList$: Observable<Array<ProductAttribute>>;

    constructor(private productAttributeService: ProductAttributeService){}

    setDescribeInformationOnProductAttributes(attributes: Array<ProductAttribute>){
        this.productAttributeService.setDescribeInformationOnProductAttributes(attributes).subscribe(attributeList => this.productAttributeList = attributeList);
        // or
        this.productAttributeList$ = this.productAttributeService.setDescribeInformationOnProductAttributes(attributes);
    }
}
```
    * @param attributes An array of products attributes for which '_describe' property with metadata information needs to be added.
    * @returns An array of product attributes with metadata information for each attribute.
    */
    setDescribeInformationOnProductAttributes(attributes) {
        return of(null);
    }
    /**
    * Method returns an array of product attributes.
    * ### Example:
```typescript
import { ProductAttributeService, ProductAttribute, Product } from '@congacommerce/ecommerce';
import { Observable } from 'rxjs/Observable';

export class MyComponent implements OnInit{
    productAttributeList: Array<ProductAttribute>;
    productAttributeList$: Observable<Array<ProductAttribute>>;

    constructor(private productAttributeService: ProductAttributeService){}

    getAttributeGroupIdsForFields(attributes: Array<ProductAttribute>){
        this.productAttributeService.getAttributeGroupIdsForFields(attributes).subscribe(attributeList => this.productAttributeList = attributeList);
        // or
        this.productAttributeList$ = this.productAttributeService.getAttributeGroupIdsForFields(attributes);
    }
}
```
    * @param attributes An array of products attributes.
    * @returns An array of product attribute in an observable.
    */
    getAttributeGroupIdsForFields(attributes) {
        const fields = attributes.map(r => r.Field);
        const filterList = [];
        filterList.push(new AFilter(this.type, [new ACondition(this.type, 'Field', 'In', fields)]));
        return this.where(null, 'AND', filterList);
    }
}
ProductAttributeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductAttributeService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ProductAttributeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductAttributeService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductAttributeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });
/**
 * @ignore
 * Placeholder service for the product attribute values
 */
class ProductAttributeValueService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = ProductAttributeValue;
    }
    getInstanceWithDefaults(product, objectMetadata) {
        const instance = this.getInstance();
        const attributeList = flatten(map(get(product, 'AttributeGroups', []), member => get(member, 'AttributeGroup.Attributes')));
        if (!isNil(objectMetadata)) {
            forEach(attributeList, attribute => {
                if (!isNil(attribute))
                    set(instance, attribute.Field, SalesforceUtils.getDefaultValue(find(objectMetadata.fields, (field) => field.name === attribute.Field)));
            });
        }
        return instance;
    }
}
ProductAttributeValueService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductAttributeValueService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ProductAttributeValueService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductAttributeValueService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductAttributeValueService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/** Enum contains all charge type  */
var ChargeType;
(function (ChargeType) {
    ChargeType["StandardPrice"] = "Standard Price";
    ChargeType["License"] = "License Fee";
    ChargeType["Subscription"] = "Subscription Fee";
    ChargeType["Implementation"] = "Implementation Fee";
    ChargeType["Installation"] = "Installation Fee";
    ChargeType["Maintenance"] = "Maintenance Fee";
    ChargeType["Adjustment"] = "Adjustment";
    ChargeType["SalesTax"] = "Sales Tax";
    ChargeType["ShippingHandling"] = "Shipping & Handling";
})(ChargeType || (ChargeType = {}));

/**
 * The price list items map a product to a specific price list. They provide the base price for any product in your catalog
 * <h3>Usage</h3>
 *
 ```typescript
 import { PriceListItemService, AObjectService} from '@congacommerce/ecommerce';
 
 export class MyComponent implements OnInit{
 constructor( private priceListItemService: PriceListItemService)
 }
 // or
 export class MyService extends AObjectService {
      private priceListItemService: PriceListItemService = this.injector.get(PriceListItemService);
  }
 ```
 */
class PriceListItemService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = PriceListItem;
    }
    /**
     * Method gets price list for a given product.
     * ### Example:
     ```typescript
     import { PriceListItemService, PriceListItem, Product} from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         priceListItem: PriceListItem;
     
         constructor(private priceListItemService: PriceListItemService){}
     
         getPriceListItem(product: Product){
             this.priceListItem = this.priceListItemService.getPriceListItemForProduct(product);
         }
     }
     ```
     * @param product the instance of the product to return the price list item for.
     * @param chargeType an optional parameter representing the charge type to return the price list item for.
     * @returns price list item object.
     */
    static getPriceListItemForProduct(product, chargeType) {
        let pli;
        if (!isNil(chargeType))
            pli = find(get(product, 'PriceLists', []), (item) => item.ChargeType === chargeType);
        if (isNil(pli))
            pli = defaultTo(find(get(product, 'PriceLists', []), (item) => item.ChargeType === ChargeType.StandardPrice || item.ChargeType === ChargeType.Subscription), get(product, 'PriceLists[0]'));
        return pli;
    }
    /**
     * Method gets a single price list item record for a given product code.
     * ### Example:
     ```typescript
     import { PriceListItemService, PriceListItem, Product} from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         priceListItem: PriceListItem;
     
         constructor(private priceListItemService: PriceListItemService){}
     
         getPriceListItem(productCodeList: Array<string>){
             this.priceListItem = this.priceListItemService.getPriceListItemByCode(productCodeList);
         }
     }
     ```
     * @param productCodeList string list representing the product codes to return the price list item for.
     * @returns A hot observable containing the price list item for requested product(s).
     */
    getPriceListItemByCode(productCodeList) {
        const _productList = productCodeList.filter(code => code != null && code.trim().length > 0);
        if (get(_productList, 'length', 0) > 0) {
            return this.where([
                new ACondition(this.type, 'Product.ProductCode', 'In', _productList)
            ]);
        }
        else {
            return of([]);
        }
    }
}
PriceListItemService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceListItemService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
PriceListItemService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceListItemService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceListItemService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * The account service provides methods for interacting with the accounts the user has access to.
 * <h3>Usage</h3>
 *
 ```typescript
import { AccountService, AObjectService} from '@congacommerce/ecommerce';

export class MyComponent implements OnInit{
constructor( private accountService: AccountService)
}
// or
export class MyService extends AObjectService {
     private accountService: AccountService = this.injector.get(AccountService);
 }
```
 */
class AccountService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = Account;
        this.cartService = this.injector.get(CartService);
        this.categoryService = this.injector.get(CategoryService);
        this.STORAGE_KEY = 'account';
        this.account = new BehaviorSubject(null);
    }
    /**
    * Retrieves the account information based on the accountid passed.
    * ### Example:
     ```typescript
     import { AccountService, Account} from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         accountDetails: Account;
         accountDetails$: Observable<Account>;
     
         constructor(private accountService: AccountService){}
     
         getAccountDetails(Id: string){
             this.accountService.getAccount(Id).subscribe(a => this.accountDetails = a);
             // or
             this.accountDetails$ = this.accountService.getAccount(Id);
         }
     }
     ```
     * @ignore
     */
    getAccount(accountId) {
        return this.fetch(accountId);
    }
    /**
     * Retrieves the account associated with the current user.
     * For guest user it retrieves the account associated with the storefront object.
     * ### Example:
    ```typescript
    import { AccountService, Account} from '@congacommerce/ecommerce';
    import { Observable } from 'rxjs/Observable';
    
    export class MyComponent implements OnInit{
        accountDetails: Account;
        accountDetails$: Observable<Account>;
    
        constructor(private accountService: AccountService){}
    
        getMyAccountDetails(){
            this.accountService.getMyAccount().subscribe(a => this.accountDetails = a);
            // or
            this.accountDetails$ = this.accountService.getMyAccount();
        }
    }
    ```
     * @returns an observable containing the account record
     */
    getMyAccount() {
        const subject = new BehaviorSubject(null);
        this.platformService.apiService.get('/accounts/default', this.type)
            .pipe(take(1))
            .subscribe(account => subject.next(account));
        return subject.pipe(filter$1(d => !isNil(d)));
    }
    /**
     * Retrieves the current active account (used for order-on-behalf functions)
     * ### Example:
     ```typescript
     import { AccountService, Account} from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         accountDetails: Account;
         accountDetails$: Observable<Account>;
     
         constructor(private accountService: AccountService){}
     
         getCurrentAccountDetails(){
             this.accountService.getCurrentAccount().subscribe(a => this.accountDetails = a);
             // or
             this.accountDetails$ = this.accountService.getCurrentAccount();
         }
     }
     ```
     * @returns an observable containing the account record
     */
    getCurrentAccount() {
        this.platformService.apiService.get('/accounts/active', this.type)
            .pipe(take(1))
            .subscribe(account => this.account.next(account));
        return this.account.pipe(filter$1(d => !isNil(d)));
    }
    /**
     * Sets the selected account to be the current active account for order-on-behalf functions.
     * Will store the selected account record in local storage
     * ### Example:
     ```typescript
     import { AccountService, Account} from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         accountDetails: Account;
         accountDetails$: Observable<Account>;
     
         constructor(private accountService: AccountService){}
     
         getCurrentAccountDetails(){
             this.accountService.getCurrentAccount().subscribe(a => this.accountDetails = a);
             // or
             this.accountDetails$ = this.accountService.getCurrentAccount();
         }
     }
     ```
     * @param account the account record to set active
     * @param useLocalStorage boolean flag to use to store the selected account in local storage
     * @returns an observable containing the account record that was set to active
     */
    setAccount(account, useLocalStorage = false) {
        const accountId = (account instanceof Account) ? get(account, 'Id') : account;
        localStorage.setItem(this.STORAGE_KEY, accountId);
        this.getAccount(accountId).pipe(take(1)).subscribe(res => this.account.next(res));
        this.cacheService.update(this.type);
        this.cartService.refreshCart();
        this.categoryService.refresh();
        return of(null);
    }
}
AccountService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AccountService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
AccountService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AccountService, providedIn: 'root' });
__decorate([
    MemoizeAll(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Observable)
], AccountService.prototype, "getMyAccount", null);
__decorate([
    MemoizeAll(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Observable)
], AccountService.prototype, "getCurrentAccount", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AccountService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], propDecorators: { getMyAccount: [], getCurrentAccount: [] } });

/**
 * 'Increment and Merge' updates the existing asset. 'Increment' does not update the existing asset.
 * @ignore
 */
var IncrementLineAction;
(function (IncrementLineAction) {
    IncrementLineAction["INCREMENT_AND_MERGE"] = "Increment and Merge";
    IncrementLineAction["INCREMENT"] = "Increment";
})(IncrementLineAction || (IncrementLineAction = {}));

/** @ignore  */
const _moment$3 = moment;
/**
 * Cart Item service returns the selling term and the end date of a recurring product.
 * <h3>Usage</h3>
 *
 ```typescript
import { CartItemService, AObjectService} from '@congacommerce/ecommerce';

export class MyComponent implements OnInit{
constructor( private cartItemService: CartItemService)
}
// or
export class MyService extends AObjectService {
     private cartItemService: CartItemService = this.injector.get(CartItemService);
 }
```
*/
class CartItemService extends LineItemService {
    constructor() {
        super(...arguments);
        this.type = CartItem;
        this.frequencyMap = {
            'Hourly': 'hours',
            'Monthly': 'months',
            'Daily': 'days',
            'Weekly': 'weeks',
            'Quarterly': 'years',
            'Half Yearly': 'years',
            'Yearly': 'years',
            '--None--': '--None--'
        };
        this.cartService = this.injector.get(CartService);
        this.productAttributeValueService = this.injector.get(ProductAttributeValueService);
        this.accountService = this.injector.get(AccountService);
        this.storefrontService = this.injector.get(StorefrontService);
        this.priceListService = this.injector.get(PriceListService);
        this.categoryService = this.injector.get(CategoryService);
        this.apiService = this.injector.get(ApiService);
        /**
         * Need to use an offset to account for the debounce time. (i.e. user clicking add to cart a really quickly)
         */
        this.lineItemOffset = 0;
    }
    /**
     * This method returns the end date of a recurring product based on its start date and the selling frequency.
     * @param purchaseDate the day of purchase of the product.
     * @param term selling term of the recurring product.
     * @param frequency the selling frequency for the product. Selling frequency may take values like hourly, daily, weekly, monthly, quarterly, half yearly and yearly.
     * @returns a date value representing the day of end of service of the product.
     */
    getEndDate(purchaseDate, term, frequency) {
        let endDate;
        let date = new Date(purchaseDate);
        switch (frequency) {
            case 'Hourly': {
                endDate = _moment$3(date).add(term, 'h').toDate();
                break;
            }
            case 'Daily': {
                endDate = _moment$3(date).add(term, 'd').toDate();
                break;
            }
            case 'Weekly': {
                endDate = _moment$3(date).add(term, 'w').toDate();
                break;
            }
            case 'Monthly': {
                endDate = _moment$3(date).add(term, 'M').toDate();
                break;
            }
            case 'Quarterly': {
                endDate = _moment$3(date).add(term, 'Q').toDate();
                break;
            }
            case 'Half Yearly': {
                endDate = _moment$3(date).add(term * 6, 'M').toDate();
                break;
            }
            case 'Yearly': {
                endDate = _moment$3(date).add(term, 'y').toDate();
                break;
            }
            default: {
                endDate = date;
            }
        }
        return endDate = (frequency !== 'Hourly' && frequency !== '--None--') ? _moment$3(endDate).subtract(1, 'd').toDate() : endDate;
    }
    /**
     * This method is used to calculate selling term of the recurring product based on its start date, end date and the selling frequency.
     * ### Example:
     ```typescript
     import { CartItemService, CartItem } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         term: number;
     
         constructor(private cartItemService: CartItemService){}
     
         getTermForProduct(startDate: Date, endDate: Date, frequency: 'Hourly' | 'Daily' | 'Weekly' | 'Monthly' | 'Quarterly' | 'Half Yearly' | 'Yearly' | '--None--' ){
             this.term = this.cartItemService.getTerm(startDate, endDate, frequency);
         }
     }
     ```
     * @param startDate the day of purchase of the product.
     * @param endDate the day of end of service for the product.
     * @param frequency the selling frequency of the product.
     * @returns number representing the selling term of the recurring product.
    */
    getTerm(startDate, endDate, frequency) {
        let tempEndDate = cloneDeep(endDate);
        tempEndDate.add(1, 'd');
        if (startDate.format('DD') === endDate.format('DD') || startDate.format('DD') === tempEndDate.format('DD')) {
            endDate = endDate.add(1, 'd');
        }
        let val = endDate.diff(startDate, this.frequencyMap[frequency], true);
        if (frequency === 'Quarterly')
            val = val * 4;
        if (frequency === 'Half Yearly')
            val = val * 2;
        val = Math.round(val * 1000) / 1000;
        return val;
    }
    /**
     * @ignore
     */
    getReadableTerm(term, frequency) {
        let val = term;
        if (frequency === 'One Time')
            return frequency;
        else {
            if (frequency === 'Quarterly')
                val = val * 4;
            if (frequency === 'Half Yearly')
                val = val * 2;
            val = Math.round(val * 1000) / 1000;
            return `${val} ${this.frequencyMap[frequency]}`;
        }
    }
    /**
     * This method returns cart line items based on the cart id and line type passed.
     * ### Example:
     ```typescript
     import { CartItemService, CartItem } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         cartItemList: Array<CartItem>;
         cartItemList$: Observable<Array<CartItem>>;
     
         constructor(private cartItemService: CartItemService){}
     
         getCartItems(cartId: string){
             this.cartItemService.getCartItemsForCart(cartId).subscribe(a => this.cartItemList = a);
             // or
             this.cartItemList$ = this.cartItemService.getCartItemsForCart(cartId);
         }
     }
     ```
     * @param cartId Cart Id for which the line items are to be retrieved.
     * @param lineType Type of cart line item to be retrieved.
     * @returns An observable containing the array of cart line items of a given line type, for a given cart.
     */
    getCartItemsForCart(cartId, lineType) {
        return this.where([
            new ACondition(this.type, 'ConfigurationId', 'Equal', cartId),
            new ACondition(this.type, 'LineType', 'In', (lineType) ? [lineType] : ['Product/Service', 'Option', 'Misc'])
        ]);
    }
    /**
     * This method returns the bundled options for the cart line item passed.
     * ### Example:
     ```typescript
     import { CartItemService, CartItem } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         cartItemList: Array<CartItem>;
         cartItemList$: Observable<Array<CartItem>>;
     
         constructor(private cartItemService: CartItemService){}
     
         getbundleCartItems(item: CartItem | AssetLineItem | QuoteLineItem | OrderLineItem){
             this.cartItemService.getBundleItemsForCartItem(item).subscribe(a => this.cartItemList = a);
             // or
             this.cartItemList$ = this.cartItemService.getBundleItemsForCartItem(item);
         }
     }
     ```
     * @param item Instance of the cart, asset, quote or order line item passed.
     * @param context An optional context object to avoid additional network callouts
     * @returns An observable containing the array of option line items for a given cart, asset, quote or order line item.
     */
    getBundleItemsForCartItem(item, context) {
        // If the item is a cart item and has a related asset
        const service = this.metadataService.getAObjectServiceForType(item);
        if (service && item) {
            let field = 'ConfigurationId';
            if (item instanceof AssetLineItem)
                field = 'BusinessObjectId';
            else if (item instanceof QuoteLineItem)
                field = 'QuoteId';
            else if (item instanceof OrderLineItem)
                field = 'OrderId';
            const item$ = service.get([get(item, 'Id')]).pipe(map$1(res => res[0]));
            return (!isNil(context) && !(item instanceof AssetLineItem))
                ? of(filter(context, i => isEqual(i.LineNumber, get(item, 'PrimaryLineNumber'))))
                : item$.pipe(mergeMap((i) => service.where([
                    new ACondition(service.type, 'LineNumber', 'Equal', get(i, 'PrimaryLineNumber')),
                    new ACondition(service.type, field, 'Equal', get(i, field))
                ])));
        }
        else
            return of(null);
    }
    /**
     * Method will generate the default cart items for a given asset.
     * ### Example:
     ```typescript
     import { CartItemService, CartItem } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         cartItemList: Array<CartItem>;
         cartItemList$: Observable<Array<CartItem>>;
     
         constructor(private cartItemService: CartItemService){}
     
         getAssetCartItems(cartItem: CartItem){
             this.cartItemService.getCartItemsForAsset(cartItem).subscribe(a => this.cartItemList = a);
             // or
             this.cartItemList$ = this.cartItemService.getCartItemsForAsset(cartItem);
         }
     }
     ```
     * @param cartItem the primary cart item with a related asset. Generated from the amend / configure asset API
     * @param context An optional context object to avoid additional network callouts
     * @returns an Obseravable containing the array of CartItem associated with cart
    */
    getCartItemsForAsset(cartItem, context) {
        if (isNil(cartItem, 'AssetLineItem'))
            return throwError(new Error('You must provide a cart item with a related asset generated from the amend or configure asset API'));
        return zip(this.getOptionsForItem(get(cartItem, 'AssetLineItem')), this.getOptionsForItem(cartItem, context))
            .pipe(map$1(([assetItems, cartItems]) => {
            // Map the asset lines
            return concat(map(assetItems, 
            // To a new cart item
            asset => {
                const existing = find(cartItems, (i) => get(i, 'AssetLineItemId') === get(asset, 'Id'));
                if (!isNil(existing))
                    return existing;
                else {
                    // Line copies the details of an asset line item to a new cart item ommiting the default Salesforce fields
                    const attributeValue = assign(new ProductAttributeValue(), omit(pick(get(asset, 'AttributeValue'), keys(new ProductAttributeValue())), AObjectService.defaultFields));
                    const newCartItem = assign(new CartItem(), omit(pick(asset, keys(new CartItem())), AObjectService.defaultFields));
                    newCartItem.AttributeValue = attributeValue;
                    newCartItem.AssetLineItem = cloneDeep(asset);
                    newCartItem.AssetLineItemId = get(asset, 'Id');
                    newCartItem.LineStatus = LineStatus.Existing;
                    return newCartItem;
                }
            }), filter(cartItems, i => isNil(get(i, 'AssetLineItem'))));
        }));
    }
    /**
     * Method gets the cart items for a given product. A bundle product with option groups populated must be passed in to retrieve related option cart items.
     * ### Example:
     ```typescript
     import { CartItemService, CartItem } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         cartItemList: Array<CartItem>;
         cartItemList$: Observable<Array<CartItem>>;
     
         constructor(private cartItemService: CartItemService){}
     
         getCartItems(product: Product){
             this.cartItemService.getCartItemsForProduct(product).subscribe(a => this.cartItemList = a);
             // or
             this.cartItemList$ = this.cartItemService.getCartItemsForProduct(product);
         }
     }
     ```
     * @param product the product or bundle product record to generate the cart items for
     * @param quantity the quantity to use for the cart item(s)
     * @param cart the related cart that the cart items will be added to. Must be passed in or the line number that is used will start at 1
     * @param cartItems optional list of related cart items to determine the starting primary line number
     * @param productOptionComponent The related ProductOptionComponent record for generating option line items
     * @param parentBundleNumber the default parent bundle number to use
     * @param lineNumber the default line number to use.
     * @param lineStatus the default line status to use.
     * @returns an Obseravable containing the array of CartItem associated with Product
     */
    getCartItemsForProduct(product, quantity = 1, cart, cartItems, productOptionComponent, parentBundleNumber, lineNumber, lineStatus) {
        let product$ = of(product);
        return combineLatest([product$, this.productAttributeValueService.describe(), this.priceListService.getPriceListId(), this.accountService.getCurrentAccount()])
            .pipe(map$1(([p, metadata, priceListId, account]) => {
            let cartItemList = new Array();
            let primaryLineNumber = this.getNextPrimaryLineNumber(defaultTo(cartItems, get(cart, 'LineItems', [])), cart);
            const generateLinesForProduct = (bundleProduct, lineNo, primaryNo, parentNo, optionComponent, itemSequence = primaryNo) => {
                const cartItem = new CartItem();
                const priceListItem = defaultTo(PriceListItemService.getPriceListItemForProduct(get(optionComponent, 'ComponentProduct', bundleProduct)), PriceListItemService.getPriceListItemForProduct(bundleProduct));
                if (priceListItem) {
                    const startDate = new Date();
                    const endDate = _moment$3(this.getEndDate(new Date(), defaultTo(get(priceListItem, 'DefaultSellingTerm'), 1), defaultTo(get(priceListItem, 'DefaultSellingTerm'), defaultTo(get(priceListItem, 'Frequency'), '--None--'))));
                    const categoryList = this.categoryService.getCategoryBranchForProductSync((optionComponent != null) ? get(optionComponent, 'ComponentProduct') : bundleProduct);
                    const classification = first(categoryList);
                    const classificationHierarchy = join(map(categoryList, 'Name'), ' | ');
                    const hierarchyInfo = join(map(categoryList, c => c.Name + ':Id=' + c.Id + ' | ' + c.Name + ':IncludeInTotalsView__c=' + c.IncludeInTotalsView), ' | ');
                    cartItem.ClassificationId = get(classification, 'Id');
                    cartItem.ClassificationHierarchy = classificationHierarchy;
                    cartItem.ClassificationHierarchyInfo = hierarchyInfo;
                    cartItem.LineType = isNil(optionComponent) ? 'Product/Service' : 'Option';
                    cartItem.IsPrimaryLine = true;
                    cartItem.PricingStatus = 'Pending';
                    cartItem.Product = p;
                    cartItem.ProductId = get(p, 'Id');
                    cartItem.ProductVersion = isNil(optionComponent) ? get(p, 'Version') : get(optionComponent, 'ComponentProduct.Version');
                    cartItem.ProductOptionId = get(optionComponent, 'Id');
                    cartItem.ProductOption = optionComponent;
                    cartItem.PriceListId = defaultTo(get(cart, 'PriceListId'), priceListId);
                    cartItem.PriceListItemId = get(priceListItem, 'Id');
                    cartItem.ShipToAccountId = defaultTo(get(cart, 'ShipToAccountId'), get(account, 'Id'));
                    cartItem.BillToAccountId = defaultTo(get(cart, 'BillToAccountId'), get(account, 'Id'));
                    cartItem.Taxable = priceListItem.Taxable;
                    cartItem.TaxCodeId = priceListItem.TaxCodeId;
                    cartItem.HasOptions = bundleProduct.HasOptions;
                    cartItem.HasAttributes = isNil(optionComponent) ? bundleProduct.HasAttributes : optionComponent.ComponentProduct.HasAttributes;
                    cartItem.ItemSequence = itemSequence;
                    cartItem.LineStatus = defaultTo(lineStatus, LineStatus.New);
                    cartItem.LineNumber = lineNo;
                    cartItem.PrimaryLineNumber = primaryNo;
                    cartItem.ParentBundleNumber = parentNo;
                    cartItem.PricingTerm = 1;
                    cartItem.StartDate = _moment$3(startDate).format('YYYY-MM-DD');
                    cartItem.EndDate = _moment$3(endDate).format('YYYY-MM-DD');
                    cartItem.ConfigurationId = get(cart, 'Id');
                    cartItem.Quantity = defaultTo(get(optionComponent, 'DefaultQuantity', quantity), 1);
                    if (cartItem.HasAttributes)
                        cartItem.AttributeValue = this.productAttributeValueService.getInstanceWithDefaults(bundleProduct, metadata);
                    cartItem.OptionId = get(optionComponent, 'ComponentProductId');
                    cartItem.Option = get(optionComponent, 'ComponentProduct');
                    cartItemList.push(cartItem);
                    const generateOptions = (bundleProd) => {
                        flatten(map(get(bundleProd, 'OptionGroups', []), productOptionGroup => {
                            return get(productOptionGroup, 'IsHidden')
                                ? filter(get(productOptionGroup, 'Options', []), { 'Default': true })
                                : filter(get(productOptionGroup, 'Options', []), (opt) => opt.Default || opt.Required);
                        })).forEach((option, index) => {
                            primaryLineNumber += 1;
                            generateLinesForProduct(option.ComponentProduct, lineNo, primaryLineNumber, cartItem.PrimaryLineNumber, option, itemSequence + 1);
                        });
                    };
                    if (optionComponent)
                        generateOptions(optionComponent.ComponentProduct);
                    generateOptions(bundleProduct);
                }
            };
            // Get the category information for the products
            generateLinesForProduct(p, defaultTo(lineNumber, primaryLineNumber), primaryLineNumber, parentBundleNumber, productOptionComponent);
            return cartItemList;
        }));
    }
    /**
     * @ignore
     */
    getNextPrimaryLineNumber(cartItems, cart) {
        this.lineItemOffset += 1;
        if (isNil(this.debounceReset))
            this.debounceReset = debounce(this.resetOffset, this.configurationService.get('debounceTime', 500));
        this.debounceReset();
        if (cartItems) {
            let max = Math.max(...compact(cartItems).map(o => o.PrimaryLineNumber), 0);
            if (find(get(cart, 'LineItems'), item => item.PrimaryLineNumber === (max + this.lineItemOffset))) {
                max = Math.max(...compact(get(cart, 'LineItems')).map(o => o.PrimaryLineNumber), 0);
            }
            return max + this.lineItemOffset;
        }
        else
            return this.lineItemOffset;
    }
    /**
     * @ignore
     */
    addCartItems(cartItems) {
        forEach(cartItems, (cartItem) => {
            cartItem.ConfigurationId = CartService.getCurrentCartId();
        });
        return this.upsert(cartItems).pipe(tap(() => this.cartService.refreshCart()));
    }
    /**
     * @ignore
     */
    getCartItem(cartItemId) {
        return this.query({
            conditions: [new ACondition(this.type, 'Id', 'In', [cartItemId])],
            skipCache: true
        })
            .pipe(map$1(([item]) => {
            if (item) {
                item.Quantity = item.Quantity ? item.Quantity : item.TotalQuantity;
                return [item];
            }
            else {
                return null;
            }
        }));
    }
    resetOffset() {
        this.lineItemOffset = 0;
    }
}
CartItemService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CartItemService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CartItemService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CartItemService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CartItemService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

let ConfigCustomDisplayColumns = class ConfigCustomDisplayColumns extends AObject {
    constructor() {
        super(...arguments);
        this.DisplayType = null;
        this.FieldName = null;
        this.Flow = null;
        this.HeaderStyle = null;
        this.IsEditable = null;
        this.IsPricePoint = null;
        this.Sequence = null;
        this.Style = null;
        this.StyleClass = null;
    }
};
__decorate([
    Expose({ name: 'Apttus_Config2__DisplayType__c' }),
    __metadata("design:type", String)
], ConfigCustomDisplayColumns.prototype, "DisplayType", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__FieldName__c' }),
    __metadata("design:type", String)
], ConfigCustomDisplayColumns.prototype, "FieldName", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Flow__c' }),
    __metadata("design:type", String)
], ConfigCustomDisplayColumns.prototype, "Flow", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__HeaderStyle__c' }),
    __metadata("design:type", String)
], ConfigCustomDisplayColumns.prototype, "HeaderStyle", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsEditable__c' }),
    __metadata("design:type", Boolean)
], ConfigCustomDisplayColumns.prototype, "IsEditable", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsPricePoint__c' }),
    __metadata("design:type", Boolean)
], ConfigCustomDisplayColumns.prototype, "IsPricePoint", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__IsSortable__c' }),
    __metadata("design:type", Boolean)
], ConfigCustomDisplayColumns.prototype, "IsSortable", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Sequence__c' }),
    __metadata("design:type", Number)
], ConfigCustomDisplayColumns.prototype, "Sequence", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Style__c' }),
    __metadata("design:type", String)
], ConfigCustomDisplayColumns.prototype, "Style", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__StyleClass__c' }),
    __metadata("design:type", String)
], ConfigCustomDisplayColumns.prototype, "StyleClass", void 0);
ConfigCustomDisplayColumns = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__ConfigCustomDisplayColumns__c'
    })
], ConfigCustomDisplayColumns);

/**
 * User view service returns the configurable view of cart item fields to be displayed for a user on cart page.
* <h3>Usage</h3>
*
```typescript
import { UserViewService } from '@congacommerce/ecommerce';

constructor(private userViewService: UserViewService) {}

// or

export class MyService extends AObjectService {
     private userViewService: UserViewService = this.injector.get(UserViewService);
 }
```
*/
class UserViewService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = ConfigCustomDisplayColumns;
        /**
         * List of user view records for a given user.
         */
        this.userViews = new Array();
        this.storageKey = 'user-view';
        this.apiService = this.injector.get(ApiService);
        this.userService = this.injector.get(UserService);
    }
    /**
     * This method fetches the list of display columns for cart item fields, matching the default user view.
     * ### Example:
       ```typescript
       import { UserViewService } from '@congacommerce/ecommerce';
  
       constructor(private userViewService: UserViewService) {
       this.subscriptions.push(this.userViewService.getUserView().subscribe(res => {....}));
       }
     ```
     * @param viewId string identifier representing the user view.
     * @returns an observable containing list of display columns for cart item fields.
     */
    getUserView(viewId = null) {
        return this.userService.getCurrentUser().pipe(switchMap((user) => {
            const view = get(JSON.parse(localStorage.getItem(this.storageKey)), `${user.Id}`);
            if (!isEmpty(view))
                return of(view);
            if (viewId) {
                return this.apiService.get(`/users/${get(user, 'Id')}/views/${viewId}`);
            }
            else {
                return this.apiService.get(`/users/${get(user, 'Id')}/views/active`);
            }
        }), map$1(data => {
            this.userViews = data;
            const mappedViews = [];
            map(data, item => {
                const view = {
                    isSelected: item.IsSelected,
                    displayColumn: plainToClass(this.type, item.DisplayColumn)
                };
                mappedViews.push(view);
            });
            return mappedViews;
        }));
    }
    /**
     * @ignore
     */
    getUserViews() {
        return this.userService.getCurrentUser().pipe(switchMap((user) => this.apiService.get(`/users/${get(user, 'Id')}/views`)), map$1(res => plainToClass(this.type, res)));
    }
    /**
     * This method stores the given list of user view records in browser storage.
     * ### Example:
       ```typescript
       import { UserViewService } from '@congacommerce/ecommerce';
  
       constructor(private userViewService: UserViewService) {
       this.subscriptions.push(this.userViewService.getUserView().subscribe(res => {
              const myView = this.mapUserView(res);
              this.updateUserView(myView);
       }));
       }
     ```
     * @param view list of user view records to be stored.
     * @returns an observable of boolean.
     */
    updateUserView(view, viewId = null) {
        return this.userService.getCurrentUser().pipe(switchMap((user) => {
            if (view) {
                localStorage.setItem(this.storageKey, JSON.stringify({ [user.Id]: view }));
                return of(true);
            }
            return of(false);
        }));
    }
}
UserViewService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: UserViewService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
UserViewService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: UserViewService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: UserViewService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

let ApprovalRequest = class ApprovalRequest extends AObject {
    constructor() {
        super(...arguments);
        this.Action_Approve_Id = null;
        this.Action_Reassign_Id = null;
        this.Active = null;
        this.Actual_Approver = null;
        this.ActualApproverName = null;
        this.Action = null;
        this.Action_Prefix = null;
        this.ApprovalCount = null;
        this.Request_Comments = null;
        this.ApprovalFromEmail = null;
        this.ApprovalPercent = null;
        this.ApprovalPolicy = null;
        this.Approval_Process = null;
        this.ProcessInstanceId = null;
        this.Approval_Status = null;
        this.Approver_Comments = null;
        this.Assigned_To_Link = null;
        this.Assigned_To_Name = null;
        this.Assigned_To_Id = null;
        this.Assigned_To_Type = null;
        this.Auto_Complete = null;
        this.AutoEscalate = null;
        this.AutoReapprove = null;
        this.Backup_From_User = null;
        this.CanEscalate = null;
        this.ChildObjectId = null;
        this.ChildObjectLink = null;
        this.ChildObjectName = null;
        this.ChildObjectType = null;
        this.ContinuePolicyApprovalOnAReject = null;
        this.CriteriaFieldNames = null;
        this.Date = null;
        this.DateApproved = null;
        this.DateAssigned = null;
        this.DateCancelled = null;
        this.DateEscalated = null;
        this.DateReassigned = null;
        this.DateRejected = null;
        this.DelegateApprover = null;
        this.DelegateApproverIds = null;
        this.DependsOn = null;
        this.EscalatedToHighestLevel = null;
        this.EscalateToChain = null;
        this.EscalateToId = null;
        this.EscalateToName = null;
        this.EscalateToType = null;
        this.ExpectedCompletionDate = null;
        this.ExpectedDaysToComplete = null;
        this.ExpectedHoursToComplete = null;
        this.ExpectedMinutesToComplete = null;
        this.Group = null;
        this.Group_Unique_Id = null;
        this.HasAttachments = null;
        this.HasDelegateApprover = null;
        this.InEscalation = null;
        this.Initial_Submitter = null;
        this.Internal_Comments = null;
        this.IsAdhoc = null;
        this.IsAutoReapprovalEnabled = null;
        this.IsSubprocess = null;
        this.Notify_Only = null;
        this.Object_Id = null;
        this.Object_Id_Link = null;
        this.Object_Name = null;
        this.Object_Type = null;
        this.Parent_Agreement = null;
        this.ParentRequestId = null;
        this.PrevAssignedToName = null;
        this.PrevAssignedToId = null;
        this.PrevAssignedToType = null;
        this.Assigned_To = null;
        this.Rejection_Action = null;
        this.Related_Agreement = null;
        this.AgreementLineItemId = null;
        this.Related_Agreement_Owner = null;
        this.Related_Agreement_Requestor = null;
        this.Related_Agreement_Term_Exception = null;
        this.Related_Opportunity = null;
        this.Related_Opportunity_Owner = null;
        this.RequestType = null;
        this.Send_Email = null;
        this.StepSequenceString = null;
        this.StepSequence = null;
        this.Status_Link = null;
        this.StepNameLink = null;
        this.Step = null;
        this.Step_Group_Seq_Number = null;
        this.StepLabel = null;
        this.Step_Name = null;
        this.SubmissionComment1 = null;
        this.SubmissionComment2 = null;
        this.SubmissionComment3 = null;
        this.SubprocessDependsOn = null;
        this.SubprocessName = null;
        this.SubprocessSequence = null;
        this.Sequence = null;
        this.SubstepDependsOn = null;
        this.SubstepName = null;
        this.SubstepSequence = null;
        this.Workflow_Trigger_Added_Comments = null;
    }
};
__decorate([
    AField({
        soql: 'Apttus_Approval__Action_Approve_Id__c',
        aql: 'ActionApproveId'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Action_Approve_Id", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Action_Reassign_Id__c',
        aql: 'ActionReassignId'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Action_Reassign_Id", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Active__c',
        aql: 'Active'
    }),
    __metadata("design:type", Boolean)
], ApprovalRequest.prototype, "Active", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Actual_Approver__c'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Actual_Approver", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__ActualApproverName__c',
        aql: 'ActualApproverName'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "ActualApproverName", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Action__c',
        aql: 'ApprovalAction'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Action", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Action_Prefix__c',
        aql: 'ApprovalActionPrefix'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Action_Prefix", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__ApprovalCount__c',
        aql: 'ApprovalCount'
    }),
    __metadata("design:type", Number)
], ApprovalRequest.prototype, "ApprovalCount", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Request_Comments__c',
        aql: 'ApprovalDetails'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Request_Comments", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__ApprovalFromEmail__c',
        aql: 'ApprovalFromEmail'
    }),
    __metadata("design:type", Boolean)
], ApprovalRequest.prototype, "ApprovalFromEmail", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__ApprovalPercent__c',
        aql: 'ApprovalPercent'
    }),
    __metadata("design:type", Number)
], ApprovalRequest.prototype, "ApprovalPercent", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__ApprovalPolicy__c',
        aql: 'ApprovalPolicy'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "ApprovalPolicy", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Approval_Process__c',
        aql: 'ApprovalProcess'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Approval_Process", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__ProcessInstanceId__c',
        aql: 'ApprovalProcessInstanceId'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "ProcessInstanceId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Approval_Status__c',
        aql: 'ApprovalStatus'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Approval_Status", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Approver_Comments__c',
        aql: 'ApproverComments'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Approver_Comments", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Assigned_To_Link__c',
        aql: 'AssignedToLink'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Assigned_To_Link", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Assigned_To_Name__c'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Assigned_To_Name", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Assigned_To_Id__c'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Assigned_To_Id", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Assigned_To_Type__c'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Assigned_To_Type", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Auto_Complete__c',
        aql: 'AutoComplete'
    }),
    __metadata("design:type", Boolean)
], ApprovalRequest.prototype, "Auto_Complete", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__AutoEscalate__c',
        aql: 'AutoEscalate'
    }),
    __metadata("design:type", Boolean)
], ApprovalRequest.prototype, "AutoEscalate", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__AutoReapprove__c',
        aql: 'AutoReapprove'
    }),
    __metadata("design:type", Boolean)
], ApprovalRequest.prototype, "AutoReapprove", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Backup_From_User__c'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Backup_From_User", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__CanEscalate__c',
        aql: 'CanEscalate'
    }),
    __metadata("design:type", Boolean)
], ApprovalRequest.prototype, "CanEscalate", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__ChildObjectId__c',
        aql: 'ChildObjectId'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "ChildObjectId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__ChildObjectLink__c',
        aql: 'ChildObjectLink'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "ChildObjectLink", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__ChildObjectName__c',
        aql: 'ChildObjectName'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "ChildObjectName", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__ChildObjectType__c',
        aql: 'ChildObjectType'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "ChildObjectType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__ContinuePolicyApprovalOnAReject__c',
        aql: 'ContinuePolicyApprovalOnAReject'
    }),
    __metadata("design:type", Boolean)
], ApprovalRequest.prototype, "ContinuePolicyApprovalOnAReject", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__CriteriaFieldNames__c',
        aql: 'CriteriaFieldNames'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "CriteriaFieldNames", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Date__c',
        aql: 'Date'
    }),
    __metadata("design:type", Date)
], ApprovalRequest.prototype, "Date", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__DateApproved__c',
        aql: 'DateApproved'
    }),
    __metadata("design:type", Date)
], ApprovalRequest.prototype, "DateApproved", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__DateAssigned__c',
        aql: 'DateAssigned'
    }),
    __metadata("design:type", Date)
], ApprovalRequest.prototype, "DateAssigned", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__DateCancelled__c',
        aql: 'DateCancelled'
    }),
    __metadata("design:type", Date)
], ApprovalRequest.prototype, "DateCancelled", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__DateEscalated__c',
        aql: 'DateEscalated'
    }),
    __metadata("design:type", Date)
], ApprovalRequest.prototype, "DateEscalated", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__DateReassigned__c',
        aql: 'DateReassigned'
    }),
    __metadata("design:type", Date)
], ApprovalRequest.prototype, "DateReassigned", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__DateRejected__c',
        aql: 'DateRejected'
    }),
    __metadata("design:type", Date)
], ApprovalRequest.prototype, "DateRejected", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__DelegateApprover__c'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "DelegateApprover", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__DelegateApproverIds__c'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "DelegateApproverIds", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__DependsOn__c',
        aql: 'DependsOn'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "DependsOn", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__EscalatedToHighestLevel__c',
        aql: 'EscalatedToHighestLevel'
    }),
    __metadata("design:type", Boolean)
], ApprovalRequest.prototype, "EscalatedToHighestLevel", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__EscalateToChain__c',
        aql: 'EscalateToChain'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "EscalateToChain", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__EscalateToId__c',
        aql: 'EscalateToId'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "EscalateToId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__EscalateToName__c',
        aql: 'EscalateToName'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "EscalateToName", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__EscalateToType__c',
        aql: 'EscalateToType'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "EscalateToType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__ExpectedCompletionDate__c',
        aql: 'ExpectedCompletionDate'
    }),
    __metadata("design:type", Date)
], ApprovalRequest.prototype, "ExpectedCompletionDate", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__ExpectedDaysToComplete__c',
        aql: 'ExpectedDaysToComplete'
    }),
    __metadata("design:type", Number)
], ApprovalRequest.prototype, "ExpectedDaysToComplete", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__ExpectedHoursToComplete__c',
        aql: 'ExpectedHoursToComplete'
    }),
    __metadata("design:type", Number)
], ApprovalRequest.prototype, "ExpectedHoursToComplete", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__ExpectedMinutesToComplete__c'
    }),
    __metadata("design:type", Number)
], ApprovalRequest.prototype, "ExpectedMinutesToComplete", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Group__c',
        aql: 'Group'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Group", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Group_Unique_Id__c',
        aql: 'GroupUniqueId'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Group_Unique_Id", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__HasAttachments__c',
        aql: 'HasAttachments'
    }),
    __metadata("design:type", Boolean)
], ApprovalRequest.prototype, "HasAttachments", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__HasDelegateApprover__c',
        aql: 'HasDelegateApprover'
    }),
    __metadata("design:type", Boolean)
], ApprovalRequest.prototype, "HasDelegateApprover", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__InEscalation__c'
    }),
    __metadata("design:type", Boolean)
], ApprovalRequest.prototype, "InEscalation", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Initial_Submitter__c'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Initial_Submitter", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Internal_Comments__c',
        aql: 'InternalComments'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Internal_Comments", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__IsAdhoc__c',
        aql: 'IsAdhoc'
    }),
    __metadata("design:type", Boolean)
], ApprovalRequest.prototype, "IsAdhoc", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__IsAutoReapprovalEnabled__c',
        aql: 'IsAutoReapprovalEnabled'
    }),
    __metadata("design:type", Boolean)
], ApprovalRequest.prototype, "IsAutoReapprovalEnabled", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__IsSubprocess__c',
        aql: 'IsSubprocess'
    }),
    __metadata("design:type", Boolean)
], ApprovalRequest.prototype, "IsSubprocess", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Notify_Only__c',
        aql: 'NotifyOnly'
    }),
    __metadata("design:type", Boolean)
], ApprovalRequest.prototype, "Notify_Only", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Object_Id__c',
        aql: 'ObjectId'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Object_Id", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Object_Id_Link__c',
        aql: 'ObjectLink'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Object_Id_Link", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Object_Name__c',
        aql: 'ObjectName'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Object_Name", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Object_Type__c',
        aql: 'ObjectType'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Object_Type", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Parent_Agreement__c'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Parent_Agreement", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__ParentRequestId__c',
        aql: 'ParentRequestId'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "ParentRequestId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__PrevAssignedToName__c'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "PrevAssignedToName", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__PrevAssignedToId__c'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "PrevAssignedToId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__PrevAssignedToType__c'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "PrevAssignedToType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Assigned_To__c',
        aql: 'AssignedTo'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Assigned_To", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Rejection_Action__c',
        aql: 'RejectionAction'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Rejection_Action", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Related_Agreement__c'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Related_Agreement", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__AgreementLineItemId__c'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "AgreementLineItemId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Related_Agreement_Owner__c'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Related_Agreement_Owner", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Related_Agreement_Requestor__c'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Related_Agreement_Requestor", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Related_Agreement_Term_Exception__c'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Related_Agreement_Term_Exception", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Related_Opportunity__c'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Related_Opportunity", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Related_Opportunity_Owner__c'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Related_Opportunity_Owner", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__RequestType__c',
        aql: 'RequestType'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "RequestType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Send_Email__c',
        aql: 'SendEmail'
    }),
    __metadata("design:type", Boolean)
], ApprovalRequest.prototype, "Send_Email", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__StepSequenceString__c',
        aql: 'StepSequenceString'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "StepSequenceString", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__StepSequence__c',
        aql: 'StepSequence'
    }),
    __metadata("design:type", Number)
], ApprovalRequest.prototype, "StepSequence", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Status_Link__c',
        aql: 'Status'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Status_Link", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__StepNameLink__c'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "StepNameLink", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Step__c',
        aql: 'Step'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Step", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Step_Group_Seq_Number__c',
        aql: 'StepGroupSeqNumber'
    }),
    __metadata("design:type", Number)
], ApprovalRequest.prototype, "Step_Group_Seq_Number", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__StepLabel__c',
        aql: 'StepLabel'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "StepLabel", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Step_Name__c',
        aql: 'StepName'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Step_Name", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__SubmissionComment1__c',
        aql: 'SubmissionComment1'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "SubmissionComment1", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__SubmissionComment2__c',
        aql: 'SubmissionComment2'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "SubmissionComment2", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__SubmissionComment3__c',
        aql: 'SubmissionComment3'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "SubmissionComment3", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__SubprocessDependsOn__c',
        aql: 'SubprocessDependsOn'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "SubprocessDependsOn", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__SubprocessName__c',
        aql: 'SubprocessName'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "SubprocessName", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__SubprocessSequence__c',
        aql: 'SubprocessSequence'
    }),
    __metadata("design:type", Number)
], ApprovalRequest.prototype, "SubprocessSequence", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Sequence__c'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "Sequence", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__SubstepDependsOn__c',
        aql: 'SubstepDependsOn'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "SubstepDependsOn", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__SubstepName__c',
        aql: 'SubstepName'
    }),
    __metadata("design:type", String)
], ApprovalRequest.prototype, "SubstepName", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__SubstepSequence__c',
        aql: 'SubstepSequence'
    }),
    __metadata("design:type", Number)
], ApprovalRequest.prototype, "SubstepSequence", void 0);
__decorate([
    AField({
        soql: 'Apttus_Approval__Workflow_Trigger_Added_Comments__c',
        aql: 'WorkflowTriggerAddedComments'
    }),
    __metadata("design:type", Boolean)
], ApprovalRequest.prototype, "Workflow_Trigger_Added_Comments", void 0);
ApprovalRequest = __decorate([
    ATable({
        sobjectName: 'Apttus_Approval__Approval_Request__c',
        aqlName: 'iwa_ApprovalRequest'
    })
], ApprovalRequest);

/**
 * Product attribute rules are a powerful feature that add a level of dynamic configuration to products a given set of product attributes.
 * <h3>Usage</h3>
 *
 ```typescript
 import { ProductAttributeRuleService, AObjectService} from '@congacommerce/ecommerce';
 
 export class MyComponent implements OnInit{
 constructor( private productAttributeRuleService: ProductAttributeRuleService)
 }
 // or
 export class MyService extends AObjectService {
      private productAttributeRuleService: ProductAttributeRuleService = this.injector.get(ProductAttributeRuleService);
  }
 ```
 */
class ProductAttributeRuleService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = ProductAttributeRule;
        this.productAttributeRuleViewService = this.injector.get(ProductAttributeRuleViewService);
    }
    /**
     * Method returns an array of product attribute rules for a given product
     * ### Example:
```typescript
import { ProductAttributeRuleService, ProductAttributeValue } from '@congacommerce/ecommerce';
import { Observable } from 'rxjs/Observable';

export class MyComponent implements OnInit{
    productAttributeRules: Array<ProductAttributeRule>;
    productAttributeRules$: Observable<Array<ProductAttributeRule>>;

    constructor(private productAttributeRuleService: ProductAttributeRuleService){}

    getRulesForProduct(productCode: string){
        this.productAttributeRuleService.getProductRules(productCode).subscribe(ruleList => this.productAttributeRules = ruleList);
        // or
        productAttributeRules$ = this.productAttributeRuleService.getProductRules(productCode);
    }
}
```
     * @param productCode the code of the product for which to retrieve attribute rules for.
     * @returns an array of attribute rules in an observable for a given product code
     */
    getProductRules(productCode) {
        // return this.where(`ID IN
        //         (SELECT Apttus_Config2__ProductAttributeRuleId__c
        //             FROM Apttus_Config2__ProductAttributeRuleView__c
        //             WHERE Apttus_Config2__ProductId__r.ProductCode = '` + productCode + `')`);
        return this.where(null, 'AND', null, null, null, [
            new AJoin(this.productAttributeRuleViewService.type, 'Id', 'ProductAttributeRuleId', [
                new ACondition(this.productAttributeRuleViewService.type, 'Product.ProductCode', 'Equal', productCode)
            ])
        ]);
    }
}
ProductAttributeRuleService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductAttributeRuleService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ProductAttributeRuleService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductAttributeRuleService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductAttributeRuleService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });
/** @ignore */
class ProductAttributeRuleViewService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = ProductAttributeRuleView;
    }
}
ProductAttributeRuleViewService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductAttributeRuleViewService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ProductAttributeRuleViewService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductAttributeRuleViewService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductAttributeRuleViewService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * The Address-Location service allows you to organize account addresses. Addresses are a sub-resource of an Account. An account may have multiple addresses.
 * <h3>Usage</h3>
 *
 ```typescript
import { AccountLocationService, AObjectService} from '@congacommerce/ecommerce';

export class MyComponent implements OnInit{
constructor( private accountLocationService: AccountLocationService)
}
// or
export class MyService extends AObjectService {
     private accountLocationService: AccountLocationService = this.injector.get(AccountLocationService);
 }
```
 */
class AccountLocationService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = AccountLocation;
        this.locations$ = new BehaviorSubject(null);
        this.accountService = this.injector.get(AccountService);
    }
    /**
     * gets all the account locations for the current account you have selected.
     * ### Example:
```typescript
import { AccountLocationService, AccountLocation } from '@congacommerce/ecommerce';
import { Observable } from 'rxjs/Observable';

export class MyComponent implements OnInit{
    accountLocationList: Array<AccountLocation>;
    accountLocationList$: Observable<Array<AccountLocation>>;

    constructor(private accountLocationService: AccountLocationService){}

    getAccountLocations(productCode: string){
        this.accountLocationService.getAccountLocations().subscribe(a => this.accountLocationList = a);
        // or
        this.accountLocationList$ + this.accountLocationService.getAccountLocations();
    }
}
```
     * @returns An observable of an account location array
     */
    getAccountLocations() {
        if (this.locations$.value)
            return this.locations$;
        else {
            this.refreshLocations();
            return this.locations$;
        }
    }
    /**
     * Saves the account location record to the current account.
     * ### Example:
```typescript
import { AccountLocationService, AccountLocation } from '@congacommerce/ecommerce';
import { Observable } from 'rxjs/Observable';

export class MyComponent implements OnInit{

    constructor(private accountLocationService: AccountLocationService){}

    saveAccountLocation(accountLocation: AccountLocation){
        this.accountLocationService.saveLocationToAccount(accountLocation)
            .subscribe(
                locationId => {...},
                err => {...}
            );
    }
}
```
     * @param location The AccountLocation record to save
     * @returns An observable of an account location record id
     */
    saveLocationToAccount(location) {
        return this.accountService.getCurrentAccount().pipe(take(1), switchMap(account => {
            location.AccountId = account.Id;
            return this.upsert([location]);
        }), map$1(res => _.get(res, '[0].Id')), tap(() => this.refreshLocations()));
    }
    /**
     * Sets the selected address as the default address.
     * ### Example:
```typescript
import { AccountLocationService, AccountLocation } from '@congacommerce/ecommerce';
import { Observable } from 'rxjs/Observable';

export class MyComponent implements OnInit{

    constructor(private accountLocationService: AccountLocationService){}

    setLocationAsDefault(accountLocation: AccountLocation){
        this.accountLocationService.setLocationAsDefault(accountLocation)
            .subscribe(
                locationIdList => {...},
                err => {...}
            );
    }
}
```
     * @param location  The AccountLocation record to set as default
     * @returns A string array of records that were updated in the process
     */
    setLocationAsDefault(location) {
        return this.getAccountLocations().pipe(take(1), switchMap(locations => {
            const d = locations.filter(al => al.IsDefault === true);
            if (d && d.length > 0)
                d.forEach(r => r.IsDefault = false);
            location.IsDefault = true;
            const toUpdate = [location].concat(d);
            return this.update(toUpdate);
        }), tap(() => this.refreshLocations()));
    }
    /**
     * @override
     * @param recordList array of records to be deleted
     * @param updateCache when set to true, will update cache after deleting records
     * @returns an array of records that were deleted in the process
     */
    delete(recordList, updateCache = true) {
        return super.delete(recordList, updateCache).pipe(tap(() => this.refreshLocations()));
    }
    refreshLocations() {
        this.accountService.getCurrentAccount()
            .pipe(take(1), switchMap(account => this.query({
            conditions: [new ACondition(this.type, 'AccountId', 'Equal', _.get(account, 'Id'))]
        })), take(1)).subscribe(locations => {
            this.locations$.next(locations);
        });
    }
}
AccountLocationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AccountLocationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
AccountLocationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AccountLocationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AccountLocationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * The contact service provides methods for interacting with the contacts the current user has access to.
 * <h3>Usage</h3>
 *
  ```typescript
 import { ContactService, AObjectService} from '@congacommerce/ecommerce';
 
 export class MyComponent implements OnInit{
 constructor( private contactService: ContactService)
 }
 // or
 export class MyService extends AObjectService {
      private contactService: ContactService = this.injector.get(ContactService);
  }
 ```
 */
class ContactService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = Contact;
        this.userService = this.injector.get(UserService);
    }
    /**
     * Gets the contact record for the current user. If the user is not logged in, it will return a new contact instance.
     * ### Example:
```typescript
import { ContactService, Contact } from '@congacommerce/ecommerce';
import { Observable } from 'rxjs/Observable';

export class MyComponent implements OnInit{
    contact: Contact;
    contact$: Observable<Contact>;

    constructor(private contactService: ContactService){}

    ngOnInit(){
        this.contactService.getMyContact().subscribe(c => this.contact = c);
        // or
        this.contact$ = this.contactService.getMyContact();
    }
}
```
     * @returns an Observable containing the current contact record
     */
    getMyContact() {
        return this.userService.me().pipe(mergeMap(user => {
            if (user.Id && user.Alias !== 'guest')
                return this.where(null, 'AND', null, null, null, [
                    new AJoin(User, 'Id', 'ContactId', [new ACondition(User, 'Id', 'Equal', user.Id)])
                ])
                    .pipe(map$1(res => {
                    if (!isEmpty(res))
                        return first(res);
                    else
                        return this.getInstance();
                }));
            else
                return of(this.getInstance());
        }));
    }
    /**
     * Gets the contact record for the current user. If the user is not logged in.
     * ### Example:
```typescript
import { ContactService, Contact } from '@congacommerce/ecommerce';
import { Observable } from 'rxjs/Observable';

export class MyComponent implements OnInit{
    contact: Contact;
    contact$: Observable<Contact>;

    constructor(private contactService: ContactService){}

    ngOnInit(){
        this.contactService.getContactForUser().subscribe(c => this.contact = c);
        // or
        this.contact$ = this.contactService.getContactForUser();
    }
}
```
     * @returns an Observable containing the current contact record
     */
    getContactForUser() {
        return this.platformService.userId().pipe(mergeMap(userId => this.where([new ACondition(this.type, 'UserId', 'Equal', userId)])), map$1(contacts => contacts[0]), catchError(e => {
            return null;
        }));
    }
    /**
    * Gets the contact record based on first name, last name and email address passed.
    * ### Example:
```typescript
import { ContactService, Contact } from '@congacommerce/ecommerce';
import { Observable } from 'rxjs/Observable';

export class MyComponent implements OnInit{
   contact: Contact;
   contact$: Observable<Contact>;

   constructor(private contactService: ContactService){}

   ngOnInit(){
       this.contactService.getContact(firstName, lastName, email).subscribe(c => this.contact = c);
       // or
       this.contact$ = this.contactService.getContact(firstName, lastName, email);
   }
}
```
    * @param objQueryParams A object contains properties like firstName, lastName, email etc..
    * @returns an Observable containing the current contact record.
    */
    getContact(objQueryParams) {
        const conditionList = [];
        for (const key in objQueryParams) {
            if (objQueryParams[key]) {
                conditionList.push(new ACondition(this.type, key, 'Equal', objQueryParams[key]));
            }
        }
        return this.where(conditionList, 'AND', null, null, null, null, true).pipe(map$1(res => res[0]), catchError(e => {
            return null;
        }));
    }
}
ContactService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ContactService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ContactService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ContactService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ContactService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * The email service provides methods for interacting with the emails of the current user has access to.
 * <h3>Usage</h3>
 *
  ```typescript
 import { EmailService, AObjectService} from '@congacommerce/ecommerce';
 
 export class MyComponent implements OnInit{
 constructor( private emailService: EmailService)
 }
 // or
 export class MyService extends AObjectService {
      private emailService: EmailService = this.injector.get(EmailService);
  }
 ```
 */
class EmailService extends AObjectService {
    /**
     *  send email with the list of email content.
     *
     * ### Example:
     ```typescript
     import { EmailService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         emailUpdates;
         emailUpdates$ : Observable<any>;
         constructor(private emailService: EmailService){}
     
       sendEmail(emailContentList: MailContent[]){
           this.emailService.sendEmail(emailContentList).subscribe(a => this.emailUpdates = a);
             // or
           emailUpdates$ = this.emailService.sendEmail(emailContentList);
       }
     }
     ```
     *
     * @param emailContentList is an array of mail content having toAddress,ccAddressesa,replyTo and more.
     *
     * @returns an observable
     */
    sendEmail(emailContentList) {
        return this.platformService.post('sendEmail', emailContentList);
    }
    /**
     *  send email template
     *
     * ### Example:
     ```typescript
     import { EmailService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         constructor(private emailService: EmailService){}
     
       sendEmailTemplate(templateName: string, to: User, what: AObject){
           this.emailService.sendEmailTemplate(templateName, to, what);
       }
     }
     ```
     * @param templateName name of the template to be used.
     * @param to  which contact from the account to be used and Address to be used to send email.
     * @param what which account to be used.
     *
     * @returns an observable
     */
    sendEmailTemplate(templateName, to, what) {
        let content = TemplateMailFactory(templateName, what.Id, to.Id, [to.Email]);
        return this.platformService.post('sendEmail', [
            content
        ]);
    }
    /**
     *  send email to address
     *
     * ### Example:
     ```typescript
     import { EmailService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         constructor(private emailService: EmailService){}
     
       sendEmailToAddress(templateName: string, to: User, what: AObject){
           this.emailService.sendEmailToAddress(templateName, to, what);
       }
     }
     ```
     * @param templateName name of the template to be used.
     * @param from which contact from the account to be used.
     * @param to  which Address to be used to send email.
     * @param what which account to be used.
     *
     * @returns an observable
     */
    sendEmailToAddress(templateName, from, to, what) {
        let content = TemplateMailFactory(templateName, what.Id, from.Id, [to]);
        return this.platformService.post('sendEmail', [
            content
        ]);
    }
    /**
     * Send email notification for new order to the guest user
     * ### Example:
     ```typescript
     import { EmailService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
        result;
         constructor(private emailService: EmailService){}
     
       guestUserNewOrderNotification(orderId: string, orderURL: string){
           this.emailService.guestUserNewOrderNotification(orderId, orderUrl).subscribe(res=> this.result=res);
       }
     }
     ```
     * @param orderId generated order Id.
     * @param orderURL order URL.
     * @returns an observable
     */
    guestUserNewOrderNotification(orderId, orderURL) {
        return this.platformService.post('guestUserNewOrderNotification', { orderId: orderId, ecommerceURL: orderURL }, 'EmailService', false);
    }
    /**
     * Send email notification on change status of the order
     * ### Example:
     ```typescript
     import { EmailService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
        result;
         constructor(private emailService: EmailService){}
     
       statusChangeNotification(templateName: string, id: string, recipentId: string){
           this.emailService.statusChangeNotification(templateName, id, recipentId).subscribe(res=> this.result=res);
       }
     }
     ```
     * @param templateName name of the template to be used.
     * @param id generated order/quote Id
     * @param recipentId which contact from the account to be used.
     * @param toAddresses  which Addresses to be used to send email.
     * @param ccAddresses  optional which Addresses to be used in cc to send email.
     * @param attachmentIds list of attachment Id
     * @returns an observable
    */
    statusChangeNotification(templateName, id, recipentId, toAddresses, ccAddresses, attachmentIds) {
        if (isEmpty(compact(ccAddresses)))
            ccAddresses = null;
        let content = TemplateMailFactory(templateName, id, recipentId, toAddresses, ccAddresses, attachmentIds);
        return this.platformService.post('sendEmail', { emailData: [content] });
    }
}
EmailService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: EmailService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EmailService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: EmailService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: EmailService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * @ignore
 */
class LookupService {
    constructor(platformService, metadataService) {
        this.platformService = platformService;
        this.metadataService = metadataService;
    }
    /**
     * When a user edits a lookup field, use this resource to search for and display suggestions. You can search for most recently used matches, for matching names, or for any match in a searchable field. You can also specify lookup filter bindings for dependent lookups.
     *
     * @param entity the API name of the source object
     * @param field the API name of a lookup field on the source object
     * @param params LookupRequest object
     */
    getLookupFieldSuggestions(entity, field, params) {
        const apiObjectName = encodeURIComponent(this.metadataService.getObjectName(entity));
        const fieldApiName = encodeURIComponent(this.metadataService.getFieldName(entity, field));
        const endpoint = `/ui-api/lookups/${apiObjectName}/${fieldApiName}${this.getQueryString(params)}`;
        return this.platformService.callout(endpoint, 'GET');
    }
    /**
     * When a user edits a lookup field, use this resource to search for and display suggestions for a specified object. You can search for most recently used matches, for matching names, or for any match in a searchable field. You can also specify lookup filter bindings for dependent lookups.
     *
     * @param entity the API name of the source object
     * @param field the API name of a lookup field on the source object
     * @param target the API name of the target (lookup) object
     * @param params LookupRequest object
     */
    getLookupFieldSuggestionsForObject(entity, field, target, params) {
        const apiObjectName = encodeURIComponent(this.metadataService.getObjectName(entity));
        const fieldApiName = encodeURIComponent(this.metadataService.getFieldName(entity, field));
        const endpoint = `/ui-api/lookups/${apiObjectName}/${fieldApiName}/${target}${this.getQueryString(params)}`;
        return this.platformService.callout(endpoint, 'GET');
    }
    getQueryString(params) {
        if (params && Object.keys(params).length > 0)
            return '?' + Object.keys(params)
                .filter(key => {
                const val = _.get(params, `${key}`);
                if (typeof val === 'string' || Array.isArray(val))
                    return val != null && val !== 'undefined' && val.length > 0;
                else
                    return val != null;
            })
                .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key])).join('&');
        else
            return '';
    }
}
LookupService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LookupService, deps: [{ token: i1.PlatformService }, { token: i1.MetadataService }], target: i0.ɵɵFactoryTarget.Injectable });
LookupService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LookupService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LookupService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.PlatformService }, { type: i1.MetadataService }]; } });

/**
 * @ignore
 */
class AuthorizationService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = AuthConfig;
    }
    getAuthorizationConfigurations() {
        return this.query({
            conditions: [new ACondition(this.type, 'Url', 'Equal', this.configurationService.endpoint())]
        });
    }
}
AuthorizationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AuthorizationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
AuthorizationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AuthorizationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AuthorizationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/** @ignore  */
const _moment$2 = moment;
/**
 * Assets are the products own by customer and a user may wish to renew/terminate/update existing assets.
 * <h3>Usage</h3>
 *
 ```typescript
import { AssetService, AObjectService} from '@congacommerce/ecommerce';

export class MyComponent implements OnInit{
constructor( private assetService: AssetService)
}
// or
export class MyService extends AObjectService {
     private assetService: AssetService = this.injector.get(AssetService);
 }
```
 */
class AssetService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = AssetLineItemExtended;
        this.cartService = this.injector.get(CartService);
        this.accountService = this.injector.get(AccountService);
        this.apiService = this.injector.get(ApiService);
        this.soapService = this.injector.get(SoapService);
        this.attributeGroupService = this.injector.get(ProductAttributeGroupService);
        this.storefrontService = this.injector.get(StorefrontService);
        this.userService = this.injector.get(UserService);
    }
    /**
    * The primary method to get the asset line items for given account.
    *
    * ### Example:
```typescript
import { AssetService  } from '@congacommerce/ecommerce';


export class MyComponent implements OnInit{
    assetLineItems: Array<AssetLineItem>;
    assetLineItems$: Observable<Array<AssetLineItem>>;

    constructor(private assetService: AssetService){}

    ngOnInit(){
        this.assetService.getAssetLineItemForAccount().subscribe(assetLineItems => {...});
        // or
        this.assetLineItems$ = this.assetService.getAssetLineItemForAccount();
        // or
        this.assetService.getAssetLineItemForAccount(accountId: string, adtlConditions: Array<ACondition>)subscribe(assetLineItems => {...});
        // or
        this.assetLineItems$ = this.assetService.getAssetLineItemForAccount(accountId: string, adtlConditions: Array<ACondition>);
    }
}
```
    * @override
    * @param accountId optional accountId, if accountId null then account details for logged in user is used to retrieve asset line item records
    * @param adtlConditions optional list of ACondition to filter asset line item records
    * @param sort optional list of ASort objects for sorting the results.
    * @param pageInfo optional parameter used to get page info using page size and page number.
    * @returns Observable<Array<AssetLineItemExtended>> returns an observable list of asset line item records
    */
    getAssetLineItemForAccount(accountId, adtlConditions, sort, pageInfo) {
        return this.accountService.getCurrentAccount().pipe(mergeMap(account => {
            if (account === null)
                return of(null);
            let conditionList = [];
            if (accountId) {
                conditionList.push(new ACondition(this.type, 'AccountId', 'Equal', accountId));
                conditionList.push(new ACondition(this.type, 'IsInactive', 'NotEqual', true));
            }
            else if (account && account.Id) {
                conditionList.push(new ACondition(this.type, 'AccountId', 'Equal', account.Id));
                conditionList.push(new ACondition(this.type, 'IsInactive', 'NotEqual', true));
            }
            if (adtlConditions) {
                conditionList = conditionList.concat(adtlConditions);
            }
            if (conditionList.length > 0) {
                return this.where(conditionList, 'AND', null, sort, pageInfo);
            }
            else {
                return of(null);
            }
        }));
    }
    /**
        * The primary method to renew the existing assets.
        *
        * ### Example:
```typescript
import { AssetService, AssetLineItemExtended } from '@congacommerce/ecommerce';

export class MyComponent implements OnInit{
    lineItemMap: Array<AssetLineItemExtended>;
    lineItemMap$: Observable<Array<AssetLineItemExtended>>;

    constructor(private assetService: AssetService){}

    ngOnInit(){
        this.assetService.renewAssets(assetIds: Array<string>, renewEndDate: Date, renewTerm: number, cartId: string, farthestAssetEndDate: boolean)subscribe(lineItemMap => {...});
        // or
        this.lineItemMap$ = this.assetService.renewAssets(assetIds: Array<string>, renewEndDate: Date, renewTerm: number, cartId: string, farthestAssetEndDate: boolean);
    }
}
```
        * @override
        * @param assetIds list of asset ids to renew
        * @param renewEndDate renew end date for asset renewal
        * @param renewTerm renew term for asset renewal
        * @param farthestAssetEndDate farthest asset end date for asset renewal
        * @returns Observable<Array<AssetLineItemExtended>> returns an observable list of all line items with all their field values.
    */
    renewAssets(assetIds, renewEndDate, renewTerm, farthestAssetEndDate) {
        if (isEmpty(assetIds))
            throw 'List of asset ids is not valid';
        const payload = {
            assetIds: assetIds,
            renewEndDate: renewEndDate ? _moment$2(renewEndDate).format('YYYY-MM-DD HH:mm:ss') : null,
            renewTerm: renewTerm,
            farthestAssetEndDate: farthestAssetEndDate
        };
        return this.apiService.post(`/assets/${CartService.getCurrentCartId()}/renew`, payload, this.type, null, false)
            .pipe(tap(() => this.cartService.reprice()));
    }
    /**
        * The primary method to terminate the existing assets.
        *
        * ### Example:
```typescript
import { AssetService } from '@congacommerce/ecommerce';

export class MyComponent implements OnInit{
    lineItemMap: Array<any>;
    lineItemMap$: Observable<Array<any>>;

    constructor(private assetService: AssetService){}

    ngOnInit(){
        this.assetService.cancelAssets(assetIds: Array<string>, cancelDate: Date)subscribe(lineItemMap => {...});
        // or
        this.lineItemMap$ = this.assetService.cancelAssets(assetIds: Array<string>, cancelDate: Date);
    }
}
```
        * @override
        * @param assetIds list of asset ids to terminate
        * @param cancelDate cancel date for asset termination
        * @returns Observable<Array<any>> returns an observable list of all line items with all their field values.
    */
    cancelAssets(assetIds, cancelDate) {
        return this.cartService.getMyCart().pipe(take(1), mergeMap(cart => {
            if (get(assetIds, 'length', 0) === 0)
                return throwError('List of asset ids is not valid');
            if (!cancelDate)
                return throwError('CancelDate is not valid or undefined');
            let date = new SimpleDate(cancelDate);
            let cancelAssetRequest = {
                assetIds: assetIds,
                cancelDate: date.getSimpleDate()
            };
            return this.apiService.post(`/assets/${cart.Id}/terminate`, cancelAssetRequest, this.type, null, false)
                .pipe(tap(() => this.cartService.reprice()));
        }));
    }
    /**
        * The primary method to increment the existing assets.
        *
        * ### Example:
```typescript
import { AssetService, IncrementAssetDO, IncrementLineAction } from '@congacommerce/ecommerce';

export class MyComponent implements OnInit{
    lineItemMap: Array<any>;
    lineItemMap$: Observable<Array<any>>;

    constructor(private assetService: AssetService){}

    ngOnInit(){
        this.assetService.incrementAssets(incrementAssetDO: Array<IncrementAssetDO>)subscribe(lineItemMap => {...});
        // or
        this.lineItemMap$ = this.assetService.incrementAssets(incrementAssetDO: Array<IncrementAssetDO>);
    }
}
```
        * @override
        * @param incrementAssetDOs list of increment asset data objects for incrementing the existing assets
        * @returns Observable<Array<any>> returns an observable list of all line items with all their field values.
    */
    incrementAssets(incrementAssetDOs) {
        return this.cartService.getMyCart().pipe(take(1), mergeMap(cart => {
            if (get(incrementAssetDOs, 'length', 0) === 0)
                return throwError('List of increment asset object is not valid');
            let incrementAssetRequest = {
                cartId: cart.Id,
                incrementAssetDOs: incrementAssetDOs
            };
            return this.apiService.post(`/assets/${cart.Id}/increment`, incrementAssetRequest, this.type, null, false)
                .pipe(tap(() => this.cartService.reprice()));
        }));
    }
    /**
    * The primary method to amend the existing assets.
    *
    * ### Example:
```typescript
import { AssetService } from '@congacommerce/ecommerce';

export class MyComponent implements OnInit{
    lineItemMap: Array<any>;
    lineItemMap$: Observable<Array<any>>;

    constructor(private assetService: AssetService){}

    ngOnInit(){
        this.assetService.amendAssets(assetIds: Array<string>)subscribe(lineItemMap => {...});
        // or
        this.lineItemMap$ = this.assetService.amendAssets(assetIds: Array<string>);
    }
}
```
    * @override
    * @param assetIds list of asset ids to amend
    * @returns Observable<Array<any>> returns an observable list of all line items with all their field values.
    */
    amendAssets(assetIds) {
        return this.cartService.getMyCart().pipe(take(1), mergeMap(cart => {
            if (get(assetIds, 'length', 0) === 0)
                return throwError('List of asset ids is not valid');
            let amendAssetRequest = {
                assetIds: assetIds
            };
            return this.apiService.post(`/assets/${cart.Id}/amend`, amendAssetRequest, null, null, false)
                .pipe(switchMap((res) => combineLatest([of(values(res)), this.getAssetsLineItemsById(keys(res))])), map$1(([cartItems, assetLineItems]) => {
                forEach(cartItems, (cartItem) => {
                    const assetLineItem = find(assetLineItems, { 'Id': cartItem.Apttus_Config2__AssetLineItemId__c });
                    set(cartItem, 'AssetLineItem', assetLineItem);
                });
                set(cart, 'LineItems', cartItems);
                this.cartService.publish(cart);
            }), tap(() => this.cartService.reprice()));
        }));
    }
    groupFormItems(items) {
        return null;
    }
    /**
     * This method returns the bundled options for the asset line item passed.
     * @param assetLineItem Instance of the quote line item passed.
     * @returns An observable containing the array of asset line items for a given asset line item.
     */
    getBundleItemsForAssetLineItem(assetLineItem) {
        const assetLineItem$ = (typeof assetLineItem === 'string') ? this.get([assetLineItem]).pipe(map$1(res => res[0])) : of(assetLineItem);
        return assetLineItem$.pipe(mergeMap(item => this.where([
            new ACondition(this.type, 'BundleAssetId', 'Equal', item.Id)
        ])));
    }
    /**
    * The primary method to swap the existing assets. Creates line items for the cancelled asset line item and new line items for swapped product.
    *
    * ### Example:
```typescript
import { AssetService } from '@congacommerce/ecommerce';

export class MyComponent implements OnInit{
    lineItemMap: Array<any>;
    lineItemMap$: Observable<Array<any>>;

    constructor(private assetService: AssetService){}

    ngOnInit(){
        this.assetService.swapAssets(assetIds: Array<string>)subscribe(lineItemMap => {...});
        // or
        this.lineItemMap$ = this.assetService.swapAssets(assetIds: Array<string>);
    }
}
```
    * @override
    * @param assetIds list of asset ids which are swapped
    * @param productIds list of ids of the product with which the asset is being swapped
    * @param newStartDate new asset start date on swapping
    * @returns Observable<Array<any>> returns an observable list of all line items with all their field values.
    */
    swapAssets(assetIds, productIds, newStartDate) {
        return this.cartService.getMyCart().pipe(take(1), mergeMap(cart => {
            if (get(assetIds, 'length', 0) === 0 || get(productIds, 'length', 0) === 0)
                return of(null);
            return this.apiService.post('swapAssets', { cartId: cart.Id, assetIds: assetIds, productIds: productIds, newStartDate: newStartDate }, this.type, null, false)
                .pipe(tap(() => this.cartService.reprice()));
        }));
    }
    /**
    * This method can be used to get the asset line items for given set of products.
    * ABO must be enabled in the storefront to get asset line item records.
    * ### Example:
```typescript
import { AssetService } from '@congacommerce/ecommerce';

export class MyComponent implements OnInit{
    assetLineItems: Array<AssetLineItem>;
    assetLineItems$: Observable<Array<AssetLineItem>>;

    constructor(private assetService: AssetService){}

    ngOnInit(){
        this.assetService.getAssetLineItemsforProducts(products: Array<Product>).subscribe(assetLineItems => {...});
        // or
        this.assetLineItems$ = this.assetService.getAssetLineItemsforProducts(products: Array<Product>);
    }
}
```
    * @override
    * @param productList array of products or an array of string representing product ids.
    * @returns Observable<Array<AssetLineItemExtended>> returns an observable list of asset line item records.
    */
    getAssetLineItemsforProducts(productList) {
        if (get(productList, 'length') > 0) {
            let productIds = null;
            if (every(productList, item => typeof (item) === 'string')) {
                productIds = map(productList, p => p).join(',');
            }
            else {
                productIds = map(productList, p => p.Id).join(',');
            }
            return combineLatest([this.storefrontService.getStorefront(), this.userService.isLoggedIn()])
                .pipe(switchMap(([storefront, isLoggedIn]) => {
                if (storefront.EnableABO && isLoggedIn) {
                    return this.query({
                        conditions: [
                            new ACondition(this.type, 'Product.Id', 'In', productIds)
                        ],
                        filters: [
                            new AFilter(this.type, [
                                new ACondition(this.type, 'LineType', 'NotEqual', 'Option'),
                                new ACondition(this.type, 'Product.ConfigurationType', 'NotEqual', 'Option'),
                                new ACondition(this.type, 'IsPrimaryLine', 'Equal', true)
                            ])
                        ]
                    });
                }
                else {
                    return of(null);
                }
            }));
        }
        else {
            return of(null);
        }
    }
    /**
     * Method will return the details of asset details for a given assetLineItemId.
    *
    * ### Example:
```typescript
import { AssetService  } from '@congacommerce/ecommerce';


export class MyComponent implements OnInit{
    assetLineItems: Array<AssetLineItem>;
    assetLineItems$: Observable<Array<AssetLineItem>>;

    constructor(private assetService: AssetService){}

    ngOnInit(){
        this.assetService.getAssetLineItemById().subscribe(assetLineItems => {...});
        // or
        this.assetLineItems$ = this.assetService.getAssetLineItemById();
        // or
        this.assetService.getAssetLineItemById(assetIds:Array<string>)subscribe(assetLineItems => {...});
        // or
        this.assetLineItems$ = this.assetService.getAssetLineItemById(assetIds:Array<string>);
    }
}
```
    
     * @param assetIds An array of asset ids.
     * @returns It will return an array of assetLineItem details.
    */
    getAssetsLineItemsById(assetIds) {
        const ids = assetIds.toString();
        return this.apiService.post('/Apttus_Config2__AssetLineItem__c/query', {
            'alias': false,
            'conditions': [
                {
                    'field': 'Id',
                    'filterOperator': 'In',
                    'value': ids
                }
            ],
        }, this.type, null, false);
    }
}
AssetService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
AssetService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetService, providedIn: 'root' });
__decorate([
    memoize(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", Observable)
], AssetService.prototype, "getAssetLineItemsforProducts", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], propDecorators: { getAssetLineItemsforProducts: [] } });

/** @ignore  */
const _moment$1 = moment;
/**
 * Products are the goods for buy /sell with its detailed information. The service provides methods for interacting with the products.
 *
 * <h3>Usage</h3>
 *
 ```typescript
 import { ProductService } from '@congacommerce/ecommerce';

 constructor(private productService: ProductService) {}

 // or

 export class MyService extends AObjectService {
     private productService: ProductService = this.injector.get(ProductService);
  }
 ```
 */
class ProductService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = Product;
        this.plService = this.injector.get(PriceListService);
        this.pliService = this.injector.get(PriceListItemService);
        this.categoryService = this.injector.get(CategoryService);
        this.translatorService = this.injector.get(TranslatorLoaderService);
        this.turboApiService = this.injector.get(TurboApiService);
        this.assetService = this.injector.get(AssetService);
        this.productCategoryService = this.injector.get(ProductCategoryService, 'productCategoryService');
    }
    /**
     * @ignore
     */
    onWhere(recordList) {
        return this.translatorService.translateData(recordList);
    }
    /**
     * @ignore
     *
     */
    //  Filter products with invalid effective/expiration dates as turbo APIs don't handle it.
    filterInvalidProducts(products) {
        let productList = [];
        if (get(products, 'length') > 0) {
            const today = _moment$1(new Date()).valueOf();
            productList = filter(products, p => {
                const pli = defaultTo(find(get(p, 'PriceLists', []), (item) => item.ChargeType === ChargeType.StandardPrice || item.ChargeType === ChargeType.Subscription), get(p, 'PriceLists[0]'));
                const isProductExpired = (!isNil(p.ExpirationDate) && p.ExpirationDate < today) || (!isNil(p.EffectiveDate) && p.EffectiveDate > today);
                const isPliExpired = isNil(pli) || isNil(pli.ListPrice) || (!isNil(pli.ExpirationDate) && pli.ExpirationDate < today) || (!isNil(pli.EffectiveDate) && pli.EffectiveDate > today);
                if (!isProductExpired && !isPliExpired)
                    return p;
            });
        }
        return productList;
    }
    /**
     * This method is used to search products by search string
     *
     * ###Example
     ```typescript
        import { ProductService } from '@congacommerce/ecommerce';

        export class MyComponent implements OnInit{
            products: Array<Product>;
            products$: Observable<Array<Product>>;
        
            constructor(private productService: ProductService){}
        
            ngOnInit(){
                this.productService.searchProducts(searchString: string).subscribe(products => {...});
                // or
                this.products$ = this.productService.searchProducts(searchString: string);
            }
        }
        ```
     *
     * @param searchString: search term
     * @param fieldList: fields which you want to fetch separated by comma e.g 'Name,ProductCode'
     * @param limit: number of records
     * @override
     * @param searchString string to search the products with. Minimum characters in the search string must be 3.
     * @param limit a number representing the number of product records expected in the result set.
     * @param fetchTranslations boolean to fetch translations for the records searched. Default value is true.
     * @return Observable<Array<Product>> returns an observable list of product records.
     */
    searchProducts(searchString, limit = 5, fetchTranslations = true) {
        // Turbo API supports search with minimum 3 characters in the search string.
        if (searchString && searchString.length > 2) {
            return this.plService.getPriceListId().pipe(switchMap(priceListId => this.turboApiService.get(`/pricing/dataadmin/turbo/search/pricelists/${priceListId}/products?searchString=${searchString}&fetchTranslations=${fetchTranslations}&pageSize=${limit}`, ProductResult, false)), switchMap(result => this.translatorService.translateData(get(result, 'Products'))), map$1(products => this.filterInvalidProducts(products)));
        }
        else
            return of(null);
    }
    /**
    * This method can be used to get the fetch the list of products by product code.
    * ### Example:
```typescript
import { Product, ProductService } from '@congacommerce/ecommerce';

export class MyComponent implements OnInit{
    products: Array<Product>;
    products$: Observable<Array<Product>>;

    constructor(private productService: ProductService){}

    ngOnInit(){
        this.productService.getProductsByCode(productCodeList: Array<string>).subscribe(products => {...});
        // or
        this.products$ = this.productService.getProductsByCode(productCodeList: Array<string>);
    }
}
```
    * @override
    * @param productCodeList Array of string represnting the list of product codes.
    * @return Observable<Array<Product>> returns an observable list of product records.
    */
    getProductsByCode(productCodeList) {
        return this.where([
            new ACondition(this.type, 'ProductCode', 'In', productCodeList.map(code => code))
        ]).pipe(flatMap(productList => this.translatorService.translateData(productList)));
    }
    /**
    * This method can be used to get the fetch the list of ProductResults
    * including total product count, for a given price list and category.
    * ### Example:
```typescript
import { Product, ProductService } from '@congacommerce/ecommerce';

export class MyComponent implements OnInit{
    products: Array<Product>;
    products$: Observable<Array<Product>>;

    constructor(private productService: ProductService){}

    ngOnInit(){
        this.productService.getProducts(categories: Array<string>,
            pageSize: number,
            pageNumber: number,
            orderBy: string,
            orderDirection: 'ASC' | 'DESC',
            searchString: string,
            adtlConditions: Array<ACondition>
            ).subscribe(products => {...});
        // or
        this.products$ = this.productService.getProducts(categories: Array<string>,
            pageSize: number,
            pageNumber: number,
            orderBy: string,
            orderDirection: 'ASC' | 'DESC',
            searchString: string,
            adtlConditions: Array<ACondition>
            );
    }
}
```
    * @override
    * @param categories List of categories the products belong to.
    * @param pageSize
    * @param pageNumber
    * @param orderBy string representing the sort field on result set.
    * @param orderDirection to sort the result sets. Default value is Asending.
    * @param searchString to search products matching the string.
    * @param adtlConditions list of additional AConditions to filter the product list.
    * @param fetchProductFeatures boolean to fetch product feature values. Defaulted to true.
    * @param fetchTranslations boolean to fetch product translations. Default value is true.
    * @return Observable<Array<ProductResult>> returns an observable list of ProductResult.
    */
    getProducts(categories, pageSize = 10, pageNumber = 1, orderBy = null, orderDirection = null, searchString = null, adtlConditions = null, fetchProductFeatures = true, fetchTranslations = true) {
        let queryparam = new URLSearchParams();
        orderBy && queryparam.append('sortField', orderBy);
        orderDirection && queryparam.append('sortOrder', orderDirection);
        searchString && queryparam.append('searchString', searchString);
        if (isEmpty(adtlConditions) && (isEmpty(categories) || isNil(categories))) {
            return this.plService.getPriceListId()
                .pipe(switchMap(priceListId => this.turboApiService.get(`/pricing/dataadmin/turbo/search/pricelists/${priceListId}/products?${queryparam.toString()}&fetchProductFeatures=${fetchProductFeatures}&fetchTranslations=${fetchTranslations}&pageSize=${pageSize}&pageNumber=${pageNumber}`)), switchMap(result => {
                const productResult = plainToClass(ProductResult, result, { excludeExtraneousValues: true });
                const products = this.filterInvalidProducts(get(productResult, 'Products'));
                const assetLineItems$ = this.assetService.getAssetLineItemsforProducts(products);
                return combineLatest([this.translatorService.translateData(products), of(productResult.TotalCount), assetLineItems$]);
            }), map$1(([products, totalCount, assetLineItems]) => {
                map(products, product => set(product, 'AssetLineItems', filter(assetLineItems, asset => asset.ProductId === product.Id)));
                return {
                    Products: products,
                    TotalCount: totalCount
                };
            }));
        }
        else if (!isEmpty(adtlConditions) || get(categories, 'length') > 1) {
            const queryOptions = {
                conditions: adtlConditions,
                page: new APageInfo(pageSize, pageNumber),
                sortOrder: [new ASort(this.type, orderBy, orderDirection)],
                searchString: searchString,
                alias: false,
                filters: [
                    new AFilter(this.type, [
                        new ACondition(this.type, 'Apttus_Config2__EffectiveDate__c', 'LessEqual', 'TODAY'),
                        new ACondition(this.type, 'Apttus_Config2__EffectiveDate__c', 'Null', null)
                    ], null, 'OR'),
                    new AFilter(this.type, [
                        new ACondition(this.type, 'Apttus_Config2__ExpirationDate__c', 'GreaterEqual', 'TODAY'),
                        new ACondition(this.type, 'Apttus_Config2__ExpirationDate__c', 'Null', null)
                    ], null, 'OR')
                ],
                children: [
                    {
                        field: 'PriceLists'
                    },
                    {
                        field: 'Apttus_Config2__ProductFeatureValues__r',
                        lookups: [
                            {
                                field: 'Apttus_Config2__FeatureId__c',
                                lookups: [{ field: 'Apttus_Config2__FeatureSetId__c' }]
                            }
                        ]
                    },
                    {
                        field: 'Apttus_Config2__Translation__r'
                    }
                ]
            };
            if (!isEmpty(categories))
                set(queryOptions, 'joins', [
                    new AJoin(this.productCategoryService.type, 'Id', 'ProductId', [new ACondition(this.productCategoryService.type, 'ClassificationId', 'In', categories)])
                ]);
            return combineLatest([this.query(queryOptions), this.query(assign({ aggregate: true }, queryOptions))])
                .pipe(switchMap(([products, aggregate]) => {
                const assetLineItems$ = this.assetService.getAssetLineItemsforProducts(products);
                return combineLatest([this.translatorService.translateData(products), of(aggregate), assetLineItems$]);
            }), map$1(([products, aggregate, assetLineItems]) => {
                map(products, product => {
                    set(product, 'AssetLineItems', filter(assetLineItems, asset => asset.ProductId === product.Id));
                });
                return {
                    Products: products,
                    TotalCount: get(aggregate, '[0].total_records')
                };
            }));
        }
        else {
            return this.plService.getPriceListId()
                .pipe(switchMap(priceListId => this.turboApiService.get(`/pricing/dataadmin/turbo/search/pricelists/${priceListId}/categories/${first(categories)}/products?${queryparam.toString()}&fetchTranslations=${fetchTranslations}&pageSize=${pageSize}&pageNumber=${pageNumber}`)), switchMap(result => {
                const productResult = plainToClass(ProductResult, result, { excludeExtraneousValues: true });
                const products = this.filterInvalidProducts(get(productResult, 'Products'));
                const assetLineItems$ = this.assetService.getAssetLineItemsforProducts(products);
                return combineLatest([this.translatorService.translateData(products), of(productResult.TotalCount), assetLineItems$]);
            }), map$1(([products, totalCount, assetLineItems]) => {
                map(products, product => set(product, 'AssetLineItems', filter(assetLineItems, asset => asset.ProductId === product.Id)));
                return {
                    Products: products,
                    TotalCount: totalCount
                };
            }));
        }
    }
    /**
    * This method can be used to get the fetch the product details for a given product identifier.
    * It will return all the configurations of a bundle including option and attribute groups.
    * ### Example:
```typescript
import { Product, ProductService } from '@congacommerce/ecommerce';

export class MyComponent implements OnInit{
    product: Product;
    product$: Observable<Product>;

    constructor(private productService: ProductService){}

    ngOnInit(){
        this.productService.fetch(id: string).subscribe(product => {...});
        // or
        this.product$ = this.productService.fetch(id: string);
    }
}
```
    * @override
    * @param id represnting the product identifier.
    * @return Observable<Product> returns an observable of product record.
    */
    fetch(id) {
        const subject = new BehaviorSubject(null);
        this.plService.getPriceListId()
            .pipe(switchMap(priceListId => {
            const productRes$ = this.turboApiService.get(`/pricing/dataadmin/turbo/search/pricelists/${priceListId}/products/${id}`);
            const assetLineItems$ = this.assetService.getAssetLineItemsforProducts([id]);
            const productCategories$ = this.categoryService.getCategoriesByProductId(id);
            return combineLatest([productRes$, assetLineItems$, productCategories$, this.categoryService.getCategories()]);
        }), switchMap(([productRes, assetLineItems, productCategories, categories]) => {
            const product = plainToClass(this.type, get(productRes, 'Entity'), { excludeExtraneousValues: true });
            set(product, 'AssetLineItems', assetLineItems);
            set(product, 'Categories', productCategories);
            return this.translatorService.translateData([product], categories);
        }), map$1(first), take(1)).subscribe(product => subject.next(product));
        return subject.pipe(filter$1(r => r != null));
    }
}
ProductService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ProductService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductService, providedIn: 'root' });
__decorate([
    MemoizeAll(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Observable)
], ProductService.prototype, "fetch", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], propDecorators: { fetch: [] } });

/**
 * The order line item object represents an order line item in Apttus. Only order line item for given order will be returned by this service.
 * <h3>Usage</h3>
 *
  ```typescript
 import { OrderLineItemService, AObjectService} from '@congacommerce/ecommerce';
 
 export class MyComponent implements OnInit{
 constructor( private orderLineItemService: OrderLineItemService)
 }
 // or
 export class MyService extends AObjectService {
      private orderLineItemService: OrderLineItemService = this.injector.get(OrderLineItemService);
  }
 ```
 */
class OrderLineItemService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = OrderLineItem;
    }
    /**
     * method returns a list of order line items for the order
     * ### Example:
```typescript
import { OrderLineItemService, OrderLineItem } from '@congacommerce/ecommerce';
import { Observable } from 'rxjs/Observable';

export class MyComponent implements OnInit{
    orderLineItemList: Array<OrderLineItem>;
    orderLineItemList$: Observable<Array<OrderLineItem>>;

    constructor(private orderLineItemService: OrderLineItemService){}

    ngOnInit(){
        this.orderLineItemService.getOrderLineItemsForOrder(orderId: string).subscribe(o => this.orderLineItemList = o);
        // or
        this.orderLineItemList$ = this.orderLineItemService.getOrderLineItemsForOrder(orderId: string);
    }
}
```
     * @override
     * @param orderId the order id to filter the order line items results
     * @param days the number of days into the past with which to retrieve orders. If left empty, will retrieve all orders
     * @param limit the total number of records to return
     * @param offset the offset of the records to return (i.e. records 10-20, the offset will be 10)
     * @param orderBy the field by which to order the records
     * @param orderDirection the direction in which to sort the records
     * @returns an observable array of order line items
     */
    getOrderLineItemsForOrder(orderId = null, days, limit = 10, pageNumber = 0, orderBy = 'CreatedDate', orderDirection = 'DESC') {
        const conditions = [];
        if (orderId)
            conditions.push(new ACondition(this.type, 'OrderId', 'Equal', orderId));
        return this.where(conditions, 'AND', null, [
            new ASort(this.type, orderBy, orderDirection)
        ], new APageInfo(limit, pageNumber), null);
    }
    /**
         * This method returns  list of order line items for the given orderId
         * ### Example:
    ```typescript
    import { OrderLineItemService, OrderLineItem } from '@congacommerce/ecommerce';
    import { Observable } from 'rxjs/Observable';
    
    export class MyComponent implements OnInit{
        orderLineItemList: Array<OrderLineItem>;
        orderLineItemList$: Observable<Array<OrderLineItem>>;
    
        constructor(private orderLineItemService: OrderLineItemService){}
    
        ngOnInit(){
            this.orderLineItemService.getOrderLineItems(orderId: string).subscribe(o => this.orderLineItemList = o);
            // or
            this.orderLineItemList$ = this.orderLineItemService.getOrderLineItems(orderId: string);
        }
    }
    ```
         * @override
         * @param orderId the order id to fetch the related order line items results
         * @returns an observable array of order line items
         */
    getOrderLineItems(orderId = null) {
        return this.platformService.apiService.post('/Apttus_Config2__OrderLineItem__c/query', {
            'conditions': [
                {
                    'field': 'OrderId',
                    'filterOperator': 'Equal',
                    'value': orderId
                }
            ],
            'lookups': [
                {
                    'field': 'Apttus_Config2__ProductId__c'
                },
                {
                    'field': 'Apttus_Config2__AttributeValueId__c'
                }
            ],
            'children': [{
                    'field': 'Apttus_Config2__OrderTaxBreakups__r'
                }]
        }, this.type, null);
    }
}
OrderLineItemService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OrderLineItemService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
OrderLineItemService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OrderLineItemService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OrderLineItemService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * The quote represents a price breakdown for a given product configuration. Quotes are generally associated with an approval process and can be converted to a cart or an order.
 *
 * <h3>Usage</h3>
 *
 ```typescript
    import { QuoteLineItemService } from '@congacommerce/ecommerce';
 *
    constructor(private quoteLineItemService: QuoteLineItemService) { }

// or

    export class MyService extends AObjectService {
     private quoteLineItemService: QuoteLineItemService = this.injector.get(QuoteLineItemService);
    }
 ```
 */
class QuoteLineItemService extends LineItemService {
    constructor() {
        super(...arguments);
        this.type = QuoteLineItem;
    }
    /**
     * This method returns the quote line item with adjustment details.
     * ### Example:
     ```typescript
     import { QuoteLineItemService, QuoteLineItem } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';

     export class MyComponent implements OnInit{
    quoteLineItem: OrderLineItem;
    quoteLineItem$: Observable<OrderLineItem>;

    constructor(private quoteLineItemService: QuoteLineItemService){}

    ngOnInit(){
        this.quoteLineItemService.getPromotionDetailsForQuoteLineItem(lineItemId: string).subscribe(o => this.quoteLineItem = o);
        // or
        this.quoteLineItem$ = this.quoteLineItemService.getPromotionDetailsForQuoteLineItem(lineItemId: string);
    }
}
     ```
     * This method returns the adjustment items on a given quote line item.
     * @param lineItemId Id of the quote line item.
     * @returns An observable containing the given quote line item with adjustment item details.
     */
    getPromotionDetailsForQuoteLineItem(lineItemId) {
        return this.where([new ACondition(this.type, 'Id', 'Equal', lineItemId)]);
    }
    /**
     * This method returns the bundled options for the quote line item passed.
     * ### Example:
     ```typescript
     import { QuoteLineItemService, QuoteLineItem } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';

     export class MyComponent implements OnInit{
         quoteLineItem$: Observable<OrderLineItem>;
         quoteLineItem: OrderLineItem;

     constructor(private quoteLineItemService: QuoteLineItemService){}
         
     ngOnInit(){
        this.quoteLineItemService.getBundleItemsForQuoteLineItem(lineItemId: string).subscribe(o => this.quoteLineItem = o);
        // or
        this.quoteLineItem$ = this.quoteLineItemService.getBundleItemsForQuoteLineItem(lineItemId: string);
            }
        }
     ```
     * @param quoteLineItem Instance of the quote line item passed.
     * @returns An observable containing the array of option line items for a given quote line item.
     */
    getBundleItemsForQuoteLineItem(quoteLineItem) {
        const quoteLineItem$ = (typeof quoteLineItem === 'string') ? this.get([quoteLineItem]).pipe(map$1(res => res[0])) : of(quoteLineItem);
        return quoteLineItem$.pipe(mergeMap((item) => this.where([
            new ACondition(this.type, 'ParentBundleNumber', 'Equal', item.LineNumber),
            new ACondition(this.type, 'Proposal', 'Equal', item.ProposalId)
        ])));
    }
    /**
           * This method returns  list of quote line items for the given quoteId
           * ### Example:
      ```typescript
      import { QuoteLineItemService, QuoteLineItem } from '@congacommerce/ecommerce';
      import { Observable } from 'rxjs/Observable';
      
      export class MyComponent implements OnInit{
          QuoteLineItemList: Array<QuoteLineItem>;
          QuoteLineItemList$: Observable<Array<QuoteLineItem>>;
      
          constructor(private quoteLineItemService:QuoteLineItemService){}
      
          ngOnInit(){
              this.quoteLineItemService.getQuoteLineItems(quoteId: string).subscribe(o => this.quoteLineItemList = o);
              // or
              this.quoteLineItemList$ = this.quoteLineItemService.getQuoteLineItems(quoteId: string);
          }
      }
      ```
           * @override
           * @param quoteId the quote id to fetch the related quote line items results
           * @returns an observable array of quote line items
           */
    getQuoteLineItems(quoteId) {
        return this.platformService.apiService.post('/Apttus_Proposal__Proposal_Line_Item__c/query', {
            'conditions': [
                {
                    'field': 'ProposalId',
                    'filterOperator': 'Equal',
                    'value': quoteId
                }
            ],
            'lookups': [
                {
                    'field': 'Apttus_Proposal__Product__c'
                },
                {
                    'field': 'Apttus_QPConfig__AttributeValueId__c'
                }
            ],
            'children': [{
                    'field': 'Apttus_QPConfig__TaxBreakups__r'
                }]
        }, this.type, null);
    }
}
QuoteLineItemService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: QuoteLineItemService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
QuoteLineItemService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: QuoteLineItemService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: QuoteLineItemService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/** @ignore  */
const _moment = moment;
/**
 * Product options service provide you different functions related to product options.
 *
 * <h3>Usage</h3>
 *
 ```typescript
 import { ProductOptionService } from '@congacommerce/ecommerce';
 
 constructor(private productOptionService: ProductOptionService) {}
 
 // or
 
 export class MyService extends AObjectService {
      private productOptionService: ProductOptionService = this.injector.get(ProductOptionService);
  }
 ```
 */
class ProductOptionService extends ProductService {
    constructor() {
        super(...arguments);
        this.type = Product;
        this.productAttributeValueService = this.injector.get(ProductAttributeValueService);
        this.assetService = this.injector.get(AssetService);
        this.lineItemService = this.injector.get(LineItemService);
        this.cartItemService = this.injector.get(CartItemService);
        this.cartService = this.injector.get(CartService);
        this.productService = this.injector.get(ProductService);
        this.plService = this.injector.get(PriceListService);
        this.turboService = this.injector.get(TurboApiService);
    }
    /**
    * Method takes a bundle product record and organizes the attributes and options into it's tree structure. Will filter out any attributes or option groups
    * that are empty and associate related cart items with each option
    *
    * ### Example:
    ```typescript
    import { ProductOptionService, Product } from '@congacommerce/ecommerce';
    import { Observable } from 'rxjs/Observable';

    export class MyComponent implements OnInit{
          product$: Observable<Product>;

          constructor(private productOptionService: ProductOptionService){}

          ngOnInit(){
               this.product$ = this.productOptionService.getProductOptionTree(productId:string);
          }
     }
    ```
    *
    * @param productId Id of the product is of type string
    * @param relatedTo Related primary line item
    * @param applyFilter accepts 'none' | 'items' | 'changes', By default the value is set as 'none', i.e no filter is applied. If the applyFilter is 'items' it returns
    * options are selected. If the applyFilter is 'changes' it returns the attributes/options that are changed, required for helper method 'groupOptionGroups'
    * @param changes Changes accepts list fo cartItems.
    * @returns returns an observable of Product
    */
    getProductOptionTree(productId, relatedTo, applyFilter = 'none', changes) {
        return combineLatest([this.fetch(productId), this.cartService.getMyCart(), this.productAttributeValueService.describe()])
            .pipe(switchMap(([product, cart, metadata]) => {
            if (product) {
                set(product, 'ProductAttributeMatrixViews', filter(get(product, 'ProductAttributeMatrixViews'), r => r.Active));
                remove(get(product, 'ProductAttributeMatrixViews'), r => {
                    const expiredate = _moment(r.AttributeValueMatrix.ExpirationDate).format('YYYY-MM-DD');
                    return _moment(expiredate).isBefore(_moment(new Date()).format('YYYY-MM-DD'));
                });
                let cartItems$ = this.cartItemService.getCartItemsForProduct(product, 1, cart);
                if (!isEmpty(changes))
                    cartItems$ = of(changes);
                else if (!isNil(get(relatedTo, 'AssetLineItem')))
                    cartItems$ = this.cartItemService.getCartItemsForAsset(relatedTo, cart);
                else if (!isNil(relatedTo))
                    cartItems$ = this.cartItemService.getOptionsForItem(relatedTo, cart);
                return cartItems$.pipe(map$1(cartItems => {
                    const bundleProduct = cloneDeep(product);
                    const cartItem = find(cartItems, (i) => get(i, 'LineType') === 'Product/Service');
                    const attrValue = isNil(changes) ? defaultTo(get(relatedTo, 'AttributeValue', get(cartItem, 'AttributeValue')), new ProductAttributeValue()) : get(cartItem, 'AttributeValue');
                    set(cartItem, 'AttributeValue', attrValue);
                    bundleProduct.set('item', cloneDeep(cartItem));
                    return this.groupOptionGroups(bundleProduct, attrValue, cartItems, applyFilter, metadata, null);
                }));
            }
            else
                return of(null);
        }));
    }
    /**
     * This method returns a list of product options components configured for the bundle product.
     * Uses '@MemoizeAll()' decorator imported from 'lodash-decorators', only caches items that you actually use -- but
     * holds on to all the cached items forever.
     *
     * ### Example:
     ```typescript
     import { ProductOptionService, ProductOptionComponent } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';

     export class MyComponent implements OnInit{
           product$: Array<ProductOptionComponent>;

           constructor(private productOptionService: ProductOptionService){}

           ngOnInit(){
                this.product$ = this.productOptionService.getProductOptions(product: Product);
           }
      }
     ```
     * @param product instance of product object.
     * @returns an Array of ProductOptionComponent.
     */
    getProductOptions(product) {
        const items = [];
        const handleComponent = (c) => {
            items.push(c);
            forEach(get(c, 'ComponentProduct.OptionGroups', []), handleGroup);
        };
        const handleGroup = (g) => {
            forEach(get(g, 'ChildOptionGroups', []), handleGroup);
            forEach(get(g, 'Options'), handleComponent);
        };
        forEach(get(product, 'OptionGroups', []), (og) => handleGroup(og));
        return items;
    }
    /**
    * This method returns list of ProductOptionComponent filters out ProductOptionComponent which is not associated
    * with the group parameter.
     *
     * ### Example:
     ```typescript
     import { ProductOptionService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';

     export class MyComponent implements OnInit{
           productOptionGroup$: Array<ProductOptionComponent>;

           constructor(private productOptionService: ProductOptionService){}

           ngOnInit(){
                this.productOptionGroup$ = this.productOptionService.getProductOptionsForGroup(product: Product, group: ProductOptionGroup);
           }
      }
     ```
    * @param product Instance of a  product to process
    * @param group  Instance of a product option group
    * @returns an array of ProductoptionComponent.
    */
    getProductOptionsForGroup(product, group) {
        const items = [];
        const handleComponent = (c) => {
            if (group.Id === c.ProductOptionGroupId) {
                items.push(c);
            }
            forEach(get(c, 'ComponentProduct.OptionGroups', []), handleGroup);
        };
        const handleGroup = (g) => {
            forEach(get(g, 'ChildOptionGroups', []), handleGroup);
            forEach(get(g, 'Options'), handleComponent);
        };
        forEach(get(product, 'OptionGroups', []), (og) => handleGroup(og));
        return items;
    }
    /**
     * This method is responsible for creating the tree structure by looping through attribute groups and option groups in recursive fashion and generate tree structure keeping the
     * primary bundle product as the root.
     *
     * ### Example:
     ```typescript
     import { ProductOptionService, Product } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';

     export class MyComponent implements OnInit{
           Product$: Product;

           constructor(private productOptionService: ProductOptionService){}

           ngOnInit(){
                this.Product$ = this.productOptionService.groupOptionGroups(p: Product
                        , attributeValue: ProductAttributeValue
                        , relatedItems: Array<CartItem | QuoteLineItem | AssetLineItem | OrderLineItem>
                        , applyFilter: 'none' | 'items' | 'changes' = 'none'
                        , metadata: any
                        , parentItem?: CartItem | QuoteLineItem | AssetLineItem | OrderLineItem);
                    }
      }
     ```
     * @param p is an instance of product object.
     * @param attributeValue is an instance of product attribute value object.
     * @param relatedItems is a list of CartItem | QuoteLineItem | AssetLineItem | OrderLineItem object.
     * @param applyFilter accepts 'none' | 'items' | 'changes', By default the value is set as 'none', i.e no filter is applied. If the applyFilter is 'items' it returns
     * options are selected. If the applyFilter is 'changes' it returns the attributes/options that are changed.
     * @param metadata is the metadata information of the related object.
     * @param parentItem is an instance of CartItem | QuoteLineItem | AssetLineItem | OrderLineItem object.
     * @returns product object.
     */
    groupOptionGroups(p, attributeValue, relatedItems, applyFilter = 'none', metadata, parentItem) {
        let optionGroups = get(p, 'OptionGroups', []);
        let attributeGroupMembers = get(p, 'AttributeGroups', []);
        const changedStatus = [LineStatus.Amend, LineStatus.Upgrade, LineStatus.Cancel, LineStatus.New];
        parentItem = defaultTo(parentItem, find(relatedItems, i => get(i, 'LineType') === 'Product/Service' && i.IsPrimaryLine === true));
        // sort the list of ProductAttributes with in attribute groups.
        forEach(attributeGroupMembers, member => {
            set(member, 'AttributeGroup.ProductAttributes', sortBy(get(member, 'AttributeGroup.Attributes', []), 'Sequence'));
        });
        const assetAttributeValue = get(parentItem, 'Asset.AttributeValue', get(parentItem, 'AttributeValue'));
        if (!isEmpty(attributeGroupMembers) && applyFilter === 'items' || applyFilter === 'changes') {
            forEach(attributeGroupMembers, member => {
                set(member, 'AttributeGroup.Attributes', filter(get(member, 'AttributeGroup.Attributes'), (attribute) => {
                    // If the passed filter is "changes" then return the attributes that are changed.
                    if (applyFilter === 'changes') {
                        return get(assetAttributeValue, attribute.Field) !== get(attributeValue, attribute.Field);
                    }
                    return (!isNil(attributeValue)
                        ? !isNil(get(attributeValue, attribute.Field))
                        : !isNil(SalesforceUtils.getDefaultValue(find(get(metadata, 'fields'), (field) => field.name === attribute.Field))));
                }));
            });
            set(p, 'AttributeGroups', filter(attributeGroupMembers, (member) => get(member, 'AttributeGroup.Attributes.length', 0) > 0));
        }
        if (!isEmpty(optionGroups)) {
            forEach(optionGroups, group => {
                forEach(get(group, 'Options', []), (option) => {
                    // Add Product Option Group to Product Option Component if it's missing
                    if (isNil(get(option, 'ProductOptionGroup'))) {
                        const productOptionGrp = omit(mapValues(group), ['Options', 'OptionGroup']);
                        set(option, 'ProductOptionGroup', productOptionGrp);
                    }
                    const item = find(relatedItems, i => get(i, 'OptionId') === get(option, 'ComponentProductId')
                        && get(i, 'ParentBundleNumber') === get(parentItem, 'PrimaryLineNumber')
                        && every(flatten(map(optionGroups, g => get(g, 'Options'))), (o) => get(o, 'ComponentProduct._metadata.item.PrimaryLineNumber') !== get(i, 'PrimaryLineNumber')));
                    option.ComponentProduct.set('item', cloneDeep(item));
                    set(option, 'ComponentProduct.ProductAttributeMatrixViews', filter(get(option, 'ComponentProduct.ProductAttributeMatrixViews'), r => r.Active));
                    remove(get(option, 'ProductAttributeMatrixViews'), r => {
                        const expiredate = _moment(r.AttributeValueMatrix.ExpirationDate).format('YYYY-MM-DD');
                        return _moment(expiredate).isBefore(_moment(new Date()).format('YYYY-MM-DD'));
                    });
                    set(option, 'ComponentProduct.ProductOptionGroup.IsHidden', group.IsHidden);
                    set(option, 'ComponentProduct', this.groupOptionGroups(get(option, 'ComponentProduct'), get(item, 'AttributeValue'), relatedItems, applyFilter, metadata, item));
                    // Filter Product Option Components with invalid effective/expiration dates.
                    set(option, 'ComponentProduct', first(this.productService.filterInvalidProducts([option.ComponentProduct])));
                });
                if (applyFilter === 'changes')
                    set(group, 'Options', filter(get(group, 'Options'), (option) => includes(changedStatus, get(option, 'ComponentProduct._metadata.item.LineStatus'))
                        || some(get(option, 'ComponentProduct.OptionGroups'), (childGroup) => get(childGroup, '_metadata.summary.changes') > 0)));
                else if (applyFilter === 'items')
                    set(group, 'Options', filter(get(group, 'Options'), (option) => !isNil(get(option, 'ComponentProduct._metadata.item')) || some(get(option, 'ComponentProduct.OptionGroups'), (childGroup) => get(childGroup, '_metadata.summary.items') > 0)));
                // Remove any options that don't have price lists
                set(group, 'Options', filter(get(group, 'Options'), (option) => get(option, 'ComponentProduct.PriceLists.length', 0) !== 0));
                // Set the option group metadata
                set(group, '_metadata.summary', {
                    changes: sumBy(get(group, 'Options'), (o) => Number(includes(changedStatus, get(o, 'ComponentProduct').get('item.LineStatus')))),
                    disabled: false
                });
                // Setting expand/collapse flag based on item selection.
                group.set('expand', (filter(get(group, 'Options'), (option) => get(option, 'ComponentProduct').get('item')).length > 0) || (filter(optionGroups, (g) => get(g, 'ParentOptionGroupId') === get(group, 'OptionGroup.Id')).length > 0) ? true : false);
            });
            // check all Option groups & Attribute groups are opened
            p.set('expandAll', (optionGroups.length === filter(optionGroups, (og) => og.get('expand')).length) && attributeGroupMembers.length <= 1);
            // Filter out any groups that don't have options and aren't a parent
            set(p, 'OptionGroups', filter(get(p, 'OptionGroups'), (optionGroup) => !isEmpty(get(optionGroup, 'Options'))
                || some(get(p, 'OptionGroups'), (g => !get(g, 'IsHidden') && get(g, 'ParentOptionGroupId') === get(optionGroup, 'OptionGroupId') && !isEmpty(get(g, 'Options'))))));
            // Organize it into a tree
            const tree = memoize$1(TreeUtils.arrayToTree, () => `optionTree-${p.Id}-${applyFilter}`);
            set(p, 'OptionGroups', tree(get(p, 'OptionGroups', []), {
                parentProperty: 'ParentOptionGroupId',
                childrenProperty: 'ChildOptionGroups',
                customID: 'OptionGroupId'
            }));
        }
        return p;
    }
    /**
     * Function that returns all the options that are Required but selected from UI.
     *
     * ### Example:
     ```typescript
     import { ProductOptionService, ProductOptionComponent } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';

     export class MyComponent implements OnInit{
           productOption$: ProductOptionComponent;

           constructor(private productOptionService: ProductOptionService){}

           ngOnInit(){
                this.productOption$ = this.productOptionService.getRequiredUncheckedOptions(allOptions: Array<ProductOptionComponent>);
           }
      }
     ```
     * @param allOptions All product options
     * @returns an Array of Product option Component.
     */
    getRequiredUncheckedOptions(allOptions) {
        // IsHidden option groups will not be considered
        let uncheckedRequiredOptions = filter(allOptions, (o) => o.Required && !o.ComponentProduct.get('item') && !get(o, 'ProductOptionGroup.IsHidden'));
        let requiredOptionGroups = map(uncheckedRequiredOptions, (a) => a.ProductOptionGroup.OptionGroupId);
        let reqUnCheckedOpts = filter(allOptions, (ao) => get(ao.ComponentProduct, 'OptionGroups.length') > 0
            && filter(ao.ComponentProduct.OptionGroups, (og) => includes(requiredOptionGroups, og.OptionGroupId)));
        if (reqUnCheckedOpts.length > 0) {
            let uncheckOptions = flatten(map(reqUnCheckedOpts, (re) => flatten(re.ComponentProduct.get('item') && map(re.ComponentProduct.OptionGroups, (op) => filter(op.Options, (opts) => opts.Required && !get(opts, 'ProductOptionGroup.IsHidden'))))));
            uncheckOptions = concat(filter(allOptions, (ao) => ao.Required && ao.ParentProductId === first(reqUnCheckedOpts).ParentProductId && !get(ao, 'ProductOptionGroup.IsHidden')), uncheckOptions);
            return uncheckOptions;
        }
        return uncheckedRequiredOptions;
    }
    /**
      * This method returns a list of product options components that must be checked to add
      * a bundle configuration to the cart.
      *
      * ### Example:
      ```typescript
      import { ProductOptionService, ProductOptionComponent } from '@congacommerce/ecommerce';
      import { Observable } from 'rxjs/Observable';
 
      export class MyComponent implements OnInit{
            productOption$: ProductOptionComponent;
 
            constructor(private productOptionService: ProductOptionService){}
 
            ngOnInit(){
                 this.productOption$ = this.productOptionService.getRequiredOptions(productOptionComponents: Array<ProductOptionComponent>, cartItems: Array<CartItem>);
            }
       }
      ```
      * @param productOptionComponents List of all product option components in a bundle.
      * @param cartItems List of selected line items in the configuration.
      * @returns an Array of ProductOptionComponent.
      */
    getRequiredOptions(productOptionComponents, cartItems) {
        // Get a list of product option components that aren't in the cart item array
        const uncheckedOptionComponents = filter(productOptionComponents, component => !get(component, 'ProductOptionGroup.IsHidden') && !includes(map(cartItems, 'ProductOptionId'), get(component, 'Id')));
        // Filter out the unrequired options
        const requiredUncheckedOptions = filter(uncheckedOptionComponents, { Required: true });
        // Get the list of option group ids
        const requiredUncheckedOptionGroups = map(requiredUncheckedOptions, option => get(option, 'ProductOptionGroup.OptionGroupId'));
        const reqdOptionsNeeded = filter(productOptionComponents, (optionComponent) => !isEmpty(get(optionComponent, 'ComponentProduct.OptionGroups'))
            && filter(get(optionComponent, 'ComponentProduct.OptionGroups'), (optionGrp) => !optionGrp.IsHidden && includes(requiredUncheckedOptionGroups, optionGrp.OptionGroupId)));
        if (reqdOptionsNeeded.length > 0) {
            // Get all required suboptions for the bundle options.
            let reqdOptions = flatten(map(reqdOptionsNeeded, (optionComponent) => flatten(this.isProductOptionSelected(optionComponent, cartItems) && map(optionComponent.ComponentProduct.OptionGroups, (optionGrp) => filter(optionGrp.Options, (opts) => opts.Required && !get(opts, 'ProductOptionGroup.IsHidden'))))));
            reqdOptions = concat(filter(productOptionComponents, (optionComponent) => !get(optionComponent, 'ProductOptionGroup.IsHidden') && optionComponent.ComponentProduct.IsActive && optionComponent.Required && optionComponent.ParentProductId === first(reqdOptionsNeeded).ParentProductId), reqdOptions);
            return reqdOptions;
        }
        return requiredUncheckedOptions;
    }
    /**@ignore */
    isProductOptionSelected(productOptionComponent, cartItems) {
        return (find(cartItems, item => get(item, 'LineType') === 'Option' && get(item, 'ProductOption.Id') === get(productOptionComponent, 'Id'))) ? true : false;
    }
}
ProductOptionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductOptionService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ProductOptionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductOptionService, providedIn: 'root' });
__decorate([
    MemoizeAll(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Product]),
    __metadata("design:returntype", Array)
], ProductOptionService.prototype, "getProductOptions", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductOptionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], propDecorators: { getProductOptions: [] } });
/**
 * Product options are individual products that users can select from when configuring a bundle.
 *
 * <h3>Usage</h3>
 *
 ```typescript
 import { ProductOptionComponentService } from '@congacommerce/ecommerce';
 
 constructor(private productOptionComponentService: ProductOptionComponentService) {}
 
 // or
 
 export class MyService extends AObjectService {
      private productOptionComponentService: ProductOptionComponentService = this.injector.get(ProductOptionComponentService);
  }
 ```
 */
class ProductOptionComponentService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = ProductOptionComponent;
        this.pliService = this.injector.get(PriceListItemService);
        this.productService = this.injector.get(ProductService);
        this.cartItemService = this.injector.get(CartItemService);
        this.attributeService = this.injector.get(ProductAttributeService);
        this.attributeGroupService = this.injector.get(ProductAttributeGroupService);
        this.orderLineItemService = this.injector.get(OrderLineItemService);
        this.quoteLineItemService = this.injector.get(QuoteLineItemService);
    }
    globalFilter() {
        return of([
            new AFilter(this.type, [new ACondition(this.type, 'ParentProduct.IsActive', 'Equal', true), new ACondition(this.type, 'ComponentProduct.IsActive', 'Equal', true)])
        ]);
    }
    globalJoin() {
        const plService = this.injector.get(PriceListService);
        return plService.getPriceListId().pipe(map$1(plid => [new AJoin(this.pliService.type, 'ComponentProductId', 'ProductId', [new ACondition(this.pliService.type, 'PriceListId', 'Equal', plid)])]));
    }
}
ProductOptionComponentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductOptionComponentService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ProductOptionComponentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductOptionComponentService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductOptionComponentService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });
/**
 * Product option groups are a way of grouping the individual options for a product
 *
* <h3>Usage</h3>
*
```typescript
import { ProductOptionGroupService } from '@congacommerce/ecommerce';

constructor(private productOptionGroupService: ProductOptionGroupService) {}

// or

export class MyService extends AObjectService {
     private productOptionGroupService: ProductOptionGroupService = this.injector.get(ProductOptionGroupService);
 }
```
 */
class ProductOptionGroupService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = ProductOptionGroup;
    }
    /**
     * method gets a list of product option groups for a given product
     * ### Example:
```typescript
import { ProductOptionGroupService, ProductOptionGroup } from '@congacommerce/ecommerce';
import { Observable } from 'rxjs/Observable';

export class MyComponent implements OnInit{
    optionGroupList: Array<ProductOptionGroup>;
    optionGroupList$: Observable<Array<ProductOptionGroup>>;

    constructor(private productOptionGroupService: ProductOptionGroupService){}

    getProductOptionGroupsForProduct(product: Product){
        this.productOptionGroupService.getProductOptionGroupsForProduct(product).subscribe(o => this.optionGroupList = o);
        // or
        this.optionGroupList$ = this.productOptionGroupService.getProductOptionGroupsForProduct(product);
    }
}
```
     * @param product the instance of the product with which to return option groups for
     * @returns an observable array of product option groups for a given product
     */
    getProductOptionGroupsForProduct(product) {
        if (get(product, 'OptionGroups', []).length > 0)
            // return this.where(`ID IN (` + SObjectService.arrayToCsv(product.OptionGroups.records.map(res => res.Id)) + `)`);
            return this.where([new ACondition(this.type, 'Id', 'In', Object.keys(product.OptionGroups).map(key => product.OptionGroups[key].Id))]);
        else
            return of([]);
    }
}
ProductOptionGroupService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductOptionGroupService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ProductOptionGroupService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductOptionGroupService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductOptionGroupService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * The conversion service is responsible for pulling conversion rates from your Salesforce instance.
 * NOTE: Remember to set the enableMultiCurrency in your salesforce.config.ts file to true.
 *  <h3>Usage</h3>
 *
 ```typescript
 import { ConversionService, AObjectService} from '@congacommerce/ecommerce';
 
 export class MyComponent implements OnInit{
 constructor( private conversionService: ConversionService)
 }
 // or
 export class MyService extends AObjectService {
      private conversionService: ConversionService = this.injector.get(ConversionService);
  }
 ```
 */
class ConversionService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = CurrencyType;
        this.userService = this.injector.get(UserService);
        this.priceListService = this.injector.get(PriceListService);
        this.storefrontService = this.injector.get(StorefrontService);
    }
    /**
     * primary method for pulling conversion rates from Salesforce.
     * ### Example:
     ```typescript
     import { ConversionService, CurrencyType } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         conversionRate: Array<CurrencyType>;
         conversionRate$: Observable<Array<CurrencyType>>;
     
         constructor(private conversionervice: ConversionService){}
     
         getConversion(){
             this.conversionervice.getConversionRates().subscribe(a => this.conversionRate = a);
             // or
             this.conversionRate$ = this.conversionService.getConversionRates();
         }
     }
     ```
     * @returns a cold observable containing the array of currency type instances
     */
    getConversionRates() {
        return this.storefrontService.active()
            .pipe(map$1(data => _.get(data, 'CurrencyTypes')));
    }
    /**
     * Used for getting a single instance of currencytype for the current user
     * ### Example:
     ```typescript
     import { ConversionService, CurrencyType } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         conversionRate: CurrencyType;
         conversionRate$: Observable<CurrencyType>;
     
         constructor(private conversionervice: ConversionService){}
     
         getMyCurrencyType(){
             this.conversionervice.getMyCurrencyType().subscribe(a => this.conversionRate = a);
             // or
             this.conversionRate$ = this.conversionService.getMyCurrencyType();
         }
     }
     ```
     * @returns a hot observable containing the currency type of the current user
     */
    getMyCurrencyType() {
        return combineLatest(this.userService.me(), this.getConversionRates()).pipe(map$1(([user, conversionRates]) => {
            const rates = conversionRates.filter(r => r != null && r.IsoCode === user.DefaultCurrencyIsoCode);
            if (rates && rates.length > 0)
                return rates[0];
            else
                return new CurrencyType();
        }));
    }
    /**
     * Used for getting a single instance of currencytype based on the price List
     * ### Example:
     ```typescript
     import { ConversionService, CurrencyType } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         conversionRate: CurrencyType;
         conversionRate$: Observable<CurrencyType>;
     
         constructor(private conversionervice: ConversionService){}
     
         getCurrencyTypeForPricelist(){
             this.conversionervice.getCurrencyTypeForPricelist().subscribe(a => this.conversionRate = a);
             // or
             this.conversionRate$ = this.conversionService.getCurrencyTypeForPricelist();
         }
     }
     ```
     * @returns a hot observable containing the currency type of the price List
     */
    getCurrencyTypeForPricelist() {
        return combineLatest(this.getConversionRates(), this.priceListService.getPriceList())
            .pipe(mergeMap(([conversionRates, priceList]) => {
            return of(_.find(conversionRates, rate => _.get(rate, 'IsoCode') === _.get(priceList, 'CurrencyIsoCode')));
        }));
    }
}
ConversionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConversionService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ConversionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConversionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConversionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * Price matrices are used to map various product facets to a price adjustment. For example, there may be matrixes for attributes or quantities that adjust the base price. Use this
 * service to retrieve the data for those matrices.
 ```typescript
 import { PriceMatrixService, AObjectService} from '@congacommerce/ecommerce';
 
 export class MyComponent implements OnInit{
 constructor( private priceMatrixService: PriceMatrixService)
 }
 // or
 export class MyService extends AObjectService {
      private priceMatrixService: PriceMatrixService = this.injector.get(PriceMatrixService);
  }
 ```
 */
class PriceMatrixService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = PriceMatrix;
        this.priceListItemService = this.injector.get(PriceListItemService);
    }
    /**
     * Method gets all the price matrix data for a specific product.
     *
     * @param productCode the code of the product to retrieve the price matrix data for.
     * @param attributeGroupName An optional parameter defining the specific attribute group to retrieve matrix data for.
     * @returns A hot observable containing an array of price matrix data for the given product.
     */
    getPriceMatrixDataByCode(productCode, attributeGroupName) {
        let groupNameFilter = (attributeGroupName) ? [PriceMatrixService.attributeGroupNameQuery(attributeGroupName, this.type)] : null;
        return this.where(null, 'AND', groupNameFilter, null, null, [
            new AJoin(this.priceListItemService.type, 'PriceListItemId', 'Id', [new ACondition(this.priceListItemService.type, 'Product.ProductCode', 'Equal', productCode)])
        ]);
    }
    /**
     * Method returns the price matrix data for a given array of price list items.
     *
     * @param priceListItemList The array of price list items to return price matrix data for.
     * @param attributeGroupName An optional parameter of defining the specific attribute group to retrieve matrix data for.
     * @returns A hot observable containing an array of price matrix data for the given price list items.
     */
    getPriceMatrixData(priceListItemList, attributeGroupName) {
        const ids = priceListItemList.map(r => r.Id);
        const groupNameFilter = (attributeGroupName) ? [PriceMatrixService.attributeGroupNameQuery(attributeGroupName, this.type)] : null;
        if (ids && ids.length > 0 && some(ids, (i => !isNil(i))))
            return this.where([new ACondition(this.type, 'PriceListItemId', 'In', ids)], 'AND', groupNameFilter);
        else
            return of([]);
    }
    /** @ignore */
    static attributeGroupNameQuery(attributeGroupName, type) {
        const conditionList = [];
        for (let i = 1; i <= 6; i++) {
            conditionList.push(new ACondition(type, 'Dimension' + i + '.Id.Attribute.AttributeGroup.Name', 'Equal', attributeGroupName));
        }
        return new AFilter(type, conditionList, null, 'OR');
    }
}
PriceMatrixService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceMatrixService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
PriceMatrixService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceMatrixService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceMatrixService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * Stubbed service for Apttus price rules. Currently has no supporting methods.
 * @ignore
 */
class PriceRuleService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = PriceRule;
        this.priceListService = this.injector.get(PriceListService);
    }
    getPriceRules() {
        return this.priceListService.getPriceListId().pipe(mergeMap(priceListId => this.where([
            new ACondition(this.type, 'Ruleset.PriceListId', 'Equal', priceListId)
        ], 'AND', [
            new AFilter(this.type, [
                new ACondition(this.type, 'Ruleset.EffectiveDate', 'Null', null),
                new ACondition(this.type, 'Ruleset.EffectiveDate', 'LessEqual', 'Today')
            ], null, 'OR'),
            new AFilter(this.type, [
                new ACondition(this.type, 'Ruleset.ExpirationDate', 'Null', null),
                new ACondition(this.type, 'Ruleset.ExpirationDate', 'GreaterThan', 'Today')
            ], null, 'OR')
        ], [
            new ASort(this.type, 'Ruleset.Sequence', 'ASC'),
            new ASort(this.type, 'Sequence', 'ASC')
        ])));
    }
}
PriceRuleService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceRuleService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
PriceRuleService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceRuleService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceRuleService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * Core pipe to convert a number into the currency and format of the given user.
 * ### Example:
 ```html
    <!-- Renders $5.55 for USD users -->
    <span>{{5.55 | localCurrencyPipe | async}}</span>
 ```
 */
class LocalCurrencyPipe {
    constructor(conversionService, userService, currencyPipe) {
        this.conversionService = conversionService;
        this.userService = userService;
        this.currencyPipe = currencyPipe;
    }
    /**
     * @param value the number to convert
     */
    transform(value) {
        return combineLatest([this.conversionService.getCurrencyTypeForPricelist(), this.userService.getLocale()])
            .pipe(map$1(res => this.currencyPipe.transform(value, get(first(res), 'IsoCode'), 'symbol-narrow', '1.' + get(first(res), 'DecimalPlaces', 2) + '-' + get(first(res), 'DecimalPlaces', 2), res[1])));
    }
}
LocalCurrencyPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LocalCurrencyPipe, deps: [{ token: ConversionService }, { token: UserService }, { token: i3$1.CurrencyPipe }], target: i0.ɵɵFactoryTarget.Pipe });
LocalCurrencyPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LocalCurrencyPipe, name: "localCurrency" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LocalCurrencyPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'localCurrency'
                }]
        }], ctorParameters: function () { return [{ type: ConversionService }, { type: UserService }, { type: i3$1.CurrencyPipe }]; } });
/**
 * @ignore
 */
class FormatCurrencyPipe {
    constructor(userService, currencyPipe, conversionService) {
        this.userService = userService;
        this.currencyPipe = currencyPipe;
        this.conversionService = conversionService;
    }
    transform(value, args) {
        if (!value || value == null || value === undefined)
            value = 0;
        return combineLatest(this.conversionService.getMyCurrencyType(), this.userService.getLocale()).pipe(map$1(([rate, locale]) => {
            if (!value || value == null || value === undefined)
                value = 0;
            return this.currencyPipe.transform(value, rate.IsoCode, 'symbol-narrow', '1.' + rate.DecimalPlaces + '-' + rate.DecimalPlaces, locale);
            // return new Intl.NumberFormat(this.userService.getDefaultLocale(false), { style: 'currency', currency: currencyCode }).format(value * conversionRate);
        }));
    }
}
FormatCurrencyPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FormatCurrencyPipe, deps: [{ token: UserService }, { token: i3$1.CurrencyPipe }, { token: ConversionService }], target: i0.ɵɵFactoryTarget.Pipe });
FormatCurrencyPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FormatCurrencyPipe, name: "formatCurrency" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FormatCurrencyPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'formatCurrency'
                }]
        }], ctorParameters: function () { return [{ type: UserService }, { type: i3$1.CurrencyPipe }, { type: ConversionService }]; } });
/**
 * Core pipe to convert a number into the currency and format specified by the user.
 * By default conversion is done based on the currency ISO code defined in the price list.
 * However, user can also pass the currency ISO code that needs to be accounted for during the currency conversion.
 * Additionally user can pass the display currency symbol and decimal representation of the currency value.
 * ### Example:
 ```html
    <!-- Renders $5.55 -->
    <span>{{5.55 | convertCurrency | async}}</span>
    <!-- Renders €65.23 -->
    <span>{{65.23 | convertCurrency: 'EUR' | async}}</span>
    <!-- Renders CA$821.36 -->
    <span>{{821.36 | convertCurrency: 'CAD': 'symbol' | async}}</span>
 ```
 */
class ConvertCurrencyPipe {
    constructor(conversionService, userService, currencyPipe) {
        this.conversionService = conversionService;
        this.userService = userService;
        this.currencyPipe = currencyPipe;
    }
    /**
     * @param value the number to convert.
     * @param currencyIsoCode a string value representing ISO 4217 currency code.
     * Defaulted to the currency code defined on price list.
     * @param display to display the currency symbol.
     * Can take values like 'code', 'symbol', 'symbol-narrow', a customized string or boolean. Defaulted to symbol-narrow
     * @param digitsInfo string representing decimal representation of currency value.
     */
    transform(value, currencyIsoCode = null, display = 'symbol-narrow', digitsInfo = '1.') {
        const currencyType$ = (currencyIsoCode) ? this.conversionService.getConversionRates().pipe(map$1(rates => find(rates, r => r != null && r.IsoCode === currencyIsoCode))) : this.conversionService.getCurrencyTypeForPricelist();
        return combineLatest([currencyType$, this.userService.getLocale()])
            .pipe(map$1(([currency, locale]) => {
            const currencyCode = (currency && currency.IsoCode) ? currency.IsoCode : LocaleCurrency.getCurrency(locale);
            const conversionRate = (currency && currency.ConversionRate) ? currency.ConversionRate : 1;
            const finalValue = value * conversionRate;
            return this.currencyPipe.transform(finalValue, currencyCode, display, digitsInfo + get(currency, 'DecimalPlaces', 2) + '-' + get(currency, 'DecimalPlaces', 2), locale);
        }));
    }
}
ConvertCurrencyPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConvertCurrencyPipe, deps: [{ token: ConversionService }, { token: UserService }, { token: i3$1.CurrencyPipe }], target: i0.ɵɵFactoryTarget.Pipe });
ConvertCurrencyPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConvertCurrencyPipe, name: "convertCurrency" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConvertCurrencyPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'convertCurrency'
                }]
        }], ctorParameters: function () { return [{ type: ConversionService }, { type: UserService }, { type: i3$1.CurrencyPipe }]; } });

/**
 * Client-side pricing engine for retrieving price for various points in the ecommerce application.
 * NOTE: It is not guarunteed that this service will always return accurate pricing for a given cart. You should always call cartService.priceCart(...) to trigger
 * the server-side pricing engine to get the final price of a given cart.
 * There are also pipes provided that wrap this service to provide pricing within a template (i.e. ProductPricePipe, OrderPricePipe, CartPricePipe etc...)
 * <h3>Usage</h3>
 *
 ```typescript
 import { PriceService, AObjectService} from '@congacommerce/ecommerce';
 
 export class MyComponent implements OnInit{
 constructor( private priceService: PriceService)
 }
 // or
 export class MyService extends AObjectService {
      private priceService: PriceService = this.injector.get(PriceService);
  }
 ```
 */
class PriceService {
    constructor(priceListService, cartService, priceMatrixService, metadataService, localCurrencyPipe, productAttributeValueService, conversionService, storefrontService) {
        this.priceListService = priceListService;
        this.cartService = cartService;
        this.priceMatrixService = priceMatrixService;
        this.metadataService = metadataService;
        this.localCurrencyPipe = localCurrencyPipe;
        this.productAttributeValueService = productAttributeValueService;
        this.conversionService = conversionService;
        this.storefrontService = storefrontService;
        this.queryKey = null;
        this.matrixData = {};
        this.cartPending = false;
        this.previousCartPrice = null;
    }
    /**
     * Method calcuates the adjustment amount for a line item based on its adjustment type.
     * @param adjustmentAmount numeric value representing the adjustment amount on line item.
     * @param adjustmentType string value representing the type of adjustment.
     * @param amount numeric value representing the price on line item. The price can be list price, base price etc.
     * @returns a numberic value representing the adjustment amount.
     */
    static adjustValue(adjustmentAmount, adjustmentType, amount) {
        adjustmentAmount = (isNaN(adjustmentAmount)) ? 0 : adjustmentAmount;
        let val = amount;
        if (adjustmentType === Adjustment.PER_DISCOUNT)
            val = (amount - (amount * (adjustmentAmount / 100)));
        else if (adjustmentType === Adjustment.DISCOUNT_AMOUNT)
            val = amount - (adjustmentAmount);
        else if (adjustmentType === Adjustment.PER_MARKUP)
            val = amount + ((amount * (adjustmentAmount / 100)));
        else if (adjustmentType === Adjustment.MARKUP_AMT)
            val = amount + (adjustmentAmount);
        else if (adjustmentType === Adjustment.PRICE_FACTOR)
            val = amount * (adjustmentAmount);
        else if (adjustmentType === Adjustment.LIST_PRICE_OVERRIDE)
            val = (adjustmentAmount);
        return val;
    }
    /**
     * Method is used to retrieve the price for a given product.
     *
     * ### Example:
     ```typescript
     import { PriceService, Price, Product } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         price: Price;
         price$: Observable<Price>;
     
         constructor(private priceService: PriceService){}
     
         getProductPrice(product: Product){
             this.priceService.getProductPrice(product).subscribe(a => this.price = a);
             // or
             this.price$ = this.priceService.getProductPrice(product);
         }
     }
     ```
     * @param product the instance of the product to return the price for.
     * @param quantity the number of product items to calculate.
     * @param term an integer value representing the selling term, defaulted to 1.
     * @param attributeValue an optional parameter representing the product attribute value.
     * @param bundle flag indicates if the product is a bundle with option groups and product option components.
     * @param chargeType an optional parameter representing the charge type to calculate the price for.
     * @returns a hot observable containing the price instance for the given product.
     */
    getProductPrice(product, quantity = 1, term = 1, attributeValue, bundle = false, chargeType) {
        return combineLatest([
            this.productAttributeValueService.describe(),
            this.priceListService.getPriceList()
        ])
            .pipe(mergeMap(([metadata, priceList]) => {
            let adjustmentType, adjustmentAmount = null;
            const pli = PriceListItemService.getPriceListItemForProduct(product, chargeType);
            if (priceList && !isNil(priceList.BasedOnPriceListId) && priceList.BasedOnPriceListId === get(pli, 'PriceListId')) {
                adjustmentType = priceList.BasedOnAdjustmentType;
                adjustmentAmount = priceList.BasedOnAdjustmentAmount;
            }
            if (!isNil(pli)) {
                const unitPrice = (get(pli, 'ContractPrice', 0) > 0) ? get(pli, 'ContractPrice') : get(pli, 'ListPrice');
                const plCurrencyAmount = this.convertCurrency(unitPrice);
                const unitPriceWithAdjustments = PriceService.adjustValue(adjustmentAmount, adjustmentType, plCurrencyAmount);
                const p = new Price(this.localCurrencyPipe);
                const priceType = get(pli, 'PriceType');
                p.basePrice = unitPriceWithAdjustments;
                p.listPrice = unitPriceWithAdjustments;
                p.listExtendedPrice = unitPriceWithAdjustments * quantity;
                p.baseExtendedPrice = unitPriceWithAdjustments * quantity * term;
                p.netPrice = (priceType === 'Recurring' && term) ? unitPriceWithAdjustments * quantity * term : unitPriceWithAdjustments * quantity;
                // Attributes
                const attr = defaultTo(attributeValue, this.productAttributeValueService.getInstanceWithDefaults(product, metadata));
                this.matrixAdjustment(p, get(pli, 'PriceMatrices'), quantity, attr, null);
                if (bundle) {
                    const productOptions = filter(flatten(map(get(product, 'OptionGroups'), (group) => get(group, 'Options'))), c => get(c, 'Default') === true);
                    const optionObsv$ = (!isEmpty(productOptions))
                        ? zip(...productOptions.map(c => this.getProductPrice(get(c, 'ComponentProduct'), defaultTo(c.DefaultQuantity, 1), 1, undefined, true)))
                        : of(null);
                    return optionObsv$.pipe(map$1(optionPrices => {
                        p.netPrice += defaultTo(sumBy(optionPrices, 'netPrice') * quantity, 0);
                        return p;
                    }));
                }
                else {
                    return of(p);
                }
            }
            else
                return of(new Price(this.localCurrencyPipe));
        }));
    }
    /**
     * Method is used to retrieve the price of an option for a given product
     * ### Example:
     ```typescript
     import { PriceService, Price, ProductOptionComponent } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         price: Price;
         price$: Observable<Price>;
     
         constructor(private priceService: PriceService){}
     
         getOptionAdjustmentPrice(option: ProductOptionComponent){
             this.priceService.getOptionAdjustmentPrice(option).subscribe(a => this.price = a);
             // or
             this.price$ = this.priceService.getOptionAdjustmentPrice(option);
         }
     }
     ```
     * @param option the instance of the product option component to calculate the adjustment amount for
     * @param quantity the quantity of options to get the price for
     * @returns a hot observable containing the price of the given option
     */
    getOptionAdjustmentPrice(option, quantity = 1) {
        if (option)
            return this.getProductPrice(option.ComponentProduct, quantity);
        else
            return of(new Price(this.localCurrencyPipe, 0, 0, 0));
    }
    /**
     * Method returns a price for a given attribute and its value on a product
     *
     * ### Example:
     ```typescript
     import { PriceService, Price, ProductAttribute, Product } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         price: Price;
         price$: Observable<Price>;
     
         constructor(private priceService: PriceService){}
     
          getAttributePriceForProduct(product: Product, attribute: ProductAttribute, attributeValue: any){
             this.priceService.getAttributePriceForProduct(product, attribute, attributeValue).subscribe(a => this.price = a);
             // or
             this.price$ = this.priceService.getAttributePriceForProduct(product, attribute, attributeValue);
         }
     }
     ```
     * @param product the instance of the product that the attribute is associated with
     * @param attribute the instance of the attribute to calculate the adjustment for
     * @param attributeValue The value of the attribute to calculate the price for
     * @returns a hot observable containing the price of a given attribute value
     */
    getAttributePriceForProduct(product, attribute, attributeValue) {
        return this.priceListService.getPriceList().pipe(mergeMap(priceList => {
            const priceListItem = get(product, 'PriceLists')
                .filter(pli => (pli != null) ? pli.PriceListId === priceList.Id : false)[0];
            const price = (priceListItem) ? (priceListItem.ContractPrice) ? priceListItem.ContractPrice : priceListItem.ListPrice : null;
            if (!priceListItem)
                return throwError(new Error('Product does not have a valid price list item'));
            else {
                return this.priceMatrixService.getPriceMatrixData([priceListItem]).pipe(map$1(priceMatrixData => {
                    if (priceMatrixData.length > 0 && get(priceMatrixData[0], 'MatrixEntries')) {
                        const sortedDimensions = priceMatrixData.sort((n1, n2) => n1.Sequence - n2.Sequence);
                        let val = null;
                        for (let matrix of sortedDimensions) {
                            matrix.MatrixEntries.forEach(entry => {
                                for (let i = 1; i <= 6; i++) {
                                    if (get(attribute, 'Field') === get(matrix, 'Dimension' + i + '.Datasource') &&
                                        get(entry, 'Dimension' + i + 'Value') === attributeValue) {
                                        val = PriceService.adjustValue(entry.AdjustmentAmount, entry.AdjustmentType, priceListItem.ListPrice);
                                        break;
                                    }
                                }
                            });
                        }
                        const final = (val - price);
                        return new Price(this.localCurrencyPipe, final);
                    }
                    else
                        return new Price(this.localCurrencyPipe, 0);
                }));
            }
        }));
    }
    /**
     * Method returns the price for a given cart. If the first parameter is left blank, it will return the price for the current cart.
     *
     * @param cart$ An optional parameter of the cart to calculate the price for. Can be an observable or a Cart instance. If left blank, will return the price for the current cart.
     * @returns A hot observable containing the price of the given cart
     */
    getCartPrice(cart$) {
        if (!cart$)
            cart$ = this.cartService.getMyCart();
        else if (cart$ instanceof Cart)
            cart$ = of(cart$);
        return cart$.pipe(mergeMap(cart => {
            if (!isEmpty(get(cart, 'LineItems')) && (this.cartService.isPricePending(cart) || isEmpty(get(cart, 'SummaryGroups')))) {
                // Filter line items with price type as 'Usage' since usage pricing is computed only at billing time.
                const lineItemsPrice$ = filter(get(cart, 'LineItems', []), item => (item.LineType === 'Product/Service' && item.PriceType !== 'Usage') || item.LineType === 'Misc').map(item => this.getLineItemPrice(item));
                return isEmpty(lineItemsPrice$) ? of(new Price(this.localCurrencyPipe)) : combineLatest(lineItemsPrice$)
                    .pipe(map$1(priceArray => {
                    return reduce(priceArray, (a, b) => (a) ? a.addPrice(b) : a);
                }));
            }
            else {
                // Taking subtotal netPrice as baseExtendedPrice as gradn total has tax calculated in it.
                const grandTotal = find(get(cart, 'SummaryGroups', []), (group) => group.LineType === 'Grand Total');
                const subTotal = filter(get(cart, 'SummaryGroups', []), (group) => (group.LineType === 'Subtotal' && group.ChargeType !== 'Sales Tax'));
                if (grandTotal)
                    return of(new Price(this.localCurrencyPipe, grandTotal.NetPrice, grandTotal.BasePrice, grandTotal.ExtendedListPrice, sum(subTotal.map(t => t.ExtendedListPrice)), sum(subTotal.map(t => t.BaseExtendedPrice)) + grandTotal.OptionPrice));
                else {
                    return of(new Price(this.localCurrencyPipe));
                }
            }
        }));
    }
    /**
     * Method returns a price instance for a given cart item. If the price for the item has already been calculated, it will not do client side calculation.
     *
     * ### Example:
     ```typescript
     import { PriceService, Price, CartItem , AssetLineItem , OrderLineItem , QuoteLineItem } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         price: Price;
         price$: Observable<Price>;
     
         constructor(private priceService: PriceService){}
     
           getLineItemPrice(itemList: Array<CartItem | AssetLineItem | OrderLineItem | QuoteLineItem> | CartItem | AssetLineItem | QuoteLineItem | OrderLineItem){
             this.priceService.getLineItemPrice(itemList).subscribe(a => this.price = a);
             // or
             this.price$ = this.priceService.getLineItemPrice(itemList);
         }
     }
     ```
     * @param itemList list of line items to return a price for.
     * Line items can be from a cart, an asset, an order or a quote.
     * @param options an optional parameter that lists option groups for the line items.
     * option items can be from an asset, an order or a quote.
     * @returns A hot observable containing the price of the given item.
     */
    getLineItemPrice(itemList, options) {
        const validLines = [LineStatus.Amend, LineStatus.New, LineStatus.Upgrade, LineStatus.Renew, LineStatus.Increment, LineStatus.Existing, LineStatus.Activate];
        const getItemPrice = (item, chargeType) => {
            const product = (get(item, 'LineType') === 'Option') ? get(item, 'Option') : get(item, 'Product');
            set(item, 'PriceListItem.Frequency', defaultTo(get(item, 'PriceListItem.Frequency'), '--None--'));
            const empty$ = of(new Price(this.localCurrencyPipe, 0, 0, 0, 0, 0));
            if (isNil(item))
                return empty$;
            if (item.IsOptionRollupLine) {
                return this.getRollupItemPrice(item);
            }
            if (item instanceof CartItem && get(item, 'PricingStatus') !== 'Complete') {
                const primaryItem = find(itemList, itm => get(itm, 'LineType') === 'Product/Service');
                // passing right quantity for product price calculations for client side pricing.
                const qty = get(item, 'LineType') === 'Product/Service' ? get(primaryItem, 'Quantity', 1) : get(item, 'Quantity', 1);
                return this.getProductPrice(product, qty, get(item, 'SellingTerm'), get(item, 'AttributeValue'), false, chargeType).pipe(map$1(res => {
                    if (item.LineType === 'Option') {
                        res.listExtendedPrice *= get(primaryItem, 'Quantity', 1);
                        res.baseExtendedPrice *= get(primaryItem, 'Quantity', 1);
                        res.netPrice *= get(primaryItem, 'Quantity', 1);
                    }
                    return res;
                }));
            }
            else {
                let breakupItems = (item instanceof OrderLineItem) ? 'OrderTaxBreakups' : 'TaxBreakups';
                if (includes(validLines, get(item, 'LineStatus') || get(item, 'AssetStatus')) || isNil(get(item, 'LineStatus'))) {
                    return this.storefrontService.getStorefront()
                        .pipe(take(1), map$1(store => new Price(this.localCurrencyPipe, item.NetPrice
                        + ((get(store, 'EnableTaxCalculations', false) && get(item, breakupItems)) ? sumBy(get(item, breakupItems), 'TaxAmount') : 0)
                        + (get(store, 'EnableTaxCalculations', false) ? (sumBy(flatten(compact(map(options, breakupItems))), 'TaxAmount')) : 0), item.BasePrice, (item.LineType === 'Misc' ? 0 : get(item, 'ListPrice')), (item.LineType === 'Misc' ? 0 : get(item, 'ListPrice') * item.Quantity), item.ExtendedPrice)) // Close map
                    ); // Close pipe
                }
                else {
                    return empty$;
                }
            }
        };
        if (isArray(itemList)) {
            const items = compact(filter(itemList, i => includes(validLines, get(i, 'LineStatus') || get(i, 'AssetStatus'))));
            return combineLatest(map(items, i => getItemPrice(i, ChargeType.StandardPrice)))
                .pipe(map$1(prices => {
                return reduce(prices, (acc, val) => acc.addPrice(val));
            }));
        }
        else
            return getItemPrice(itemList);
    }
    /**
     * @ignore
     */
    getRollupItemPrice(item) {
        return of(new Price(this.localCurrencyPipe, item.NetPrice));
    }
    /**
     * Method returns a price for a given order instance.
     *
     * ### Example:
     ```typescript
     import { PriceService, Price, Order } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         price: Price;
         price$: Observable<Price>;
     
         constructor(private priceService: PriceService){}
     
           getOrderPrice(order: Order){
             this.priceService.getOrderPrice(order).subscribe(a => this.price = a);
             // or
             this.price$ = this.priceService.getOrderPrice(order);
         }
     }
     ```
     * @param order the instance of the order to return a price for
     * @returns a hot observable containing the price of the order
     */
    getOrderPrice(order) {
        return this.storefrontService.getStorefront()
            .pipe(mergeMap(store => {
            const orderPrice = new Price(this.localCurrencyPipe);
            const optionPrice = sum(filter(get(order, 'OrderLineItems'), lineItem => lineItem.LineType === 'Option').map(item => item.BaseExtendedPrice));
            // Filter the line items with price type as 'Usage' since usage pricing is computed only at billing time. (Current behavior in CPQ).
            filter(get(order, 'OrderLineItems'), i => (i.LineType === 'Product/Service' && i.PriceType !== 'Usage' || (get(store, 'EnableTaxCalculations', false) && i.LineType === 'Misc'))).forEach(lineItem => {
                const linePrice = new Price(this.localCurrencyPipe, lineItem.NetPrice, lineItem.BasePrice, (lineItem.LineType === 'Misc' ? 0 : get(lineItem, 'PriceListItem.ListPrice')), (lineItem.LineType === 'Misc' ? 0 : get(lineItem, 'NetPrice')), (lineItem.LineType === 'Misc' ? 0 : lineItem.BaseExtendedPrice));
                return orderPrice.addPrice(linePrice);
            });
            orderPrice.addPrice(new Price(this.localCurrencyPipe, null, null, null, null, optionPrice));
            return of(orderPrice);
        }));
    }
    /**
     * @ignore
     */
    getAssetLineItemPrice(assetLineItem) {
        return of(new Price(this.localCurrencyPipe, get(assetLineItem, 'NetPrice', 0), get(assetLineItem, 'BasePrice', 0), get(assetLineItem, 'ListPrice', 0), get(assetLineItem, 'ExtendedPrice', 0), get(assetLineItem, 'BaseExtendedPrice', 0)));
    }
    /**
     * Method returns a price for a given Quote instance.
     *
     * ### Example:
     ```typescript
     import { PriceService, Price, Quote} from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         price: Price;
         price$: Observable<Price>;
     
         constructor(private priceService: PriceService){}
     
           getQuotePrice(quote: Quote){
             this.priceService.getQuotePrice(quote).subscribe(a => this.price = a);
             // or
             this.price$ = this.priceService.getQuotePrice(quote);
         }
     }
     ```
     * @param quote the instance of the Quote to return a price for
     * @returns a hot observable containing the price of the Quote
     */
    getQuotePrice(quote) {
        return this.storefrontService.getStorefront()
            .pipe(mergeMap(store => {
            const quotePrice = new Price(this.localCurrencyPipe);
            filter(get(quote, 'QuoteLineItems'), i => ((i.LineType === 'Product/Service' && i.PriceType !== 'Usage') ||
                (get(store, 'EnableTaxCalculations', false) && i.LineType === 'Misc'))).forEach(lineItem => {
                const linePrice = new Price(this.localCurrencyPipe, lineItem.NetPrice, lineItem.BasePrice, (lineItem.LineType === 'Misc' ? 0 : get(lineItem, 'PriceListItem.ListPrice')), (lineItem.LineType === 'Misc' ? 0 : get(lineItem, 'NetPrice')), (lineItem.LineType === 'Misc' ? 0 : lineItem.ExtendedPrice));
                return quotePrice.addPrice(linePrice);
            });
            return of(quotePrice);
        }));
    }
    /**
     * Method returns price for a given OrderLineItem instance.
     *
     * ### Example:
     ```typescript
     import { PriceService, Price, OrderLineItem} from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         price: Price;
         price$: Observable<Price>;
     
         constructor(private priceService: PriceService){}
     
           getOrderLineItemPrice(orderLI: OrderLineItem){
             this.priceService.getOrderLineItemPrice(orderLI).subscribe(a => this.price = a);
             // or
             this.price$ = this.priceService.getOrderLineItemPrice(orderLI);
         }
     }
     ```
     * @param OrderLineItem the instance of the OrderLineItem to return a price for
     * @returns a hot observable containing the price of the LineItem
     */
    getOrderLineItemPrice(orderLI) {
        return this.storefrontService.getStorefront().pipe(mergeMap(store => {
            if (get(store, 'EnableTaxCalculations', false) && get(orderLI, 'Taxable', false)) {
                return of(new Price(this.localCurrencyPipe, (orderLI.NetPrice + sum(get(orderLI, 'OrderTaxBreakups').map(res => res.TaxAmount))), orderLI.BasePrice, orderLI.ListPrice));
            }
            else
                return of(new Price(this.localCurrencyPipe, orderLI.NetPrice, orderLI.BasePrice, orderLI.ListPrice));
        }));
    }
    /**
     * Method returns a NetPrice for a given QuoteLineItem instance.
     *
     * ### Example:
     ```typescript
     import { PriceService, Price, QuoteLineItem} from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         price: Price;
         price$: Observable<Price>;
     
         constructor(private priceService: PriceService){}
     
           getQuoteLineItemPrice(quoteLI: QuoteLineItem){
             this.priceService.getQuoteLineItemPrice(quoteLI).subscribe(a => this.price = a);
             // or
             this.price$ = this.priceService.getQuoteLineItemPrice(quoteLI);
         }
     }
     ```
     * @param QuoteLineItem the instance of the QuoteLineItem to return a price for
     * @returns a hot observable containing the price of the QuoteLineItem
     */
    getQuoteLineItemPrice(quoteLI) {
        return this.storefrontService.getStorefront().pipe(mergeMap(store => {
            if (get(store, 'EnableTaxCalculations', false) && get(quoteLI, 'Taxable', false)) {
                return of(new Price(this.localCurrencyPipe, (quoteLI.NetPrice + sum(get(quoteLI, 'TaxBreakups').map(res => res.TaxAmount))), quoteLI.BasePrice, quoteLI.ListPrice));
            }
            else
                return of(new Price(this.localCurrencyPipe, quoteLI.NetPrice, quoteLI.BasePrice, quoteLI.ListPrice));
        }));
    }
    /**
     * @ignore
     */
    ruleAdjustment(p, priceRules, lineItem) {
        const product = lineItem.Product;
        const productGroups = defaultTo(get(product, 'ProductGroups'), []).map(groupMember => groupMember.ProductGroupId);
        // Get matching rule sets
        const matchingRules = priceRules.filter(rule => (rule.Ruleset.ProductFamily === product.Family || rule.Ruleset.ProductFamily == null)
            && (rule.Ruleset.ProductCategory === get(product, 'Categories[0].Name') || rule.Ruleset.ProductCategory == null)
            && (productGroups.indexOf(rule.Ruleset.ProductGroupId) >= 0 || rule.Ruleset.ProductGroupId == null)
            && this.validateCriteria(rule.Ruleset.Criteria, lineItem));
        matchingRules.forEach(rule => this.processEntries(rule, rule.RuleEntries, p, lineItem.Quantity, lineItem.AttributeValue, lineItem));
        return p;
    }
    /**
     * @ignore
     */
    validateCriteria(criteriaString, lineItem) {
        if (!criteriaString)
            return true;
        else {
            const criteriaObject = JSON.parse(criteriaString);
            if (criteriaObject.sObjectName !== 'Apttus_Config2__LineItem__c')
                return false;
            let valid = true;
            get(criteriaObject, 'filter.predicates', []).forEach(p => {
                let validItem = false;
                if (p.CompOper === 'contains' && get(lineItem, this.metadataService.getKeyName(lineItem, p.FieldName), '').indexOf(get(p, 'FieldValue', '')) >= 0)
                    validItem = true;
                else if (p.CompOper === 'equal to' && get(lineItem, this.metadataService.getKeyName(lineItem, p.FieldName), '') === get(p, 'FieldValue', ''))
                    validItem = true;
                else if (p.CompOper === 'not equal to' && get(lineItem, this.metadataService.getKeyName(lineItem, p.FieldName), '') !== get(p, 'FieldValue', ''))
                    validItem = true;
                else if (p.CompOper === 'starts with' && get(lineItem, this.metadataService.getKeyName(lineItem, p.FieldName), '').indexOf(get(p, 'FieldValue', '')) === 0)
                    validItem = true;
                else if (p.CompOper === 'does not contain' && get(lineItem, this.metadataService.getKeyName(lineItem, p.FieldName), '').indexOf(get(p, 'FieldValue', '')) < 0)
                    validItem = true;
                else if (p.CompOper === 'less than' && get(lineItem, this.metadataService.getKeyName(lineItem, p.FieldName), '') < get(p, 'FieldValue', ''))
                    validItem = true;
                else if (p.CompOper === 'greater than' && get(lineItem, this.metadataService.getKeyName(lineItem, p.FieldName), '') > get(p, 'FieldValue', ''))
                    validItem = true;
                else if (p.CompOper === 'less than or equal to' && get(lineItem, this.metadataService.getKeyName(lineItem, p.FieldName), '') <= get(p, 'FieldValue', ''))
                    validItem = true;
                else if (p.CompOper === 'greater than or equal to' && get(lineItem, this.metadataService.getKeyName(lineItem, p.FieldName), '') >= get(p, 'FieldValue', ''))
                    validItem = true;
                else if (p.CompOper === 'in' && get(p, 'FieldValue', '').indexOf(get(lineItem, this.metadataService.getKeyName(lineItem, p.FieldName), '')) >= 0)
                    validItem = true;
                else if (p.CompOper === 'not in' && get(p, 'FieldValue', '').indexOf(get(lineItem, this.metadataService.getKeyName(lineItem, p.FieldName), '')) < 0)
                    validItem = true;
                if (!validItem)
                    valid = false;
            });
            return valid;
        }
    }
    /**
     * @ignore
     */
    matrixAdjustment(p, priceMatrices, quantity, attributeValue, context) {
        if (!isEmpty(get(priceMatrices, '[0].MatrixEntries', []))) {
            const sortedDimensions = priceMatrices.sort((n1, n2) => n1.Sequence - n2.Sequence);
            const qty = get(context, 'Quantity', quantity);
            for (const matrix of sortedDimensions) {
                this.processEntries(matrix, matrix.MatrixEntries, p, qty, attributeValue, context);
                if (matrix.StopProcessingMoreMatrices) {
                    break;
                }
            }
        }
    }
    /**
     * @ignore
     */
    processEntries(record, entries, p, quantity, attributeValue, lineItem) {
        let lastEntry = null;
        const sortedEntries = entries.sort((n1, n2) => n1.Sequence - n2.Sequence);
        for (const entry of sortedEntries) {
            let validEntry = false;
            for (let i = 1; i <= 6; i++) {
                const prefix = 'Dimension' + i;
                if (get(record, prefix + '.ContextType') || get(record, prefix + '.BusinessObject')) {
                    if (get(record, prefix + '.ContextType') === 'Product Attribute') {
                        if (attributeValue && attributeValue.hasOwnProperty(get(record, prefix + '.Datasource'))) {
                            validEntry = this.validateEntry(get(record, prefix + 'ValueType'), get(lineItem, this.metadataService.getKeyName(lineItem, get(record, prefix + '.Datasource'))), get(entry, prefix + 'Value'));
                        }
                    }
                    else if (get(record, prefix + '.ContextType') === 'Line Item' || get(record, prefix + '.ContextType') === 'Order Line Item' || get(record, prefix + '.BusinessObject') === 'Apttus_Config2__LineItem__c') {
                        validEntry = this.validateEntry(get(record, prefix + 'ValueType'), get(lineItem, this.metadataService.getKeyName(lineItem, get(record, prefix + '.Datasource'))), get(entry, prefix + 'Value'));
                    }
                }
                if (validEntry)
                    break;
            }
            if (validEntry) {
                lastEntry = entry;
                break;
            }
        }
        if (get(lastEntry, 'AdjustmentType') === Adjustment.LIST_PRICE_OVERRIDE)
            p.basePrice = get(lastEntry, 'AdjustmentAmount');
        else
            p.basePrice = PriceService.adjustValue(get(lastEntry, 'AdjustmentAmount'), get(lastEntry, 'AdjustmentType'), p.basePrice);
    }
    /**
     * @ignore
     */
    validateEntry(attrType, attrValue, expectedValue) {
        if (attrType === 'Discrete')
            return attrValue === expectedValue || Number(attrValue) === Number(expectedValue);
        else if (attrType === 'Range') {
            return Number(attrValue) <= Number(expectedValue);
        }
        else
            return false;
    }
    /**
     * Method converts a given price value to price list currency, based on the conversion rates defined.
     * @ignore
     */
    convertCurrency(value) {
        let res = value;
        this.conversionService.getCurrencyTypeForPricelist().pipe(take(1)).subscribe(currency => {
            const conversionRate = (currency && currency.ConversionRate) ? currency.ConversionRate : 1;
            res = value * conversionRate;
        });
        return res;
    }
}
PriceService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceService, deps: [{ token: PriceListService }, { token: CartService }, { token: PriceMatrixService }, { token: i1.MetadataService }, { token: LocalCurrencyPipe }, { token: ProductAttributeValueService }, { token: ConversionService }, { token: StorefrontService }], target: i0.ɵɵFactoryTarget.Injectable });
PriceService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: PriceListService }, { type: CartService }, { type: PriceMatrixService }, { type: i1.MetadataService }, { type: LocalCurrencyPipe }, { type: ProductAttributeValueService }, { type: ConversionService }, { type: StorefrontService }]; } });
/** @ignore  */
var Adjustment;
(function (Adjustment) {
    Adjustment["PER_DISCOUNT"] = "% Discount";
    Adjustment["DISCOUNT_AMOUNT"] = "Discount Amount";
    Adjustment["PER_MARKUP"] = "% Markup";
    Adjustment["MARKUP_AMT"] = "Markup Amount";
    Adjustment["PRICE_FACTOR"] = "Price Factor";
    Adjustment["LIST_PRICE_OVERRIDE"] = "List Price Override";
})(Adjustment || (Adjustment = {}));

/**
 * @ignore
 */
class SearchService extends AObjectService {
    constructor() {
        super(...arguments);
        this.productService = this.injector.get(ProductService);
        this.categoryService = this.injector.get(CategoryService);
        this.plService = this.injector.get(PriceListService);
        this.pliService = this.injector.get(PriceListItemService);
        this.translatorService = this.injector.get(TranslatorLoaderService);
    }
    searchProducts(searchString, limit = 10, pageNumber = 0, orderBy = null, orderDirection = null, conditions = null, joins = null) {
        if (searchString && searchString.trim().length > 0) {
            searchString = deburr(searchString);
            const totalRecords$ = this.productService.query({
                conditions: conditions,
                searchString: searchString,
                joins: joins,
                aggregate: true
            });
            const searchRecords$ = this.productService.query({
                conditions: conditions,
                searchString: searchString,
                joins: joins,
                page: new APageInfo(limit, pageNumber)
            });
            return combineLatest([totalRecords$, searchRecords$])
                .pipe(map$1(([totalRecords, searchRecords]) => ({
                productList: searchRecords,
                totals: get(first(totalRecords), 'total_records')
            })));
        }
        else {
            return combineLatest(this.productService.query({ conditions: conditions, sortOrder: [new ASort(this.productService.type, orderBy, orderDirection)], page: new APageInfo(limit, pageNumber), joins: joins, cacheStrategy: 'performance' }), this.productService.aggregate(conditions, 'AND', null, joins).pipe(map$1(res => get(first(res), 'total_records')))).pipe(map$1(res => {
                return {
                    productList: res[0],
                    totals: res[1]
                };
            }));
        }
    }
}
SearchService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SearchService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
SearchService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SearchService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SearchService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * The Product Information service is a way to find the attachments associated with a product
 *
 * <h3>Usage</h3>
 *
 ```typescript
 import { ProductInformationService } from '@congacommerce/ecommerce';
 
 constructor(private productInformationService: ProductInformationService) {}
 
 // or
 
 export class MyService extends AObjectService {
      private productInformationService: ProductInformationService = this.injector.get(ProductInformationService);
  }
 ```
 */
class ProductInformationService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = ProductInformation;
    }
    /**
     * Method is used to retrieve the list of production information items with attachments for a given product.
     * ### Example
     ```typescript
        import { ProductInformationService, ProductInformation } from '@congacommerce/ecommerce';

        export class MyComponent implements OnInit{
            productsInfo: ProductInformation;
            productsInfo$: Observable<ProductInformation>;
        
            constructor(private productInformationService: ProductInformationService){}
        
            ngOnInit(){
                this.productInformationService.getProductInformation(productId: string).subscribe(products => {...});
                // or
                this.productsInfo$ = this.productInformationService.getProductInformation(productId: string);
            }
        }
        ```
     * @param productId the id of the product to return the product inoformation items for
     * @returns an observable containing the product information details for the given product
     */
    getProductInformation(productId) {
        if (!productId)
            return of([]);
        else {
            return this.platformService.apiService.get(`/Apttus_Config2__ProductInformation__c?condition[0]=ProductId,Equal,${productId}&children=Attachments`);
        }
    }
    /**
     * Method is used to retrieve the string URL for product attachments.
     *
     * ### Example
     ```typescript
        import { ProductInformationService, ProductInformation } from '@congacommerce/ecommerce';

        export class MyComponent implements OnInit{
            productAttachments;
        
            constructor(private productInformationService: ProductInformationService){}
        
            ngOnInit(){
                this.productAttachments = this.productInformationService.getAttachmentUrl(attachmentId: string, productId: string);
            }
        }
        ```
     * @param productId the id of the product to generate the attachment url for
     * @param attachmentId the id of the product attachment file
     * @returns a string url for the given product attachment
     */
    getAttachmentUrl(attachmentId, productId) {
        const endpoint = `${this.configurationService.get('endpoint')}/servlet/servlet.FileDownload?file=`;
        return endpoint + attachmentId;
    }
}
ProductInformationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductInformationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ProductInformationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductInformationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductInformationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * Notes allows to add/fetch comments.
 * <h3>Usage</h3>
 *
 ```typescript
 import { NoteService, AObjectService} from '@congacommerce/ecommerce';
 
 export class MyComponent implements OnInit{
 constructor( private noteService: NoteService)
 }
 // or
 export class MyService extends AObjectService {
      private noteService: NoteService = this.injector.get(NoteService);
  }
 ```
 */
class NoteService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = Note;
    }
    /**
     * This method fetches list of  notes using ParentId.
     * ### Example:
     ```typescript
     import { NoteService, Note } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         NoteList: Array<Note>;
         NoteList$: Observable<Array<Note>>;
     
         constructor(private noteService: NoteService){}
     
         getNoteList(Id: string){
             this.noteService.getNotes(Id).subscribe(a => this.NoteList = a);
             // or
             this.NoteList$ = this.noteService.getNotes(Id);
         }
     }
     ```
     * @param parentId as string
     * @returns Observable of list of note object.
     * */
    getNotes(parentId) {
        return this.platformService.apiService.get(`/note?condition[0]=ParentId,Equal,${parentId}&lookups=CreatedById&sort[field]=CreatedDate&sort[direction]=DESC`, this.type);
    }
}
NoteService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: NoteService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
NoteService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: NoteService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: NoteService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * @ignore
 */
class AttachmentsService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = QuoteAttachment;
    }
    /**
       * Method returns an observable of array of string.
       * ### Example:
       ```typescript
        import { QuoteAttachment, AttachmentService } from '@congacommerce/ecommerce';
        import { Observable } from 'rxjs/Observable';
  
        export class MyComponent implements OnInit{
             attachments: Array<string>;
             attachments$: Observable<Array<string>>;
  
             constructor(private attachmentService: AttachmentService){}
  
             addAttachment(attachmentObj: QuoteAttachment, parentId: string){
                  this.attachmentService.addAttachment(attachmentObj, parentId).subscribe(res => attachments = res);
                  // or
                  attachments$ = this.attachmentService.addAttachment(attachmentObj, parentId);
             }
        }
       ```
       * @param attachment instance of QuoteAttachment is required to create attachment.It has the details of attachement object.
       * @param parentId type string is required to create attachment. Id can be quoteId or OrderID.
       * @returns an array of string of id's in an observable for a given attachment.
       */
    addAttachment(attachment = new QuoteAttachment(), parentId) {
        attachment.ParentId = parentId;
        return this.upsert([attachment]).pipe(map$1(res => _.get(res, '[0].Id')));
    }
}
AttachmentsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AttachmentsService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
AttachmentsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AttachmentsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AttachmentsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * The attachment represents a file that can be associated with an order, quote, etc as an attachment.
 * @ignore
 */
class AttachmentService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = Attachment;
    }
    /**
     * Method to upload the attachment for quote, order, etc and associate with given parent id
     * ### Example:
     ```typescript
      import { AttachmentService, Attachment } from '@congacommerce/ecommerce';
      import { Observable } from 'rxjs/Observable';

      export class MyComponent implements OnInit{

           constructor(private attachmentService: AttachmentService){}

           ngOnInit(){
                this.attachmentService.uploadAttachment(file: File, parentId: string).subscribe((res) => {
                });
           }
      }
     ```
     * @param file file to upload as an attachment for given parent id
     * @param parentId id of associted parent of an attachment
     * @returns an observable of the uploaded attached with id, errors and status
     */
    uploadAttachment(file, parentId) {
        if (!file) {
            return throwError('Invalid file');
        }
        if (!parentId) {
            return throwError('Invalid parent id');
        }
        let reader = new FileReader();
        reader.readAsDataURL(file);
        return Observable.create((observer) => {
            reader.onload = () => {
                let base64data = reader.result.toString().split(',')[1];
                this.platformService.getConnection().sobject('Attachment').create({
                    ParentId: parentId,
                    Name: file.name,
                    Body: (base64data) ? base64data : '',
                    ContentType: file.type
                }).then((res) => {
                    observer.next(res);
                    observer.complete();
                    this.cacheService.refresh(Quote);
                });
            };
            reader.onerror = (error) => {
                observer.error(error);
            };
        });
    }
    /** Method to get attachments */
    getAttachments(parentId) {
        return this.platformService.apiService.get(`/attachment?condition[0]=ParentId,Equal,${parentId}&lookups=CreatedById&sort[field]=CreatedDate&sort[direction]=DESC`, Attachment);
    }
}
AttachmentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AttachmentService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
AttachmentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AttachmentService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AttachmentService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * The service is responsible for fetching the product feature values.
 * <h3>Usage</h3>
 *
 ```typescript
 import { ProductFeatureValueService, AObjectService} from '@congacommerce/ecommerce';
 
 export class MyComponent implements OnInit{
 constructor( private productFeatureValueService: ProductFeatureValueService)
 }
 // or
 export class MyService extends AObjectService {
      private productFeatureValueService: ProductFeatureValueService = this.injector.get(ProductFeatureValueService);
  }
 ```
 */
class ProductFeatureValueService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = ProductFeatureValue;
    }
    /**
     * This method fecthes the feature values for the list of products.
     * ### Example:
     ```typescript
     import { ProductFeatureValueService, ProductFeatureValue, Product } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         productFeatureValue$: Observable<Array<ProductFeatureValue>>;
         productFeatureValue: Array<ProductFeatureValue>;
     
         constructor(private productFeatureValueService ProductFeatureValueService){}
     
         getFeature(productList: Array<Product> | Array<string>){
            this.productFeatureValueService.getProductFeatureValues(productList).subscribe(a => this.productFeatureValue = a);
             // or
             this.productFeatureValue$ = this.productFeatureValueService.getProductFeatureValues(productList);
         }
     }
     ```
     * @params productlist is an Array of ProductObject or Array of productId.
     * @returns an observable of Array of ProductFeatureValue object.
     */
    getProductFeatureValues(productList) {
        if (get(productList, 'length') > 0) {
            let productIds = null;
            if (every(productList, item => typeof (item) === 'string')) {
                productIds = map(productList, p => p).join(',');
            }
            else {
                productIds = map(productList, p => p.Id).join(',');
            }
            return this.query({
                conditions: [new ACondition(this.type, 'ProductId', 'In', productIds)],
                lookups: [
                    {
                        field: 'Apttus_Config2__FeatureId__c',
                        lookups: [{ field: 'Apttus_Config2__FeatureSetId__c' }]
                    }
                ]
            });
        }
        else
            return of(null);
    }
}
ProductFeatureValueService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductFeatureValueService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ProductFeatureValueService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductFeatureValueService, providedIn: 'root' });
__decorate([
    memoize(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", Observable)
], ProductFeatureValueService.prototype, "getProductFeatureValues", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductFeatureValueService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], propDecorators: { getProductFeatureValues: [] } });

/**
 * File services allows to fetch and download attachment for the order/quote.
 * <h3>Usage</h3>
 *
 ```typescript
import { FileService, AObjectService} from '@congacommerce/ecommerce';

export class MyComponent implements OnInit{
constructor( private fileService: FileService)
}
// or
export class MyService extends AObjectService {
     private fileService: FileService = this.injector.get(FileService);
 }
```
 */
class FileService {
    constructor(apiService) {
        this.apiService = apiService;
    }
    /**
     * This method fetches all the files based on entity id.
     * ### Example:
     ```typescript
     import { FileService, File } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         fileList: Array<File>;
         fileList$: Observable<Array<File>>;
     
         constructor(private fileService: FileService){}
     
         getFiles(Id: string){
             this.fileService.getFiles(Id).subscribe(a => this.fileList = a);
             // or
             this.fileList$ = this.fileService.getFiles(Id);
         }
     }
     ```
     * @param entityId Ids is an instance of string.
     * @returns Observable<Array<file>> returns an observable list of files based on given id.
    */
    getFiles(entityId) {
        return this.apiService.get(`/files/${entityId}`, File);
    }
    /**
     * This method used to download attachments.
     * ### Example:
     ```typescript
     import { FileService, File } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         fileList: Array<File>;
         fileList$: Observable<Array<File>>;
     
         constructor(private fileService: FileService){}
     
         downloadFiles(file: File){
            this.fileService.downloadFiles(file);
         }
     }
     ```
     * @param file is an instance of <File>.
    */
    downloadFile(file) {
        this.apiService.get(`/files/${file.Id}/download`)
            .subscribe(data => download('data:text/plain,base64,' + data, file.Title, 'text/plain'));
    }
}
FileService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FileService, deps: [{ token: i1.ApiService }], target: i0.ɵɵFactoryTarget.Injectable });
FileService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FileService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FileService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.ApiService }]; } });
/* An interface for the attachments associated with order/quote */
class File extends AObject {
}

/**
 * @ignore
 */
class TaxServiceCore extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = TaxBreakup;
        this.cartService = this.injector.get(CartService);
        this.apiService = this.injector.get(ApiService);
        this.configService = this.injector.get(ConfigurationService);
    }
    computeTaxForCart() {
        return this.cartService.getMyCart().pipe(take(1), mergeMap((cart) => {
            if (cart.Id) {
                return this.apiService.post(`/carts/${cart.Id}/tax?mode=${this.configService.get('pricingMode')}`).pipe(tap(() => this.cartService.priceCart()));
            }
            else {
                return of(null);
            }
        }));
    }
    getTaxBreakupForLineItem(lineItemId) {
        return this.where([new ACondition(this.type, 'LineItemId', 'Equal', lineItemId)], 'AND', null, null, null);
    }
    getTaxBreakUpsForConfiguration(...args) {
        return this.cartService.getMyCart().pipe(flatMap((cartData) => {
            return this.query({
                conditions: [
                    new ACondition(this.type, 'LineItem.LineType', 'Equal', 'Misc'),
                    new ACondition(this.type, 'LineItem.ConfigurationId', 'Equal', cartData.Id),
                    new ACondition(this.type, 'BreakupType', 'NotEqual', 'Total')
                ], skipCache: true
            });
        }));
    }
}
TaxServiceCore.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TaxServiceCore, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
TaxServiceCore.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TaxServiceCore, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TaxServiceCore, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });
/**
 * @ignore
 */
class ProposalTaxBreakupService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = ProposalTaxBreakup;
    }
    getTaxBreakupForQuote(quoteId) {
        return this.query({
            conditions: [
                new ACondition(this.type, 'LineItem.Proposal', 'Equal', quoteId),
                new ACondition(this.type, 'LineItem.LineType', 'Equal', 'Misc')
            ]
        });
    }
}
ProposalTaxBreakupService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProposalTaxBreakupService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ProposalTaxBreakupService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProposalTaxBreakupService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProposalTaxBreakupService, decorators: [{
            type: Injectable
        }] });
/**
 * @ignore
 */
class OrderTaxBreakupService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = OrderTaxBreakup;
    }
    getTaxBreakupForOrder(orderId) {
        return this.query({
            conditions: [
                new ACondition(this.type, 'OrderLineItem.OrderId', 'Equal', orderId),
                new ACondition(this.type, 'OrderLineItem.LineType', 'Equal', 'Misc')
            ]
        });
    }
}
OrderTaxBreakupService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OrderTaxBreakupService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
OrderTaxBreakupService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OrderTaxBreakupService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OrderTaxBreakupService, decorators: [{
            type: Injectable
        }] });

/**
 * The order represents purchase of products. The orders are generally converted from the cart.
 *
 * <h3>Usage</h3>
 *
 ```typescript
 import { OrderService } from '@congacommerce/ecommerce';
 
 constructor(private orderService: OrderService) {}
 
 // or
 
 export class MyService extends AObjectService {
      private orderService: OrderService = this.injector.get(OrderService);
  }
 ```
 */
class OrderService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = Order;
        this.cartItemService = this.injector.get(CartItemService);
        this.userService = this.injector.get(UserService);
        this.cartService = this.injector.get(CartService);
        this.priceListService = this.injector.get(PriceListService);
        this.accountService = this.injector.get(AccountService);
        this.itemService = this.injector.get(CartItemService);
        this.taxService = this.injector.get(TaxServiceCore);
        this.translateService = this.injector.get(TranslateService);
        this.noteService = this.injector.get(NoteService);
        this.attachmentService = this.injector.get(AttachmentService);
        this.orderLineItemService = this.injector.get(OrderLineItemService);
    }
    /**
     * The method fetches the order based on given order Id in parameter.
     *
     * ### Example:
     ```typescript
     import { OrderService, Order } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     export class MyComponent implements OnInit{
           result: Order
           result$: Observable<Order>;
           constructor(private orderService: OrderService){}

           getOrder(orderId: string){
            this.orderService.getOrder(orderId).subscribe(r => this.result = r);
            // or
            results$ = this.orderService.getOrder(orderId);
           }
      }
     ```
     * @param Id is an order Id is of type string.
     * @returns An observable of Order for a given Order Id.
     */
    getOrder(Id) {
        return combineLatest(this.platformService.apiService.get(`/orders?condition[0]=Id,Equal,${Id}&lookups=PriceListId,PrimaryContact,BillToAccountId,ShipToAccountId,SoldToAccountId,Owner,CreatedBy`, this.type), this.orderLineItemService.getOrderLineItemsForOrder(Id), this.noteService.getNotes(Id), this.attachmentService.getAttachments(Id)).pipe(map$1(([arr, lineItems, notes, attachments]) => {
            const order = first(arr);
            if (!order) {
                return;
            }
            order.OrderLineItems = lineItems;
            order.Notes = notes;
            order.Attachments = attachments;
            return order;
        }));
    }
    /**
     * @ignore
     */
    globalFilter() {
        return combineLatest(this.userService.getCurrentUser(), this.accountService.getCurrentAccount())
            .pipe(filter$1(([user, account]) => user != null), map$1(([user, account]) => {
            let conditions = [
                new ACondition(this.type, 'OwnerId', 'Equal', user.Id),
                new ACondition(this.type, 'CreatedById', 'Equal', user.Id)
            ];
            return [new AFilter(this.type, conditions, null, 'OR'), new AFilter(this.type, [new ACondition(this.type, 'SoldToAccountId', 'Equal', account.Id)])];
        }));
    }
    /**
     * @ignore
     */
    getMyOrders(accountId = null, days, limit = 10, pageNumber = 0, orderBy = 'CreatedDate', orderDirection = 'DESC') {
        const conditions = [];
        if (accountId)
            conditions.push(new ACondition(this.type, 'BillToAccountId', 'Equal', accountId));
        if (days)
            conditions.push(new ACondition(this.type, 'CreatedDate', 'LastXDays', days));
        return this.query({
            conditions: conditions,
            sortOrder: [new ASort(this.type, orderBy, orderDirection)],
            page: new APageInfo(limit, pageNumber),
            expand: false
        });
    }
    /**@ignore */
    getOrderTotal() {
        return null;
    }
    /**
     * @ignore
     */
    convertCartToOrder(order = new Order(), primaryContact, cart, selectedAccount, acceptOrder = true) {
        const account$ = isEmpty(selectedAccount)
            ?
                this.accountService.getCurrentAccount().pipe(map$1(account => {
                    return {
                        BillToAccountId: account.Id,
                        ShipToAccountId: account.Id,
                        SoldToAccountId: account.Id
                    };
                }))
            : of(selectedAccount);
        const cart$ = !isNil(cart) ? of(cart) : this.cartService.getMyCart();
        return zip(account$, cart$)
            .pipe(mergeMap(([_account, _cart]) => {
            order.ShipToAccountId = defaultTo(get(_account, 'ShipToAccountId') ? get(_account, 'ShipToAccountId') : get(_cart, 'ShipToAccountId'), get(_account, 'Id'));
            order.BillToAccountId = get(_account, 'BillToAccountId') ? get(_account, 'BillToAccountId') : defaultTo(get(_cart, 'BillToAccountId'), get(_account, 'Id'));
            order.SoldToAccountId = get(_account, 'SoldToAccountId') ? get(_account, 'SoldToAccountId') : get(_account, 'Id');
            let orderReq = { Order: order.strip(), Contact: primaryContact.strip() };
            return this.platformService.apiService.post(`/carts/${CartService.getCurrentCartId()}/checkout`, orderReq, this.type)
                .pipe(tap(() => {
                CartService.deleteLocalCart();
                this.cacheService.refresh(this.type);
                this.cartService.refreshCart();
            }));
        }));
    }
    /**
     * @ignore
     */
    convertOrderToCart(order) {
        return this.createCart(order.Id).pipe(mergeMap(cartId => this.cartService.getCartWithId(cartId)), delayWhen(cart => this.taxService.delete(flatten(map(cart.LineItems, item => (item.OrderTaxBreakups))), false)), delayWhen(cart => this.cartItemService.delete(filter(get(cart, 'LineItems'), item => (item.LineType === 'Misc' && item.ChargeType === 'Sales Tax')), false)), mergeMap(cart => this.cartService.setCartActive(cart)));
    }
    /**
     * @ignore
     */
    mergeCartItems(orderItemList, cart) {
        return iif(() => cart != null, of(cart), this.cartService.getMyCart().pipe(take(1))).pipe(mergeMap(tempCart => this.priceListService.getPriceListId().pipe(take(1), mergeMap(priceListId => {
            let cartItemInsertList = [];
            let cartItemUpdateList = [];
            for (let oldCartItem of orderItemList) {
                let cartItem = new CartItem();
                if (tempCart.LineItems && tempCart.LineItems) {
                    let currentCartItem = tempCart.LineItems.filter(item => item.ProductId === oldCartItem.ProductId)[0];
                    if (currentCartItem) {
                        cartItem.Id = currentCartItem.Id;
                        cartItem.Quantity = currentCartItem.Quantity;
                        cartItemUpdateList.push(cartItem);
                    }
                }
                if (!cartItem.Id) {
                    cartItem.Product = oldCartItem.Product;
                    cartItem.PriceList.Id = priceListId;
                    cartItem.ItemSequence = tempCart.NumberOfItems + 1;
                    cartItem.LineNumber = tempCart.NumberOfItems + 1;
                    cartItem.PrimaryLineNumber = tempCart.NumberOfItems + 1;
                    cartItem.ConfigurationId = tempCart.Id;
                    cartItemInsertList.push(cartItem);
                }
                cartItem.Quantity += oldCartItem.Quantity;
            }
            return iif(() => cartItemUpdateList.length > 0, this.itemService.update(cartItemUpdateList), of(null)).pipe(mergeMap(() => iif(() => cartItemInsertList.length > 0, this.itemService.create(cartItemInsertList), of(null))));
        }), tap(() => this.cartService.priceCart('default')))));
    }
    /**
     * @ignore
     */
    getOrderByName(orderName) {
        return this.where([new ACondition(this.type, 'Name', 'Equal', orderName)]).pipe(map$1(res => res[0]));
    }
    /**
     * @ignore
     */
    getOrderByQuote(quoteId) {
        return this.where([new ACondition(this.type, 'ProposalId', 'Equal', quoteId)]).pipe(map$1(res => first(res)));
    }
    /**
     * @ignore
     */
    acceptOrder(orderId) {
        return this.platformService.apiService.post(`/orders/${orderId}/accept`).pipe(tap(() => this.cacheService.refresh(this.type)));
    }
    /**
     * @ignore
     */
    createCart(orderId) {
        if (!orderId) {
            this.translateService.stream('SERVICES.INVALID_ORDER_ID').subscribe((val) => {
                return throwError(val);
            });
        }
        return this.platformService.apiService.post(`/orders/${orderId}/carts`);
    }
    /**
     * @ignore
     */
    getAllOrders() {
        return this.aggregate([new ACondition(this.type, 'Id', 'NotNull', null)]).pipe(map$1(res => res[0]));
    }
}
OrderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OrderService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
OrderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OrderService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OrderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * The quote represents a price breakdown for a given product configuration. Quotes are generally associated with an approval process and can be converted to a cart or an order.
 *
 * <h3>Usage</h3>
 *
 ```typescript
 import { QuoteService } from '@congacommerce/ecommerce';

 constructor(private quoteService: QuoteService) {}

 // or

 export class MyService extends AObjectService {
     private quoteService: QuoteService = this.injector.get(QuoteService);
  }
 ```
 */
class QuoteService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = Quote;
        this.contactService = this.injector.get(ContactService);
        this.cartItemService = this.injector.get(CartItemService);
        this.noteService = this.injector.get(NoteService);
        this.userService = this.injector.get(UserService);
        this.cartService = this.injector.get(CartService);
        this.translateService = this.injector.get(TranslateService);
        this.taxService = this.injector.get(TaxServiceCore);
        this.quoteLineItemService = this.injector.get(QuoteLineItemService);
        this.attachmentService = this.injector.get(AttachmentService);
        this.accountService = this.injector.get(AccountService);
    }
    onInit() {
        this.contactService = this.injector.get(ContactService);
        this.cartItemService = this.injector.get(CartItemService);
    }
    /** The Method gets details of the Quote.
     * ### Example:
     ```typescript
     import { QuoteService, Quote } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';

     export class MyComponent implements OnInit{
           quote: Quote;

           constructor(private quoteService: QuoteService){}

                this.quoteService.getQuote(quoteId).subscribe(
                    c => c,
                    err => {...}
                );
        }
     }
     ```
     * @param Id the Id of the quote
     * @returns an observable of the quote instance that was created from the cart
     * @ignore
     *  // TODO : use this method getQuote in quote detail component
    */
    getQuote(Id) {
        return combineLatest(this.platformService.apiService.get(`/quotes?condition[0]=Id,Equal,${Id}&lookups=PriceListId,Primary_Contact,BillToAccountId,ShipToAccountId,Account,CreatedBy`, this.type), this.quoteLineItemService.getQuoteLineItems(Id), this.noteService.getNotes(Id), this.attachmentService.getAttachments(Id)).pipe(map$1(([arr, lineItems, notes, attachments]) => {
            const quote = first(arr);
            if (!quote) {
                return;
            }
            quote.R00N70000001yUfBEAU = lineItems;
            quote.Notes = notes;
            quote.Attachments = attachments;
            return quote;
        }));
    }
    /**
 * @ignore
 */
    globalFilter() {
        return combineLatest(this.userService.getCurrentUser(), this.accountService.getCurrentAccount())
            .pipe(filter$1(([user, account]) => user != null), map$1(([user, account]) => {
            const conditions = [
                new ACondition(this.type, 'OwnerId', 'Equal', user.Id),
                new ACondition(this.type, 'CreatedById', 'Equal', user.Id)
            ];
            return [new AFilter(this.type, conditions, null, 'OR'), new AFilter(this.type, [new ACondition(this.type, 'AccountId', 'Equal', account.Id)])];
        }));
    }
    /**
     * Returns a list of quotes for the given user.
     * ### Example:
     ```typescript
     import { QuoteService, Quote } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';

     export class MyComponent implements OnInit{
           quoteList: Array<Quote>;
           quoteList$: Observable<Array<Quote>>;

           constructor(private quoteService: QuoteService){}

           ngOnInit(){
                this.quoteService.getMyQuotes().subscribe(q => this.quoteList = q);
                // or
                this.quoteList$ = this.quoteService.getMyQuotes();
           }
      }
     ```
     * @param days the number of days in the past from now with which to retrieve quotes.
     * @param limit the total number of records to return
     * @param offset the offset of the records to return (i.e. records 10-20, the offset will be 10)
     * @param orderBy the field by which to order the records
     * @param orderDirection the direction in which to sort the records
     * @returns a an observable array of quote instances for the current user
     */
    getMyQuotes(days, limit = 10, pageNumber = 0, orderBy = 'CreatedDate', orderDirection = 'DESC') {
        return this.platformService.apiService.get(`/quotes?lookups=PriceListId&children=SummaryGroups&sort[field]=${orderBy}&sort[direction]=${orderDirection}&page[limit]=${limit}&page[current]=${pageNumber}`, this.type);
    }
    /**
     * Method converts the current cart into a quote instance. Sets the business object on the cart to 'Proposal'
     * ### Example:
     ```typescript
     import { QuoteService, Quote } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';

     export class MyComponent implements OnInit{
           quote: Quote;

           constructor(private quoteService: QuoteService){}

           ngOnInit(){
                const q = new Quote();
                q.Name = 'Sample Quote';
                this.quoteService.convertCartToQuote(q).subscribe(
                    q => this.quote = q,
                    err => {...}
                );
           }
      }
     ```
     * @param quote an optional quote instance to specify predefined parameters on the quote that gets created
     * @returns an observable of the quote instance that was created from the cart
     */
    convertCartToQuote(quote = new Quote()) {
        quote.Primary_ContactId = (quote.Primary_ContactId) ? quote.Primary_ContactId : get(quote, 'Primary_Contact.Id');
        const q = quote.strip();
        return this.platformService.apiService.post(`/carts/${CartService.getCurrentCartId()}/proposal`, q, this.type)
            .pipe(tap(() => {
            this.cacheService.refresh(this.type);
            CartService.deleteLocalCart();
            this.cartService.refreshCart();
        }));
    }
    /**
     * Method creates new cart and clones the finalized cart linked to the quote Id passed as argument to the new cart and set the new cart as active
     *
     * ### Example:
     ```typescript
     import { QuoteService, Quote } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';

     export class MyComponent implements OnInit{
           quote: Quote;

           constructor(private quoteService: QuoteService){}

           convertQuoteToCart(quoteId: string) {
                this.quoteService.convertQuoteToCart(quoteId).subscribe(
                    c => c,
                    err => {...}
                );
           }
        }
     }
     ```
     * @param quote an optional quote instance to specify predefined parameters on the quote that gets created
     * @returns an observable of the quote instance that was created from the cart
     */
    convertQuoteToCart(quoteId) {
        return this.createCart(quoteId).pipe(mergeMap(cartId => this.cartService.getCartWithId(cartId)), delayWhen(cart => this.taxService.delete(flatten(map(cart.LineItems, item => (item.TaxBreakups))), false)), delayWhen(cart => this.cartItemService.delete(filter(get(cart, 'LineItems'), item => (item.LineType === 'Misc' && item.ChargeType === 'Sales Tax')), false)), mergeMap(cart => this.cartService.setCartActive(cart)));
    }
    /**
     * Method generates a document for a given quote record based on a template.
     * ### Example:
     ```typescript
     import { QuoteService, Quote, TemplateService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';

     export class MyComponent implements OnInit{

           constructor(private quoteService: QuoteService, private templateService: TemplateService){}

           generateDocumentForQuote(quote: Quote){
               this.templateService.getActiveTemplates('Proposal')
                .take(1)
                .subscribe(templateList => {
                    this.quoteService.generateDocument(templateList[0], quote, 'PDF', true, 'Full access').subscribe(
                        () => {...},
                        err => {...}
                    );
                });
           }
      }
     ```
     * @param template The instance of the template record with which to generate the document
     * @param quote the instance of the quote to generate the document from
     * @param format the format of the document to create
     * @param isDraft A boolean value determining if the draft watermark should be placed on the quote
     * @param pLevel Access level of the document that gets generated
     * @param synchronizeWithCartId the cart id to synchronize the quote with first before generating the document
     * @returns an empty observable when the process completes
     */
    // generateDocument(template: Template, quote: Quote, format: 'PDF' | 'DOC' | 'DOCX' | 'RTF' = 'PDF', isDraft: boolean = true, pLevel: 'Full access' | 'Insert comments only' | 'Insert comments and tracked changes only' | 'Read only' | 'Fill in form fields only' = 'Read only', synchronizeWithCartId: string = null): Observable<void> {
    //     // return this.platformService.organizationId().flatMap(orgId => {
    //     //     if(synchronizeWithCartId)
    //     //         return this.soapService.doRequest('Apttus_CPQApi/CPQWebService', 'synchronizeCart', { request: { CartId: synchronizeWithCartId } }).flatMap(() => this.soapService.doRequest('Apttus_Proposal/MergeWebService', 'generateDoc2', {
    //     //             templateId: template.Id,
    //     //             proposalId: quote.Id,
    //     //             pLevel: pLevel,
    //     //             docFormat: format,
    //     //             isDraft: isDraft,
    //     //             sessionId: this.platformService.connection.accessToken,
    //     //             serverUrl: this.platformService.connection.instanceUrl + '/services/Soap/u/39.0/' + orgId
    //     //         }));
    //     //     else
    //     //         return this.soapService.doRequest('Apttus_Proposal/MergeWebService', 'generateDoc2', {
    //     //             templateId: template.Id,
    //     //             proposalId: quote.Id,
    //     //             pLevel: pLevel,
    //     //             docFormat: format,
    //     //             isDraft: isDraft,
    //     //             sessionId: this.platformService.connection.accessToken,
    //     //             serverUrl: this.platformService.connection.instanceUrl + '/services/Soap/u/39.0/' + orgId
    //     //         });
    //     // });
    //     return null;
    // }
    /**
     * Method gets a quote by the name
     * ### Example:
     ```typescript
     import { QuoteService, Quote } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';

     export class MyComponent implements OnInit{
           quote: Quote;

           constructor(private quoteService: QuoteService){}

           getQuoteByName(name: string){
                this.quoteService.getQuoteByName(name).subscribe(q => this.quote = q);
           }
      }
     ```
     * @param name the name field value of the record to retrieve
     * @returns an observable of the quote retrieved
     */
    getQuoteByName(name) {
        return this.where([new ACondition(this.type, 'Name', 'Equal', name)]).pipe(map$1(res => res[0]));
    }
    /**
     * Method to abandon the cart in Draft status.
     * ### Example:
     ```typescript
     import { QuoteService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';

     export class MyComponent implements OnInit{
           result: boolean;

           constructor(private quoteService: QuoteService){}

           abandonCart(){
                this.quoteService.abandonCart().subscribe(r => this.result = r);
           }
      }
     ```
     * @returns <code>true</code> if the operation was successful, <code>false</code> otherwise
     */
    abandonCart() {
        return this.cartService.getMyCart().pipe(take(1), mergeMap(cart => {
            return this.platformService.apiService.post(`/carts/${cart.Id}/abandon`);
        }));
    }
    /**
     * Method to accept the given quote.
     * ### Example:
     ```typescript
     import { QuoteService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';

     export class MyComponent implements OnInit{
           result: boolean;

           constructor(private quoteService: QuoteService){}

           acceptQuote(quoteId: string){
                this.quoteService.acceptQuote(quoteId).subscribe(r => this.result = r);
           }
      }
     ```
     * @param quoteId the id of quote
     * @returns <code>true</code> if the operation was successful, <code>false</code> otherwise
     */
    acceptQuote(quoteId) {
        if (!quoteId) {
            this.translateService.stream('SERVICES.INVALID_QUOTE_ID').subscribe((val) => {
                return throwError(val);
            });
        }
        return this.platformService.apiService.post(`/quotes/${quoteId}/accept`);
    }
    /**
     * Method to create a new cart for quote
     * ### Example:
     ```typescript
     import { QuoteService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';

     export class MyComponent implements OnInit{
           result: string;

           constructor(private quoteService: QuoteService){}

           abandonCart(){
                this.quoteService.createCart().subscribe(r => this.result = r);
           }
      }
     ```
     * @param quoteId the id of quote
     * @returns the id of new cart for given quote
     */
    createCart(quoteId) {
        if (!quoteId) {
            this.translateService.stream('SERVICES.INVALID_QUOTE_ID').subscribe((val) => {
                return throwError(val);
            });
        }
        return this.platformService.apiService.post(`/quotes/${quoteId}/carts`);
    }
    /**
     * Method to generate the document for a custom object
     * ### Example:
     ```typescript
     import { QuoteService, GenerateDocument } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';

     export class MyComponent implements OnInit{
           result: string;

           constructor(private quoteService: QuoteService){}

           acceptQuote(quoteId: string){
                this.quoteService.generateDocument(generateDocumentRequest: GenerateDocument).subscribe(r => this.result = r);
           }
      }
     ```
     * @param generateDocumentRequest a request for generating the document for a custom object
     * @returns Id of generated document
     */
    generateDocument(generateDocumentRequest) {
        if (!generateDocumentRequest) {
            this.translateService.stream('SERVICES.INVALID_GENERATE_DOC_REQ').subscribe((val) => {
                return throwError(val);
            });
        }
        return this.platformService.apiService.post(`quotes/generate-document`, generateDocumentRequest);
    }
    /**
   * Method to get the aggregate of quote total by approval stage
   * ### Example:
   ```typescript
   import { QuoteService, GenerateDocument } from '@congacommerce/ecommerce';
   import { Observable } from 'rxjs/Observable';

   export class MyComponent implements OnInit{
         result: string;

         constructor(private quoteService: QuoteService){}

         getGrandTotalByApprovalStage(){
             this.quoteService.getGrandTotalByApprovalStage().subscribe(r => r);
         }
         }
    }
   ```
   * @returns Aggregate of quote total object based on the Approval Stage.
   */
    getGrandTotalByApprovalStage() {
        return combineLatest(this.userService.me(), this.accountService.getCurrentAccount()).pipe(mergeMap(([user, account]) => {
            return this.platformService.apiService.post('/Apttus_QPConfig__ProposalSummaryGroup__c/query', {
                'aggregate': true,
                'groupBy': ['apttus_qpconfig__proposalid__r.Approval_Stage'],
                'aggregateFields': [{
                        'field': 'NetPrice',
                        'aggregateType': 'SUM'
                    }],
                'conditions': [{
                        'field': 'apttus_qpconfig__proposalid__r.OwnerId',
                        'filterOperator': 'In',
                        'value': user.Id
                    },
                    {
                        'field': 'Name',
                        'filterOperator': 'Equal',
                        'value': 'Grand Total'
                    },
                    {
                        'field': 'apttus_qpconfig__proposalid__r.AccountId',
                        'filterOperator': 'Equal',
                        'value': account.Id
                    }]
            })
                .pipe(map$1(res => map(res, rec => {
                return {
                    'Stage': get(rec, 'Apttus_Proposal__Approval_Stage__c'),
                    'NetPrice': get(rec, 'SUM_NetPrice')
                };
            })));
        }));
    }
    /**
     * Method moves the quote status from Draft to Approved.
     * ### Example:
     ```typescript
     import { QuoteService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     export class MyComponent implements OnInit{
           result: boolean;
           constructor(private quoteService: QuoteService){}
           finalizeQuote(quoteId: string){
                this.quoteService.finalizeQuote(quoteId).subscribe(r => this.result = r);
           }
      }
     ```
     * This method updates the status on quote from Draft to Approved.
     * @param quoteId string identifier of the quote.
     * @returns <code>true</code> if the operation was successful, <code>false</code> otherwise.
     */
    finalizeQuote(quoteId) {
        if (!quoteId) {
            this.translateService.stream('SERVICES.INVALID_QUOTE_ID').subscribe((val) => {
                return throwError(val);
            });
        }
        return this.platformService.apiService.post(`/quotes/${quoteId}/finalize`);
    }
}
QuoteService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: QuoteService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
QuoteService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: QuoteService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: QuoteService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * The order details guard ensures that a user has access to details of an order, if not it redirects them to the login screen.
*/
class OrderDetailsGuard {
    constructor(router, apiService) {
        this.router = router;
        this.apiService = apiService;
    }
    canActivate(route, state) {
        const orderId = split(get(state, 'url'), '/').pop();
        return this.apiService.get(`/orders/${orderId}`)
            .pipe(map$1(orderList => {
            return !isEmpty(orderList);
        }), tap(canActivate => {
            if (!canActivate)
                this.router.navigate(['/login', orderId]);
        }));
    }
}
OrderDetailsGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OrderDetailsGuard, deps: [{ token: i2.Router }, { token: i1.ApiService }], target: i0.ɵɵFactoryTarget.Injectable });
OrderDetailsGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OrderDetailsGuard });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OrderDetailsGuard, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i2.Router }, { type: i1.ApiService }]; } });
/**
 * When the user attempts to access an order/quote, Details Guard checks if they are authorized, otherwise, they will be redirected to the login page
*/
class DetailsGuard {
    constructor(router, userService, apiService, toastr, translateService) {
        this.router = router;
        this.userService = userService;
        this.apiService = apiService;
        this.toastr = toastr;
        this.translateService = translateService;
    }
    canActivate(route, state) {
        const objectId = split(get(state, 'url'), '/').pop();
        const objectName = get(state, 'url').includes('proposals' || 'quote') ? 'quotes' : 'orders';
        let isLoggedIn = false;
        return combineLatest([this.apiService.get(`/${objectName}/${objectId}`), this.userService.isLoggedIn()])
            .pipe(map$1(([objectDetails, isUserLoggedIn]) => {
            isLoggedIn = isUserLoggedIn;
            return !isEmpty(objectDetails);
        }), tap(canActivate => {
            if (!canActivate) {
                if (isLoggedIn) {
                    this.toastr.error(this.translateService.instant(objectName === 'orders' ? 'ERROR.INACCESSIBLE_ORDER' : 'ERROR.INACCESSIBLE_QUOTE'));
                    this.router.navigate(['/']);
                }
                else {
                    const params = { redirectUrl: window.location.hash ? window.location.href : window.location.pathname.replace(/^\//, "") };
                    this.router.navigate(['/login'], { queryParams: params });
                }
            }
        }));
    }
}
DetailsGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DetailsGuard, deps: [{ token: i2.Router }, { token: UserService }, { token: i1.ApiService }, { token: i4.ToastrService }, { token: i5.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
DetailsGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DetailsGuard });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DetailsGuard, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i2.Router }, { type: UserService }, { type: i1.ApiService }, { type: i4.ToastrService }, { type: i5.TranslateService }]; } });
/**
 * When the user attempts to access an order/quote, Partner Details Guard checks if they are authorized, otherwise, they will be redirected to the home page
*/
class PartnerDetailsGuard {
    constructor(router, apiService, toastr, translateService) {
        this.router = router;
        this.apiService = apiService;
        this.toastr = toastr;
        this.translateService = translateService;
    }
    canActivate(route, state) {
        const objectId = split(get(state, 'url'), '/').pop();
        const objectName = get(state, 'url').includes('proposals' || 'quote') ? 'quotes' : 'orders';
        return this.apiService.get(`/${objectName}/${objectId}`)
            .pipe(map$1(objectDetails => {
            return !isEmpty(objectDetails);
        }), tap(canActivate => {
            if (!canActivate) {
                this.toastr.error(this.translateService.instant(objectName === 'orders' ? 'ERROR.INACCESSIBLE_ORDER' : 'ERROR.INACCESSIBLE_QUOTE'));
                return this.router.navigate(['/']);
            }
        }));
    }
}
PartnerDetailsGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PartnerDetailsGuard, deps: [{ token: i2.Router }, { token: i1.ApiService }, { token: i4.ToastrService }, { token: i5.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
PartnerDetailsGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PartnerDetailsGuard });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PartnerDetailsGuard, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i2.Router }, { type: i1.ApiService }, { type: i4.ToastrService }, { type: i5.TranslateService }]; } });

/**
 * @ignore
 */
class OrderModule {
}
OrderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OrderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OrderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OrderModule, imports: [CommerceModule, i5.TranslateModule] });
OrderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OrderModule, providers: [], imports: [[CommerceModule, TranslateModule.forChild()]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OrderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommerceModule, TranslateModule.forChild()],
                    declarations: [],
                    providers: [],
                    exports: []
                }]
        }] });

/**
 * Provides pricing for a given product. Used as a pipe wrapper around PriceService.getProductPrice(...)
 * NOTE: It is recommend you use the {@link PriceComponent} component when rendering price as it has been optimized for change detection.
 * ### Example:
 ```html
 <!-- The totalPrice attribute on the returned price instance will be the number value of the price (i.e. 9.99) -->
 <span>{{(product | ProductPricePipe:1:productAttributeValueList:productOptionList | async)?.totalPrice}}<span>

 <!-- To get the formatted price (i.e. $9.99), use netPrice$ instead of totalPrice property and pass it through the async pipe again -->
 <span>{{(product | ProductPricePipe:1:productAttributeValueList:productOptionList | async)?.netPrice$ | async}}<span>
 ```
 */
class ProductPricePipe {
    constructor(priceService) {
        this.priceService = priceService;
    }
    /**
     * @param value the product record to retrieve the price for
     * @param quantity the total number of products
     * @param attributes any associated attribute values to roll into the price
     * @param options any associated options to roll into the price
     */
    transform(value, quantity = 1) {
        return this.priceService.getProductPrice(value, quantity).pipe(filter$1(r => r != null));
    }
}
ProductPricePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductPricePipe, deps: [{ token: PriceService }], target: i0.ɵɵFactoryTarget.Pipe });
ProductPricePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductPricePipe, name: "ProductPricePipe" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductPricePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'ProductPricePipe' }]
        }], ctorParameters: function () { return [{ type: PriceService }]; } });
/**
 * Provides pricing for a given product option
 * NOTE: It is recommend you use the {@link PriceComponent} component when rendering price as it has been optimized for change detection.
 * ### Example:
 ```html
 <!-- The totalPrice attribute on the returned price instance will be the number value of the price (i.e. 9.99) -->
 <span>{{(productOption | OptionPricePipe:1 | async)?.totalPrice}}<span>

 <!-- To get the formatted price (i.e. $9.99), use netPrice$ instead of totalPrice property and pass it through the async pipe again -->
 <span>{{(productOption | OptionPricePipe:1 | async)?.netPrice$ | async}}<span>
 ```
 */
class OptionPricePipe {
    constructor(priceService) {
        this.priceService = priceService;
    }
    transform(option, quantity) {
        return this.priceService.getOptionAdjustmentPrice(option, quantity).pipe(filter$1(r => r != null));
    }
}
OptionPricePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OptionPricePipe, deps: [{ token: PriceService }], target: i0.ɵɵFactoryTarget.Pipe });
OptionPricePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OptionPricePipe, name: "OptionPricePipe" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OptionPricePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'OptionPricePipe' }]
        }], ctorParameters: function () { return [{ type: PriceService }]; } });
/**
 * Provides pricing for a given cart record
 * NOTE: It is recommend you use the {@link PriceComponent} component when rendering price as it has been optimized for change detection.
 * ### Example:
 ```html
 <!-- The totalPrice attribute on the returned price instance will be the number value of the price (i.e. 9.99) -->
 <span>{{(cart | CartPricePipe | async)?.totalPrice}}<span>

 <!-- To get the formatted price (i.e. $9.99), use netPrice$ instead of totalPrice property and pass it through the async pipe again -->
 <span>{{(cart | CartPricePipe | async)?.netPrice$ | async}}<span>
 ```
 */
class CartPricePipe {
    constructor(priceService) {
        this.priceService = priceService;
    }
    transform(value) {
        return this.priceService.getCartPrice(value).pipe(filter$1(r => r != null));
    }
}
CartPricePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CartPricePipe, deps: [{ token: PriceService }], target: i0.ɵɵFactoryTarget.Pipe });
CartPricePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CartPricePipe, name: "CartPricePipe" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CartPricePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'CartPricePipe' }]
        }], ctorParameters: function () { return [{ type: PriceService }]; } });
/**
 * Provides pricing for a given cart item record
 * NOTE: It is recommend you use the {@link PriceComponent} component when rendering price as it has been optimized for change detection.
 * ### Example:
 ```html
 <!-- The totalPrice attribute on the returned price instance will be the number value of the price (i.e. 9.99) -->
 <span>{{(cartItem | CartItemPricePipe | async)?.totalPrice}}<span>

 <!-- To get the formatted price (i.e. $9.99), use netPrice$ instead of totalPrice property and pass it through the async pipe again -->
 <span>{{(cartItem | CartItemPricePipe | async)?.netPrice$ | async}}<span>
 ```
 */
class CartItemPricePipe {
    constructor(priceService) {
        this.priceService = priceService;
    }
    transform(value) {
        return this.priceService.getLineItemPrice(value).pipe(filter$1(r => r != null));
    }
}
CartItemPricePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CartItemPricePipe, deps: [{ token: PriceService }], target: i0.ɵɵFactoryTarget.Pipe });
CartItemPricePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CartItemPricePipe, name: "CartItemPricePipe" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CartItemPricePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'CartItemPricePipe' }]
        }], ctorParameters: function () { return [{ type: PriceService }]; } });
/**
 * Provides pricing for a given attribute value
 * ### Example:
 ```html
 <!-- The totalPrice attribute on the returned price instance will be the number value of the price (i.e. 9.99) -->
 <span>{{(attributeValue | AttributeValuePricePipe:product:productAttribute | async)?.totalPrice}}<span>

 <!-- To get the formatted price (i.e. $9.99), use netPrice$ instead of totalPrice property and pass it through the async pipe again -->
 <span>{{(attributeValue | AttributeValuePricePipe:product:productAttribute | async)?.netPrice$ | async}}<span>
 ```
 */
class AttributeValuePricePipe {
    constructor(priceService) {
        this.priceService = priceService;
    }
    transform(value, product, attribute) {
        return this.priceService.getAttributePriceForProduct(product, attribute, value).pipe(filter$1(r => r != null));
    }
}
AttributeValuePricePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AttributeValuePricePipe, deps: [{ token: PriceService }], target: i0.ɵɵFactoryTarget.Pipe });
AttributeValuePricePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AttributeValuePricePipe, name: "AttributeValuePricePipe" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AttributeValuePricePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'AttributeValuePricePipe' }]
        }], ctorParameters: function () { return [{ type: PriceService }]; } });
/**
 * Provides pricing for a given cart order record
 * NOTE: It is recommend you use the {@link PriceComponent} component when rendering price as it has been optimized for change detection.
 * ### Example:
 ```html
 <!-- The totalPrice attribute on the returned price instance will be the number value of the price (i.e. 9.99) -->
 <span>{{(order | OrderPricePipe | async)?.totalPrice}}<span>

 <!-- To get the formatted price (i.e. $9.99), use netPrice$ instead of totalPrice property and pass it through the async pipe again -->
 <span>{{(order | OrderPricePipe | async)?.netPrice$ | async}}<span>
 ```
 */
class OrderPricePipe {
    constructor(priceService) {
        this.priceService = priceService;
    }
    transform(value) {
        return this.priceService.getOrderPrice(value).pipe(filter$1(r => r != null));
    }
}
OrderPricePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OrderPricePipe, deps: [{ token: PriceService }], target: i0.ɵɵFactoryTarget.Pipe });
OrderPricePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OrderPricePipe, name: "OrderPricePipe" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OrderPricePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'OrderPricePipe' }]
        }], ctorParameters: function () { return [{ type: PriceService }]; } });
/**
 * Provides pricing for a given order line item record
 * NOTE: It is recommend you use the {@link PriceComponent} component when rendering price as it has been optimized for change detection.
 * ### Example:
 ```html
 <!-- The NetPrice attribute on the returned price instance will be the number value of the price (i.e. 9.99) -->
 <span>{{(lineItem | OrderLineItemPricePipe | async)?.NetPrice}}<span>

 <!-- To get the formatted NetPrice (i.e. $9.99), use netPrice$ instead of netPrice property and pass it through the async pipe again -->
 <span>{{(lineItem | OrderLineItemPricePipe | async)?.netPrice$ | async}}<span>
 ```
 */
class OrderLineItemPricePipe {
    constructor(priceService) {
        this.priceService = priceService;
    }
    transform(value) {
        return this.priceService.getOrderLineItemPrice(value).pipe(filter$1(r => r != null));
    }
}
OrderLineItemPricePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OrderLineItemPricePipe, deps: [{ token: PriceService }], target: i0.ɵɵFactoryTarget.Pipe });
OrderLineItemPricePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OrderLineItemPricePipe, name: "OrderLineItemPricePipe" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OrderLineItemPricePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'OrderLineItemPricePipe' }]
        }], ctorParameters: function () { return [{ type: PriceService }]; } });
/** TODO:  */
class LineItemPricePipe {
    constructor(priceService) {
        this.priceService = priceService;
    }
    transform(value) {
        return this.priceService.getLineItemPrice(value).pipe(filter$1(r => r != null));
    }
}
LineItemPricePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LineItemPricePipe, deps: [{ token: PriceService }], target: i0.ɵɵFactoryTarget.Pipe });
LineItemPricePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LineItemPricePipe, name: "LineItemPricePipe" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LineItemPricePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'LineItemPricePipe' }]
        }], ctorParameters: function () { return [{ type: PriceService }]; } });
/**
 * Provides pricing for a given Quote record
 * NOTE: It is recommend you use the {@link PriceComponent} component when rendering price as it has been optimized for change detection.
 * ### Example:
 ```html
 <!-- The totalPrice attribute on the returned price instance will be the number value of the price (i.e. 9.99) -->
 <span>{{(quote | QuotePricePipe | async)?.totalPrice}}<span>

 <!-- To get the formatted price (i.e. $9.99), use netPrice$ instead of totalPrice property and pass it through the async pipe again -->
 <span>{{(quote | QuotePricePipe | async)?.netPrice$ | async}}<span>
 ```
 */
class QuotePricePipe {
    constructor(priceService) {
        this.priceService = priceService;
    }
    transform(value) {
        return this.priceService.getQuotePrice(value).pipe(filter$1(r => r != null));
    }
}
QuotePricePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: QuotePricePipe, deps: [{ token: PriceService }], target: i0.ɵɵFactoryTarget.Pipe });
QuotePricePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: QuotePricePipe, name: "QuotePricePipe" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: QuotePricePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'QuotePricePipe' }]
        }], ctorParameters: function () { return [{ type: PriceService }]; } });

/** @ignore  */
class PriceMatrixFilter {
    transform(priceMatrixList, dataSource) {
        const priceMatrixEntryList = [];
        if (priceMatrixList) {
            priceMatrixList
                .filter(matrix => _.get(matrix, 'MatrixEntries'))
                .forEach(matrix => matrix.MatrixEntries
                .forEach(entry => {
                let valid = true;
                for (let i = 1; i <= 6; i++) {
                    if (!valid)
                        break;
                    valid = (_.get(entry, 'Dimension' + i + 'Value') === undefined ||
                        (_.get(entry, 'Dimension' + i + 'Value') !== undefined
                            && _.get(matrix, 'Dimension' + i + '.Datasource') === dataSource
                        // &&
                        // (
                        //   _.get(entry, 'Apttus_Config2__Dimension' + i + 'Value__c') === _.get(productAttributeValue, _.get(matrix, 'Apttus_Config2__Dimension' + i + 'Id__r.Apttus_Config2__Datasource__c'))
                        //   ||
                        //   _.get(productAttributeValue, _.get(matrix, 'Apttus_Config2__Dimension' + i + 'Id__r.Apttus_Config2__Datasource__c')) == null
                        // )
                        ));
                }
                if (valid)
                    priceMatrixEntryList.push(entry);
            }));
        }
        return priceMatrixEntryList;
    }
}
PriceMatrixFilter.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceMatrixFilter, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
PriceMatrixFilter.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceMatrixFilter, name: "priceMatrixFilter" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceMatrixFilter, decorators: [{
            type: Pipe,
            args: [{ name: 'priceMatrixFilter' }]
        }] });

/**
 * @ignore
 */
const pricingPipes = [ProductPricePipe, AttributeValuePricePipe, CartItemPricePipe, CartPricePipe, PriceMatrixFilter, LocalCurrencyPipe, FormatCurrencyPipe, OrderPricePipe, OrderLineItemPricePipe, OptionPricePipe, QuotePricePipe, LineItemPricePipe, ConvertCurrencyPipe];
/**
 * @ignore
 */
class PricingModule {
}
PricingModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PricingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PricingModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PricingModule, declarations: [ProductPricePipe, AttributeValuePricePipe, CartItemPricePipe, CartPricePipe, PriceMatrixFilter, LocalCurrencyPipe, FormatCurrencyPipe, OrderPricePipe, OrderLineItemPricePipe, OptionPricePipe, QuotePricePipe, LineItemPricePipe, ConvertCurrencyPipe], imports: [CommonModule], exports: [ProductPricePipe, AttributeValuePricePipe, CartItemPricePipe, CartPricePipe, PriceMatrixFilter, LocalCurrencyPipe, FormatCurrencyPipe, OrderPricePipe, OrderLineItemPricePipe, OptionPricePipe, QuotePricePipe, LineItemPricePipe, ConvertCurrencyPipe] });
PricingModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PricingModule, providers: [pricingPipes, CurrencyPipe], imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PricingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [pricingPipes],
                    providers: [pricingPipes, CurrencyPipe],
                    exports: [pricingPipes]
                }]
        }] });

let Template = class Template extends AObject {
    constructor() {
        super(...arguments);
        this.Name = null;
        this.ActivateVersion = null;
        this.ActiveVersionId = null;
        this.Agreement_Types = null;
        this.BusinessObject = null;
        this.Category = null;
        this.CheckoutById = null;
        this.CheckoutDate = null;
        this.CheckoutVersionId = null;
        this.ClonedFromId = null;
        this.ClonedFromReferenceId = null;
        this.Description = null;
        this.EnableAgreementClauseTracking = null;
        this.ExcludedMergeChildObjects = null;
        this.FrameworkFormat = null;
        this.Guidance = null;
        this.IsActive = null;
        this.IsTransient = null;
        this.Keywords = null;
        this.Language = null;
        this.Locale = null;
        this.Mergefields2 = null;
        this.Mergefields = null;
        this.NeedsPublishing = null;
        this.Next_Revision_Date = null;
        this.NumberOfClauses = null;
        this.OutputPage = null;
        this.Publish = null;
        this.PublishedDate = null;
        this.PubDocId = null;
        this.PublishStatus = null;
        this.ReferenceId = null;
        this.Subcategory = null;
        this.TermExceptionId = null;
        this.TextContent = null;
        this.Type = null;
        this.Unpublish = null;
    }
};
__decorate([
    AField({
        soql: 'Name',
        aql: 'Name'
    }),
    __metadata("design:type", String)
], Template.prototype, "Name", void 0);
__decorate([
    AField({
        soql: 'Apttus__ActivateVersion__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "ActivateVersion", void 0);
__decorate([
    AField({
        soql: 'Apttus__ActiveVersionId__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "ActiveVersionId", void 0);
__decorate([
    AField({
        soql: 'Apttus__Agreement_Types__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "Agreement_Types", void 0);
__decorate([
    AField({
        soql: 'Apttus__BusinessObject__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "BusinessObject", void 0);
__decorate([
    AField({
        soql: 'Apttus__Category__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "Category", void 0);
__decorate([
    AField({
        soql: 'Apttus__CheckoutById__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "CheckoutById", void 0);
__decorate([
    AField({
        soql: 'Apttus__CheckoutDate__c',
    }),
    __metadata("design:type", Date)
], Template.prototype, "CheckoutDate", void 0);
__decorate([
    AField({
        soql: 'Apttus__CheckoutVersionId__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "CheckoutVersionId", void 0);
__decorate([
    AField({
        soql: 'Apttus__ClonedFromId__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "ClonedFromId", void 0);
__decorate([
    AField({
        soql: 'Apttus__ClonedFromReferenceId__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "ClonedFromReferenceId", void 0);
__decorate([
    AField({
        soql: 'Apttus__Description__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "Description", void 0);
__decorate([
    AField({
        soql: 'Apttus__EnableAgreementClauseTracking__c',
    }),
    __metadata("design:type", Boolean)
], Template.prototype, "EnableAgreementClauseTracking", void 0);
__decorate([
    AField({
        soql: 'Apttus__ExcludedMergeChildObjects__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "ExcludedMergeChildObjects", void 0);
__decorate([
    AField({
        soql: 'Apttus__FrameworkFormat__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "FrameworkFormat", void 0);
__decorate([
    AField({
        soql: 'Apttus__Guidance__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "Guidance", void 0);
__decorate([
    AField({
        soql: 'Apttus__IsActive__c',
    }),
    __metadata("design:type", Boolean)
], Template.prototype, "IsActive", void 0);
__decorate([
    AField({
        soql: 'Apttus__IsTransient__c',
    }),
    __metadata("design:type", Boolean)
], Template.prototype, "IsTransient", void 0);
__decorate([
    AField({
        soql: 'Apttus__Keywords__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "Keywords", void 0);
__decorate([
    AField({
        soql: 'Apttus__Language__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "Language", void 0);
__decorate([
    AField({
        soql: 'Apttus__Locale__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "Locale", void 0);
__decorate([
    AField({
        soql: 'Apttus__Mergefields2__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "Mergefields2", void 0);
__decorate([
    AField({
        soql: 'Apttus__Mergefields__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "Mergefields", void 0);
__decorate([
    AField({
        soql: 'Apttus__NeedsPublishing__c',
    }),
    __metadata("design:type", Boolean)
], Template.prototype, "NeedsPublishing", void 0);
__decorate([
    AField({
        soql: 'Apttus__Next_Revision_Date__c',
    }),
    __metadata("design:type", Date)
], Template.prototype, "Next_Revision_Date", void 0);
__decorate([
    AField({
        soql: 'Apttus__NumberOfClauses__c',
    }),
    __metadata("design:type", Number)
], Template.prototype, "NumberOfClauses", void 0);
__decorate([
    AField({
        soql: 'Apttus__OutputPage__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "OutputPage", void 0);
__decorate([
    AField({
        soql: 'Apttus__Publish__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "Publish", void 0);
__decorate([
    AField({
        soql: 'Apttus__PublishedDate__c',
    }),
    __metadata("design:type", Date)
], Template.prototype, "PublishedDate", void 0);
__decorate([
    AField({
        soql: 'Apttus__PubDocId__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "PubDocId", void 0);
__decorate([
    AField({
        soql: 'Apttus__PublishStatus__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "PublishStatus", void 0);
__decorate([
    AField({
        soql: 'Apttus__ReferenceId__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "ReferenceId", void 0);
__decorate([
    AField({
        soql: 'Apttus__Subcategory__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "Subcategory", void 0);
__decorate([
    AField({
        soql: 'Apttus__TermExceptionId__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "TermExceptionId", void 0);
__decorate([
    AField({
        soql: 'Apttus__TextContent__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "TextContent", void 0);
__decorate([
    AField({
        soql: 'Apttus__Type__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "Type", void 0);
__decorate([
    AField({
        soql: 'Apttus__Unpublish__c',
    }),
    __metadata("design:type", String)
], Template.prototype, "Unpublish", void 0);
Template = __decorate([
    ATable({
        sobjectName: 'Apttus__APTS_Template__c',
        aqlName: null
    })
], Template);

/**
 * A template service provides methods for the proposal and agreement templates within Apttus. Use this to retrieve template records.
 * <h3>Usage</h3>
 *
 ```typescript
 import { TemplateService } from '@congacommerce/ecommerce';

 constructor(private templateService: TemplateService) {}

 // or

 export class MyService extends AObjectService {
     private templateService: TemplateService = this.injector.get(TemplateService);
  }
 ```
 */
class TemplateService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = Template;
    }
    /**
     * Method is used to retrieve active templates within Apttus
     * ### Example:
```typescript
import { TemplateService, Template } from '@congacommerce/ecommerce';
import { Observable } from 'rxjs/Observable';

export class MyComponent implements OnInit{
    templateList: Array<Template>;
    templateList$: Observable<Array<Template>>;

    constructor(private templateService: TemplateService){}

    ngOnInit(){
        this.templateService.getActiveTemplates().subscribe(t => this.templateList = t);
        // or
        this.templateList$ = this.templateService.getActiveTemplates();
    }
}
```
     * @param type the type of templates to pull (Proposal or Agreement)
     * @returns an observable array of active templates
     */
    getActiveTemplates(type) {
        // return this.where(`Apttus__IsActive__c = TRUE AND Apttus__PublishStatus__c = 'Published' AND Apttus__Type__c = '` + type + `'`);
        return this.where([
            new ACondition(this.type, 'IsActive', 'Equal', true),
            new ACondition(this.type, 'PublishStatus', 'Equal', 'Published'),
            new ACondition(this.type, 'BusinessObject', 'Equal', type),
        ]);
    }
}
TemplateService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TemplateService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
TemplateService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TemplateService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TemplateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * @ignore
 */
class DocGenModule {
}
DocGenModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DocGenModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DocGenModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DocGenModule, imports: [CommonModule] });
DocGenModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DocGenModule, providers: [], imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DocGenModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [],
                    providers: [],
                    exports: []
                }]
        }] });

/**
 * Responsible to calculating Tax using CPQ's computeTaxForCart(cartId) API
 * <h3>Usage</h3>
 *
 ```typescript
 import { TaxService } from '@congacommerce/ecommerce';

 constructor(private taxService: TaxService) {}

 // or

 export class MyService extends AObjectService {
     private taxService: TaxService = this.injector.get(TaxService);
  }
 ```
 */
class TaxService extends TaxServiceCore {
    /**
     * Method to compute tax using 'computeTaxForCart(cartId)' CPQ API
     *
     *  ### Example:
```typescript
import { TaxService } from '@congacommerce/ecommerce';
export class MyComponent implements OnInit{
    constructor(private taxService: TaxService){}
    ngOnInit(){
        this.taxService.computeTaxForCart().subscribe(taxResults => {...});
    }
}
```
     * @override
     */
    computeTaxForCart() {
        return super.computeTaxForCart();
    }
    /**
     * Retrieves Tax Breakup for a perticular line item.
     *  ### Example:
```typescript
import { TaxService } from '@congacommerce/ecommerce';
export class MyComponent implements OnInit{
    constructor(private taxService: TaxService){}
    ngOnInit(){
        this.taxService.getTaxBreakupForLineItem(lineItemId).subscribe(taxResults => {...});
    }
}
```
     * @param lineItemId string identifier of the line item to retrieve tax breakups for.
     * @override
     * @return an observable containing list of tax breakup items for a given line item.
     */
    getTaxBreakupForLineItem(lineItemId) {
        return super.getTaxBreakupForLineItem(lineItemId);
    }
    /**
   * Retrieves Tax Breakup for current configuration
   * @param lineItemId Line item id for which you want to retrieve tax breakups
   *  ### Example:
```typescript
import { TaxService } from '@congacommerce/ecommerce';
export class MyComponent implements OnInit{
    constructor(private taxService: TaxService){}
    ngOnInit(){
        this.taxService.getTaxBreakUpsForConfiguration().subscribe(taxResults => {...});
    }
}
```
   * @override
   * @returns an observable containing list of tax breakup items for the active cart.
   */
    getTaxBreakUpsForConfiguration() {
        return super.getTaxBreakUpsForConfiguration();
    }
}
TaxService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TaxService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
TaxService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TaxService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TaxService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });
/** @ignore */
class ProposalTaxService extends ProposalTaxBreakupService {
    getTaxBreakupForQuote(quoteId) {
        return super.getTaxBreakupForQuote(quoteId);
    }
}
ProposalTaxService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProposalTaxService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ProposalTaxService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProposalTaxService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProposalTaxService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });
/**
 * @ignore
 */
class OrderTaxService extends OrderTaxBreakupService {
    getTaxBreakupForOrder(orderId) {
        return super.getTaxBreakupForOrder(orderId);
    }
}
OrderTaxService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OrderTaxService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
OrderTaxService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OrderTaxService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OrderTaxService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

let TaxCertificate = class TaxCertificate extends AObject {
    constructor() {
        super(...arguments);
        this.Description = null;
        this.EffectiveDate = null;
        this.ExpirationDate = null;
    }
};
__decorate([
    AField({
        soql: 'Apttus_Config2__Description__c',
        aql: 'Description'
    }),
    __metadata("design:type", String)
], TaxCertificate.prototype, "Description", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__EffectiveDate__c',
        aql: 'EffectiveDate'
    }),
    __metadata("design:type", Date)
], TaxCertificate.prototype, "EffectiveDate", void 0);
__decorate([
    AField({
        soql: 'Apttus_Config2__ExpirationDate__c',
        aql: 'ExpirationDate'
    }),
    __metadata("design:type", Date)
], TaxCertificate.prototype, "ExpirationDate", void 0);
TaxCertificate = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__TaxCertificate__c',
        aqlName: 'cpq_TaxCertificate'
    })
], TaxCertificate);

let PaymentMethod = class PaymentMethod extends AObject {
    constructor() {
        super(...arguments);
        this.AccountId = null;
        this.CardExpirationMonth = null;
        this.CardExpirationYear = null;
        this.CardNumber = null;
        this.CardType = null;
        this.ECheckAccountNumber = null;
        this.ECheckAccountType = null;
        this.ECheckRoutingNumber = null;
        this.IsDefault = null;
        this.PaymentMethodName = null;
        this.PaymentMethodType = null;
        this.ProfileId = null;
        this.Status = null;
        this.TokenId = null;
        this.Name = null;
    }
};
__decorate([
    AField({
        soql: 'Apttus_Billing__AccountId__c',
        aql: 'AccountId'
    }),
    __metadata("design:type", String)
], PaymentMethod.prototype, "AccountId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__CardExpirationMonth__c',
        aql: 'CardExpirationMonth'
    }),
    __metadata("design:type", Number)
], PaymentMethod.prototype, "CardExpirationMonth", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__CardExpirationYear__c',
        aql: 'CardExpirationYear'
    }),
    __metadata("design:type", Number)
], PaymentMethod.prototype, "CardExpirationYear", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__CardNumber__c',
        aql: 'CardNumber'
    }),
    __metadata("design:type", String)
], PaymentMethod.prototype, "CardNumber", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__CardType__c',
        aql: 'CardType'
    }),
    __metadata("design:type", String)
], PaymentMethod.prototype, "CardType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__ECheckAccountNumber__c',
        aql: 'ECheckAccountNumber'
    }),
    __metadata("design:type", String)
], PaymentMethod.prototype, "ECheckAccountNumber", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__ECheckAccountType__c',
        aql: 'ECheckAccountType'
    }),
    __metadata("design:type", String)
], PaymentMethod.prototype, "ECheckAccountType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__ECheckRoutingNumber__c',
        aql: 'ECheckRoutingNumber'
    }),
    __metadata("design:type", String)
], PaymentMethod.prototype, "ECheckRoutingNumber", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__IsDefault__c',
        aql: 'IsDefault'
    }),
    __metadata("design:type", Boolean)
], PaymentMethod.prototype, "IsDefault", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__PaymentMethodName__c',
        aql: 'PaymentMethodName'
    }),
    __metadata("design:type", String)
], PaymentMethod.prototype, "PaymentMethodName", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__PaymentMethodType__c',
        aql: 'PaymentMethodType'
    }),
    __metadata("design:type", String)
], PaymentMethod.prototype, "PaymentMethodType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__ProfileId__c',
        aql: 'ProfileId'
    }),
    __metadata("design:type", String)
], PaymentMethod.prototype, "ProfileId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__Status__c',
        aql: 'Status'
    }),
    __metadata("design:type", String)
], PaymentMethod.prototype, "Status", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__TokenId__c',
        aql: 'TokenId'
    }),
    __metadata("design:type", String)
], PaymentMethod.prototype, "TokenId", void 0);
__decorate([
    AField({
        aql: 'Name',
        soql: 'Name'
    }),
    __metadata("design:type", String)
], PaymentMethod.prototype, "Name", void 0);
PaymentMethod = __decorate([
    ATable({
        sobjectName: 'Apttus_Billing__PaymentMethod__c',
        aqlName: ''
    })
], PaymentMethod);

let GatewayTransaction = class GatewayTransaction extends AObject {
    constructor() {
        super(...arguments);
        this.AccountId = null;
        this.AuthAmount = null;
        this.AuthAVSCode = null;
        this.AuthResponse = null;
        this.CardExpirationMonth = null;
        this.CardExpirationYear = null;
        this.CardNumber = null;
        this.CardType = null;
        this.ECheckAccountNumber = null;
        this.ECheckAccountType = null;
        this.ECheckRoutingNumber = null;
        this.GatewayDecision = null;
        this.GatewayMessage = null;
        this.OrderId = null;
        this.PaymentId = null;
        this.PaymentMethodId = null;
        this.PaymentMethodTyp = null;
        this.ProfileId = null;
        this.ReasonCode = null;
        this.ReferenceId = null;
        this.RefundId = null;
        this.RelatedAuthRequestId = null;
        this.RequestAmount = null;
        this.RequestCurrency = null;
        this.RequestDate = null;
        this.RequestTaxAmount = null;
        this.RequestTokenId = null;
        this.ResponseCode = null;
        this.ResponseDate = null;
        this.ResponseString = null;
        this.Status = null;
        this.TransactionId = null;
        this.TransactionType = null;
        this.UpdatedTokenId = null;
    }
};
__decorate([
    AField({
        soql: 'Apttus_Billing__AccountId__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "AccountId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__AuthAmount__c',
        aql: ''
    }),
    __metadata("design:type", Number)
], GatewayTransaction.prototype, "AuthAmount", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__AuthAVSCode__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "AuthAVSCode", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__AuthResponse__c',
        aql: 'AuthResponse'
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "AuthResponse", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__CardExpirationMonth__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "CardExpirationMonth", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__CardExpirationYear__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "CardExpirationYear", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__CardNumber__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "CardNumber", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__CardType__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "CardType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__ECheckAccountNumber__c',
        aql: ''
    }),
    __metadata("design:type", Boolean)
], GatewayTransaction.prototype, "ECheckAccountNumber", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__ECheckAccountType__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "ECheckAccountType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__ECheckRoutingNumber__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "ECheckRoutingNumber", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__GatewayDecision__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "GatewayDecision", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__GatewayMessage__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "GatewayMessage", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__OrderId__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "OrderId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__PaymentId__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "PaymentId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__PaymentMethodId__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "PaymentMethodId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__PaymentMethodType__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "PaymentMethodTyp", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__ProfileId__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "ProfileId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__ReasonCode__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "ReasonCode", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__ReferenceId__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "ReferenceId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__RefundId__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "RefundId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__RelatedAuthRequestId__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "RelatedAuthRequestId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__RequestAmount__c',
        aql: ''
    }),
    __metadata("design:type", Number)
], GatewayTransaction.prototype, "RequestAmount", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__RequestCurrency__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "RequestCurrency", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__RequestDate__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "RequestDate", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__RequestTaxAmount__c',
        aql: ''
    }),
    __metadata("design:type", Number)
], GatewayTransaction.prototype, "RequestTaxAmount", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__RequestTokenId__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "RequestTokenId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__ResponseCode__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "ResponseCode", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__ResponseDate__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "ResponseDate", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__ResponseString__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "ResponseString", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__Status__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "Status", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__TransactionId__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "TransactionId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__TransactionType__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "TransactionType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__UpdatedTokenId__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayTransaction.prototype, "UpdatedTokenId", void 0);
GatewayTransaction = __decorate([
    ATable({
        sobjectName: 'Apttus_Billing__GatewayTransaction__c',
        aqlName: ''
    })
], GatewayTransaction);

let GatewayCommunication = class GatewayCommunication extends AObject {
    constructor() {
        super(...arguments);
        this.CommunicationDate = null;
        this.GatewayTransactionId = null;
        this.GatewayTransaction = new GatewayTransaction();
        this.Payload = null;
        this.PayloadType = null;
        this.Status = null;
        this.Type = null;
    }
};
__decorate([
    AField({
        soql: 'Apttus_Billing__CommunicationDate__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayCommunication.prototype, "CommunicationDate", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__GatewayTransactiontId__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayCommunication.prototype, "GatewayTransactionId", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__GatewayTransactiontId__r',
        aql: ''
    }),
    __metadata("design:type", GatewayTransaction)
], GatewayCommunication.prototype, "GatewayTransaction", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__Payload__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayCommunication.prototype, "Payload", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__PayloadType__c',
        aql: 'AuthResponse'
    }),
    __metadata("design:type", String)
], GatewayCommunication.prototype, "PayloadType", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__Status__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayCommunication.prototype, "Status", void 0);
__decorate([
    AField({
        soql: 'Apttus_Billing__Type__c',
        aql: ''
    }),
    __metadata("design:type", String)
], GatewayCommunication.prototype, "Type", void 0);
GatewayCommunication = __decorate([
    ATable({
        sobjectName: 'Apttus_Billing__GatewayCommunication__c',
        aqlName: ''
    })
], GatewayCommunication);

class PaymentTransaction {
    constructor() {
        this.Currency = null;
        this.CustomerFirstName = null;
        this.CustomerLastName = null;
        this.CustomerEmailAddress = null;
        this.CustomerAddressLine1 = null;
        this.CustomerAddressCity = null;
        this.CustomerAddressStateCode = null;
        this.CustomerAddressCountryCode = null;
        this.CustomerAddressPostalCode = null;
        this.CustomerBillingAccountName = null;
        this.CustomerBillingAccountID = null;
        this.OrderAmount = '0';
        this.PaymentToken = null;
        this.Locale = null;
        this.PaymentType = null;
        this.isUserLoggedIn = null;
        this.OrderGeneratedID = null;
        this.OrderName = null;
    }
}

/**
 * The gateway transaction object store transaction type and unique ID for each transaction.
 * @ignore
 */
class GatewayTransactionService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = GatewayTransaction;
    }
}
GatewayTransactionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: GatewayTransactionService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
GatewayTransactionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: GatewayTransactionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: GatewayTransactionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * The gateway communication object stores payment request/response payload for each transaction.
 * <h3>Usage</h3>
 *
  ```typescript
 import { GatewayCommunicationService, AObjectService} from '@congacommerce/ecommerce';
 
 export class MyComponent implements OnInit{
 constructor( private gatewayCommunicationService: GatewayCommunicationService)
 }
 // or
 export class MyService extends AObjectService {
      private gatewayCommunicationService: GatewayCommunicationService = this.injector.get(GatewayCommunicationService);
  }
 ```
 */
class GatewayCommunicationService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = GatewayCommunication;
    }
    /**
      * Retrieves the gateway communication if response has been received from the
      * payment gateway (CyberSource) based on the gateway transaction's ID
      * and also updating payment method cache
      * ### Example:
  ```typescript
  import { GatewayCommunicationService} from '@congacommerce/ecommerce';
  export class MyComponent implements OnInit{
      gatewayCommunication: GatewayCommunication;
      constructor(private gatewayCommunicationService: GatewayCommunicationService){}
      ngOnInit(){
          this.gatewayCommunicationService.getResponseUpdate(this.gatewayCommunication.GatewayTransactiontId).subscribe(response => {
          });
      }
  }
  ```
    /**
     * This method retrieves the gateway communication record for a given transaction id.
     * @param gatewayTransactionId representing the gateway transaction identifier.
     * @returns an observable containing the gateway communication response.
     */
    getResponseUpdate(gatewayTransactionId) {
        let conditionList = [];
        conditionList.push(new ACondition(this.type, 'GatewayTransactiontId', 'Equal', gatewayTransactionId));
        conditionList.push(new ACondition(this.type, 'PayloadType', 'Equal', 'Response'));
        return this.query({ skipCache: true, conditions: conditionList })
            .pipe(map$1(res => first(res)));
    }
}
GatewayCommunicationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: GatewayCommunicationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
GatewayCommunicationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: GatewayCommunicationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: GatewayCommunicationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * Responsible to do CRUD operation on payment service
 */
class PaymentService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = PaymentMethod;
        this.gatewayTransactionService = this.injector.get(GatewayTransactionService);
        this.gatewayCommunicationService = this.injector.get(GatewayCommunicationService);
    }
    /**
   * This is a silent method I-FRAME for payment
    * @param transactionDetails payment related transaction details
    * @param gatewayTransaction gateway transaction details to store
    * @param gatewayCommunication gateway communication details to store
   * @returns observable of array including object and gateway transaction string to trace payment response
   */
    saleCaptureMethod(transactionDetails, gatewayTransaction = new GatewayTransaction(), gatewayCommunication = new GatewayCommunication()) {
        return this.platformService.post('GetPaymentRequestDetails', transactionDetails, 'APTS_CyberSourceRestResource', false, 0, '').pipe(take(1), flatMap(response => {
            if (response === null)
                return of(null);
            gatewayTransaction.AccountId = transactionDetails.CustomerBillingAccountID;
            gatewayTransaction.OrderId = transactionDetails.OrderGeneratedID;
            gatewayTransaction.TransactionId = _.get(response, 'transaction_uuid');
            gatewayTransaction.ProfileId = _.get(response, 'profile_id');
            gatewayTransaction.TransactionType = _.defaultTo(_.get(gatewayTransaction, 'TransactionType'), 'Capture');
            gatewayTransaction.RequestDate = _.get(response, 'signed_date_time');
            gatewayTransaction.Status = _.defaultTo(_.get(gatewayTransaction, 'Status'), 'Pending');
            return this.gatewayTransactionService.create([gatewayTransaction], true).pipe(take(1), flatMap(gtResponse => {
                gatewayCommunication.GatewayTransactionId = _.get(gtResponse, '[0].Id');
                gatewayCommunication.Payload = JSON.stringify(response);
                gatewayCommunication.PayloadType = _.defaultTo(_.get(gatewayTransaction, 'PayloadType'), 'Request');
                gatewayCommunication.CommunicationDate = response['signed_date_time'];
                gatewayCommunication.Type = _.defaultTo(_.get(gatewayTransaction, 'Type'), 'Payment Method Request');
                return this.gatewayCommunicationService.create([gatewayCommunication], true).pipe(flatMap(() => {
                    return of([response, gatewayCommunication.GatewayTransactionId]);
                }));
            }));
        }));
    }
    /**
     * This method is responsible for fetching active cards for payment based on the account id.
     * @param accountId the account Id value.
     * @returns List of details of payment Method for the associated account Id.
     */
    getActiveCardsForAccount(accountId) {
        return this.platformService.apiService.get(`/Apttus_Billing__PaymentMethod__c?condition[0]=AccountId,Equal,${accountId}&condition[1]=Status,Equal,Active`, this.type);
    }
    /**
     * This is a silent method I-FRAME for payment
      * @param transactionDetails payment related transaction details
      * @param gatewayTransaction gateway transaction details to store
      * @param gatewayCommunication gateway communication details to store
     * @returns observable of array including object and gateway transaction string to trace payment response
     */
    silentOrderPayment(transactionDetails, gatewayTransaction = new GatewayTransaction(), gatewayCommunication = new GatewayCommunication()) {
        return this.getDefaultPaymentMethod(transactionDetails.CustomerBillingAccountID).pipe(take(1), flatMap(result => {
            transactionDetails.PaymentToken = result.TokenId;
            return this.platformService.post('GetSilentPaymentRequestDetails', transactionDetails, 'APTS_CyberSourceRestResource', false, 0, '').pipe(take(1), flatMap(response => {
                if (response === null)
                    return of(null);
                gatewayTransaction.AccountId = transactionDetails.CustomerBillingAccountID;
                gatewayTransaction.OrderId = transactionDetails.OrderGeneratedID;
                gatewayTransaction.TransactionId = _.get(response, 'transaction_uuid');
                gatewayTransaction.ProfileId = _.get(response, 'profile_id');
                gatewayTransaction.TransactionType = _.defaultTo(_.get(gatewayTransaction, 'TransactionType'), 'Sale');
                gatewayTransaction.RequestDate = _.get(response, 'signed_date_time');
                gatewayTransaction.Status = _.defaultTo(_.get(gatewayTransaction, 'Status'), 'Pending');
                return this.gatewayTransactionService.create([gatewayTransaction], true).pipe(take(1), flatMap(gtResponse => {
                    gatewayCommunication.GatewayTransactionId = _.get(gtResponse, '[0].Id');
                    gatewayCommunication.Payload = JSON.stringify(response);
                    gatewayCommunication.PayloadType = _.defaultTo(_.get(gatewayTransaction, 'PayloadType'), 'Request');
                    gatewayCommunication.CommunicationDate = response['signed_date_time'];
                    gatewayCommunication.Type = _.defaultTo(_.get(gatewayTransaction, 'Type'), 'Payment Against Order');
                    return this.gatewayCommunicationService.create([gatewayCommunication], true).pipe(flatMap(() => {
                        return of([response, gatewayCommunication.GatewayTransactionId]);
                    }));
                }));
            }));
        }));
    }
    /**
     * @ignore
     *
    */
    getDefaultPaymentMethod(accountID) {
        let conditionList = [];
        conditionList.push(new ACondition(this.type, 'AccountId', 'Equal', accountID));
        conditionList.push(new ACondition(this.type, 'Status', 'Equal', 'Active'));
        conditionList.push(new ACondition(this.type, 'IsDefault', 'Equal', true));
        return this.where(conditionList, 'AND', null, null, null, null).pipe(take(1), flatMap((result) => {
            return result;
        }));
    }
}
PaymentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PaymentService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
PaymentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PaymentService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PaymentService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * @ignore
 */
class PaymentModule {
}
PaymentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PaymentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PaymentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PaymentModule });
PaymentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PaymentModule, providers: [], imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PaymentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    declarations: [],
                    providers: [],
                    exports: []
                }]
        }] });

/**
 * @ignore
 */
class AttributeTranslationService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = AttributeGroupTranslation;
        this.userService = this.injector.get(UserService);
    }
}
AttributeTranslationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AttributeTranslationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
AttributeTranslationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AttributeTranslationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AttributeTranslationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * @ignore
 */
class ProductTranslationService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = ProductTranslation;
    }
    getProductTranslation(productId) {
        return this.where([new ACondition(this.type, 'ProductId', 'Equal', productId)]);
    }
}
ProductTranslationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductTranslationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ProductTranslationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductTranslationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductTranslationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * Promotion Service defines a way to add/remove promotions to/from the cart.
 * @ignore
 */
class IncentiveService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = Incentive;
    }
    getIncentiveById(Incentives) {
        return this.query({
            conditions: [new ACondition(Incentive, 'Id', 'In', this.type)]
        });
    }
}
IncentiveService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: IncentiveService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
IncentiveService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: IncentiveService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: IncentiveService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * Promotion Service defines a way to add/remove promotions to/from the cart.
 *
 * <h3>Usage</h3>
 *
 ```typescript
 import { PromotionService } from '@congacommerce/ecommerce';

 constructor(private promotionService: PromotionService) {}

 // or

 export class MyService extends AObjectService {
     private promotionService: PromotionService = this.injector.get(PromotionService);
  }
 ```
 */
class PromotionService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = AdjustmentItem;
        this.cartService = this.injector.get(CartService);
        this.configService = this.injector.get(ConfigurationService);
        this.apiService = this.injector.get(ApiService);
        this.incentiveService = this.injector.get(IncentiveService);
    }
    /**
       * Method applies promotion to the current cart based on the promo code passed.
       * ### Example:
  ```typescript
  import { PromotionService } from '@congacommerce/ecommerce';
  import { Observable } from 'rxjs/Observable';
  
  export class MyComponent implements OnInit{
      constructor(private promotionService: PromotionService){}
  
      applyPromotions(promocode: string){
            this.promotionService.applyPromotions(promocode).subscribe({...});
      }
  }
  ```
       * @param promocode a string value representing the promotion code to be applied to the cart.
       * @returns a observable<boolean | HttpErrorResponse> when the operation has completed.
       */
    applyPromotions(promocode) {
        return this.platformService.apiService.post(`/carts/${CartService.getCurrentCartId()}/promotions?mode=${this.configService.get('pricingMode')}`, { code: promocode })
            .pipe(tap(res => {
            if (res)
                this.cartService.priceCart();
        }), catchError(e => of(e)));
    }
    /**
    * Method returns an observable containing an array of adjustment line items for the current cart.
    * ### Example:
  ```typescript
    import { PromotionService } from '@congacommerce/ecommerce';
    import { AdjustmentItem } from '@congacommerce/ecommerce';
    import { Observable } from 'rxjs/Observable';
  
    export class MyComponent implements OnInit{
        adjustmentLineItems$: Observable<Array<AdjustmentLineItem>>;
        adjustmentLineItems; Array<AdjustmentLineItem>;
        constructor(private promotionService: PromotionService){}
  
        getAppliedPromotionForCart(){
              this.promotionService.getAppliedPromotionForCart().subscribe(res => this.adjustmentLineItems = res);
              or
              this.adjustmentLineItems$ = this.promotionService.getAppliedPromotionForCart();
        }
    }
  ```
      *@param incentiveCode is the valid incentive code value.
      *@returns an observable containing an array of adjustment line items for the current cart.
    */
    getAppliedPromotionForCart(incentiveCode) {
        return this.cartService.getMyCart(false)
            .pipe(flatMap(cart => {
            const conditionList = [
                new ACondition(this.type, 'LineItem.ConfigurationId', 'Equal', get(cart, 'Id')),
                new ACondition(this.type, 'IncentiveId', 'NotEqual', null),
                new ACondition(this.type, 'Type', 'Equal', 'Promotion')
            ];
            if (incentiveCode)
                conditionList.push(new ACondition(this.type, 'Incentive.IncentiveCode', 'Equal', incentiveCode));
            return this.query({
                conditions: conditionList,
                skipCache: true
            });
        }));
    }
    /**
      * Method returns an observable containing an array of adjustment line items for the lineItem
      * based on the LineNumber.
      *
      * ### Example:
      ```typescript
        import { PromotionService } from '@congacommerce/ecommerce';
        import { AdjustmentItem } from '@congacommerce/ecommerce';
        import { Observable } from 'rxjs/Observable';
      
        export class MyComponent implements OnInit{
            adjustmentLineItems$: Observable<Array<AdjustmentLineItem>>;
            adjustmentLineItems; Array<AdjustmentLineItem>;
            constructor(private promotionService: PromotionService){}
      
            getAppliedPromotionForLineItem(lineNumber: number){
                  this.promotionService.getAppliedPromotionForLineItem(lineNumber).subscribe(res => this.adjustmentLineItems = res);
                  or
                  this.adjustmentLineItems$ = this.promotionService.getAppliedPromotionForLineItem(lineNumber);
            }
        }
      ```
      *
      * @param lineNumber is of type number, which accepts the LineNumber of the lineItem.
      * @returns an observable containing an array of adjustment line items for the lineItem based on the lineNumber.
      */
    getAppliedPromotionForLineItem(lineNumber) {
        return this.cartService.getMyCart(false)
            .pipe(flatMap(cart => {
            const conditionList = [
                new ACondition(this.type, 'LineItem.ConfigurationId', 'Equal', get(cart, 'Id')),
                new ACondition(this.type, 'IncentiveId', 'NotEqual', null),
                new ACondition(this.type, 'LineItem.LineNumber', 'Equal', lineNumber)
            ];
            return this.query({
                conditions: conditionList,
                skipCache: true
            });
        }));
    }
    /**
     * Method to get list of incentives based on matching criteria. Criteria should contain valid incentive codes.
     * @param incentiveCodes List of IncentiveCodes seperated by commas
     * @returns Return list of Incentives for matching criteria.
     */
    getIncentiveByCode(incentiveCodes) {
        return this.apiService.post('/Apttus_Config2__Incentive__c/query', {
            'conditions': [
                {
                    'field': 'IncentiveCode',
                    'filterOperator': 'In',
                    'value': incentiveCodes
                }
            ]
        }, this.incentiveService.type);
    }
    /**
       * Method removes the promotion from the current cart if it is already applied.
       * ### Example:
  ```typescript
  import { PromotionService } from '@congacommerce/ecommerce';
  import { Observable } from 'rxjs/Observable';
  
  export class MyComponent implements OnInit{
        constructor(private promotionService: PromotionService){}
  
        removeAppliedPromotion(promocode: string, msg: string = 'valid', incentiveName?: string){
            this.promotionService.removeAppliedPromotion(promocode).subscribe({...});
        }
  }
  ```
       * @param incentive is the valid incentive record.
       * @returns a void observable when the operation has completed.
       */
    removeAppliedPromotion(incentive) {
        const code = incentive.get('couponCode') ? incentive.get('couponCode') : incentive.IncentiveCode;
        return this.platformService.apiService.delete(`carts/${CartService.getCurrentCartId()}/promotions/${code}?mode=${this.configService.get('pricingMode')}`)
            .pipe(tap(() => this.cartService.priceCart()));
    }
}
PromotionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PromotionService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
PromotionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PromotionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PromotionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * @ignore
 */
class AppliedRuleInfoService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = AppliedRuleInfo;
    }
}
AppliedRuleInfoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AppliedRuleInfoService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
AppliedRuleInfoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AppliedRuleInfoService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AppliedRuleInfoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });
/**
 * Constraint rules are a powerful feature when configuring products. They allow you to include, excludes, recommend, validate and replace products based on business logic.
 * <h3>Usage</h3>
 *
  ```typescript
 import { AppliedRuleActionInfoService, AObjectService} from '@congacommerce/ecommerce';
 
 export class MyComponent implements OnInit{
 constructor( private appliedRuleActionInfoService: AppliedRuleActionInfoService)
 }
 // or
 export class MyService extends AObjectService {
      private appliedRuleActionInfoService: AppliedRuleActionInfoService = this.injector.get(AppliedRuleActionInfoService);
  }
 ```
 */
class AppliedRuleActionInfoService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = AppliedRuleActionInfo;
        this.appliedRuleActionSubject = new BehaviorSubject([]);
        this.cartService = this.injector.get(CartService);
        this.configService = this.injector.get(ConfigurationService);
        this.state = new BehaviorSubject(null);
    }
    onInit() {
        if (this.configService.get('skipRules')) {
            this.state.next(null);
        }
        else {
            this.cartService.getMyCart()
                .pipe(filter$1(cart => cart && !cart.IsPricePending), switchMap(cart => {
                if (isNil(get(cart, 'LineItems')) || isEmpty(get(cart, 'LineItems')))
                    return of(null);
                const cartId = !isNil(cart) && !isNil(get(cart, 'Id')) ? cart.Id : 'active';
                return this.platformService.apiService.get(`/carts/${cartId}/rules`, this.type);
            })).subscribe(rules => {
                this.state.next(rules);
            });
        }
    }
    /**
     * Method retrieves the actions that are taken on a cart when the constraint rules are applied
     * ### Example:
     ```typescript
     import { AppliedRuleActionInfoService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         appliedRule : Array<AppliedRuleActionInfo>;
         appliedRule$ : Observable<Array<AppliedRuleActionInfo>>;
         constructor(private appliedRuleActionInfoService: AppliedRuleActionInfoService){}
     
       getAppliedRule(){
           this.appliedRuleActionInfoService.getAppliedActionsForCart().subscribe(a => this.appliedRule = a);
             // or
           assets$ = this.appliedRuleActionInfoService.getAppliedActionsForCart();
       }
     }
     ```
     * @param cart The cart to retrieve constraint rules for. If left blank, will use the current cart.
     * @returns An observable array of AppliedRuleActionInfo
     */
    getAppliedActionsForCart(cart) {
        return this.state;
    }
    /**
     * Deletes constraint rules for the given cart.
     * ### Example:
     ```typescript
     import { AppliedRuleActionInfoService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
 
         constructor(private appliedRuleActionInfoService: AppliedRuleActionInfoService){}
     
       deleteRulesForCart(cart?: Cart){
             this.appliedRuleActionInfoService.deleteRulesForCart(cart);
       }
     }
     ```
     * @param cart The cart on which to delete constraint rules. If left blank, will use the current cart.
     */
    deleteRulesForCart(cart) {
        const obsv = (cart) ? of(cart) : this.cartService.getMyCart();
        return obsv.pipe(take(1), switchMap(c => this.delete(concat(get(c, 'AppliedRuleActionInfo'), get(c, 'AppliedRuleInfo')), false)), catchError(e => {
            console.log(e);
            return e;
        }));
    }
}
AppliedRuleActionInfoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AppliedRuleActionInfoService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
AppliedRuleActionInfoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AppliedRuleActionInfoService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AppliedRuleActionInfoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * @ignore
 * Constraint rules are a powerful feature when configuring products. They allow you to include, excludes, recommend, validate and replace products based on business logic.
 */
class ConstraintRuleActionService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = ConstraintRuleAction;
    }
}
ConstraintRuleActionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConstraintRuleActionService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ConstraintRuleActionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConstraintRuleActionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConstraintRuleActionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * Constraint rules are a powerful feature when configuring products. They allow you to include, excludes, recommend, validate and replace products based on business logic.
 * <h3>Usage</h3>
 *
 ```typescript
 import { ConstraintRuleService, AObjectService} from '@congacommerce/ecommerce';
 
 export class MyComponent implements OnInit{
 constructor( private constraintRuleService: ConstraintRuleService)
 }
 // or
 export class MyService extends AObjectService {
      private constraintRuleService: ConstraintRuleService = this.injector.get(ConstraintRuleService);
  }
 ```
 */
class ConstraintRuleService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = ConstraintRule;
        this.productService = this.injector.get(ProductService);
        this.cartService = this.injector.get(CartService);
        this.araiService = this.injector.get(AppliedRuleActionInfoService);
        this.pliService = this.injector.get(PriceListItemService);
        this.productOptionService = this.injector.get(ProductOptionService);
        this.soapService = this.injector.get(SoapService);
        this.configService = this.injector.get(ConfigurationService);
        this.assetService = this.injector.get(AssetService);
        this.constraintRuleActionService = this.injector.get(ConstraintRuleActionService);
        this.onConstraintRuleError = new EventEmitter();
    }
    /**
     * @ignore
     */
    globalFilter() {
        return of([
            new AFilter(this.type, [
                new ACondition(this.type, 'EffectiveDate', 'LessEqual', 'Today'),
                new ACondition(this.type, 'EffectiveDate', 'Equal', null)
            ], null, 'OR'),
            new AFilter(this.type, [
                new ACondition(this.type, 'ExpirationDate', 'GreaterThan', 'Today'),
                new ACondition(this.type, 'ExpirationDate', 'Equal', null)
            ], null, 'OR'),
            new AFilter(this.type, [
                new ACondition(this.type, 'Active', 'Equal', true)
            ])
        ]);
    }
    /**
     * @ignore
     */
    associateAndApplyRules(finalize = false, cart) {
        const obsv = (cart) ? of(cart) : this.cartService.getMyCart(true).pipe(take(1));
        return obsv.pipe(switchMap((_cart) => this.araiService.deleteRulesForCart(_cart).pipe(mergeMap(() => this.associateConstraintRules(_cart)), mergeMap(() => this.applyConstraintRules(finalize, _cart)))));
    }
    /**
     * This method can be used to fetch the list of constraint rules for the given list of productIds.
     * It will return all the configurations of a constraint rules with constraint rule conditon and constraint rule action.
     * ### Example:
        ```typescript
        import { ConstraintRule, ConstraintRuleService } from '@congacommerce/ecommerce';

        export class MyComponent implements OnInit{
        rule: Array<ConstraintRule>;
        rule$: Observable<Array<ConstraintRule>>;

        constructor(private crService: ConstraintRuleService){}

        ngOnInit(){
            this.crService.getConstraintRulesForProducts(productList: Array<string> | Array<Product>).subscribe(rulesList => {rule = rulesList;});
            // or
            this.rule$ = this.crService.getConstraintRulesForProducts(productList: Array<string> | Array<Product>);
        }
        }
        ```
        * @override
        * @param productList represnting the list of product Id as  string or  list of product instance of product object.
        * @param matchInPrimaryLines represnting the matchInPrimaryLines flag is a boolean value for a rule.
        * @param matchInOptions represnting the matchInOptions flag is a boolean value for a rule.
        * @return Observable<Array<ConstraintRule>> returns an observable of Array<ConstraintRule> records.
   */
    getConstraintRulesForProducts(productList, matchInPrimaryLines = true, matchInOptions = false) {
        if (!matchInPrimaryLines && !matchInOptions)
            return throwError('matchInPrimaryLines or matchInOptions must be set to true');
        if (get(productList, 'length') > 0) {
            let productIdList;
            if (every(productList, (item) => typeof item === 'string'))
                productIdList = map(productList, (productId) => ({ Id: productId }));
            else
                productIdList = map(productList, (product) => ({ Id: get(product, 'Id') }));
            return this.platformService.apiService.post(`/products/rules?matchInPrimaryLines=${matchInPrimaryLines}&matchInOptions=${matchInOptions}`, productIdList, this.type)
                .pipe(map$1(productRuleMap => {
                return flatten(values(productRuleMap));
            }), map$1(rules => plainToClass(this.type, rules, { ignoreDecorators: true })));
        }
        else {
            return of(null);
        }
    }
    /**
     * This method can be used to fetch the list of product for the given cart which has recommended rules set.
     * ### Example:
        ```typescript
        import { ConstraintRule, ConstraintRuleService } from '@congacommerce/ecommerce';

        export class MyComponent implements OnInit{
        products: Array<Product>;
        products$: Observable<Array<Product>>;

        constructor(private crService: ConstraintRuleService){}

        ngOnInit(){
            this.crService.getRecommendationsForCart().subscribe(products => {products = products;});
            // or
            this.products$ = this.crService.getRecommendationsForCart();
        }
        }
        ```
        * @override
        * @param cart represnting the cart record is optional, if cart record is not passed fetches the active cart.
        * @return Observable<Array<Product>> returns an observable of Array<Product> records.
   */
    getRecommendationsForCart(cart) {
        return this.araiService.getAppliedActionsForCart()
            .pipe(map$1(actions => filter(actions, action => action.ConstraintRuleAction.ActionType === 'Recommendation')), switchMap(actions => {
            const productIds = uniq(flatten(map$1(actions, split('SuggestProductIds', ','))));
            return this.productService.query({
                conditions: [new ACondition(this.productService.type, 'Id', 'In', productIds)]
            });
        }));
    }
    /**
      * This method can be used to fetch the list of product which has recommended rules set for the list of product passed as argument.
      * ### Example:
         ```typescript
         import { ConstraintRule, ConstraintRuleService } from '@congacommerce/ecommerce';

         export class MyComponent implements OnInit{
         products: Array<Product>;
         products$: Observable<Array<Product>>;

         constructor(private crService: ConstraintRuleService){}

         ngOnInit(){
             this.crService.getRecommendationsForProducts(productList: Array<Product> | Array<string>).subscribe(products => {products = products;});
             // or
             this.products$ = this.crService.getRecommendationsForProducts(productList: Array<Product> | Array<string>);
         }
         }
         ```
         * @override
         * @param productList represnting the list of product record.
         * @return Observable<Array<Product>> returns an observable of Array<Product> records.
    */
    getRecommendationsForProducts(productList) {
        if (get(productList, 'length', 0) > 0) {
            return this.getConstraintRulesForProducts(productList).pipe(map$1(rules => compact(uniqBy(rules, 'Id'))), mergeMap(rules => {
                if (isEmpty(compact(rules)))
                    return of(null);
                else {
                    return this.productService.query({
                        children: [
                            {
                                field: 'Apttus_Config2__AssetLineItems__r',
                                filters: [
                                    new AFilter(this.assetService.type, [new ACondition(this.assetService.type, 'LineType', 'NotEqual', 'Option'),
                                        new ACondition(this.assetService.type, 'Product.ConfigurationType', 'NotEqual', 'Option'),
                                        new ACondition(this.assetService.type, 'IsPrimaryLine', 'Equal', true),
                                        new ACondition(this.assetService.type, 'AssetStatus', 'Equal', 'Activated')])
                                ],
                                lookups: [
                                    {
                                        field: 'Product'
                                    }
                                ]
                            },
                            {
                                field: 'Apttus_Config2__PriceLists__r'
                            }
                        ],
                        joins: [
                            new AJoin(this.constraintRuleActionService.type, 'Id', 'ProductId', [
                                new ACondition(this.constraintRuleActionService.type, 'ActionType', 'Equal', 'Recommendation'),
                                new ACondition(this.constraintRuleActionService.type, 'ConstraintRuleId', 'In', rules.map(rule => rule.Id))
                            ])
                        ]
                    });
                }
            }));
        }
        else
            return of(null);
    }
    /**
     * This method can be used to fetch the list of Applied rule action info records for active cart.
     * It returns AppliedRuleActionInfo record having constraint rule action, actionType as Exclusion.
     * ### Example:
        ```typescript
        import { AppliedRuleActionInfo, ConstraintRuleService } from '@congacommerce/ecommerce';

        export class MyComponent implements OnInit{
        rule: Array<AppliedRuleActionInfo>;
        rule$: Observable<Array<AppliedRuleActionInfo>>;

        constructor(private crService: ConstraintRuleService){}

        ngOnInit(){
            this.crService.getExclusionProductActionsForCart().subscribe(rule => {rule = rule;});
            // or
            this.rule$ = this.crService.getExclusionProductActionsForCart();
        }
        }
        ```
        * @override
        * @return Observable<Array<AppliedRuleActionInfo>> returns an observable of Array<AppliedRuleActionInfo> records.
   */
    getExclusionProductActionsForCart() {
        return this.araiService.getAppliedActionsForCart()
            .pipe(map$1(actions => filter(actions, action => action.ConstraintRuleAction.ActionType === 'Exclusion')));
    }
    /**
    * This method can be used to fetch the list of Applied rule action info records for active cart.
    * It returns  applied rule action info records have pending flag as true.
    * ### Example:
       ```typescript
       import { AppliedRuleActionInfo, ConstraintRuleService } from '@congacommerce/ecommerce';

       export class MyComponent implements OnInit{
       rule: Array<AppliedRuleActionInfo>;
       rule$: Observable<Array<AppliedRuleActionInfo>>;

       constructor(private crService: ConstraintRuleService){}

       ngOnInit(){
           this.crService.getPendingActionsForCart().subscribe(rule => {rule = rule;});
           // or
           this.rule$ = this.crService.getPendingActionsForCart();
       }
       }
       ```
       * @override
       * @return Observable<Array<AppliedRuleActionInfo>> returns an observable of Array<AppliedRuleActionInfo> records.
  */
    getPendingActionsForCart() {
        return this.araiService.getAppliedActionsForCart()
            .pipe(map$1(actions => {
            let filteredAppliedRuleAction = filter(actions, action => action.Pending === true && !isEmpty(concat(get(action, 'ActionProductIds'))));
            filteredAppliedRuleAction = this.getDistinctAppliedRules(filteredAppliedRuleAction);
            return filteredAppliedRuleAction;
        }));
    }
    /**
    * This method can be used to fetch the list of ConstraintRule records for given product identifier.
    * It do not fetch the constraint rule record if SkipRule flag is true.
    * ### Example:
       ```typescript
       import { ConstraintRule, ConstraintRuleService } from '@congacommerce/ecommerce';

       export class MyComponent implements OnInit{
       rule: Array<ConstraintRule>;
       rule$: Observable<Array<ConstraintRule>>;

       constructor(private crService: ConstraintRuleService){}

       ngOnInit(){
           this.crService.getRuleByProductId(productId: string).subscribe(rule => {rule = rule;});
           // or
           this.rule$ = this.crService.getRuleByProductId(productId: string);
       }
       }
       ```
       * @override
       * @param productId represnting the product identifier.
       * @return Observable<Array<ConstraintRule>> returns an observable of Array<ConstraintRule> records.
  */
    getRuleByProductId(productId) {
        // Don't fetch product rules if skipRules flag is set to true in the configuration.
        return (this.configService.get('skipRules')) ? of(null) : this.cacheService.buffer('constraint-rules', productId, (data) => {
            return this.platformService.apiService.post(`products/rules?matchInPrimaryLines=true&matchInOptions=false`, map(uniq(data), r => ({ Id: r })));
        }, (dataMap) => {
            return plainToClass(this.type, get(dataMap, productId), { ignoreDecorators: true });
        });
    }
    /**
    * This method returns boolean value for  active cart's applied rule action record based on pending flag.
    * ### Example:
       ```typescript
       import { ConstraintRule, ConstraintRuleService } from '@congacommerce/ecommerce';

       export class MyComponent implements OnInit{
       haserror: boolean;
       haserror: Observable<boolean>;

       constructor(private crService: ConstraintRuleService){}

       ngOnInit(){
           this.crService.hasPendingErrors().subscribe(err => {haserror = err;});
           // or
           this.haserror$ = this.crService.hasPendingErrors();
       }
       }
       ```
       * @override
       * @param cart representing the cart record is an optional parameter, if cart record is not passed fetched the active cart.
       * @return Observable<boolean> returns an observable of boolean value.
  */
    hasPendingErrors(cart) {
        return this.getPendingActionsForCart().pipe(map$1(rules => rules.filter(rule => rule.MessageType === 'Error').length > 0));
    }
    /**
     * @ignore
     */
    associateConstraintRules(cart) {
        return this.platformService.post('associateConstraintRules', { cartId: cart.Id }, 'SoapHandler', false);
    }
    /**
     * @ignore
     */
    applyConstraintRules(finalize = false, cart) {
        return this.platformService.post('applyConstraintRules', { cartId: cart.Id, finalCheck: finalize }, 'SoapHandler', false);
    }
    /**
     * @ignore
     */
    removeConstraintRules(productIdList, cart) {
        return this.platformService.post('applyConstraintRulesOnDelete', { cartId: cart.Id, deletedProductIds: productIdList }, 'SoapHandler', false);
    }
    /**
     * Method used to distinct primary line level rules.
     * @ignore
    */
    getDistinctAppliedRules(appliedRules) {
        let resp = [];
        let cartRule = filter(appliedRules, (elem) => elem.IsTargetPrimaryLine);
        cartRule = uniqBy(cartRule, 'ConstraintRuleActionId');
        const optionRule = filter(appliedRules, (elem) => elem.IsTargetOption);
        resp = [...cartRule, ...optionRule];
        return resp;
    }
}
ConstraintRuleService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConstraintRuleService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ConstraintRuleService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConstraintRuleService, providedIn: 'root' });
__decorate([
    MemoizeAll(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array, Boolean, Boolean]),
    __metadata("design:returntype", Observable)
], ConstraintRuleService.prototype, "getConstraintRulesForProducts", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConstraintRuleService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], propDecorators: { getConstraintRulesForProducts: [] } });

/**@ignore */
class AttributeValueMatrixService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = ProductAttributeMatrixView;
        this.productService = this.injector.get(ProductService);
        this.metadataService = this.injector.get(MetadataService);
        this.productAttributeService = this.injector.get(ProductAttributeService);
    }
    onInit() {
        this.l2Size = 15;
        this.l1Size = this.l2Size * this.l2Size;
    }
    /** -- Method declarations -- */
    init(data) {
        this.dataBits = new BitString(data);
        this.dataLength = this.dataBits.length;
        // fetch pad count, from end of data (3 bits)
        this.padCount = this.dataBits.getBitNumber(this.dataLength - 3, 3);
        // get node count (20 bits ending at length - 3 bits)
        this.nodeCount = this.dataBits.getBitNumber(this.dataLength - 23, 20);
        // get directory size (20 bits ending at length - 23 bits)
        this.directorySize = this.dataBits.getBitNumber(this.dataLength - 43, 20);
        // calculate directory start index
        this.directoryStart = this.directorySize <= 0 ? 0 : this.dataLength - this.padCount - this.directorySize - 43;
        // calculate the label sizes (4 bits, after trie bit vector)
        this.labelSize = this.dataBits.getBitNumber(this.nodeCount * 2 + 1, 4);
        // The position of the first bit of the data in 0th node.
        this.letterStart = this.nodeCount * 2 + 5;
        // calculate L1 bits width
        this.l1Bits = Math.floor(Math.log(this.nodeCount * 2 + 1) / Math.log(2)) + 1;
        // calculate L2 bits width
        this.l2Bits = Math.floor(Math.log(this.l1Size) / Math.log(2)) + 1;
        // calculate bits in directory entry
        this.sectionBits = (this.l1Size / this.l2Size - 1) * this.l2Bits + this.l1Bits;
    }
    /**
      Retrieve the root node. You can use this node to obtain all of the other
      nodes in the trie.
      */
    getRoot() {
        return this.getNodeByIndex(0);
    }
    /**
     * Retrieve the FrozenTrieNode of the trie, given its index in level-order.
     */
    getNodeByIndex(index, parentNode) {
        // retrieve the node letter.
        const letterOffset = this.letterStart + ((index - 1) * this.labelSize);
        const letter = this.dataBits.getBitNumber(letterOffset, this.labelSize);
        // get index of first child
        const firstChild = this.select(0, index + 1) - index;
        // Nodes are encoded in level order, so child of first node
        // must be past the 0 in this position
        const childOfNextNode = this.select(0, index + 2) - index - 1;
        return new AptValueMatrixNode(this, index, letter, firstChild, parentNode, childOfNextNode - firstChild);
    }
    /**
     * Returns the position of the y'th 0 or 1 bit, depending on the "which"
     * parameter.
     */
    select(which, y) {
        let high = this.nodeCount * 2 + 1;
        let low = -1;
        let val = -1;
        while (high - low > 1) {
            const probe = (high + low) / 2 | 0;
            const selectRank = this.rank(which, probe);
            if (selectRank === y) {
                // We have to continue searching after we have found it,
                // because we want the _first_ occurrence.
                val = probe;
                high = probe;
            }
            else if (selectRank < y) {
                low = probe;
            }
            else {
                high = probe;
            }
        }
        return val;
    }
    /**
     * Returns the number of 1 or 0 bits (depending on the "which" parameter) to
     * to and including position x.
     */
    rank(which, x) {
        if (which === 0) {
            return x - this.rank(1, x) + 1;
        }
        let selectRank = 0;
        let o = x;
        let sectionPos = 0;
        if (o >= this.l1Size) {
            sectionPos = (o / this.l1Size | 0) * this.sectionBits;
            selectRank = this.dataBits.getBitNumber(this.directoryStart + (sectionPos - this.l1Bits), this.l1Bits);
            // calculate bits which have not been summarized
            o = o % this.l1Size;
        }
        if (o >= this.l2Size) {
            sectionPos += (o / this.l2Size | 0) * this.l2Bits;
            selectRank += this.dataBits.getBitNumber(this.directoryStart + (sectionPos - this.l2Bits), this.l2Bits);
        }
        selectRank += this.dataBits.countOnesBits(x - x % this.l2Size, x % this.l2Size + 1);
        return selectRank;
    }
    getAttributeMatrixForProducts(productList) {
        return this.cacheService.buffer('attributeMatrixView', productList, (allProducts) => {
            return this.getAttributeMatrix(_.flatten(allProducts));
        }, (results) => {
            return results;
            // return _.flatten(_.map(results, r => _.get(r, '_metadata.rules')));
        }, 100, 10);
    }
    /**
     * Gets the matrix view for the given product.
     * @param product instance of product object.
     * @param hasAttr If it's true get the matrix view for the product
     * @returns Observable array of Allowed values for the given product.
     */
    getAttributeMatrix(productList) {
        if (productList) {
            // First query retrieves list of potential rules that the product list is a member of
            productList = productList.filter(p => p != null);
            const product$ = (productList.every((item) => typeof item === 'string')) ? this.productService.get(productList) : of(productList);
            return product$.pipe(mergeMap((_productList) => {
                const groupIds = _.uniq(_productList.map(p => _.get(p, 'AttributeGroups').map(r => r.AttributeGroupId)));
                const filterList = [];
                if (groupIds) {
                    filterList.push(new AFilter(this.type, [new ACondition(this.type, 'ProductId', 'Equal', null),
                        new ACondition(this.type, 'ProductAttributeScopeId', 'In', groupIds), new ACondition(this.type, 'AttributeValueMatrix.Active', 'Equal', true)], null, 'AND'));
                }
                return this.query({
                    filters: filterList,
                })
                    .pipe(map$1(matrixResults => {
                    return matrixResults;
                }));
            }));
        }
    }
    /**
       * Process the attribute matrix rules
       * Modes of operation: (Default mode is 1)
       * <1> Default and treat null as nothing is applicable
       * <2> Default and treat null as a wild card, i.e. many default values
       * <3> Constrain and treat null as a no value is available
       * <4> Constrain and treat null as a wild card, i.e. all values available
       *
       * @param matrixInfos the Array of ProductAttributeMatrixView from server
       * @param attrMetadata attribute field metadata map
       * @return a mapping of the available values by field API name
       */
    processAttributeMatrices(matrixInfos, attrMetadata, attributeSO, userSelected, lastTouched, userCleared, attributeSOCopy) {
        let matrixResults = {
            defaults: {},
            constraints: {},
            forceSets: {},
            reset: {},
            items: [],
        };
        matrixInfos.forEach((rule) => {
            if (_.isUndefined(_.get(rule, '_metadata.reverseKeys'))) {
                // store reverse key lookup
                _.set(rule, '_metadata.reverseKeys', {});
                let keyMap = JSON.parse(rule.Keys);
                _.map(keyMap, function (value, key) {
                    if (keyMap.hasOwnProperty(key)) {
                        rule._metadata.reverseKeys[keyMap[key]] = key;
                    }
                });
                // update hash key with actual object bindings
                rule.Keys = keyMap;
            }
            const columnDetails = JSON.parse(rule.Columns);
            const columns = columnDetails.columns;
            const items = [];
            let restoreColumns = [];
            let lastTouchedIdx = null;
            let controlIdx = null;
            let hasUserClearedSelection = false;
            for (let key in columns) {
                if (columns.hasOwnProperty(key)) {
                    const fieldName = columns[key];
                    const fieldType = attrMetadata.fields.find(r => r.name === columns[key]).type;
                    const isSelectType = (fieldType === 'multipicklist') || (fieldType === 'picklist');
                    const isMultiSelect = fieldType === 'multipicklist';
                    let itemValue;
                    itemValue = _.get(attributeSO, `${fieldName}`);
                    if (isMultiSelect)
                        itemValue = _.isNil(itemValue) ? [] : _.split(itemValue, ';');
                    if ((itemValue instanceof Array && _.get(itemValue, 'length') >= 0 && !isMultiSelect) ||
                        (itemValue instanceof Array && _.get(itemValue, 'length') === 0 && isMultiSelect))
                        itemValue = undefined;
                    if (fieldName === lastTouched) {
                        lastTouchedIdx = items.length;
                    }
                    const item = {
                        Name: fieldName,
                        Id: fieldName,
                        value: itemValue,
                        columnValue: itemValue,
                        isMultiSelect: isMultiSelect,
                        isSelectType: isSelectType,
                        isWildcard: (_.get(rule, 'AttributeValueMatrix.TreatNullAsWildcard') === true) ? true : false
                    };
                    const isUserSelected = _.get(userSelected, `${fieldName}`);
                    const isUserCleared = _.get(userCleared, `${fieldName}`);
                    const isLastTouched = item.Id === lastTouched;
                    if (_.get(rule, 'AttributeValueMatrix.ApplicationType') !== 'Force Set'
                        && isUserCleared === true) {
                        restoreColumns.push(items.length);
                        hasUserClearedSelection = true;
                    }
                    // set the controlling column
                    if ((_.get(rule, 'AttributeValueMatrix.ApplicationType') !== 'Force Set'
                        && isUserSelected === true && isUserCleared === true)) {
                        restoreColumns.push(items.length);
                        controlIdx = items.length;
                    }
                    else if (_.get(rule, 'AttributeValueMatrix.ApplicationType') === 'Force Set'
                        && isLastTouched) {
                        controlIdx = items.length;
                    }
                    // add item to collection
                    items.push(item);
                }
            }
            matrixResults.items = _.concat(matrixResults.items, items);
            // If user clears a value from one attribute and changes another, the latter becomes the control.
            // E.g. USA | CA | San Mateo, clear CA and choose another city in the US, State should lock to value
            // containing the selected city (USA | AZ | Phoenix).
            if (_.get(rule, 'AttributeValueMatrix.ApplicationType') === 'Constrain' && hasUserClearedSelection && _.get(userSelected, `${lastTouched}`) && controlIdx === null) {
                controlIdx = lastTouchedIdx;
            }
            // user cleared and picked new value, so it becomes
            // the new "user selection"
            if (controlIdx !== null) {
                const validCombinationNew = this.getAvailableForNewSelection(controlIdx, items, rule);
                for (let itemIdx = 0; itemIdx < items.length; itemIdx++) {
                    const item = items[itemIdx];
                    const fieldName = items[itemIdx].Id;
                    let availableForField = matrixResults.constraints[fieldName];
                    const validCombination = this.getValidValues(validCombinationNew[fieldName], fieldName, items, rule);
                    if (_.get(rule, 'AttributeValueMatrix.ApplicationType') === 'Force Set') {
                        // union all of the values together
                        availableForField = matrixResults.forceSets[fieldName];
                        _.set(matrixResults, `forceSets.${fieldName}`, _.union(availableForField, validCombination));
                    }
                    else if (_.get(rule, 'AttributeValueMatrix.ApplicationType') === 'Default') {
                        // additional defaults creates a union
                        availableForField = matrixResults.defaults[fieldName];
                        _.set(matrixResults, `defaults.${fieldName}`, _.union(availableForField, validCombination));
                    }
                    else {
                        // intersection of available values
                        availableForField = matrixResults.constraints[fieldName];
                        if (_.isUndefined(availableForField)) {
                            _.set(matrixResults, `constraints.${fieldName}`, validCombination);
                        }
                        else {
                            _.set(matrixResults, `constraints.${fieldName}`, _.intersection(availableForField, validCombination));
                        }
                    }
                }
            }
            else if (!hasUserClearedSelection || _.get(rule, 'AttributeValueMatrix.ApplicationType') === 'Constrain') {
                // collect the new matrix values
                const validCombinations = this.getAvailableValues(items, rule);
                for (const fieldName in validCombinations) {
                    if (validCombinations.hasOwnProperty(fieldName)) {
                        let validCombination = validCombinations[fieldName];
                        validCombination = this.getValidValues(validCombination, fieldName, items, rule);
                        if (_.get(rule, 'AttributeValueMatrix.ApplicationType') === 'Force Set') {
                            // union all of the values together
                            const availableForField = matrixResults.forceSets[fieldName];
                            _.set(matrixResults, `forceSets.${fieldName}`, _.union(availableForField, validCombination));
                        }
                        else if (_.get(rule, 'AttributeValueMatrix.ApplicationType') === 'Default') {
                            // additional defaults creates a union
                            const availableForField = matrixResults.defaults[fieldName];
                            _.set(matrixResults, `defaults.${fieldName}`, _.union(availableForField, validCombination));
                        }
                        else {
                            // intersection of available values
                            const availableForField = matrixResults.constraints[fieldName];
                            if (_.isUndefined(availableForField)) {
                                _.set(matrixResults, `constraints.${fieldName}`, validCombination);
                            }
                            else {
                                _.set(matrixResults, `constraints.${fieldName}`, _.intersection(availableForField, validCombination));
                            }
                        }
                    }
                }
            }
            if (controlIdx == null &&
                _.get(rule, 'AttributeValueMatrix.ApplicationType') === 'Constrain' &&
                restoreColumns.length) { // user cleared selection will open up all values
                if (_.isUndefined(_.get(rule, '_metadata.allOptions'))) {
                    rule._metadata.allOptions = this.getAllOptions(items, rule);
                }
                // build the reset columns
                for (let restoreIdx = 0; restoreIdx < restoreColumns.length; restoreIdx++) {
                    let itemIdx = restoreColumns[restoreIdx];
                    let fieldName = items[itemIdx].Id;
                    let availableForField = matrixResults.reset[fieldName];
                    if (_.isUndefined(availableForField)) {
                        matrixResults.reset[fieldName] = rule._metadata.allOptions[fieldName];
                    }
                    else {
                        matrixResults.reset[fieldName] = _.intersection(availableForField, rule._metadata.allOptions[fieldName]);
                    }
                }
            }
            else if (controlIdx !== null) { // remove user cleared flag
                const resetField = items[controlIdx].Id;
                for (let count = 0; count < items.length; count++) {
                    if (count !== controlIdx) {
                        _.get(userCleared, `${items[count].Id}`, false);
                    }
                }
            }
        }, this);
        matrixResults.items = _.uniqBy(matrixResults.items, 'Name');
        return this.getAllowedValues(matrixResults, attributeSO, attributeSOCopy);
    }
    /**
    * Get values avaialble given new selection.
    * This method will attempt to retain as many pre-selcted values,
    * i.e. whichever values are valid with the newIdx being the driver
    *
    * @param newIdx the index of the newly updated column
    * @param columns the column details
    * @param matrixInfo the matrix info
    * @return mapping of valid combinations
    */
    getAvailableForNewSelection(newIdx, columns, matrixInfo) {
        for (let itemIdx = 0; itemIdx < columns.length; itemIdx++) {
            if (newIdx === itemIdx) {
                continue;
            }
            // setup wildcard override
            for (let siblingIdx = 0; siblingIdx < columns.length; siblingIdx++) {
                let siblingItem = columns[siblingIdx];
                siblingItem.isWildcard =
                    siblingIdx !== newIdx && siblingIdx > itemIdx;
            }
            // check valid for this combination
            const checkItem = columns[itemIdx];
            const resetItem = columns[newIdx];
            const resetField = resetItem.Id;
            const validCombinations = this.getAvailableValues(columns, matrixInfo);
            const resetChoices = this.getValidValues(validCombinations[resetField], resetField, columns, matrixInfo);
            if (resetChoices.indexOf(resetItem.value) < 0) {
                checkItem.value = null;
            }
        }
        // remove the wildcard override and re-execute
        for (let itemIdx = 0; itemIdx < columns.length; itemIdx++) {
            let item = columns[itemIdx];
            item.isWildcard = false;
        }
        // retain as many selections as possible
        return this.getAvailableValues(columns, matrixInfo);
    }
    setFieldValues(matrixView, attributeSO, attributeSOCopy) {
        _.forEach(matrixView, (view) => {
            if (view.allowedValues && !_.isEmpty(view.resetValues)) {
                const resttemp = Object.keys(view.resetValues);
                for (let i = 0; i < resttemp.length; i++) {
                    const attributeVal = _.get(attributeSO, `${resttemp[i]}`) ? _.get(attributeSO, `${resttemp[i]}`).split(';').sort() : [];
                    if (view.items.isMultiSelect && _.some(view.resetValues[resttemp[i]])) {
                        view.resetValues[resttemp[i]] = view.resetValues[resttemp[i]].sort();
                    }
                    if (!_.isEqual(attributeVal, view.resetValues[resttemp[i]])) {
                        if (view.items.isSelectType && !view.items.isMultiSelect) {
                            view.items.value = null;
                        }
                        else if (view.items.isMultiSelect && view.resetValues[resttemp[i]].length === 0) {
                            // view.items.value = [].join(';');
                            view.items.value = null;
                        }
                        else if (view.items.isMultiSelect && view.resetValues[resttemp[i]].length > 0) {
                            const val = _.intersection(view.resetValues[resttemp[i]], [attributeSO[resttemp[i]]]);
                            view.items.value = val.join(';');
                        }
                    }
                    if (_.isEmpty(view.items.value))
                        view.items.value = null;
                }
            }
            else {
                if (view.allowedValues && !_.isEmpty(view.constraints)) {
                    const temp = Object.keys(view.constraints);
                    for (let i = 0; i < temp.length; i++) {
                        const attributeVal = _.get(attributeSO, `${temp[i]}`) ? _.get(attributeSO, `${temp[i]}`).split(';').sort() : [];
                        if (view.items.isMultiSelect && _.some(view.constraints[temp[i]])) {
                            view.constraints[temp[i]] = view.constraints[temp[i]].sort();
                        }
                        if (!_.isEqual(attributeVal, view.constraints[temp[i]])) {
                            if (view.items.isSelectType && !view.items.isMultiSelect && _.get(view.constraints[temp[i]], 'length') > 1) {
                                if (!view.items.columnValue)
                                    view.items.value = null;
                            }
                            else if (view.items.isMultiSelect && view.constraints[temp[i]].length === 0) {
                                if (_.get(attributeSO[temp[i]], 'length') > 0)
                                    view.items.value = attributeSO[temp[i]].join(';');
                                else
                                    view.items.value = null;
                            }
                            else if (view.items.isMultiSelect && view.constraints[temp[i]].length > 1) {
                                const val = _.intersection(view.constraints[temp[i]], [attributeSO[temp[i]]]);
                                view.items.value = val.join(';');
                            }
                            else {
                                if (view.items.isSelectType && !view.items.isMultiSelect) {
                                    view.items.value = view.constraints[temp[i]][0];
                                }
                                else {
                                    if (attributeSO.hasOwnProperty(temp[i]) && view.items.columnValue) {
                                        view.items.value = _.intersection(view.constraints[temp[i]], [attributeSO[temp[i]]]).join(';');
                                    }
                                    else if (!attributeSO.hasOwnProperty(temp[i]) && !view.items.columnValue) {
                                        view.items.value = view.constraints[temp[i]].join(';');
                                    }
                                    else {
                                        view.items.value = view.constraints[temp[i]].join(';');
                                    }
                                }
                            }
                        }
                        else {
                            if (!_.get(attributeSO, `${temp[i]}`) && view.items.isSelectType && !view.items.isMultiSelect) {
                                view.items.value = null;
                            }
                            else if (_.get(attributeSO, `${temp[i]}.length`) === 0 && view.items.isMultiSelect) {
                                view.items.value = null;
                            }
                            else {
                                view.items.value = _.get(attributeSO, `${temp[i]}`);
                            }
                        }
                        if (_.isEmpty(view.items.value))
                            view.items.value = null;
                    }
                }
                if (view.allowedValues && !_.isEmpty(view.forceSets)) {
                    const forcesettemp = Object.keys(view.forceSets);
                    for (let i = 0; i < forcesettemp.length; i++) {
                        const attributeVal = _.get(attributeSO, `${forcesettemp[i]}`) ? _.get(attributeSO, `${forcesettemp[i]}`).split(';').sort() : [];
                        if (view.items.isMultiSelect && _.some(view.forceSets[forcesettemp[i]])) {
                            view.forceSets[forcesettemp[i]] = view.forceSets[forcesettemp[i]].sort();
                        }
                        if (!_.isEqual(attributeVal, view.forceSets[forcesettemp[i]])) {
                            if ((view.items.isSelectType && !view.items.isMultiSelect && view.forceSets[forcesettemp[i]].length > 1)) {
                                if (attributeSO[forcesettemp[i]]) {
                                    view.items.value = attributeSO[forcesettemp[i]];
                                }
                                else {
                                    view.items.value = null;
                                }
                            }
                            else if (view.items.isMultiSelect && view.forceSets[forcesettemp[i]].length > 1) {
                                if (attributeSO.hasOwnProperty(forcesettemp[i]) && !view.items.columnValue) {
                                    view.items.value = _.intersection(view.forceSets[forcesettemp[i]], [attributeSO[forcesettemp[i]]]).join(';');
                                }
                                else if (attributeSO.hasOwnProperty(forcesettemp[i]) && view.items.columnValue) {
                                    view.items.value = view.items.columnValue.join(';');
                                }
                                else if (attributeSO.hasOwnProperty(forcesettemp[i]) && !view.items.columnValue) {
                                    view.items.value = _.union(view.forceSets[forcesettemp[i]], [attributeSO[forcesettemp[i]]]).join(';');
                                }
                                else if (view.forceSets[forcesettemp[i]].length === 0) {
                                    if (attributeSOCopy.hasOwnProperty(forcesettemp[i]))
                                        view.items.value = attributeSOCopy[forcesettemp[i]].join(';');
                                }
                            }
                            else {
                                if (view.items.isSelectType && !view.items.isMultiSelect) {
                                    view.items.value = view.forceSets[forcesettemp[i]][0];
                                }
                                else if (view.items.isSelectType && view.items.isMultiSelect) {
                                    view.items.value = _.join(view.forceSets[forcesettemp[i]], ';');
                                }
                                else {
                                    view.items.value = view.forceSets[forcesettemp[i]];
                                }
                            }
                        }
                        else {
                            if (view.items.isMultiSelect) {
                                const val = _.union(attributeSO[forcesettemp[i]], [attributeSO[forcesettemp[i]]]);
                                view.items.value = val.join(';');
                            }
                            else if (view.items.isSelectType && !view.items.isMultiSelect) {
                                view.items.value = view.forceSets[forcesettemp[i]].join(';');
                            }
                        }
                        if (_.isEmpty(view.items.value))
                            view.items.value = null;
                    }
                }
                if (view.allowedValues && !_.isEmpty(view.defaults)) {
                    const defaulttemp = Object.keys(view.defaults);
                    for (let i = 0; i < defaulttemp.length; i++) {
                        const attributeVal = _.get(attributeSO, `${defaulttemp[i]}`) ? _.get(attributeSO, `${defaulttemp[i]}`).split(';').sort() : [];
                        if (view.items.isMultiSelect && _.some(view.defaults[defaulttemp[i]])) {
                            view.defaults[defaulttemp[i]] = view.defaults[defaulttemp[i]].sort();
                        }
                        if (!_.isEqual(attributeVal, view.defaults[defaulttemp[i]])) {
                            if (view.items.isSelectType && !view.items.isMultiSelect) {
                                if (_.get(attributeSO, `${defaulttemp[i]}`))
                                    view.items.value = _.get(attributeSO, `${defaulttemp[i]}`);
                                else if (view.defaults[defaulttemp[i]] > 1)
                                    view.items.value = null;
                                else
                                    view.items.value = view.defaults[defaulttemp[i]][0];
                            }
                            else {
                                if (view.defaults[defaulttemp[i]].length === 0 && attributeSO[defaulttemp[i]].length === 0) {
                                    view.items.value = [].join(';');
                                }
                                else
                                    view.items.value = _.union(view.defaults[defaulttemp[i]], attributeSO[defaulttemp[i]]).join(';');
                            }
                        }
                        if (_.isEmpty(view.items.value))
                            view.items.value = null;
                    }
                }
            }
        });
        return matrixView;
    }
    /**
     * Get all available options
     * @param items the context columns
     * @param matrixInfo the matrix info
     * @return list of all combinations
     */
    getAllOptions(items, matrixInfo) {
        const ctxItems = _.cloneDeep(items);
        for (let itemIdx = 0; itemIdx < ctxItems.length; itemIdx++) {
            const item = ctxItems[itemIdx];
            item.isWildcard = true;
        }
        return this.getAvailableValues(ctxItems, matrixInfo);
    }
    /**
     * Get the valid values
     * @param validCombination the valid combinations including "null"
     * @param nullAsWildcard whether to treat null as wildcard or true value
     * @return valid combinations. modifies list
     */
    getValidValues(validCombination, fieldName, allItems, matrixInfo) {
        // build null key
        let nullIdx = validCombination.indexOf(null);
        if (nullIdx >= 0) {
            if (_.get(matrixInfo, 'AttributeValueMatrix.TreatNullAsWildcard') === true) { // Null treated as a wildcard by default
                if (_.isUndefined(_.get(matrixInfo, '_metadata.allOptions'))) {
                    matrixInfo._metadata.allOptions = this.getAllOptions(allItems, matrixInfo);
                }
                validCombination = matrixInfo._metadata.allOptions[fieldName];
                nullIdx = validCombination.indexOf(null);
                if (nullIdx >= 0) {
                    validCombination.splice(nullIdx, 1);
                }
            }
            else {
                validCombination.length = 0; // nothing is applicable
            }
        }
        return validCombination;
    }
    /**
     * Get the available values for the given combination
     * @param items the items to test
     * @param matrixInfos the AttributeMatrixDO
     * @return a mapping of the available values by item id
     */
    getAvailableValues(items, matrixInfo) {
        // init values
        this.init(matrixInfo.Hash);
        let level = 0;
        let nodesForLevel = this.getRoot().getChildren();
        const availableValues = {};
        while (level < items.length && nodesForLevel.length > 0) {
            const levelInput = items[level];
            const levelSize = nodesForLevel.length;
            const isMultiSelect = levelInput.isMultiSelect;
            const isSelectType = levelInput.isSelectType;
            const nodeKeys = {};
            let isWildCard = true; // wildcard behavior by default
            if (levelInput.isWildcard !== true
                && !_.isUndefined(levelInput.value)
                && levelInput.value !== null) {
                // determine node keys
                let inputArray = [levelInput.value];
                if (isMultiSelect) {
                    inputArray = levelInput.value instanceof Array ? levelInput.value : levelInput.value.split(';');
                    for (let idx = 0, len = inputArray.length; idx < len; idx++) {
                        const inputValue = inputArray[idx];
                        nodeKeys[inputValue] = inputValue;
                    }
                }
                else {
                    const nodeKey = _.get(matrixInfo, '_metadata.reverseKeys')[levelInput.value];
                    if (!_.isUndefined(nodeKey)) {
                        nodeKeys[nodeKey] = nodeKey;
                    }
                }
                isWildCard = false;
            }
            // console.log('level=' + level + '  nodeKey=' + nodeKey + ' node.letter==' + node.letter);
            if (isWildCard || levelInput.isWildcard) { // wildcards
                if (level < items.length - 1) {
                    for (let m = 0; m < levelSize; m++) {
                        const node = nodesForLevel.shift();
                        const children = node.getChildren();
                        for (let n = 0; n < children.length; n++) {
                            // add back for next level inspection
                            const child = children[n];
                            nodesForLevel.push(child);
                        }
                    }
                }
            }
            else {
                for (let k = 0; k < levelSize; k++) {
                    const node = nodesForLevel.shift();
                    const nodeLetter = node.letter;
                    const nodeKey = matrixInfo.Keys[nodeLetter];
                    // always include null if matrix accepts wildcards
                    if (nodeKey === null && _.get(matrixInfo, 'AttributeValueMatrix.TreatNullAsWildcard') === true) {
                        if (level === items.length - 1) {
                            nodesForLevel.push(node);
                        }
                        else { // willd check next level
                            nodesForLevel = nodesForLevel.concat(node.getChildren());
                        }
                    }
                    else {
                        let splitLetter = [nodeLetter];
                        if (isMultiSelect) {
                            if (nodeKey === null) {
                                splitLetter = [null];
                            }
                            else {
                                splitLetter = nodeKey instanceof Array ? nodeKey : nodeKey.split(';');
                            }
                        }
                        for (let p = 0; p < splitLetter.length; p++) {
                            const letter = splitLetter[p];
                            if (!_.isUndefined(nodeKeys[letter])) { // matching node
                                if (level === items.length - 1) {
                                    nodesForLevel.push(node);
                                }
                                else { // willd check next level
                                    nodesForLevel = nodesForLevel.concat(node.getChildren());
                                }
                                break;
                            }
                        }
                    }
                }
            }
            level += 1;
        }
        // console.log('results=');
        //  console.log('nodesForLevel',nodesForLevel);
        // populate list backwards from the leaf node
        let addedColumns = {};
        if (!_.isUndefined(items) && items != null) {
            for (let i = level - 1; i >= 0; i--) {
                addedColumns[i] = [];
                let valuesForLevel = [];
                const item = items[i];
                const levelSize = nodesForLevel.length;
                for (let j = 0; j < levelSize; j++) {
                    const node = nodesForLevel.shift();
                    if (_.isUndefined(addedColumns[i][node.letter])) {
                        const optionValue = matrixInfo.Keys[node.letter];
                        if (item.isSelectType) {
                            if (item.isMultiSelect) {
                                const splitOptions = optionValue === null ? null : (optionValue instanceof Array) ? optionValue : optionValue.split(';');
                                valuesForLevel = _.uniq(valuesForLevel.concat(splitOptions));
                            }
                            else {
                                valuesForLevel.push(optionValue);
                            }
                        }
                        else {
                            valuesForLevel.push(optionValue);
                        }
                        addedColumns[i][node.letter] = true;
                    }
                    const parentNode = node.getParent();
                    if (parentNode != null) {
                        nodesForLevel.push(parentNode);
                    }
                }
                availableValues[item.Id] = valuesForLevel;
            }
            for (; level < items.length; level++) {
                const column = items[level];
                availableValues[column.Id] = [];
            }
        }
        return availableValues;
    }
    /**
     * @ignore
    *
    */
    getAllowedValues(matrixResults, attributeSO, attributeSOCopy) {
        let validCombinations = [];
        const evaluatedMatrixFields = _.uniq(this.matrixResultFields(matrixResults));
        for (let count = 0; count < evaluatedMatrixFields.length; count++) {
            let fieldName = evaluatedMatrixFields[count];
            let allowedValues;
            let resetValue;
            const hasMatrixConstraint = matrixResults && matrixResults.constraints[fieldName];
            const matrixAllows = (matrixResults && matrixResults.constraints[fieldName]) || [];
            if (hasMatrixConstraint) {
                allowedValues = matrixAllows;
                resetValue = matrixResults.reset;
            }
            else if (matrixResults && matrixResults.reset[fieldName]) { // matrix reset
                allowedValues = matrixResults.reset[fieldName];
            }
            else {
                allowedValues = true; // indicates allow all values
            }
            validCombinations.push({
                allowedValues: allowedValues,
                resetValues: _.pick(resetValue, fieldName),
                defaults: _.pick(matrixResults.defaults, fieldName),
                constraints: _.pick(matrixResults.constraints, fieldName),
                forceSets: _.pick(matrixResults.forceSets, fieldName),
                items: _.find(matrixResults.items, r => r.Name === fieldName)
            });
        }
        validCombinations = this.setFieldValues(validCombinations, attributeSO, attributeSOCopy);
        return validCombinations;
    }
    /**
     * @ignore
     */
    // tslint:disable-next-line:prefer-function-over-method
    matrixResultFields(matrixResults) {
        const matrixFields = [];
        _.forEach(_.keys(matrixResults.constraints), (fieldKey) => {
            matrixFields.push(fieldKey);
        });
        _.forEach(_.keys(matrixResults.defaults), (fieldKey) => {
            matrixFields.push(fieldKey);
        });
        _.forEach(_.keys(matrixResults.reset), (fieldKey) => {
            matrixFields.push(fieldKey);
        });
        _.forEach(_.keys(matrixResults.forceSets), (fieldKey) => {
            matrixFields.push(fieldKey);
        });
        return matrixFields;
    }
}
AttributeValueMatrixService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AttributeValueMatrixService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
AttributeValueMatrixService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AttributeValueMatrixService, providedIn: 'root' });
__decorate([
    memoize((pList) => JSON.stringify([_.map(pList)])),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", Observable)
], AttributeValueMatrixService.prototype, "getAttributeMatrixForProducts", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AttributeValueMatrixService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], propDecorators: { getAttributeMatrixForProducts: [] } });
/**
 * This class is used for traversing the succinctly encoded trie.
 */
class AptValueMatrixNode {
    constructor(trie, index, letter, firstChild, parent, childCount) {
        this.children = null;
        this.children = null;
        this.node = this;
        /** -- Attach public variables -- */
        this.node.trie = trie;
        this.node.index = index;
        this.node.letter = letter;
        this.node.firstChild = firstChild;
        this.node.parent = parent;
        this.node.childCount = childCount;
        this.node.getParent = this.getParent;
        this.node.getChild = this.getChild;
        this.node.getChildren = this.getChildren;
        this.node.getChildCount = this.getChildCount;
    }
    /**
     * Returns the number of children.
     */
    getChildCount() {
        return this.node.childCount;
    }
    /**
     * Returns the FrozenTrieNode for the given child.
     * @param index The 0-based index of the child of this node. For example, if
     * the node has 5 children, and you wanted the 0th one, pass in 0.
     */
    getChild(index) {
        const result = null;
        return this.node.trie.getNodeByIndex(this.node.firstChild + index, this.node);
    }
    /**
     * Returns the FrozenTrieNode for all children
     */
    getChildren() {
        if (this.node.children == null) {
            this.node.children = [];
            for (let i = 0; i < this.node.childCount; i++) {
                this.node.children.push(this.getChild(i));
            }
        }
        return this.node.children;
    }
    /**
     * Return the parent node
     */
    getParent() {
        return this.node.parent;
    }
}
/**
* Given a string of data, the BitString class supports
* reading or counting a number of bits from an arbitrary position in the
* string.
*/
class BitString {
    constructor(str) {
        this.MaskTop = [
            0x3f, 0x1f, 0x0f, 0x07, 0x03, 0x01, 0x00
        ];
        this.BitsInByte = [
            0, 1, 1, 2, 1, 2, 2, 3, 1, 2, 2, 3, 2, 3, 3, 4, 1, 2, 2, 3, 2, 3, 3, 4, 2,
            3, 3, 4, 3, 4, 4, 5, 1, 2, 2, 3, 2, 3, 3, 4, 2, 3, 3, 4, 3, 4, 4, 5, 2, 3,
            3, 4, 3, 4, 4, 5, 3, 4, 4, 5, 4, 5, 5, 6, 1, 2, 2, 3, 2, 3, 3, 4, 2, 3, 3,
            4, 3, 4, 4, 5, 2, 3, 3, 4, 3, 4, 4, 5, 3, 4, 4, 5, 4, 5, 5, 6, 2, 3, 3, 4,
            3, 4, 4, 5, 3, 4, 4, 5, 4, 5, 5, 6, 3, 4, 4, 5, 4, 5, 5, 6, 4, 5, 5, 6, 5,
            6, 6, 7, 1, 2, 2, 3, 2, 3, 3, 4, 2, 3, 3, 4, 3, 4, 4, 5, 2, 3, 3, 4, 3, 4,
            4, 5, 3, 4, 4, 5, 4, 5, 5, 6, 2, 3, 3, 4, 3, 4, 4, 5, 3, 4, 4, 5, 4, 5, 5,
            6, 3, 4, 4, 5, 4, 5, 5, 6, 4, 5, 5, 6, 5, 6, 6, 7, 2, 3, 3, 4, 3, 4, 4, 5,
            3, 4, 4, 5, 4, 5, 5, 6, 3, 4, 4, 5, 4, 5, 5, 6, 4, 5, 5, 6, 5, 6, 6, 7, 3,
            4, 4, 5, 4, 5, 5, 6, 4, 5, 5, 6, 5, 6, 6, 7, 4, 5, 5, 6, 5, 6, 6, 7, 5, 6,
            6, 7, 6, 7, 7, 8
        ];
        this.AlphabetDigits = {
            'A': 0, 'B': 1, 'C': 2, 'D': 3, 'E': 4, 'F': 5,
            'G': 6, 'H': 7, 'I': 8, 'J': 9, 'K': 10, 'L': 11,
            'M': 12, 'N': 13, 'O': 14, 'P': 15, 'Q': 16, 'R': 17,
            'S': 18, 'T': 19, 'U': 20, 'V': 21, 'W': 22, 'X': 23,
            'Y': 24, 'Z': 25, 'a': 26, 'b': 27, 'c': 28, 'd': 29,
            'e': 30, 'f': 31, 'g': 32, 'h': 33, 'i': 34, 'j': 35,
            'k': 36, 'l': 37, 'm': 38, 'n': 39, 'o': 40, 'p': 41,
            'q': 42, 'r': 43, 's': 44, 't': 45, 'u': 46, 'v': 47,
            'w': 48, 'x': 49, 'y': 50, 'z': 51, '0': 52, '1': 53,
            '2': 54, '3': 55, '4': 56, '5': 57, '6': 58, '7': 59,
            '8': 60, '9': 61, '-': 62, '_': 63
        };
        this.encodingWidth = 6;
        this.bytes = str;
        this.length = this.bytes.length * this.encodingWidth;
    }
    /**
   * Returns the internal string of bytes
   */
    getData() {
        return this.bytes;
    }
    /**
  * Returns a decimal number, consisting of a certain number, numDigits, of bits
  * starting at a certain position, startPosition.
  */
    getBitNumber(startPosition, numDigits) {
        // case 1: bits lie within the given byte
        if ((startPosition % this.encodingWidth) + numDigits <= this.encodingWidth) {
            return (this.AlphabetDigits[this.bytes[startPosition / this.encodingWidth | 0]] & this.MaskTop[startPosition % this.encodingWidth]) >>
                (this.encodingWidth - startPosition % this.encodingWidth - numDigits);
            // case 2: bits lie incompletely in the given byte
        }
        else {
            let result = (this.AlphabetDigits[this.bytes[startPosition / this.encodingWidth | 0]] &
                this.MaskTop[startPosition % this.encodingWidth]);
            const remainder = this.encodingWidth - startPosition % this.encodingWidth;
            startPosition += remainder;
            numDigits -= remainder;
            while (numDigits >= this.encodingWidth) {
                result = (result << this.encodingWidth) | this.AlphabetDigits[this.bytes[startPosition / this.encodingWidth | 0]];
                startPosition += this.encodingWidth;
                numDigits -= this.encodingWidth;
            }
            if (numDigits > 0) {
                result = (result << numDigits) | (this.AlphabetDigits[this.bytes[startPosition / this.encodingWidth | 0]] >>
                    (this.encodingWidth - numDigits));
            }
            return result;
        }
    }
    /**
  * Counts the number of bits set to 1 starting at position p and
  * ending at position startPosition + numDigits
  */
    countOnesBits(startPosition, numDigits) {
        let count = 0;
        while (numDigits >= 8) {
            count += this.BitsInByte[this.getBitNumber(startPosition, 8)];
            startPosition += 8;
            numDigits -= 8;
        }
        return count + this.BitsInByte[this.getBitNumber(startPosition, numDigits)];
    }
}

/**
 * Attribute rules is  a powerful feature when configuring products.
 * They allow you to 'Allow', 'Default','Hidden','Disabled', 'Required' actions on the product attributes
 * based on business logic.
 * <h3>Usage</h3>
 *
  ```typescript
 import { AttributeRuleService, AObjectService} from '@congacommerce/ecommerce';
 
 export class MyComponent implements OnInit{
 constructor( private attributeRuleService: AttributeRuleService)
 }
 // or
 export class MyService extends AObjectService {
      private attributeRuleService: AttributeRuleService = this.injector.get(AttributeRuleService);
  }
 ```
 */
class AttributeRuleService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = ProductAttributeRule;
        this.productService = this.injector.get(ProductService);
    }
    onInit() {
    }
    /**@ignore */
    getActionFlag(action, actionName) {
        return action === actionName;
    }
    /**@ignore */
    getResetFlag(action, resetValues) {
        return action === 'Reset' && resetValues.length > 0;
    }
    /**
     * Process the ABC constraint rule action, given attribute rule and matrix constraints.
     * ### Example:
     ```typescript
     import { AttributeRuleService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         attributeRule : Array<AttributeRuleResult>;
         attributeRule$ : Observable<Array<AttributeRuleResult>>;
         constructor(private attributeRuleService: AttributeRuleService){}
     
       getAttributeRulesForProducts(productList: Array<string> | Array<Product>){
           this.attributeRuleService.getAttributeRulesForProducts(productList).subscribe(a => this.attributeRule = a);
             // or
           assets$ = this.attributeRuleService.getAttributeRulesForProducts(productList);
       }
     }
     ```
     * @param productList instance of Array of product object or list of product ids of type string.
     * @returns Observable array of processed attribute rules for the given product.
     */
    getAttributeRulesForProducts(productList) {
        const subject = new BehaviorSubject(null);
        if (productList) {
            // First query retrieves list of potential rules that the product list is a member of
            productList = productList.filter(p => p != null);
            const product$ = (productList.every((item) => typeof item === 'string')) ? this.productService.get(productList) : of(productList);
            product$
                .pipe(mergeMap((_productList) => {
                const familyList = _productList.map(p => _.get(p, 'Family')).filter(r => r != null);
                const groupList = _.flatten(_productList.map(p => _.get(p, 'ProductGroups', []))).map(group => _.get(group, 'ProductGroupId')).filter(x => x != null);
                let filters = [];
                let newFilters = [];
                filters = [
                    new AFilter(this.type, [
                        new ACondition(this.type, 'ProductScope', 'In', ['', 'All']),
                        new ACondition(this.type, 'ProductScope', 'Includes', _productList.map(p => p.Id))
                    ], null, 'OR')
                ];
                newFilters = [
                    new AFilter(this.type, [
                        new ACondition(this.type, 'EffectiveDate', 'Equal', null),
                        new ACondition(this.type, 'EffectiveDate', 'LessEqual', new Date())
                    ], null, 'OR'),
                    new AFilter(this.type, [
                        new ACondition(this.type, 'ExpirationDate', 'Equal', null),
                        new ACondition(this.type, 'ExpirationDate', 'GreaterEqual', new Date())
                    ], null, 'OR'),
                    new AFilter(this.type, [
                        new ACondition(this.type, 'ProductScope', 'In', ['', 'All']),
                        new ACondition(this.type, 'ProductScope', 'Includes', _productList.map(p => p.Id))
                    ], null, 'OR')
                ];
                if (_.get(familyList, 'length') > 0) {
                    filters.push(new AFilter(this.type, [
                        new ACondition(this.type, 'ProductFamilyScope', 'In', ['', 'All']),
                        new ACondition(this.type, 'ProductFamilyScope', 'Includes', familyList)
                    ], null, 'OR'));
                }
                if (_.get(groupList, 'length') > 0)
                    filters.push(new AFilter(this.type, [
                        new ACondition(this.type, 'ProductGroupScope', 'In', ['', 'All']),
                        new ACondition(this.type, 'ProductGroupScope', 'Includes', groupList)
                    ], null, 'OR'));
                return zip(this.where([new ACondition(this.type, 'Active', 'Equal', true)], 'AND', newFilters, null, new APageInfo(50, 1), null), this.describe(ProductAttributeValue))
                    .pipe(map$1(([attrRules, attrMetadata]) => {
                    _productList.forEach(product => {
                        const mergeActionResult = {};
                        _.forEach(attrRules, attrRule => {
                            const ruleActions = attrRule.ProductAttributeRuleActions;
                            _.forEach(ruleActions, (ruleAction, index, list) => {
                                const apiName = ruleAction.Field.indexOf('.') > -1 ? ruleAction.Field.split('.').pop() : ruleAction.Field;
                                const fieldType = attrMetadata.fields.find(r => r.name === apiName).type;
                                const isSelectType = (fieldType === 'multipicklist') || (fieldType === 'picklist');
                                if (ruleAction.Action === 'Allow' && !isSelectType) {
                                    list.splice(index, 1);
                                }
                                else {
                                    if (mergeActionResult.hasOwnProperty(apiName) && _.get(mergeActionResult, `${apiName}`)) {
                                        const attributeResult = mergeActionResult[apiName];
                                        attributeResult.isHiddenAction = attributeResult.isHiddenAction ? attributeResult.isHiddenAction : this.getActionFlag(ruleAction.Action, 'Hidden');
                                        attributeResult.isReadOnlyAction = attributeResult.isReadOnlyAction ? attributeResult.isReadOnlyAction : this.getActionFlag(ruleAction.Action, 'Disabled');
                                        attributeResult.isRequiredAction = attributeResult.isRequiredAction ? attributeResult.isRequiredAction : this.getActionFlag(ruleAction.Action, 'Required');
                                        if (this.getActionFlag(ruleAction.Action, 'Allow') && !attributeResult.isConstraintAction) {
                                            attributeResult.isConstraintAction = true;
                                            attributeResult.values = ruleAction.Values;
                                        }
                                        if (this.getActionFlag(ruleAction.Action, 'Default') && !attributeResult.isDefaultAction) {
                                            attributeResult.isDefaultAction = true;
                                            attributeResult.defaultValue = ruleAction.Values;
                                        }
                                        if (this.getActionFlag(ruleAction.Action, 'Reset') && !attributeResult.isReset && ruleAction.Values.length > 0) {
                                            attributeResult.isReset = true;
                                            attributeResult.resetValues = ruleAction.Values;
                                        }
                                    }
                                    else {
                                        const attributeResult = {
                                            field: apiName,
                                            isConstraintAction: this.getActionFlag(ruleAction.Action, 'Allow'),
                                            isDefaultAction: this.getActionFlag(ruleAction.Action, 'Default'),
                                            isHiddenAction: this.getActionFlag(ruleAction.Action, 'Hidden'),
                                            isReadOnlyAction: this.getActionFlag(ruleAction.Action, 'Disabled'),
                                            isRequiredAction: this.getActionFlag(ruleAction.Action, 'Required'),
                                            isReset: this.getResetFlag(ruleAction.Action, ruleAction.Values),
                                            values: this.getActionFlag(ruleAction.Action, 'Default') ? [] : ruleAction.Values,
                                            sfDefaultValue: SalesforceUtils.getDefaultValue(_.find(attrMetadata.fields, (field) => field.name === apiName)),
                                            defaultValue: ruleAction.Values,
                                            resetValues: this.getResetFlag(ruleAction.Action, ruleAction.Values) ? ruleAction.Values : []
                                        };
                                        mergeActionResult[apiName] = attributeResult;
                                    }
                                }
                            });
                        });
                        _.set(product, '_metadata.rules', Object.values(mergeActionResult));
                    });
                    return _productList;
                }), map$1(results => _.flatten(_.map(results, r => _.get(r, '_metadata.rules')))));
            }), take(1))
                .subscribe(results => subject.next(results));
        }
        return subject.pipe(filter$1(r => r != null));
    }
}
AttributeRuleService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AttributeRuleService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
AttributeRuleService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AttributeRuleService, providedIn: 'root' });
__decorate([
    MemoizeAll(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", Observable)
], AttributeRuleService.prototype, "getAttributeRulesForProducts", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AttributeRuleService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], propDecorators: { getAttributeRulesForProducts: [] } });

/** @ignore */
var ConstraintActionsMode;
(function (ConstraintActionsMode) {
    ConstraintActionsMode["INCLUDEALL"] = "Include All";
    ConstraintActionsMode["INCLUDEANY"] = "Include Any";
    ConstraintActionsMode["INCLUDEMINMAX"] = "Include Min/Max";
    ConstraintActionsMode["EXCLUDEALL"] = "Exclude All";
    ConstraintActionsMode["EXCLUDEAFTERONE"] = "Exclude After One";
    ConstraintActionsMode["EXCLUDEAFTERMAX"] = "Exclude After Max";
})(ConstraintActionsMode || (ConstraintActionsMode = {}));
/** @ignore */
var ConstraintActionsType;
(function (ConstraintActionsType) {
    ConstraintActionsType["INCLUSION"] = "Inclusion";
    ConstraintActionsType["EXCLUSION"] = "Exclusion";
})(ConstraintActionsType || (ConstraintActionsType = {}));
/** @ignore */
var ConstraintActionsIntent;
(function (ConstraintActionsIntent) {
    ConstraintActionsIntent["AUTO_INCLUDE"] = "Auto Include";
    ConstraintActionsIntent["DISABLE_SELECTION"] = "Disable Selection";
    ConstraintActionsIntent["PROMPT"] = "Prompt";
    ConstraintActionsIntent["SHOW_MESSAGE"] = "Show Message";
    ConstraintActionsIntent["HIDE"] = "Hide";
})(ConstraintActionsIntent || (ConstraintActionsIntent = {}));

/**@ignore */
class ClientConstraintRuleService {
    constructor(productOptionService, crService) {
        this.productOptionService = productOptionService;
        this.crService = crService;
        this.ruleMessages$ = new BehaviorSubject(null);
        this.performAction$ = new BehaviorSubject(null);
        this.currentSelections = [];
        this.appliedRuleActionInfoRec = [];
    }
    /**
     * validates the Constraint rule condition based on the scope.
     * @param condition Consttraint rule condition.
     * @param product instance of product.
     * @param selectedComponents List of omponent already configured for the complex product.
     * @returns boolean value stating the conditionrule is satisfied or not.
     * @ignore
     */
    validateCRCondition(condition, product, selectedComponents) {
        /* Condition to be checked on scope product. It then checks for  matchInOptions or  matchInPrimaryLines.
         Also, checks if the condition is already part of selectedComponents if the condition is satisfied then return true.
         Similary, perform the check if the condition scope is product family or product group.*/
        // condition Scope as Product
        return (condition.ProductScope === 'Product' && ((get(condition, 'MatchInOptions') && !get(condition, 'MatchInPrimaryLines')
            && get(filter(selectedComponents, (r) => r.ComponentProduct.Id === condition.ProductId), 'length') > 0)
            || (get(condition, 'MatchInPrimaryLines') && !get(condition, 'MatchInOptions') && get(product, 'Id') === get(condition, 'ProductId'))
            || (get(condition, 'MatchInOptions') && get(condition, 'MatchInPrimaryLines') && get(filter(selectedComponents, (r) => r.ComponentProduct.Id === condition.ProductId), 'length') > 0
                && product.Id === condition.ProductId)))
            ||
                // condition Scope as ProductFamily
                (condition.ProductScope === 'Product Family' && ((get(condition, 'MatchInOptions') && !get(condition, 'MatchInPrimaryLines')
                    && get(uniq(filter(selectedComponents, (r) => r.ComponentProduct.Family === condition.ProductFamily)), 'length') > 0)
                    || (get(condition, 'MatchInPrimaryLines') && !get(condition, 'MatchInOptions')
                        && get(difference([get(condition, 'ProductFamily')], [get(product, 'Family')]), 'length') === 0)
                    || (get(condition, 'MatchInPrimaryLines') && get(condition, 'MatchInOptions')
                        && get(uniq(filter(selectedComponents, (r) => r.ComponentProduct.Family === condition.ProductFamily)), 'length') > 0
                        && get(difference([get(condition, 'ProductFamily')], [get(product, 'Family')]), 'length') === 0)))
            ||
                // condition Scope as ProductGroup
                (condition.ProductScope === 'Product Group' && ((get(condition, 'MatchInOptions') && !get(condition, 'MatchInPrimaryLines')
                    && filter(filter(flatMap$1(selectedComponents.map(r => get(r.ComponentProduct, 'ProductGroups', [])).map(groupMember => groupMember)), (groupMember) => groupMember !== null), (r) => r.ProductGroupId === condition.ProductGroupId).length > 0)
                    || (get(condition, 'MatchInPrimaryLines') && !get(condition, 'MatchInOptions')
                        && filter(get(product, 'ProductGroups', []), groupMember => groupMember.ProductGroupId === condition.ProductGroupId).length > 0)
                    || (get(condition, 'MatchInPrimaryLines') && get(condition, 'MatchInOptions')
                        && filter(filter(flatMap$1(selectedComponents.map(r => r.ComponentProduct.ProductGroups).map(groupMember => groupMember)), (groupMember) => groupMember !== null), (r) => r.ProductGroupId === condition.ProductGroupId).length > 0
                        && filter(get(product, 'ProductGroups', []), groupMember => groupMember.ProductGroupId === condition.ProductGroupId).length > 0)));
    }
    /**
     * To fetch the constraint rule for the given Bundle product.
     * @param bundleProduct instance of bundle product.
     * @param cartItem instance of cartItem.
     * @returns Observable of array of constraint rule.
     * @ignore
     */
    getConstraintRulesForProducts(bundleProduct, cartItem) {
        this.loadAlertMessages([]);
        this.appliedRuleActionInfoRec = [];
        if (!isNil(get(cartItem, 'AssetLineItem')))
            return of([]);
        let _productList = [bundleProduct];
        if (bundleProduct.HasOptions) {
            const options = map(this.productOptionService.getProductOptions(bundleProduct), c => get(c, 'ComponentProduct'));
            _productList = concat(bundleProduct, options);
        }
        const rules$ = this.crService.getConstraintRulesForProducts(uniqBy(_productList, 'Id'), true, true);
        return rules$
            .pipe(map$1(rules => {
            return filter(compact(uniqBy(rules, 'Id')), rule => {
                if (isEmpty(get(rule, 'ConstraintRuleActions')) || isNil(get(rule, 'ConstraintRuleActions')))
                    return false;
                else {
                    let valid = false;
                    _productList.forEach(product => {
                        const conditions = (isNil(get(rule, 'ConstraintRuleConditions'))) ? [] : get(rule, 'ConstraintRuleConditions', []);
                        const actions = (isNil(get(rule, 'ConstraintRuleActions'))) ? [] : get(rule, 'ConstraintRuleActions', []);
                        const productValid = conditions.filter(condition => (condition.ProductScope === 'Product' && product.Id === condition.ProductId)
                            || (condition.ProductScope === 'Product Family' && product.Family === condition.ProductFamily)
                            || (condition.ProductScope === 'Product Group' && filter(get(product, 'ProductGroups', []), groupMember => groupMember.ProductGroupId === condition.ProductGroupId).length > 0)).length > 0;
                        if (productValid) {
                            valid = true;
                            const ruleProducts = get(rule, '_metadata.productList', []);
                            ruleProducts.push(product);
                            rule.set('productList', ruleProducts);
                        }
                        const actionProductValid = actions.filter(action => (action.ProductScope === 'Product' && product.Id === action.ProductId)
                            || (action.ProductScope === 'Product Family' && product.Family === action.ProductFamily)
                            || (action.ProductScope === 'Product Group' && filter(get(product, 'ProductGroups', []), groupMember => groupMember.ProductGroupId === action.ProductGroupId).length > 0)).length === actions.length;
                        if (actionProductValid) {
                            valid = true;
                            const ruleProducts = get(rule, '_metadata.actionProductList', []);
                            ruleProducts.push(product);
                            rule.set('actionProductList', ruleProducts);
                        }
                    });
                    return valid;
                }
            });
        }), map$1(rules => filter(rules, r => r.get('actionProductList'))));
    }
    /**
    * Method is invoked after processing the rules to validate them. And perform appropriate actions.
    * Auto includes the option when 'AutoInclude' is set and remove option when disable selection is set. Also throws success message.
    * shows error or warning messages for prompt/showMessage.
    * @param ruleList list of constraint rules
    * @param product  instance of Product.
    * @param arg  instance of component List.
    * @returns An Object of actions to be performed.
    * @ignore
    **/
    validateRules(ruleList, product, arg) {
        const actionToPerform = { addOption: [], removeOption: [], disableOrHideOption: [] };
        const loadRuleMessages = [];
        forEach(ruleList, (rule) => {
            // applyAction return boolean value which states the condition is satisfied or not.
            const applyAction = rule.ConstraintRuleConditions.filter(condition => 
            // checks for condition is selected ad it satisfies the rule.
            this.validateCRCondition(condition, product, arg.selectedComponents)).length === rule.ConstraintRuleConditions.length;
            // List of rule action with autoInclude as actionIntent.
            const autoInclusionRules = uniqBy(rule.ConstraintRuleActions
                .filter(r => get(r, 'ActionType') === ConstraintActionsType.INCLUSION && get(r, 'ActionIntent') === ConstraintActionsIntent.AUTO_INCLUDE), 'Id');
            // List of rule action other than autoInclude and disable selection.
            const genricRules = uniqBy(rule.ConstraintRuleActions
                .filter(r => get(r, 'ActionIntent') !== ConstraintActionsIntent.DISABLE_SELECTION && get(r, 'ActionIntent') !== ConstraintActionsIntent.AUTO_INCLUDE
                && get(r, 'ActionIntent') !== ConstraintActionsIntent.HIDE), 'Id');
            // List of rule action with disable selection as actionIntent.
            const disableSelectionRules = uniqBy(rule.ConstraintRuleActions
                .filter(r => get(r, 'ActionType') === ConstraintActionsType.EXCLUSION && get(r, 'ActionIntent') === ConstraintActionsIntent.DISABLE_SELECTION), 'Id');
            // List of rule action with hide selection as actionIntent.
            const hideExclusionRules = uniqBy(rule.ConstraintRuleActions
                .filter(r => get(r, 'ActionType') === ConstraintActionsType.EXCLUSION && get(r, 'ActionIntent') === ConstraintActionsIntent.HIDE), 'Id');
            let actionProdList = [];
            if (!rule.get('actionProductList')) {
                actionProdList = actionProdList.concat(rule.ConstraintRuleActions.filter(p => p.Product != null && p.Product.Id !== null).map(p => p.Product.Id));
            }
            else {
                actionProdList = rule.get('actionProductList');
            }
            // let comps = [];
            // forEach(actionProdList, actionProd => {
            //   comps = comps.concat(arg.allComponents.filter(r => r.ComponentProduct.Id === actionProd.Id));
            // });
            const comps = filter(arg.allComponents, op => actionProdList.filter(actionProd => op.ComponentProduct.Id === actionProd.Id).length > 0);
            // applyAction when flag is set to true.
            if (applyAction) {
                // disable selection / hide exclusion rule
                if (get(disableSelectionRules, 'length') > 0 || get(hideExclusionRules, 'length') > 0) {
                    // condition option of DisabelExclusionRules is selected then disable the action option and remove the selection of that option. Also, display the error message
                    if (!isNil(comps)) {
                        forEach(comps, c => {
                            if (get(disableSelectionRules, 'length') > 0 && !get(c, 'ComponentProduct.ProductOptionGroup.IsHidden')) {
                                c.set('disabled', true);
                                actionToPerform.removeOption.push(c.ComponentProduct);
                                actionToPerform.disableOrHideOption.push(c);
                            }
                            if (get(hideExclusionRules, 'length') > 0 && intersection(comps, arg.selectedComponents).length === 0) {
                                c.set('hidden', true);
                                actionToPerform.disableOrHideOption.push(c);
                                actionToPerform.removeOption.push(c.ComponentProduct);
                            }
                            c.set('selected', false);
                        });
                        if ((get(disableSelectionRules, 'length') > 0 && intersection(actionToPerform.removeOption.map(p => p.Id), comps.map(c => c.ComponentProduct.Id)).length > 0)
                            || (get(hideExclusionRules, 'length') > 0 && intersection(comps, arg.selectedComponents).length > 0))
                            loadRuleMessages.push({ rule: rule, pending: true });
                    }
                    else {
                        // condition option of DisableExclusionRules is not seelcted then enable the option and remove the error message if displayed.
                        forEach(comps, (comp) => {
                            comp.set('disabled', false);
                            actionToPerform.disableOrHideOption.push(comp);
                            comp.set('ruleAction', null);
                        });
                        if (get(disableSelectionRules, 'length') > 0)
                            loadRuleMessages.push({ rule: rule, pending: false });
                    }
                }
                // auto include inclusion rule
                if (autoInclusionRules.length > 0) {
                    if (!isNil(comps)) {
                        forEach(comps, (comp) => {
                            if (!this.isProductSelected(comp.ComponentProduct.Id)) {
                                const group = get(comp, 'ProductOptionGroup');
                                if (isEmpty(get(group, 'Options')))
                                    set(group, 'Options', this.productOptionService.getProductOptionsForGroup(product, group));
                                actionToPerform.addOption.push(comp.ComponentProduct);
                            }
                        });
                        loadRuleMessages.push({ rule: rule, pending: true });
                    }
                }
                // show or remove messages when actions is not satisfied for prompt and show message actionIntent.
                if (genricRules.length > 0) {
                    if (get(actionProdList, 'length') > 0) {
                        const errormsg = !this.validateCRActionForPrompt([rule], null);
                        if (genricRules.find(r => r.ActionType === ConstraintActionsType.INCLUSION)) {
                            if (errormsg) {
                                loadRuleMessages.push({ rule: rule, pending: true });
                            }
                            else {
                                loadRuleMessages.push({ rule: rule, pending: false });
                            }
                        }
                        else if (genricRules.find(r => r.ActionType === ConstraintActionsType.EXCLUSION)) {
                            if (errormsg) {
                                loadRuleMessages.push({ rule: rule, pending: true });
                            }
                            else {
                                loadRuleMessages.push({ rule: rule, pending: false });
                            }
                        }
                    }
                }
            }
            else {
                let allowAction = true;
                if (rule.ConstraintRuleConditions.filter(r => r.MatchInPrimaryLines === true).length > 0)
                    allowAction = this.checkMatchInPrimaryLine(rule, product);
                // when apply rule apply action flag is false
                // removes the alert messages if condition is unchecked.
                if (allowAction) {
                    forEach(comps, (comp) => {
                        if (disableSelectionRules.length > 0) {
                            comp.set('disabled', false);
                            actionToPerform.disableOrHideOption.push(comp);
                        }
                        if (hideExclusionRules.length > 0) {
                            comp.set('hidden', false);
                            actionToPerform.disableOrHideOption.push(comp);
                        }
                    });
                    if (disableSelectionRules.length > 0 || autoInclusionRules.length > 0 || hideExclusionRules.length > 0)
                        loadRuleMessages.push({ rule: rule, pending: false });
                    if (genricRules.length > 0) {
                        if (genricRules.find(r => r.ActionType === ConstraintActionsType.INCLUSION)) {
                            loadRuleMessages.push({ rule: rule, pending: false });
                        }
                        else if (genricRules.find(r => r.ActionType === ConstraintActionsType.EXCLUSION)) {
                            loadRuleMessages.push({ rule: rule, pending: false });
                        }
                    }
                }
            }
        }, this);
        this.appliedRuleActionInfoRec = this.loadAlertMessages(loadRuleMessages, product);
        return actionToPerform;
    }
    /** @ignore */
    setCurrentSelection(options, flag = false) {
        if (flag)
            this.currentSelections = [];
        this.currentSelections = options;
    }
    /** @ignore */
    getCurrentSelection() {
        return this.currentSelections;
    }
    /** @ignore */
    isProductSelected(Id) {
        return filter(this.getCurrentSelection(), (item) => get(item, 'ComponentProduct.Id') === Id).length > 0;
    }
    /**
     * This method generates the Aplied Rule actionInfo record.
     * @param rule  instance of ConstraintRule.
     * @param rulePending boolean value
     * @param product instance of product.
     * @returns Applied ruleAction info record.
     * @ignore
     */
    generateRuleActionInfo(rule, rulePending, product) {
        const appliedRule = new AppliedRuleActionInfo();
        appliedRule.Pending = rulePending;
        if (first(rule.ConstraintRuleActions).ActionIntent !== ConstraintActionsIntent.AUTO_INCLUDE && first(rule.ConstraintRuleActions).ActionIntent !== ConstraintActionsIntent.DISABLE_SELECTION) {
            appliedRule.MessageType = first(rule.ConstraintRuleActions).ActionDisposition === 'Error' || first(rule.ConstraintRuleActions).ActionDisposition === 'Warning' ? first(rule.ConstraintRuleActions).ActionDisposition : null;
        }
        const primaryProd = this.checkMatchInPrimaryLine(rule, product);
        appliedRule.ConstraintRuleAction = first(rule.ConstraintRuleActions);
        appliedRule.TriggeringProductIds = map(rule.get('productList'), 'Id');
        if (primaryProd)
            appliedRule.TriggeringProductIds = appliedRule.TriggeringProductIds.concat(product.Id);
        appliedRule.ActionProductIds = map(rule.get('actionProductList'), 'Id');
        appliedRule.Message = first(rule.ConstraintRuleActions).Message;
        appliedRule.IsTargetOption = true;
        return appliedRule;
    }
    /**
     * @ignore
     */
    checkMatchInPrimaryLine(rule, product) {
        return filter(rule.ConstraintRuleConditions, (r) => r.MatchInPrimaryLines && (r.ProductId === product.Id || r.ProductFamily === product.Family || filter(get(product, 'ProductGroups', []), groupMember => groupMember.ProductGroupId === r.ProductGroupId).length > 0)).length > 0;
    }
    /**
     * Loads the Rule messages to display it as error or warning if condition is not satisfied.
     * @param ruleMsgs instance of Array of ActioInfo
     * @param product  instanc eof Bundle Product
     * @returns aaray of applied rule action Info record.
     * @ignore
     */
    loadAlertMessages(ruleMsgs, product) {
        const rules = [];
        forEach(ruleMsgs, (item) => {
            rules.push(this.generateRuleActionInfo(item.rule, item.pending, product));
        });
        this.ruleMessages$.next(rules);
        return rules;
    }
    /**
     * @ignore
     */
    assignAction(action) {
        this.performAction$.next(action);
    }
    /** @ignore */
    validateCRActionForPrompt(rulelist, product, flag = false, isPrompt = false) {
        let rules = rulelist;
        if (isPrompt) {
            const promptRules = filter(rules, (r) => get(r, 'ActionIntent') === ConstraintActionsIntent.PROMPT);
            rules = filter(promptRules, (r) => includes(map(r.get('actionProductList'), 'Id'), product.Id));
            if (flag)
                rules = filter(promptRules, (r) => includes(map(r.get('productList'), 'Id'), product.Id));
        }
        let isValid = false;
        forEach(rules, rule => {
            isValid = false;
            let count = 0;
            filter(rule.get('actionProductList'), (p) => {
                if (this.isProductSelected(p.Id))
                    count += 1;
            });
            if (first(rule.ConstraintRuleActions).IncludeMatchRule === ConstraintActionsMode.INCLUDEALL && count === get(rule.get('actionProductList'), 'length')) {
                isValid = true;
            }
            else if (first(rule.ConstraintRuleActions).IncludeMatchRule === ConstraintActionsMode.INCLUDEANY && count === 1) {
                isValid = true;
            }
            else if (first(rule.ConstraintRuleActions).IncludeMatchRule === ConstraintActionsMode.INCLUDEMINMAX && first(rule.ConstraintRuleActions).IncludeMinProducts >= first(rule.ConstraintRuleActions).IncludeMaxProducts) {
                if (count >= first(rule.ConstraintRuleActions).IncludeMinProducts && count === first(rule.ConstraintRuleActions).IncludeMaxProducts)
                    isValid = true;
            }
            else if (first(rule.ConstraintRuleActions).IncludeMatchRule === ConstraintActionsMode.EXCLUDEALL && count === 0) {
                isValid = true;
            }
            else if (first(rule.ConstraintRuleActions).IncludeMatchRule === ConstraintActionsMode.EXCLUDEAFTERONE && count < get(rule.get('actionProductList'), 'length')) {
                isValid = true;
            }
            else if (first(rule.ConstraintRuleActions).IncludeMatchRule === ConstraintActionsMode.EXCLUDEAFTERMAX && count <= first(rule.ConstraintRuleActions).IncludeMaxProducts) {
                isValid = true;
            }
            else if (first(rule.ConstraintRuleActions).ActionType === ConstraintActionsType.INCLUSION && count === get(rule.get('actionProductList'), 'length') && first(rule.ConstraintRuleActions).IncludeMatchRule !== ConstraintActionsMode.INCLUDEANY && first(rule.ConstraintRuleActions).IncludeMatchRule !== ConstraintActionsMode.INCLUDEMINMAX) {
                isValid = true;
            }
            else if (first(rule.ConstraintRuleActions).ActionType === ConstraintActionsType.EXCLUSION && count === 0) {
                isValid = true;
            }
        });
        return isValid;
    }
}
ClientConstraintRuleService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ClientConstraintRuleService, deps: [{ token: ProductOptionService }, { token: ConstraintRuleService }], target: i0.ɵɵFactoryTarget.Injectable });
ClientConstraintRuleService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ClientConstraintRuleService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ClientConstraintRuleService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: ProductOptionService }, { type: ConstraintRuleService }]; } });

let Favorite = class Favorite extends AObject {
    constructor() {
        super(...arguments);
        this.Name = null;
        this.CreatedBy = new User();
        this.OwnerId = null;
        this.ConfigurationId = null;
        this.Configuration = null;
        this.Description = null;
        this.PriceListId = null;
        this.PriceList = null;
        this.Scope = null;
    }
};
__decorate([
    Expose({ name: 'Name' }),
    __metadata("design:type", String)
], Favorite.prototype, "Name", void 0);
__decorate([
    Expose({ name: 'CreatedBy' }),
    Type(() => User),
    __metadata("design:type", User)
], Favorite.prototype, "CreatedBy", void 0);
__decorate([
    Expose({ name: 'OwnerId' }),
    __metadata("design:type", String)
], Favorite.prototype, "OwnerId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Active__c' }),
    __metadata("design:type", Boolean)
], Favorite.prototype, "Active", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ConfigurationId__c' }),
    __metadata("design:type", String)
], Favorite.prototype, "ConfigurationId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__ConfigurationId__r' }),
    Type(() => Cart),
    __metadata("design:type", Cart)
], Favorite.prototype, "Configuration", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Description__c' }),
    __metadata("design:type", String)
], Favorite.prototype, "Description", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceListId__c' }),
    __metadata("design:type", String)
], Favorite.prototype, "PriceListId", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__PriceListId__r' }),
    Type(() => PriceList),
    __metadata("design:type", PriceList)
], Favorite.prototype, "PriceList", void 0);
__decorate([
    Expose({ name: 'Apttus_Config2__Scope__c' }),
    __metadata("design:type", String)
], Favorite.prototype, "Scope", void 0);
Favorite = __decorate([
    ATable({
        sobjectName: 'Apttus_Config2__FavoriteConfiguration__c'
    })
], Favorite);

/**
 * Favorite service defines a way to save a configuration as favorite or add a saved configuration to active cart.
 * <h3>Usage</h3>
 *
  ```typescript
 import { FavoriteService, AObjectService} from '@congacommerce/ecommerce';
 
 export class MyComponent implements OnInit{
 constructor( private favoriteService: FavoriteService)
 }
 // or
 export class MyService extends AObjectService {
      private favoriteService: FavoriteService = this.injector.get(FavoriteService);
  }
 ```
 */
class FavoriteService extends AObjectService {
    constructor() {
        super(...arguments);
        this.type = Favorite;
        this.cartService = this.injector.get(CartService);
        this.priceListService = this.injector.get(PriceListService);
    }
    /**
     * @ignore
     */
    globalFilter() {
        return this.priceListService.getPriceListId().pipe(take(1), map$1(priceListId => {
            return [new AFilter(this.type, [new ACondition(this.type, 'Apttus_Config2__PriceListId__c', 'Equal', `${priceListId}`)])];
        }));
    }
    /**
     * Get the favrorite details
     * ### Example:
     ```typescript
     import { FavoriteService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         favorite: Favorite;
         favorite$: Observable<Favorite>;
         constructor(private favoriteService: FavoriteService){}
     
         getFavorite(favoriteId: string){
             this.favoriteService.getFavoriteById().subscribe(a => this.favorite = a);
               // or
             favorite$ = this.favoriteService.getFavoriteById();
         }
     }
     ```
     * @param favoriteId string value representing favorite identifier to fetch details for.
     * @param lookups string value representing the lookups to be fetched for a given favorite.
     * @returns observable containing the favorite record.
     */
    getFavoriteById(favoriteId, lookups = null) {
        const queryParam = lookups ? `?lookups=${lookups}` : '';
        return this.platformService.apiService.get(`/Apttus_Config2__FavoriteConfiguration__c/${favoriteId}${queryParam}`, this.type);
    }
    /**
     * @param configurationId string value representing favorite configuration Id.
     * @returns observable containing list of favorite configuration line items.
     */
    getFavoriteItems(configurationId) {
        return this.platformService.apiService.post('/Apttus_Config2__LineItem__c/query', {
            'alias': false,
            'conditions': [
                {
                    'field': 'ConfigurationId',
                    'filterOperator': 'Equal',
                    'value': configurationId
                }
            ],
            'lookups': [
                {
                    'field': 'Product',
                    'children': [
                        {
                            'field': 'OptionGroups'
                        }
                    ]
                },
                {
                    'field': 'Option',
                    'children': [
                        {
                            'field': 'OptionGroups'
                        }
                    ]
                },
                {
                    'field': 'ProductOption'
                },
                {
                    'field': 'AttributeValue'
                },
                {
                    'field': 'AssetLineItem'
                },
                {
                    'field': 'PriceListItem'
                }
            ],
            'children': [{
                    'field': 'AdjustmentLineItems'
                }]
        }, CartItem, false, false);
    }
    /**
     * This method adds saved favorite configurations to active cart.
     *
     * ### Example:
     ```typescript
     import { FavoriteService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         favorite: Array<CartItem>;
         favorite$: Observable<Array<CartItem>>;
         constructor(private favoriteService: FavoriteService){}
     
         addFavoriteToCart(favorite: string | Favorite){
             this.favoriteService.addFavoriteToCart(favorite).subscribe(a => this.favorite = a);
               // or
             favorite$ = this.favoriteService.addFavoriteToCart(favorite);
         }
     }
     ```
     *
     * @param favorite favorite record or string identifier of the favorite.
     * @returns an observable containing list of cart items added from a favorite.
     */
    addFavoriteToCart(favorite) {
        const favoriteId = favorite instanceof Favorite ? favorite.Id : favorite;
        return this.cartService.addItem({ 'FavoriteId': favoriteId });
    }
    /**
    * The method makes an api call to add the favorite items using the existing favoriteId and
    * returns an observable of list of cartItems which got added to the existing favorite configuration.
     * ### Example:
     ```typescript
     import { FavoriteService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         favorite: Array<CartItem>;
         favorite$: Observable<Array<CartItem>>;
         constructor(private favoriteService: FavoriteService){}
     
         addFavorite(favoriteId: string, payload: Array<FavoriteItemRequest> | Array<number>){
             this.favoriteService.addFavorite(favoriteId, payload).subscribe(a => this.favorite = a);
               // or
             favorite$ = this.favoriteService.addFavorite(favoriteId, payload);
         }
     }
     ```
    * @param favoriteId is of type string , pass the favorite Id.
    * @param payload is of type Array<FavoriteItemRequest> which consists of productid and qty information
    *  or Array<Number> is an instance of Array with number, consists of linenumber of cartitem,
    * which is part of request payload.
    * @returns an observable of list of cartitems got added to the favorite configuration.
    */
    addFavorite(favoriteId, payload) {
        return this.platformService.apiService.post(`/favorites/${favoriteId}/items`, payload);
    }
    /**
     * The method is responsible for creating new favorite by invoking api callout, and returns an observable of
     * favorite which got created with favorite information.
     * ### Example:
     ```typescript
     import { FavoriteService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         favorite: Favorite;
         favorite$: Observable<Favorite>;
         constructor(private favoriteService: FavoriteService){}
     
         createFavorite(payload: Array<Favorite>){
             this.favoriteService.createFavorite(payload).subscribe(a => this.favorite = a);
               // or
             favorite$ = this.favoriteService.createFavorite(payload);
         }
     }
     ```
     * @param payload is instance of favorite
     * @returns an observable of Favorite which got newly created.
     */
    createFavorite(payload) {
        const requestObj = map(payload, (item) => item.strip());
        return this.platformService.apiService
            .post(`/favorites`, requestObj, this.type)
            .pipe(map$1(first));
    }
    /**
     * This method removes a given favorite.
     * ### Example:
     ```typescript
     import { FavoriteService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         favorite: Favorite;
         favorite$: Observable<Favorite>;
         constructor(private favoriteService: FavoriteService){}
     
         removeFavorite(favorite: string | Favorite){
             this.favoriteService.removeFavorite(favorite).subscribe(a => this.favorite = a);
               // or
             favorite$ = this.favoriteService.removeFavorite(favorite);
         }
     }
     ```
     * @param favorite favorite record or favorite Id.
     * @returns observable instance of favorite record.
     */
    removeFavorite(favorite) {
        const favoriteId = favorite instanceof Favorite ? favorite.Id : favorite;
        return this.platformService.apiService.delete(`/favorites/${favoriteId}`, this.type);
    }
    /**
    * This method updates a given favorite. Only Name, Description and Scope of favorite can be updated.
     * ### Example:
     ```typescript
     import { FavoriteService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         favorite: Favorite;
         favorite$: Observable<Favorite>;
         constructor(private favoriteService: FavoriteService){}
     
         updateFavorite(favorite: Favorite){
             this.favoriteService.updateFavorite(favorite).subscribe(a => this.favorite = a);
               // or
             favorite$ = this.favoriteService.updateFavorite(favorite);
         }
     }
     ```
    * @param favorite record to be updated.
    * @returns observable containing favorite record with updated fields.
    */
    updateFavorite(favorite) {
        const payload = {
            'Name': favorite.Name,
            'Description': favorite.Description,
            'Scope': favorite.Scope
        };
        return this.platformService.apiService.put(`/favorites/${favorite.Id}`, payload, this.type);
    }
    /**
     * This method removes list of favorites passed.
     * ### Example:
     ```typescript
     import { FavoriteService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         favorite: Array<Favorite>;
         favorite$: Observable<Array<Favorite>>;
         constructor(private favoriteService: FavoriteService){}
     
         removeFavorites(favoriteList: Array<Favorite> | Array<string>){
             this.favoriteService.removeFavorites(favoriteList).subscribe(a => this.favorite = a);
               // or
             favorite$ = this.favoriteService.removeFavorites(favoriteList);
         }
     }
     ```
     * @param favoriteIds list of favorite records or string identifiers to be removed.
     * @returns observable containing list of favorites.
     */
    removeFavorites(favoriteList) {
        const favorites = filter(favoriteList, f => !isNil(f));
        const payload = every(favorites, fav => typeof (fav) === 'string') ?
            map(favorites, fav => ({ Id: fav }))
            : map(favorites, fav => ({ Id: fav.Id }));
        return this.platformService.apiService.post(`/favorites/delete`, payload, this.type);
    }
}
FavoriteService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FavoriteService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
FavoriteService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FavoriteService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FavoriteService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * Favorite scope represents scope values of a favorite configuration record.
 * Possible values are Public and Private.
 */
var FavoriteScope;
(function (FavoriteScope) {
    FavoriteScope["Public"] = "Public";
    FavoriteScope["Private"] = "Private";
})(FavoriteScope || (FavoriteScope = {}));

/*
 * Public API Surface of ng-salesforce
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccessLevel, Account, AccountBase, AccountLocation, AccountLocationService, AccountService, AdjustmentItem, AppLoader, AppliedRuleActionInfo, AppliedRuleInfo, ApprovalRequest, AptValueMatrixNode, AssetAttributeValue, AssetLineItem, AssetLineItemExtended, AssetService, Attachment, AttachmentService, AttachmentsService, AttributeGroupTranslation, AttributeRuleService, AttributeTranslationService, AttributeValueMatrix, AttributeValueMatrixEntry, AttributeValueMatrixService, AttributeValuePricePipe, AuthConfig, AuthConfigProviders, AuthorizationService, BatchAction, BitString, Cart, CartError, CartItem, CartItemPricePipe, CartItemService, CartPricePipe, CartService, Category, CategoryService, CategoryTranslation, ChargeType, Classification, ClientConstraintRuleService, CommerceModule, ConfigCustomDisplayColumns, ConstraintActionsIntent, ConstraintActionsMode, ConstraintActionsType, ConstraintRule, ConstraintRuleAction, ConstraintRuleCondition, ConstraintRuleService, Contact, ContactService, ConversionService, ConvertCurrencyPipe, CurrencyType, DetailsGuard, DocGenModule, EmailService, Favorite, FavoriteScope, FavoriteService, Feature, FeatureSet, File, FileService, FormatCurrencyPipe, GatewayCommunication, GatewayCommunicationService, GatewayTransaction, GatewayTransactionService, GuestGuard, Incentive, IncentiveService, IncrementLineAction, LineItemPricePipe, LineItemService, LineStatus, LocalCurrencyPipe, LoginGuard, LookupService, MailFactory, Note, NoteService, Opportunity, OptionPricePipe, Order, OrderAttributeValue, OrderDetailsGuard, OrderLineItem, OrderLineItemPricePipe, OrderLineItemService, OrderModule, OrderPricePipe, OrderService, OrderTaxBreakup, OrderTaxService, PartnerDetailsGuard, PaymentMethod, PaymentModule, PaymentService, PaymentTransaction, Price, PriceDimension, PriceDimensionBase, PriceList, PriceListBase, PriceListCategory, PriceListItem, PriceListItemService, PriceListService, PriceMatrix, PriceMatrixEntry, PriceMatrixFilter, PriceMatrixService, PriceRule, PriceRuleEntry, PriceRuleService, PriceRuleSet, PriceService, PricingModule, Product, ProductAttribute, ProductAttributeGroup, ProductAttributeGroupMember, ProductAttributeGroupMemberService, ProductAttributeGroupService, ProductAttributeMatrixView, ProductAttributeRule, ProductAttributeRuleAction, ProductAttributeRuleService, ProductAttributeRuleView, ProductAttributeRuleViewService, ProductAttributeService, ProductAttributeValue, ProductAttributeValueService, ProductCategory, ProductCategoryService, ProductFeatureValue, ProductFeatureValueService, ProductGroup, ProductGroupMember, ProductInformation, ProductInformationService, ProductOptionComponent, ProductOptionComponentService, ProductOptionGroup, ProductOptionGroupService, ProductOptionPrice, ProductOptionService, ProductPricePipe, ProductResult, ProductService, ProductTranslation, ProductTranslationService, PromotionService, ProposalTaxBreakup, ProposalTaxService, Quote, QuoteAttachment, QuoteAttributeValue, QuoteLineItem, QuoteLineItemService, QuotePricePipe, QuoteService, SamlSSOConfig, SearchService, SessionGuard, Storefront, StorefrontService, SummaryGroup, TaxBreakup, TaxCertificate, TaxCode, TaxService, Template, TemplateMailFactory, TemplateService, TranslatorLoaderService, User, UserBase, UserService, UserViewService, init };
